// noinspection JSUnusedGlobalSymbols
export enum PortalTranslationKeys {
  AdminAddons = 'Admin.Addons.title',
  AdminAddonsInteract = 'Admin.Addons.interact',
  AdminAddonsInteractWarningMessage = 'Admin.Addons.interactWarningMessage',
  AdminAddonsWarningTitle = 'Admin.Addons.warningTitle',
  AdminAdminConsentAccessDenied = 'Admin.AdminConsent.accessDenied',
  AdminAdminConsentError = 'Admin.AdminConsent.error',
  AdminAdminConsentSuccess = 'Admin.AdminConsent.success',
  AdminAuthErrorAdminConsentNeeded = 'Admin.Auth.Error.consentNeeded',
  AdminBulkOperationResultAdded = 'Admin.Bulk.OperationResult.added',
  AdminBulkOperationResultChangedBy = 'Admin.Bulk.OperationResult.changedBy',
  AdminBulkOperationResultFailedUpdates = 'Admin.Bulk.OperationResult.failedUpdates',
  AdminBulkOperationResultGridProperty = 'Admin.Bulk.OperationResult.Grid.property',
  AdminBulkOperationResultGridValue = 'Admin.Bulk.OperationResult.Grid.value',
  AdminBulkOperationResultHideSuccessfulChanges = 'Admin.Bulk.OperationResult.hideSuccessfulChanges',
  AdminBulkOperationResultPropertyEmpty = 'Admin.Bulk.OperationResult.propertyEmpty',
  AdminBulkOperationResultPropertyProfileValue = 'Admin.Bulk.OperationResult.propertyProfileValue',
  AdminBulkOperationResultPropertyUnknown = 'Admin.Bulk.OperationResult.propertyUnknown',
  AdminBulkOperationResultRemoved = 'Admin.Bulk.OperationResult.removed',
  AdminBulkOperationResultResult = 'Admin.Bulk.OperationResult.result',
  AdminBulkOperationResultServicesEdited = 'Admin.Bulk.OperationResult.servicesEdited',
  AdminBulkOperationResultTitle = 'Admin.Bulk.OperationResult.title',
  AdminBulkOperationResultUsersEdited = 'Admin.Bulk.OperationResult.usersEdited',
  AdminCallGeneratorAgent = 'Admin.CallGenerator.agent',
  AdminCallGeneratorBlindTransfer = 'Admin.CallGenerator.blindTransfer',
  AdminCallGeneratorCallCreated = 'Admin.CallGenerator.callCreated',
  AdminCallGeneratorCallFailed = 'Admin.CallGenerator.callFailed',
  AdminCallGeneratorCallType = 'Admin.CallGenerator.callType',
  AdminCallGeneratorConnectTimeMinutes = 'Admin.CallGenerator.connectTimeMinutes',
  AdminCallGeneratorConsultant = 'Admin.CallGenerator.consultant',
  AdminCallGeneratorConsultationCall = 'Admin.CallGenerator.consultationCall',
  AdminCallGeneratorConsultationState = 'Admin.CallGenerator.consultationState',
  AdminCallGeneratorConversationEndsInFuture = 'Admin.CallGenerator.conversationEndsInFuture',
  AdminCallGeneratorConversationOptions = 'Admin.CallGenerator.conversationOptions',
  AdminCallGeneratorConversationType = 'Admin.CallGenerator.conversationType',
  AdminCallGeneratorConversationTypesAfterCallWork = 'Admin.CallGenerator.ConversationTypes.afterCallWork',
  AdminCallGeneratorConversationTypesConnected = 'Admin.CallGenerator.ConversationTypes.connected',
  AdminCallGeneratorConversationTypesDialingOut = 'Admin.CallGenerator.ConversationTypes.dialingOut',
  AdminCallGeneratorConversationTypesEstablishing = 'Admin.CallGenerator.ConversationTypes.establishing',
  AdminCallGeneratorConversationTypesHandled = 'Admin.CallGenerator.ConversationTypes.handled',
  AdminCallGeneratorConversationTypesInIvr = 'Admin.CallGenerator.ConversationTypes.inIvr',
  AdminCallGeneratorConversationTypesInIvrAfterQueue = 'Admin.CallGenerator.ConversationTypes.inIvrAfterQueue',
  AdminCallGeneratorConversationTypesInQueue = 'Admin.CallGenerator.ConversationTypes.inQueue',
  AdminCallGeneratorConversationTypesNotHandled = 'Admin.CallGenerator.ConversationTypes.notHandled',
  AdminCallGeneratorConversationTypesPutOnHold = 'Admin.CallGenerator.ConversationTypes.putOnHold',
  AdminCallGeneratorConversationTypesTransferring = 'Admin.CallGenerator.ConversationTypes.transferring',
  AdminCallGeneratorDispatcherType = 'Admin.CallGenerator.dispatcherType',
  AdminCallGeneratorEndReason = 'Admin.CallGenerator.endReason',
  AdminCallGeneratorGenerate = 'Admin.CallGenerator.generate',
  AdminCallGeneratorInitiator = 'Admin.CallGenerator.initiator',
  AdminCallGeneratorLink = 'Admin.CallGenerator.link',
  AdminCallGeneratorOpeningHours = 'Admin.CallGenerator.openingHours',
  AdminCallGeneratorOpeningHoursSpecial = 'Admin.CallGenerator.openingHoursSpecial',
  AdminCallGeneratorOrigin = 'Admin.CallGenerator.origin',
  AdminCallGeneratorOriginTeamName = 'Admin.CallGenerator.originTeamName',
  AdminCallGeneratorOutboundServiceCall = 'Admin.CallGenerator.outboundServiceCall',
  AdminCallGeneratorPolicyLevel = 'Admin.CallGenerator.policyLevel',
  AdminCallGeneratorQueueTimeMinutes = 'Admin.CallGenerator.queueTimeMinutes',
  AdminCallGeneratorReceiver = 'Admin.CallGenerator.receiver',
  AdminCallGeneratorTeamName = 'Admin.CallGenerator.teamName',
  AdminCallGeneratorTerminateDate = 'Admin.CallGenerator.terminateDate',
  AdminCallGeneratorTerminateTime = 'Admin.CallGenerator.terminateTime',
  AdminCallGeneratorTerminationReason = 'Admin.CallGenerator.terminationReason',
  AdminCallGeneratorTwoWeeksAgo = 'Admin.CallGenerator.twoWeeksAgo',
  AdminCallGeneratorUserSelected = 'Admin.CallGenerator.userSelected',
  AdminCallGeneratorUserSelectionMethod = 'Admin.CallGenerator.userSelectionMethod',
  AdminCallGeneratorWeekAgo = 'Admin.CallGenerator.weekAgo',
  AdminCardAnonymizeData = 'Admin.CardTitles.AnonymizeData',
  AdminCardChangeHistory = 'Admin.CardTitles.ChangeHistory',
  AdminCardCustomer = 'Admin.CardTitles.Customer',
  AdminCardExport = 'Admin.CardTitles.Export',
  AdminCardHistory = 'Admin.CardTitles.History',
  AdminCardInteractions = 'Admin.CardTitles.Interactions',
  AdminCardInteractionTimeline = 'Admin.CardTitles.InteractionTimeline',
  AdminCardLastInteraction = 'Admin.CardTitles.LastInteraction',
  AdminCardTaskManagement = 'Admin.CardTitles.TaskManagement',
  AdminCardTasks = 'Admin.CardTitles.Tasks',
  AdminCardTenant = 'Admin.CardTitles.Tenant',
  AdminCardTenantStates = 'Admin.CardTitles.TenantStates',
  AdminCardTotalSessions = 'Admin.CardTitles.TotalSessions',
  AdminCardTotalTeams = 'Admin.CardTitles.TotalTeams',
  AdminCardTotalUsers = 'Admin.CardTitles.TotalUsers',
  AdminChangeHistoryOpenDetails = 'Admin.ChangeHistory.openDetails',
  AdminCommonCustomRoleFeatureKeyServices = 'Admin.Common.customRoleFeatureKeyServices',
  AdminCommonCustomRoleFeatureKeyServicesDistributionTab = 'Admin.Common.customRoleFeatureKeyServicesDistributionTab',
  AdminCommonCustomRoleFeatureKeyServicesDistributionUsers = 'Admin.Common.customRoleFeatureKeyServicesDistributionUsers',
  AdminCommonCustomRoleFeatureKeyServicesExtensionsMySessions = 'Admin.Common.customRoleFeatureKeyServicesExtensionsMySessions',
  AdminCommonCustomRoleFeatureKeyServicesExtensionsTab = 'Admin.Common.customRoleFeatureKeyServicesExtensionsTab',
  AdminCommonCustomRoleFeatureKeyServicesGeneralTab = 'Admin.Common.customRoleFeatureKeyServicesGeneralTab',
  AdminCommonCustomRoleFeatureKeyServicesModalitiesTab = 'Admin.Common.customRoleFeatureKeyServicesModalitiesTab',
  AdminCommonCustomRoleFeatureKeyServicesReporting = 'Admin.Common.customRoleFeatureKeyServicesReporting',
  AdminCommonCustomRoleFeatureKeyServicesUsersTab = 'Admin.Common.customRoleFeatureKeyServicesUsersTab',
  AdminCommonCustomRoleFeatureKeyServicesUsersUsersList = 'Admin.Common.customRoleFeatureKeyServicesUsersUsersList',
  AdminCommonCustomRoleFeatureKeyUsers = 'Admin.Common.customRoleFeatureKeyUsers',
  AdminCommonCustomRoleFeatureKeyUsersDirectCallService = 'Admin.Common.customRoleFeatureKeyUsersDirectCallService',
  AdminCommonCustomRoleFeatureKeyUsersGeneral = 'Admin.Common.customRoleFeatureKeyUsersGeneral',
  AdminCommonCustomRoleFeatureKeyUsersSkills = 'Admin.Common.customRoleFeatureKeyUsersSkills',
  AdminCommonCustomRoleFieldManageUserProfiles = 'Admin.Common.customRoleFieldManageUserProfiles',
  AdminCommonFilterNoData = 'Admin.Common.filterNoData',
  AdminCommonInvalidFileDuration = 'Admin.Common.invalidFileDuration',
  AdminCommonNimbusPermissionKeyAssistantTemplates = 'Admin.Common.nimbusPermissionKeyAssistantTemplates',
  AdminCommonNimbusPermissionKeyBotTemplates = 'Admin.Common.nimbusPermissionKeyBotTemplates',
  AdminCommonNimbusPermissionKeyCallSessionResources = 'Admin.Common.nimbusPermissionKeyCallSessionResources',
  AdminCommonNimbusPermissionKeyCallerAnonymizationRegexes = 'Admin.Common.nimbusPermissionKeyCallerAnonymizationRegexes',
  AdminCommonNimbusPermissionKeyChangeHistory = 'Admin.Common.nimbusPermissionKeyChangeHistory',
  AdminCommonNimbusPermissionKeyChatHandlerDomainTemplates = 'Admin.Common.nimbusPermissionKeyChatHandlerDomainTemplates',
  AdminCommonNimbusPermissionKeyChatHandlerFileTypePolicies = 'Admin.Common.nimbusPermissionKeyChatHandlerFileTypePolicies',
  AdminCommonNimbusPermissionKeyChatHandlerMessagingEntries = 'Admin.Common.nimbusPermissionKeyChatHandlerMessagingEntries',
  AdminCommonNimbusPermissionKeyChatHandlerProviderConnectors = 'Admin.Common.nimbusPermissionKeyChatHandlerProviderConnectors',
  AdminCommonNimbusPermissionKeyCustomRoles = 'Admin.Common.nimbusPermissionKeyCustomRoles',
  AdminCommonNimbusPermissionKeyCustomerOverview = 'Admin.Common.nimbusPermissionKeyCustomerOverview',
  AdminCommonNimbusPermissionKeyDistributionPolicies = 'Admin.Common.nimbusPermissionKeyDistributionPolicies',
  AdminCommonNimbusPermissionKeyFeatureFlagVisibility = 'Admin.Common.nimbusPermissionKeyFeatureFlagVisibility',
  AdminCommonNimbusPermissionKeyInstantMessaging = 'Admin.Common.nimbusPermissionKeyInstantMessaging',
  AdminCommonNimbusPermissionKeyInteractTemplates = 'Admin.Common.nimbusPermissionKeyInteractTemplates',
  AdminCommonNimbusPermissionKeyMailboxes = 'Admin.Common.nimbusPermissionKeyMailboxes',
  AdminCommonNimbusPermissionKeyManageDirectCallUserTracking = 'Admin.Common.nimbusPermissionKeyManageDirectCallUserTracking',
  AdminCommonNimbusPermissionKeyNotAvailableReasons = 'Admin.Common.nimbusPermissionKeyNotAvailableReasons',
  AdminCommonNimbusPermissionKeyOpeningHours = 'Admin.Common.nimbusPermissionKeyOpeningHours',
  AdminCommonNimbusPermissionKeyOpeningHoursPeriods = 'Admin.Common.nimbusPermissionKeyOpeningHoursPeriods',
  AdminCommonNimbusPermissionKeyPolicies = 'Admin.Common.nimbusPermissionKeyPolicies',
  AdminCommonNimbusPermissionKeyPresenceTracking = 'Admin.Common.nimbusPermissionKeyPresenceTracking',
  AdminCommonNimbusPermissionKeyResponsibilityProfiles = 'Admin.Common.nimbusPermissionKeyResponsibilityProfiles',
  AdminCommonNimbusPermissionKeyServiceCompanionTab = 'Admin.Common.nimbusPermissionKeyServiceCompanionTab',
  AdminCommonNimbusPermissionKeyServicesAssistant = 'Admin.Common.nimbusPermissionKeyServicesAssistant',
  AdminCommonNimbusPermissionKeyServicesAssistantConversationContextsList = 'Admin.Common.nimbusPermissionKeyServicesAssistantConversationContextsList',
  AdminCommonNimbusPermissionKeyServicesAssistantTemplatesList = 'Admin.Common.nimbusPermissionKeyServicesAssistantTemplatesList',
  AdminCommonNimbusPermissionKeyServicesAttendantConsole = 'Admin.Common.nimbusPermissionKeyServicesAttendantConsole',
  AdminCommonNimbusPermissionKeyServicesCodes = 'Admin.Common.nimbusPermissionKeyServicesCodes',
  AdminCommonNimbusPermissionKeyServicesCodesList = 'Admin.Common.nimbusPermissionKeyServicesCodesList',
  AdminCommonNimbusPermissionKeyServicesCompanionSpeechRecognizersList = 'Admin.Common.nimbusPermissionKeyServicesCompanionSpeechRecognizersList',
  AdminCommonNimbusPermissionKeyServicesCompanionUnify = 'Admin.Common.nimbusPermissionKeyServicesCompanionUnify',
  AdminCommonNimbusPermissionKeyServicesCompanionUnifyTranscriptionLocalesList = 'Admin.Common.nimbusPermissionKeyServicesCompanionUnifyTranscriptionLocalesList',
  AdminCommonNimbusPermissionKeyServicesContextParametersList = 'Admin.Common.nimbusPermissionKeyServicesContextParametersList',
  AdminCommonNimbusPermissionKeyServicesDataPrivacy = 'Admin.Common.nimbusPermissionKeyServicesDataPrivacy',
  AdminCommonNimbusPermissionKeyServicesDataPrivacyCallerAnonymizationRegexesList = 'Admin.Common.nimbusPermissionKeyServicesDataPrivacyCallerAnonymizationRegexesList',
  AdminCommonNimbusPermissionKeyServicesDataPrivacyFileTypePoliciesList = 'Admin.Common.nimbusPermissionKeyServicesDataPrivacyFileTypePoliciesList',
  AdminCommonNimbusPermissionKeyServicesDistributionAcw = 'Admin.Common.nimbusPermissionKeyServicesDistributionAcw',
  AdminCommonNimbusPermissionKeyServicesDistributionConversationsDistribution = 'Admin.Common.nimbusPermissionKeyServicesDistributionConversationsDistribution',
  AdminCommonNimbusPermissionKeyServicesDistributionEmergencyRouting = 'Admin.Common.nimbusPermissionKeyServicesDistributionEmergencyRouting',
  AdminCommonNimbusPermissionKeyServicesDistributionPersistentRona = 'Admin.Common.nimbusPermissionKeyServicesDistributionPersistentRona',
  AdminCommonNimbusPermissionKeyServicesDistributionPoliciesList = 'Admin.Common.nimbusPermissionKeyServicesDistributionPoliciesList',
  AdminCommonNimbusPermissionKeyServicesDistributionTaskPriority = 'Admin.Common.nimbusPermissionKeyServicesDistributionTaskPriority',
  AdminCommonNimbusPermissionKeyServicesDistributionUsersAssignment = 'Admin.Common.nimbusPermissionKeyServicesDistributionUsersAssignment',
  AdminCommonNimbusPermissionKeyServicesDistributionUsersDefaultEnability = 'Admin.Common.nimbusPermissionKeyServicesDistributionUsersDefaultEnability',
  AdminCommonNimbusPermissionKeyServicesGeneral = 'Admin.Common.nimbusPermissionKeyServicesGeneral',
  AdminCommonNimbusPermissionKeyServicesGeneralOrganizationUnit = 'Admin.Common.nimbusPermissionKeyServicesGeneralOrganizationUnit',
  AdminCommonNimbusPermissionKeyServicesInteract = 'Admin.Common.nimbusPermissionKeyServicesInteract',
  AdminCommonNimbusPermissionKeyServicesInteractDomainTemplatesList = 'Admin.Common.nimbusPermissionKeyServicesInteractDomainTemplatesList',
  AdminCommonNimbusPermissionKeyServicesLicencesAndAddons = 'Admin.Common.nimbusPermissionKeyServicesLicencesAndAddons',
  AdminCommonNimbusPermissionKeyServicesList = 'Admin.Common.nimbusPermissionKeyServicesList',
  AdminCommonNimbusPermissionKeyServicesModalitiesAudioVideo = 'Admin.Common.nimbusPermissionKeyServicesModalitiesAudioVideo',
  AdminCommonNimbusPermissionKeyServicesModalitiesEmail = 'Admin.Common.nimbusPermissionKeyServicesModalitiesEmail',
  AdminCommonNimbusPermissionKeyServicesModalitiesEmailMailboxesList = 'Admin.Common.nimbusPermissionKeyServicesModalitiesEmailMailboxesList',
  AdminCommonNimbusPermissionKeyServicesModalitiesExternalTask = 'Admin.Common.nimbusPermissionKeyServicesModalitiesExternalTask',
  AdminCommonNimbusPermissionKeyServicesModalitiesGeneral = 'Admin.Common.nimbusPermissionKeyServicesModalitiesGeneral',
  AdminCommonNimbusPermissionKeyServicesModalitiesInstantMessaging = 'Admin.Common.nimbusPermissionKeyServicesModalitiesInstantMessaging',
  AdminCommonNimbusPermissionKeyServicesModalitiesInstantMessagingList = 'Admin.Common.nimbusPermissionKeyServicesModalitiesInstantMessagingList',
  AdminCommonNimbusPermissionKeyServicesModalitiesMessagingEntriesList = 'Admin.Common.nimbusPermissionKeyServicesModalitiesMessagingEntriesList',
  AdminCommonNimbusPermissionKeyServicesModalitiesSpeechRecognizersList = 'Admin.Common.nimbusPermissionKeyServicesModalitiesSpeechRecognizersList',
  AdminCommonNimbusPermissionKeyServicesMySessionsConversationContextData = 'Admin.Common.nimbusPermissionKeyServicesMySessionsConversationContextData',
  AdminCommonNimbusPermissionKeyServicesMySessionsConversationContextUrls = 'Admin.Common.nimbusPermissionKeyServicesMySessionsConversationContextUrls',
  AdminCommonNimbusPermissionKeyServicesMySessionsKeepContextOnTransfer = 'Admin.Common.nimbusPermissionKeyServicesMySessionsKeepContextOnTransfer',
  AdminCommonNimbusPermissionKeyServicesMySessionsWidgets = 'Admin.Common.nimbusPermissionKeyServicesMySessionsWidgets',
  AdminCommonNimbusPermissionKeyServicesNimbusOneConversationContextUrls = 'Admin.Common.nimbusPermissionKeyServicesNimbusOneConversationContextUrls',
  AdminCommonNimbusPermissionKeyServicesNimbusOneSessionParameters = 'Admin.Common.nimbusPermissionKeyServicesNimbusOneSessionParameters',
  AdminCommonNimbusPermissionKeyServicesOpeningHours = 'Admin.Common.nimbusPermissionKeyServicesOpeningHours',
  AdminCommonNimbusPermissionKeyServicesOpeningHoursList = 'Admin.Common.nimbusPermissionKeyServicesOpeningHoursList',
  AdminCommonNimbusPermissionKeyServicesPermissionsMembers = 'Admin.Common.nimbusPermissionKeyServicesPermissionsMembers',
  AdminCommonNimbusPermissionKeyServicesPermissionsMembersSkillsAndProfile = 'Admin.Common.nimbusPermissionKeyServicesPermissionsMembersSkillsAndProfile',
  AdminCommonNimbusPermissionKeyServicesPermissionsUsersList = 'Admin.Common.nimbusPermissionKeyServicesPermissionsUsersList',
  AdminCommonNimbusPermissionKeyServicesReportingSlaAndThresholds = 'Admin.Common.nimbusPermissionKeyServicesReportingSlaAndThresholds',
  AdminCommonNimbusPermissionKeyServicesReportingVisibility = 'Admin.Common.nimbusPermissionKeyServicesReportingVisibility',
  AdminCommonNimbusPermissionKeyServicesTasksList = 'Admin.Common.nimbusPermissionKeyServicesTasksList',
  AdminCommonNimbusPermissionKeyServicesUsersDefaultTeamOwnerRole = 'Admin.Common.nimbusPermissionKeyServicesUsersDefaultTeamOwnerRole',
  AdminCommonNimbusPermissionKeyServicesUsersList = 'Admin.Common.nimbusPermissionKeyServicesUsersList',
  AdminCommonNimbusPermissionKeyServicesUsersListRoles = 'Admin.Common.nimbusPermissionKeyServicesUsersListRoles',
  AdminCommonNimbusPermissionKeyServicesUsersListStates = 'Admin.Common.nimbusPermissionKeyServicesUsersListStates',
  AdminCommonNimbusPermissionKeyServicesUsersTeamMemberCanChangeActiveState = 'Admin.Common.nimbusPermissionKeyServicesUsersTeamMemberCanChangeActiveState',
  AdminCommonNimbusPermissionKeySkillCategories = 'Admin.Common.nimbusPermissionKeySkillCategories',
  AdminCommonNimbusPermissionKeySkills = 'Admin.Common.nimbusPermissionKeySkills',
  AdminCommonNimbusPermissionKeySkillsWithCategoriesList = 'Admin.Common.nimbusPermissionKeySkillsWithCategoriesList',
  AdminCommonNimbusPermissionKeyUiConfigurationProfiles = 'Admin.Common.nimbusPermissionKeyUiConfigurationProfiles',
  AdminCommonNimbusPermissionKeyUserEffectiveSettings = 'Admin.Common.nimbusPermissionKeyUserEffectiveSettings',
  AdminCommonNimbusPermissionKeyUsersAssistant = 'Admin.Common.nimbusPermissionKeyUsersAssistant',
  AdminCommonNimbusPermissionKeyUsersAssistantTemplatesList = 'Admin.Common.nimbusPermissionKeyUsersAssistantTemplatesList',
  AdminCommonNimbusPermissionKeyUsersDirectCallService = 'Admin.Common.nimbusPermissionKeyUsersDirectCallService',
  AdminCommonNimbusPermissionKeyUsersDirectCallServiceDescription = 'Admin.Common.nimbusPermissionKeyUsersDirectCallServiceDescription',
  AdminCommonNimbusPermissionKeyUsersGeneral = 'Admin.Common.nimbusPermissionKeyUsersGeneral',
  AdminCommonNimbusPermissionKeyUsersGeneralOrganizationUnit = 'Admin.Common.nimbusPermissionKeyUsersGeneralOrganizationUnit',
  AdminCommonNimbusPermissionKeyUsersInteract = 'Admin.Common.nimbusPermissionKeyUsersInteract',
  AdminCommonNimbusPermissionKeyUsersInteractDomainTemplatesList = 'Admin.Common.nimbusPermissionKeyUsersInteractDomainTemplatesList',
  AdminCommonNimbusPermissionKeyUsersInteractInstantMessagingList = 'Admin.Common.nimbusPermissionKeyUsersInteractInstantMessagingList',
  AdminCommonNimbusPermissionKeyUsersLicencesAndModalities = 'Admin.Common.nimbusPermissionKeyUsersLicencesAndModalities',
  AdminCommonNimbusPermissionKeyUsersList = 'Admin.Common.nimbusPermissionKeyUsersList',
  AdminCommonNimbusPermissionKeyUsersNotAvailableReasons = 'Admin.Common.nimbusPermissionKeyUsersNotAvailableReasons',
  AdminCommonNimbusPermissionKeyUsersNotAvailableReasonsList = 'Admin.Common.nimbusPermissionKeyUsersNotAvailableReasonsList',
  AdminCommonNimbusPermissionKeyUsersReporting = 'Admin.Common.nimbusPermissionKeyUsersReporting',
  AdminCommonNimbusPermissionKeyUsersResponsibilityProfiles = 'Admin.Common.nimbusPermissionKeyUsersResponsibilityProfiles',
  AdminCommonNimbusPermissionKeyUsersResponsibilityProfilesList = 'Admin.Common.nimbusPermissionKeyUsersResponsibilityProfilesList',
  AdminCommonNimbusPermissionKeyUsersRoles = 'Admin.Common.nimbusPermissionKeyUsersRoles',
  AdminCommonNimbusPermissionKeyUsersServices = 'Admin.Common.nimbusPermissionKeyUsersServices',
  AdminCommonNimbusPermissionKeyUsersSkillsAssignment = 'Admin.Common.nimbusPermissionKeyUsersSkillsAssignment',
  AdminCommonNimbusPermissionKeyUsersSkillsLevels = 'Admin.Common.nimbusPermissionKeyUsersSkillsLevels',
  AdminCommonNimbusPermissionKeyUsersSkillsWithCategoriesList = 'Admin.Common.nimbusPermissionKeyUsersSkillsWithCategoriesList',
  AdminCommonNimbusPermissionKeyUsersUiAccess = 'Admin.Common.nimbusPermissionKeyUsersUiAccess',
  AdminCommonNimbusPermissionKeyVirtualUserAuthenticationList = 'Admin.Common.nimbusPermissionKeyVirtualUserAuthenticationList',
  AdminCommonNimbusPermissionKeyVirtualUsers = 'Admin.Common.nimbusPermissionKeyVirtualUsers',
  AdminCommonNimbusPermissionKeyWorkflows = 'Admin.Common.nimbusPermissionKeyWorkflows',
  AdminCommonNimbusUserStateInactive = 'Admin.Common.nimbusUserStateInactive',
  AdminCommonNimbusUserStateNotReady = 'Admin.Common.nimbusUserStateNotReady',
  AdminCommonNimbusUserStateReady = 'Admin.Common.nimbusUserStateReady',
  AdminCommonTenant = 'Admin.Common.tenant',
  AdminCommonTenants = 'Admin.Common.tenants',
  AdminDialogsAssignOrganizationUnitsTitle = 'Admin.Dialogs.assignOrganizationUnitsTitle',
  AdminExternalToolsUrl = 'Admin.ExternalTools.url',
  AdminGroupSelectionControlNoPartner = 'Admin.GroupSelectionControl.noPartner',
  AdminGroupSelectionControlNoTeam = 'Admin.GroupSelectionControl.noTeam',
  AdminGroupSelectionControlNoTenant = 'Admin.GroupSelectionControl.noTenant',
  AdminLicense = 'Admin.Licenses.singleTitle',
  AdminLicenseAddonsAllowTaskActivationWhileInActiveTaskDetails = 'Admin.LicenseAddons.allowTaskActivationWhileInActiveTaskDetails',
  AdminLicenseAddonsAudioVideoDetails = 'Admin.LicenseAddons.audioVideoDetails',
  AdminLicenseAddonsEmailDetails = 'Admin.LicenseAddons.emailDetails',
  AdminLicenseAddonsExternalTaskDetails = 'Admin.LicenseAddons.externalTaskDetails',
  AdminLicenseAddonsInstantMessagingDetails = 'Admin.LicenseAddons.instantMessagingDetails',
  AdminLicenseAddonsInteractDetails = 'Admin.LicenseAddons.interactDetails',
  AdminLicenseAddonsTaskParallelizationDetails = 'Admin.LicenseAddons.taskParallelizationDetails',
  AdminLicenseDetailsAttendantConsole = 'Admin.LicenseDetails.attendantConsole',
  AdminLicenseDetailsVirtualUser = 'Admin.LicenseDetails.virtualUser',
  AdminLicenseUsageDaysCount = 'Admin.LicenseUsage.daysCount',
  AdminLicenseUsageMonthsCount = 'Admin.LicenseUsage.monthsCount',
  AdminLicenses = 'Admin.Licenses.title',
  AdminLicensesAdvanced = 'Admin.Licenses.advanced',
  AdminLicensesAdvancedInfoSettings = 'Admin.Licenses.advancedInfoSettings',
  AdminLicensesAssistant = 'Admin.Licenses.assistant',
  AdminLicensesAssistantInfo = 'Admin.Licenses.assistantInfo',
  AdminLicensesAttendantConsole = 'Admin.Licenses.attendantConsole',
  AdminLicensesContactCenter = 'Admin.Licenses.contactCenter',
  AdminLicensesContactCenterInfo = 'Admin.Licenses.contactCenterInfo',
  AdminLicensesContactCenterInfoSettings = 'Admin.Licenses.contactCenterInfoSettings',
  AdminLicensesEnterprise = 'Admin.Licenses.enterprise',
  AdminLicensesEnterpriseInfoSettings = 'Admin.Licenses.enterpriseInfoSettings',
  AdminLicensesInteractInfo = 'Admin.Licenses.interactInfo',
  AdminLicensesMore = 'Admin.Licenses.more',
  AdminLicensesWebInteract = 'Admin.Licenses.webInteract',
  AdminLicensingAddService = 'Admin.Licensing.addService',
  AdminLicensingAddUser = 'Admin.Licensing.addUser',
  AdminLicensingAddVirtualUser = 'Admin.Licensing.addVirtualUser',
  AdminLicensingAdded = 'Admin.Licensing.added',
  AdminLicensingAdvanced = 'Admin.Licensing.advanced',
  AdminLicensingAllServices = 'Admin.Licensing.allServices',
  AdminLicensingAssistant = 'Admin.Licensing.assistant',
  AdminLicensingAttendantConsole = 'Admin.Licensing.attendantConsole',
  AdminLicensingAudioVideo = 'Admin.Licensing.audioVideo',
  AdminLicensingAvailable = 'Admin.Licensing.available',
  AdminLicensingCompanion = 'Admin.Licensing.companion',
  AdminLicensingCompanionInfo = 'Admin.Licensing.companionInfo',
  AdminLicensingContactCenterService = 'Admin.Licensing.contactCenterService',
  AdminLicensingContactCenterUser = 'Admin.Licensing.contactCenterUser',
  AdminLicensingContactSupport = 'Admin.Licensing.contactSupport',
  AdminLicensingDirectCallHandling = 'Admin.Licensing.directCallHandling',
  AdminLicensingDirectCallHandlingInfo = 'Admin.Licensing.directCallHandlingInfo',
  AdminLicensingDomain = 'Admin.Licensing.domain',
  AdminLicensingEdit = 'Admin.Licensing.edit',
  AdminLicensingEmail = 'Admin.Licensing.email',
  AdminLicensingEnterprise = 'Admin.Licensing.enterprise',
  AdminLicensingExternalTask = 'Admin.Licensing.externalTask',
  AdminLicensingFalse = 'Admin.Licensing.false',
  AdminLicensingInstantMessaging = 'Admin.Licensing.instantMessaging',
  AdminLicensingInsufficientLicenses = 'Admin.Licensing.insufficientLicenses',
  AdminLicensingInsufficientLicensesDetected = 'Admin.Licensing.insufficientLicensesDetected',
  AdminLicensingInsufficientLicensing = 'Admin.Licensing.insufficientLicensing',
  AdminLicensingLicenseFrom = 'Admin.Licensing.licenseFrom',
  AdminLicensingLicenseState = 'Admin.Licensing.licenseState',
  AdminLicensingLicenseTo = 'Admin.Licensing.licenseTo',
  AdminLicensingLicenseType = 'Admin.Licensing.licenseType',
  AdminLicensingLicenses = 'Admin.Licensing.licenses',
  AdminLicensingLicensesFree = 'Admin.Licensing.licensesFree',
  AdminLicensingLicensesSet = 'Admin.Licensing.licensesSet',
  AdminLicensingLicensesUsed = 'Admin.Licensing.licensesUsed',
  AdminLicensingModalsRemoveService = 'Admin.LicensingModals.removeService',
  AdminLicensingModalsRemoveUser = 'Admin.LicensingModals.removeUser',
  AdminLicensingNoLicenses = 'Admin.Licensing.noLicenses',
  AdminLicensingNoLicensesAvailable = 'Admin.Licensing.noLicensesAvailable',
  AdminLicensingNoLicensesAvailableDetails = 'Admin.Licensing.noLicensesAvailableDetails',
  AdminLicensingPageTitle = 'Admin.Licensing.pageTitle',
  AdminLicensingPartiallyAppliedChanges = 'Admin.Licensing.partiallyAppliedChanges',
  AdminLicensingPartner = 'Admin.Licensing.partner',
  AdminLicensingRemoved = 'Admin.Licensing.removed',
  AdminLicensingSaveError = 'Admin.Licensing.saveError',
  AdminLicensingSaveSuccess = 'Admin.Licensing.saveSuccess',
  AdminLicensingServiceInteract = 'Admin.Licensing.serviceInteract',
  AdminLicensingServicesLicenses = 'Admin.Licensing.servicesLicenses',
  AdminLicensingSufficientLicensing = 'Admin.Licensing.sufficientLicensing',
  AdminLicensingTenant = 'Admin.Licensing.tenant',
  AdminLicensingTenantName = 'Admin.Licensing.tenantName',
  AdminLicensingTenantState = 'Admin.Licensing.tenantState',
  AdminLicensingTenants = 'Admin.Licensing.tenants',
  AdminLicensingTrue = 'Admin.Licensing.true',
  AdminLicensingUndo = 'Admin.Licensing.undo',
  AdminLicensingUpdated = 'Admin.Licensing.updated',
  AdminLicensingUserInteract = 'Admin.Licensing.userInteract',
  AdminLicensingUsersLicenses = 'Admin.Licensing.usersLicenses',
  AdminLicensingVirtualUser = 'Admin.Licensing.virtualUser',
  AdminLicensingVirtualUserPreview = 'Admin.Licensing.virtualUserPreview',
  AdminOperationsChangeHistoryCopiedFrom = 'Admin.Operations.changeHistoryCopiedFrom',
  AdminOperationsChangeHistoryDetailsAdded = 'Admin.Operations.changeHistoryDetailsAdded',
  AdminOperationsChangeHistoryDetailsEmpty = 'Admin.Operations.changeHistoryDetailsEmpty',
  AdminOperationsChangeHistoryDetailsLocation = 'Admin.Operations.changeHistoryDetailsLocation',
  AdminOperationsChangeHistoryDetailsNewValue = 'Admin.Operations.changeHistoryDetailsNewValue',
  AdminOperationsChangeHistoryDetailsProperty = 'Admin.Operations.changeHistoryDetailsProperty',
  AdminOperationsChangeHistoryDetailsRemoved = 'Admin.Operations.changeHistoryDetailsRemoved',
  AdminOperationsChangeHistoryDetailsSuspended = 'Admin.Operations.changeHistoryDetailsSuspended',
  AdminOperationsChangeHistoryDetailsUnknown = 'Admin.Operations.changeHistoryDetailsUnknown',
  AdminOperationsChangeHistoryDetailsUnknownLocation = 'Admin.Operations.changeHistoryDetailsUnknownLocation',
  AdminOperationsChangeHistoryDetailsUpdated = 'Admin.Operations.changeHistoryDetailsUpdated',
  AdminOperationsChangeHistoryEntityTypeService = 'Admin.Operations.changeHistoryEntityTypeService',
  AdminOperationsChangeHistoryEntityTypeUser = 'Admin.Operations.changeHistoryEntityTypeUser',
  AdminOperationsChangeHistoryOperationTypeCopy = 'Admin.Operations.changeHistoryOperationTypeCopy',
  AdminOperationsChangeHistoryOperationTypeCreate = 'Admin.Operations.changeHistoryOperationTypeCreate',
  AdminOperationsChangeHistoryOperationTypeDelete = 'Admin.Operations.changeHistoryOperationTypeDelete',
  AdminOperationsChangeHistoryOperationTypeResume = 'Admin.Operations.changeHistoryOperationTypeResume',
  AdminOperationsChangeHistoryOperationTypeSuspend = 'Admin.Operations.changeHistoryOperationTypeSuspend',
  AdminOperationsChangeHistoryOperationTypeUpdate = 'Admin.Operations.changeHistoryOperationTypeUpdate',
  AdminOperationsCopyTraceLink = 'Admin.Operations.copyTraceLink',
  AdminOperationsCopyTraceLinkError = 'Admin.Operations.copyTraceLinkError',
  AdminOperationsCopyTraceLinkNotAvailableForAcs = 'Admin.Operations.copyTraceLinkNotAvailableForAcs',
  AdminOperationsFeatureFlagVisibilityFilterDisabled = 'Admin.Operations.featureFlagVisibilityFilterDisabled',
  AdminOperationsFeatureFlagVisibilityFilterEnabled = 'Admin.Operations.featureFlagVisibilityFilterEnabled',
  AdminOperationsFeatureFlagVisibilityFilterStatus = 'Admin.Operations.featureFlagVisibilityFilterStatus',
  AdminOperationsFeatureFlagVisibilityListDisplayName = 'Admin.Operations.featureFlagVisibilityListDisplayName',
  AdminOperationsFeatureFlagVisibilityListIdentifier = 'Admin.Operations.featureFlagVisibilityListIdentifier',
  AdminOperationsFeatureFlagVisibilityListIsEnabled = 'Admin.Operations.featureFlagVisibilityListIsEnabled',
  AdminOperationsFeatureFlagVisibilityPageTitle = 'Admin.Operations.featureFlagVisibilityPageTitle',
  AdminOperationsFeatureFlagVisibilitySearchPlaceholder = 'Admin.Operations.featureFlagVisibilitySearchPlaceholder',
  AdminOperationsInfo = 'Admin.Operations.info',
  AdminOperationsLastInteractionDataTime = 'Admin.Operations.LastInteraction.dateTime',
  AdminOperationsLastInteractionDuration = 'Admin.Operations.LastInteraction.duration',
  AdminOperationsLastInteractionInitialService = 'Admin.Operations.LastInteraction.initialService',
  AdminOperationsLastInteractionResult = 'Admin.Operations.LastInteraction.result',
  AdminOperationsChangeHistoryEntityTypeTenant = 'Admin.Operations.ChangeHistory.EntityType.Tenant',
  AdminOperationsChangeHistoryEntityTypeDirectCallService = 'Admin.Operations.ChangeHistory.EntityType.DirectCallService',
  AdminOperationsChangeHistoryUserNimbusUnifyConsent = 'Admin.Operations.ChangeHistory.User.NimbusUnifyConsent',
  AdminOperationsChangeHistoryUserDirectCalls = 'Admin.Operations.ChangeHistory.User.DirectCalls',
  AdminOperationsChangeHistoryTenantDirectCallTrackingEnabled = 'Admin.Operations.ChangeHistory.Tenant.DirectCallTracking.Enabled',
  AdminOperationsChangeHistoryTenantDirectCallTrackingDisabled = 'Admin.Operations.ChangeHistory.Tenant.DirectCallTracking.Disabled',
  AdminOperationsChangeHistoryTenantDirectCallTrackingProvisioningInProgress = 'Admin.Operations.ChangeHistory.Tenant.DirectCallTracking.ProvisioningInProgress',
  AdminOperationsListChangedBy = 'Admin.Operations.listChangedBy',
  AdminOperationsListCustomer = 'Admin.Operations.listCustomer',
  AdminOperationsListDateTime = 'Admin.Operations.listDateTime',
  AdminOperationsListDetailsApplicationId = 'Admin.Operations.listDetailsApplicationId',
  AdminOperationsListDetailsEntityName = 'Admin.Operations.listDetailsEntityName',
  AdminOperationsListDetailsEntityType = 'Admin.Operations.listDetailsEntityType',
  AdminOperationsListDetailsIPAddress = 'Admin.Operations.listDetailsIPAddress',
  AdminOperationsListDetailsOperationDetail = 'Admin.Operations.listDetailsOperationDetail',
  AdminOperationsListDetailsOperationDetailAadSynchronization = 'Admin.Operations.listDetailsOperationDetailAadSynchronization',
  AdminOperationsListDetailsOperationDetailCleanupJob = 'Admin.Operations.listDetailsOperationDetailCleanupJob',
  AdminOperationsListDetailsOperationDetailMsTeams = 'Admin.Operations.listDetailsOperationDetailMsTeams',
  AdminOperationsListDetailsOperationDetailNimbusPowershellProvisioning = 'Admin.Operations.listDetailsOperationDetailNimbusPowershellProvisioning',
  AdminOperationsListDetailsOperationDetailPublicApi = 'Admin.Operations.listDetailsOperationDetailPublicApi',
  AdminOperationsListDirection = 'Admin.Operations.listDirection',
  AdminOperationsListDirectionWithModality = 'Admin.Operations.List.directionWithModality',
  AdminOperationsListDuration = 'Admin.Operations.listDuration',
  AdminOperationsListEntityId = 'Admin.Operations.listEntityId',
  AdminOperationsListEntityName = 'Admin.Operations.listEntityName',
  AdminOperationsListEntityType = 'Admin.Operations.listEntityType',
  AdminOperationsListFirstAccepted = 'Admin.Operations.listFirstAccepted',
  AdminOperationsListFirstAcceptedUser = 'Admin.Operations.listFirstAcceptedUser',
  AdminOperationsListFirstQueueService = 'Admin.Operations.listFirstQueueService',
  AdminOperationsListInitialModality = 'Admin.Operations.listInitialModality',
  AdminOperationsListInitialService = 'Admin.Operations.listInitialService',
  AdminOperationsListIssues = 'Admin.Operations.listIssues',
  AdminOperationsListLastConnectedUser = 'Admin.Operations.listLastConnectedUser',
  AdminOperationsListOpeningHours = 'Admin.Operations.listOpeningHours',
  AdminOperationsListOperationType = 'Admin.Operations.listOperationType',
  AdminOperationsListQueued = 'Admin.Operations.listQueued',
  AdminOperationsListResult = 'Admin.Operations.listResult',
  AdminOperationsListState = 'Admin.Operations.listState',
  AdminOperationsListTimeInState = 'Admin.Operations.listTimeInState',
  AdminOperationsListUsers = 'Admin.Operations.listUsers',
  AdminOperationsManageAccountNotAddedAsGuest = 'Admin.OperationsManage.accountNotAddedAsGuest',
  AdminOperationsManageAddAccount = 'Admin.Operations.Manage.addAccount',
  AdminOperationsManageChangesBeenSaved = 'Admin.Operations.Manage.changesBeenSaved',
  AdminOperationsManageCooldownTimer = 'Admin.Operations.Manage.coolDownTimer',
  AdminOperationsManageError = 'Admin.Operations.Manage.error',
  AdminOperationsManageFeatures = 'Admin.Operations.Manage.features',
  AdminOperationsManageFeaturesExport = 'Admin.Operations.Manage.featuresExport',
  AdminOperationsManageFeaturesReadOnly = 'Admin.Operations.Manage.featuresReadOnly',
  AdminOperationsManageGuestIMServiceAccounts = 'Admin.Operations.Manage.guestIMServiceAccounts',
  AdminOperationsManageGuestPresenceServiceAccounts = 'Admin.Operations.Manage.guestPresenceServiceAccounts',
  AdminOperationsManageHours = 'Admin.Operations.Manage.hours',
  AdminOperationsManageImMaxMessages = 'Admin.Operations.Manage.imMaxMessages',
  AdminOperationsManageImPrimaryUpn = 'Admin.Operations.Manage.imPrimaryUpn',
  AdminOperationsManageImSecondaryUpn = 'Admin.Operations.Manage.imSecondaryUpn',
  AdminOperationsManageInvalidCredential = 'Admin.Operations.Manage.invalidCredential',
  AdminOperationsManageInvalidCredentials = 'Admin.OperationsManage.invalidCredentials',
  AdminOperationsManageInvalidLicense = 'Admin.Operations.Manage.invalidLicense',
  AdminOperationsManageLinkToGrantConsent = 'Admin.OperationsManage.linkToGrantConsent',
  AdminOperationsManageMaximumTextToSpeechCharacters = 'Admin.Operations.Manage.maximumTextToSpeechCharacters',
  AdminOperationsManageMS = 'Admin.Operations.Manage.ms',
  AdminOperationsManageNoServiceAccountWorks = 'Admin.OperationsManage.noServiceAccountWorks',
  AdminOperationsManagePassword = 'Admin.Operations.Manage.password',
  AdminOperationsManagePermissionIsMissing = 'Admin.OperationsManage.permissionIsMissing',
  AdminOperationsManagePollingInterval = 'Admin.Operations.Manage.pollingInterval',
  AdminOperationsManagePresenceServiceAccounts = 'Admin.Operations.Manage.presenceServiceAccounts',
  AdminOperationsManagePresenceUsersPerServiceAccount = 'Admin.OperationsManage.presenceUsersPerServiceAccount',
  AdminOperationsManagePrimaryPassword = 'Admin.Operations.Manage.primaryPassword',
  AdminOperationsManagePrimaryUpn = 'Admin.Operations.Manage.primaryUpn',
  AdminOperationsManageSecondaryPassword = 'Admin.Operations.Manage.secondaryPassword',
  AdminOperationsManageSecondaryUpn = 'Admin.Operations.Manage.secondaryUpn',
  AdminOperationsManageSuccessful = 'Admin.Operations.Manage.successful',
  AdminOperationsManageTextToSpeech = 'Admin.Operations.Manage.textToSpeech',
  AdminOperationsManageTextToSpeechLoadingFailed = 'Admin.Operations.Manage.textToSpeechLoadingFailed',
  AdminOperationsManageTitle = 'Admin.OperationsManage.title',
  AdminOperationsManageTtsCachingTimeoutInHours = 'Admin.Operations.Manage.ttsCachingTimeoutInHours',
  AdminOperationsManageUnknownErrorCode = 'Admin.OperationsManage.unknownErrorCode',
  AdminOperationsManageUpdateFailed = 'Admin.Operations.Manage.updateFailed',
  AdminOperationsManageUpdating = 'Admin.Operations.Manage.updating',
  AdminOperationsManageUsername = 'Admin.Operations.Manage.username',
  AdminOperationsRefresh = 'Admin.Operations.refresh',
  AdminOperationsRefreshLast = 'Admin.Operations.refreshLast',
  AdminOperationsSearchCustomer = 'Admin.Operations.Search.customer',
  AdminOperationsSearchForCustomer = 'Admin.Operations.searchForCustomer',
  AdminOperationsSearchForService = 'Admin.Operations.searchForService',
  AdminOperationsSearchOpeningHours = 'Admin.Operations.Search.openningHours',
  AdminOperationsTaskManagementBulkRemoveConfirm = 'Admin.Operations.taskManagementBulkRemoveConfirm',
  AdminOperationsTaskManagementBulkRemoveFailed = 'Admin.Operations.taskManagementBulkRemoveFailed',
  AdminOperationsTaskManagementBulkRemoveSucceeded = 'Admin.Operations.taskManagementBulkRemoveSucceeded',
  AdminOperationsTaskManagementListDirection = 'Admin.Operations.taskManagementListDirection',
  AdminOperationsTaskManagementListModality = 'Admin.Operations.taskManagementListModality',
  AdminOperationsTaskManagementListService = 'Admin.Operations.taskManagementListService',
  AdminOperationsTaskManagementListSource = 'Admin.Operations.taskManagementListSource',
  AdminOperationsTaskManagementListStartedTime = 'Admin.Operations.taskManagementListStartedTime',
  AdminOperationsTaskManagementListState = 'Admin.Operations.taskManagementListState',
  AdminOperationsTaskManagementListTimeInState = 'Admin.Operations.taskManagementListTimeInState',
  AdminOperationsTaskManagementListUser = 'Admin.Operations.taskManagementListUser',
  AdminOperationsTaskManagementListUsers = 'Admin.Operations.taskManagementListUsers',
  AdminOperationsTaskManagementRemoveSucceeded = 'Admin.Operations.taskManagementRemoveSucceeded',
  AdminOperationsUpdate = 'Admin.Operations.update',
  AdminOperationsUpdateLast = 'Admin.Operations.updateLast',
  AdminOverviewGridsServiceTotalSessionsLast14Days = 'Admin.OverviewGrids.serviceTotalSessionsLast14Days',
  AdminOverviewGridsSince = 'Admin.OverviewGrids.since',
  AdminOverviewGridsTenantTotalSessionsLast14Days = 'Admin.OverviewGrids.tenantTotalSessionsLast14Days',
  AdminPartnerDetailsPhoneNumberE164 = 'Admin.PartnerDetails.phoneNumberE164',
  AdminPartnersAdministrationSecurityGroup = 'Admin.Partners.administrationSecurityGroup',
  AdminPartnersCompanyAddress = 'Admin.Partners.companyAddress',
  AdminPartnersCompanyName = 'Admin.Partners.companyName',
  AdminPartnersContract = 'Admin.Partners.contract',
  AdminPartnersCreatePartner = 'Admin.Partners.createPartner',
  AdminPartnersCrmId = 'Admin.Partners.crmId',
  AdminPartnersDomainIsNotUnique = 'Admin.Partners.domainIsNotUnique',
  AdminPartnersEditPartner = 'Admin.Partners.editPartner',
  AdminPartnersNDA = 'Admin.Partners.nda',
  AdminPartnersNumberOfTenants = 'Admin.Partners.numberOfTenants',
  AdminPartnersO365Domain = 'Admin.Partners.o365Domain',
  AdminPartnersPartnerInformation = 'Admin.Partners.partnerInformation',
  AdminPartnersPicture = 'Admin.Partners.picture',
  AdminPartnersReassignOwnTenantConfirmation = 'Admin.Partners.reassignOwnTenantConfirmation',
  AdminPartnersSelectTenantMultiple = 'Admin.Partners.selectTenantMultiple',
  AdminPartnersStreetAddress1 = 'Admin.Partners.streetAddress1',
  AdminPartnersStreetAddress2 = 'Admin.Partners.streetAddress2',
  AdminPartnersSupportContact = 'Admin.Partners.supportContact',
  AdminPartnersTenantId = 'Admin.Partners.tenantId',
  AdminPartnersTenants = 'Admin.Partners.tenants',
  AdminPartnersUrl = 'Admin.Partners.url',
  AdminPartnersUseAsOwnTenant = 'Admin.Partners.useAsOwnTenant',
  AdminPartnersZip = 'Admin.Partners.zip',
  AdminPermissionErrorConsentNeeded = 'Admin.Permission.Error.consentNeeded',
  AdminPermissionErrorConsentNeededWithClickableLink = 'Admin.Permission.Error.consentNeededWithClickableLink',
  AdminPoliciesAddAssignment = 'Admin.Policies.addAssignment',
  AdminPoliciesAppliesThroughOrganizationUnit = 'Admin.Policies.appliesThroughOrganizationUnit',
  AdminPoliciesAppliesTo = 'Admin.Policies.appliesTo',
  AdminPoliciesAssign = 'Admin.Policies.assign',
  AdminPoliciesAssignFailed = 'Admin.Policies.assignFailed',
  AdminPoliciesAssignmentOutsideOwningOrganizationUnit = 'Admin.Policies.assignmentOutsideOwningOrganizationUnit',
  AdminPoliciesAssignmentRemoveConfirmBody = 'Admin.Policies.assignmentRemoveConfirmBody',
  AdminPoliciesAssignmentRemoveConfirmTitle = 'Admin.Policies.assignmentRemoveConfirmTitle',
  AdminPoliciesAssignmentRemoveFailed = 'Admin.Policies.assignmentRemoveFailed',
  AdminPoliciesAssignmentRemoved = 'Admin.Policies.assignmentRemoved',
  AdminPoliciesAssignmentSaved = 'Admin.Policies.assignmentSaved',
  AdminPoliciesAssignmentScopeLocked = 'Admin.Policies.assignmentScopeLocked',
  AdminPoliciesAssignmentWarnings = 'Admin.Policies.assignmentWarnings',
  AdminPoliciesAssignments = 'Admin.Policies.assignments',
  AdminPoliciesAssignmentsEmpty = 'Admin.Policies.assignmentsEmpty',
  AdminPoliciesAssignmentsEmptyHint = 'Admin.Policies.assignmentsEmptyHint',
  AdminPoliciesAssignmentsLoadFailed = 'Admin.Policies.assignmentsLoadFailed',
  AdminPoliciesAssignmentsNoMatch = 'Admin.Policies.assignmentsNoMatch',
  AdminPoliciesAssignmentsUpdated = 'Admin.Policies.assignmentsUpdated',
  AdminPoliciesAssignmentsUpdatedPartially = 'Admin.Policies.assignmentsUpdatedPartially',
  AdminPoliciesCanBeAssignedAt = 'Admin.Policies.canBeAssignedAt',
  AdminPoliciesCollapseAll = 'Admin.Policies.collapseAll',
  AdminPoliciesConcurrencyConflict = 'Admin.Policies.concurrencyConflict',
  AdminPoliciesConflicts = 'Admin.Policies.conflicts',
  AdminPoliciesCopyName = 'Admin.Policies.copyName',
  AdminPoliciesDefaultValueHint = 'Admin.Policies.defaultValueHint',
  AdminPoliciesDefinitionsEmpty = 'Admin.Policies.definitionsEmpty',
  AdminPoliciesDefinitionsEmptyHint = 'Admin.Policies.definitionsEmptyHint',
  AdminPoliciesDefinitionsNoMatch = 'Admin.Policies.definitionsNoMatch',
  AdminPoliciesDescription = 'Admin.Policies.description',
  AdminPoliciesEditAssignment = 'Admin.Policies.editAssignment',
  AdminPoliciesEffectiveValue = 'Admin.Policies.effectiveValue',
  AdminPoliciesEnforceAllSettings = 'Admin.Policies.enforceAllSettings',
  AdminPoliciesEnforceNone = 'Admin.Policies.enforceNone',
  AdminPoliciesEnforceSelectedSettings = 'Admin.Policies.enforceSelectedSettings',
  AdminPoliciesEnforcement = 'Admin.Policies.enforcement',
  AdminPoliciesEnforcementHint = 'Admin.Policies.enforcementHint',
  AdminPoliciesEnforcementModeDefault = 'Admin.Policies.EnforcementMode.default',
  AdminPoliciesEnforcementModeEnforced = 'Admin.Policies.EnforcementMode.enforced',
  AdminPoliciesEvaluateForOrganizationUnit = 'Admin.Policies.evaluateForOrganizationUnit',
  AdminPoliciesEvaluateForUser = 'Admin.Policies.evaluateForUser',
  AdminPoliciesEvaluationChain = 'Admin.Policies.evaluationChain',
  AdminPoliciesEvaluationEmptyHint = 'Admin.Policies.evaluationEmptyHint',
  AdminPoliciesEvaluationEmptyTitle = 'Admin.Policies.evaluationEmptyTitle',
  AdminPoliciesEvaluationLoadFailed = 'Admin.Policies.evaluationLoadFailed',
  AdminPoliciesEvaluationNoTypes = 'Admin.Policies.evaluationNoTypes',
  AdminPoliciesEvaluationNoTypesForSource = 'Admin.Policies.evaluationNoTypesForSource',
  AdminPoliciesEvaluationSubjectOrganizationUnit = 'Admin.Policies.EvaluationSubject.organizationUnit',
  AdminPoliciesEvaluationSubjectUser = 'Admin.Policies.EvaluationSubject.user',
  AdminPoliciesExpandAll = 'Admin.Policies.expandAll',
  AdminPoliciesGeneral = 'Admin.Policies.general',
  AdminPoliciesGoToAssignments = 'Admin.Policies.goToAssignments',
  AdminPoliciesHiddenOrganizationUnitTypes = 'Admin.Policies.hiddenOrganizationUnitTypes',
  AdminPoliciesHiddenUserTypes = 'Admin.Policies.hiddenUserTypes',
  AdminPoliciesLifecycleStateActive = 'Admin.Policies.LifecycleState.active',
  AdminPoliciesLifecycleStateRetired = 'Admin.Policies.LifecycleState.retired',
  AdminPoliciesLoadFailed = 'Admin.Policies.loadFailed',
  AdminPoliciesNamePlaceholder = 'Admin.Policies.namePlaceholder',
  AdminPoliciesNewerRevisionAvailable = 'Admin.Policies.newerRevisionAvailable',
  AdminPoliciesNoAssignment = 'Admin.Policies.noAssignment',
  AdminPoliciesNoAssignments = 'Admin.Policies.noAssignments',
  AdminPoliciesNotInOrganizationUnit = 'Admin.Policies.notInOrganizationUnit',
  AdminPoliciesOrigin = 'Admin.Policies.origin',
  AdminPoliciesOriginDefault = 'Admin.Policies.Origin.default',
  AdminPoliciesOriginEnforced = 'Admin.Policies.Origin.enforced',
  AdminPoliciesOriginPersonal = 'Admin.Policies.Origin.personal',
  AdminPoliciesOriginPolicy = 'Admin.Policies.Origin.policy',
  AdminPoliciesOwnedBy = 'Admin.Policies.ownedBy',
  AdminPoliciesPersonalPreference = 'Admin.Policies.personalPreference',
  AdminPoliciesPersonalPreferencesUnavailable = 'Admin.Policies.personalPreferencesUnavailable',
  AdminPoliciesPoliciesOfTypeOnly = 'Admin.Policies.policiesOfTypeOnly',
  AdminPoliciesPolicy = 'Admin.Policies.policy',
  AdminPoliciesPolicyType = 'Admin.Policies.policyType',
  AdminPoliciesReload = 'Admin.Policies.reload',
  AdminPoliciesRemoveAssignment = 'Admin.Policies.removeAssignment',
  AdminPoliciesResetAllToDefaults = 'Admin.Policies.resetAllToDefaults',
  AdminPoliciesRestoreAsNewRevision = 'Admin.Policies.restoreAsNewRevision',
  AdminPoliciesRetire = 'Admin.Policies.retire',
  AdminPoliciesRetireConfirmBody = 'Admin.Policies.retireConfirmBody',
  AdminPoliciesRetireConfirmBodyAssigned = 'Admin.Policies.retireConfirmBodyAssigned',
  AdminPoliciesRetireConfirmTitle = 'Admin.Policies.retireConfirmTitle',
  AdminPoliciesRetireFailed = 'Admin.Policies.retireFailed',
  AdminPoliciesRetireSuccess = 'Admin.Policies.retireSuccess',
  AdminPoliciesRevision = 'Admin.Policies.revision',
  AdminPoliciesRevisionBanner = 'Admin.Policies.revisionBanner',
  AdminPoliciesRevisionCreated = 'Admin.Policies.revisionCreated',
  AdminPoliciesRevisionLatest = 'Admin.Policies.revisionLatest',
  AdminPoliciesSaveFailed = 'Admin.Policies.saveFailed',
  AdminPoliciesSchemaDefault = 'Admin.Policies.schemaDefault',
  AdminPoliciesScope = 'Admin.Policies.scope',
  AdminPoliciesScopeChain = 'Admin.Policies.scopeChain',
  AdminPoliciesScopeKind = 'Admin.Policies.scopeKind',
  AdminPoliciesScopeKindNotAllowed = 'Admin.Policies.scopeKindNotAllowed',
  AdminPoliciesScopeKindOrganizationUnit = 'Admin.Policies.ScopeKind.organizationUnit',
  AdminPoliciesScopeKindService = 'Admin.Policies.ScopeKind.service',
  AdminPoliciesScopeKindTenant = 'Admin.Policies.ScopeKind.tenant',
  AdminPoliciesScopeKindUser = 'Admin.Policies.ScopeKind.user',
  AdminPoliciesSearchAssignments = 'Admin.Policies.searchAssignments',
  AdminPoliciesSearchDefinitions = 'Admin.Policies.searchDefinitions',
  AdminPoliciesSelectTypeHint = 'Admin.Policies.selectTypeHint',
  AdminPoliciesSelected = 'Admin.Policies.selected',
  AdminPoliciesSetting = 'Admin.Policies.setting',
  AdminPoliciesSettings = 'Admin.Policies.settings',
  AdminPoliciesSettingsUnavailable = 'Admin.Policies.settingsUnavailable',
  AdminPoliciesShadowed = 'Admin.Policies.shadowed',
  AdminPoliciesShowEffectiveSettings = 'Admin.Policies.showEffectiveSettings',
  AdminPoliciesSource = 'Admin.Policies.source',
  AdminPoliciesTypeSummaryEnforced = 'Admin.Policies.TypeSummary.enforced',
  AdminPoliciesTypeSummaryFromPolicies = 'Admin.Policies.TypeSummary.fromPolicies',
  AdminPoliciesTypeSummarySettings = 'Admin.Policies.TypeSummary.settings',
  AdminPoliciesUnassigned = 'Admin.Policies.unassigned',
  AdminPoliciesUpdateAllAssignments = 'Admin.Policies.updateAllAssignments',
  AdminPoliciesUpdateToRevision = 'Admin.Policies.updateToRevision',
  AdminPoliciesValueNotBound = 'Admin.Policies.Value.notBound',
  AdminPoliciesValueOff = 'Admin.Policies.Value.off',
  AdminPoliciesValueOn = 'Admin.Policies.Value.on',
  AdminPoliciesViewingRevision = 'Admin.Policies.viewingRevision',
  AdminReportingTeamsDirectCalls = 'Admin.Reporting.teamsDirectCalls',
  AdminReportingTeamsDirectCallsInfo = 'Admin.Reporting.teamsDirectCallsInfo',
  AdminReportingTeamsDirectCallsLicensesInfo = 'Admin.Reporting.teamsDirectCallsLicensesInfo',
  AdminReportingTeamsDirectCallsError = 'Admin.Reporting.teamsDirectCallsLicenseViolation',
  AdminSecurityGroupInfoGroupName = 'Admin.SecurityGroupInfo.groupName',
  AdminSecurityGroupInfoMembers = 'Admin.SecurityGroupInfo.members',
  AdminSecurityGroupInfoTitle = 'Admin.SecurityGroupInfo.title',
  AdminServiceAccountsAccountNotConfigured = 'Admin.ServiceAccounts.accountNotConfigured',
  AdminServiceAccountsCriticalLoad = 'Admin.ServiceAccounts.criticalLoad',
  AdminServiceAccountsCurrentlyInUse = 'Admin.ServiceAccounts.currentlyInUse',
  AdminServiceAccountsLicenseMissing = 'Admin.ServiceAccounts.licenseMissing',
  AdminServiceAccountsMultifactorAuthenticationEnabled = 'Admin.ServiceAccounts.multifactorAuthenticationEnabled',
  AdminServiceAccountsNotAddedAsGuest = 'Admin.ServiceAccounts.notAddedAsGuest',
  AdminServiceAccountsPermissionNotGranted = 'Admin.ServiceAccounts.permissionNotGranted',
  AdminServiceAccountsTemporaryDisabled = 'Admin.ServiceAccounts.temporaryDisabled',
  AdminServiceAccountsTestError = 'Admin.ServiceAccounts.testError',
  AdminServiceAccountsTestSuccessfulWithActivity = 'Admin.ServiceAccounts.testSuccessfulWithActivity',
  AdminServiceAccountsUnknownError = 'Admin.ServiceAccounts.unknownError',
  AdminServiceAccountsUnknownErrorTitle = 'Admin.ServiceAccounts.unknownErrorTitle',
  AdminServiceAccountsUnknownErrorWithCode = 'Admin.ServiceAccounts.unknownErrorWithCode',
  AdminServiceAccountsWorkingGuestAccountNotFound = 'Admin.ServiceAccounts.workingGuestAccountNotFound',
  AdminServiceListDisablePermissions = 'Admin.Service.listDisablePermissions',
  AdminServiceListDisableSelectionLicense = 'Admin.Service.listDisableSelectionLicense',
  AdminServiceListDisableSelectionServiceType = 'Admin.Service.listDisableSelectionServiceType',
  AdminServiceListLoadingErrors = 'Admin.Service.listLoadingErrors',
  AdminServiceListUnderstood = 'Admin.Service.listUnderstood',
  AdminServiceListUsers = 'Admin.Service.listUsers',
  AdminServiceSettingsActivePending = 'Admin.Service.settingsActivePending',
  AdminServiceSettingsFormE164NumberPending = 'Admin.Service.settingsFormE164NumberPending',
  AdminServiceSettingsFormServiceDisplayNamePending = 'Admin.Service.settingsFormServiceDisplayNamePending',
  AdminServiceSettingsFormServiceUPNPending = 'Admin.Service.settingsFormServiceUPNPending',
  AdminTPAVTaskLimit = 'Admin.TP.aVTaskLimit',
  AdminTPAllowTaskActivationWhileInActiveTask = 'Admin.TP.allowTaskActivationWhileInActiveTask',
  AdminTPETTaskLimit = 'Admin.TP.eTTaskLimit',
  AdminTPEmailTaskLimit = 'Admin.TP.emailTaskLimit',
  AdminTPIMTaskLimit = 'Admin.TP.iMTaskLimit',
  AdminTPModalityTaskLimit = 'Admin.TP.modalityTaskLimit',
  AdminTPTotalTaskLimit = 'Admin.TP.totalTaskLimit',
  AdminTaskListCurrentTime = 'Admin.TaskList.currentTime',
  AdminTaskListSearchPlaceholder = 'Admin.TaskList.searchPlaceholder',
  AdminTaskParallelization = 'Admin.Task.parallelization',
  AdminTaskStatesBlocked = 'Admin.TaskStates.blocked',
  AdminTaskStatesInAfterCallWork = 'Admin.TaskStates.inAfterCallWork',
  AdminTaskStatesInExtendedAfterCallWork = 'Admin.TaskStates.inExtendedAfterCallWork',
  AdminTaskStatesNotDefined = 'Admin.TaskStates.notDefined',
  AdminTeamListProvisionedSince = 'Admin.TeamList.provisionedSince',
  AdminTeamListWarning = 'Admin.TeamList.warning',
  AdminTeamUsersChartEnabledInTeams = 'Admin.TeamUsersChart.enabledInTeams',
  AdminTeamUsersChartTotalMembers = 'Admin.TeamUsersChart.totalMembers',
  AdminTeamUsersGridMemberships = 'Admin.TeamUsersGrid.memberships',
  AdminTenantCreateDomainAlreadyAdded = 'Admin.TenantCreate.domainAlreadyAdded',
  AdminTenantListLocationPicture = 'Admin.TenantList.locationPicture',
  AdminTenantModalitiesStatusIsUnknown = 'Admin.TenantModalities.statusIsUnknown',
  AdminTenantPresenceGuestAccountsTemporaryDisabled = 'Admin.TenantPresence.guestAccountsTemporaryDisabled',
  AdminTenantPresenceSomethingWentWrong = 'Admin.TenantPresence.somethingWentWrong',
  AdminTenantProvisioningMissingOrganizationUnit = 'Admin.TenantProvisioning.missingOrganizationUnit',
  AdminTenantsDetailsAcsEndpointUrl = 'Admin.TenantsDetails.acsEndpointUrl',
  AdminTenantsDetailsAcsEndpointUrlCheckConnection = 'Admin.TenantsDetails.acsEndpointUrlCheckConnection',
  AdminTenantsDetailsAcsEndpointUrlCheckFailed = 'Admin.TenantsDetails.acsEndpointUrlCheckFailed',
  AdminTenantsDetailsAcsEndpointUrlCheckSuccessful = 'Admin.TenantsDetails.acsEndpointUrlCheckSuccessful',
  AdminTenantsDetailsAcsResourceId = 'Admin.TenantsDetails.acsResourceId',
  AdminTenantsDetailsActive = 'Admin.TenantsDetails.active',
  AdminTenantsDetailsAddressLine1 = 'Admin.TenantsDetails.addressLine1',
  AdminTenantsDetailsAddressLine2 = 'Admin.TenantsDetails.addressLine2',
  AdminTenantsDetailsAdminPortal = 'Admin.TenantsDetails.adminPortal',
  AdminTenantsDetailsAi = 'Admin.TenantsDetails.ai',
  AdminTenantsDetailsAiDisableConfirmCompanion = 'Admin.TenantsDetails.aiDisableConfirmCompanion',
  AdminTenantsDetailsAiDisableConfirmIntroMessage = 'Admin.TenantsDetails.aiDisableConfirmIntroMessage',
  AdminTenantsDetailsAiDisableConfirmMessage = 'Admin.TenantsDetails.aiDisableConfirmMessage',
  AdminTenantsDetailsAiDisableConfirmVirtualUser = 'Admin.TenantsDetails.aiDisableConfirmVirtualUser',
  AdminTenantsDetailsAllowCompanion = 'Admin.TenantsDetails.allowCompanion',
  AdminTenantsDetailsAllowCompanionWarning = 'Admin.TenantsDetails.allowCompanionWarning',
  AdminTenantsDetailsAllowPartnerToAccessChangeHistory = 'Admin.TenantsDetails.allowPartnerToAccessChangeHistory',
  AdminTenantsDetailsAllowPartnerToSeeCustomerIdentifiers = 'Admin.TenantsDetails.allowPartnerToSeeCustomerIdentifiers',
  AdminTenantsDetailsAllowPartnerToSeeUserIdentifiers = 'Admin.TenantsDetails.allowPartnerToSeeUserIdentifiers',
  AdminTenantsDetailsAllowTenantAdminToDownloadTracingFile = 'Admin.TenantsDetails.allowTenantAdminToDownloadTracingFile',
  AdminTenantsDetailsAllowToSharePii = 'Admin.TenantsDetails.allowToSharePii',
  AdminTenantsDetailsAllowToSharePiiWarningOff = 'Admin.TenantsDetails.allowToSharePiiWarningOff',
  AdminTenantsDetailsAllowToSharePiiWarningOn = 'Admin.TenantsDetails.allowToSharePiiWarningOn',
  AdminTenantsDetailsAllowVirtualUser = 'Admin.TenantsDetails.allowVirtualUser',
  AdminTenantsDetailsAllowVirtualUserWarning = 'Admin.TenantsDetails.allowVirtualUserWarning',
  AdminTenantsDetailsApplicationPermissions = 'Admin.TenantsDetails.applicationPermissions',
  AdminTenantsDetailsAssignOrganizationUnitsTitle = 'Admin.TenantsDetails.assignOrganizationUnitsTitle',
  AdminTenantsDetailsAssistant = 'Admin.TenantsDetails.assistant',
  AdminTenantsDetailsAttendantConsole = 'Admin.TenantsDetails.attendantConsole',
  AdminTenantsDetailsAttendantConsoleTeamMembersVisibility = 'Admin.TenantsDetails.attendantConsoleTeamMembersVisibility',
  AdminTenantsDetailsAttendantConsoleTeamMembersVisibilityAll = 'Admin.TenantsDetails.attendantConsoleTeamMembersVisibilityAll',
  AdminTenantsDetailsAttendantConsoleTeamMembersVisibilityNone = 'Admin.TenantsDetails.attendantConsoleTeamMembersVisibilityNone',
  AdminTenantsDetailsAttendantConsoleTeamMembersVisibilityOwn = 'Admin.TenantsDetails.attendantConsoleTeamMembersVisibilityOwn',
  AdminTenantsDetailsAudioVideo = 'Admin.TenantsDetails.audioVideo',
  AdminTenantsDetailsBillingAddress = 'Admin.TenantsDetails.billingAddress',
  AdminTenantsDetailsChangeHistoryRetentionTime = 'Admin.TenantsDetails.changeHistoryRetentionTime',
  AdminTenantsDetailsChangeHistoryRetentionTimeHint = 'Admin.TenantsDetails.changeHistoryRetentionTimeHint',
  AdminTenantsDetailsChangeHistoryRetentionTimeSuffixHint = 'Admin.TenantsDetails.changeHistoryRetentionTimeSuffixHint',
  AdminTenantsDetailsCity = 'Admin.TenantsDetails.city',
  AdminTenantsDetailsCompanionInterface = 'Admin.TenantsDetails.companionInterface',
  AdminTenantsDetailsCompanyName = 'Admin.TenantsDetails.companyName',
  AdminTenantsDetailsContactName = 'Admin.TenantsDetails.contactName',
  AdminTenantsDetailsCountry = 'Admin.TenantsDetails.country',
  AdminTenantsDetailsCrmId = 'Admin.TenantsDetails.crmId',
  AdminTenantsDetailsCustomerOverview = 'Admin.TenantsDetails.customerOverview',
  AdminTenantsDetailsCustomerOverviewWarning = 'Admin.TenantsDetails.customerOverviewWarning',
  AdminTenantsDetailsCustomerSuccessPlatformIntegrationTitle = 'Admin.TenantsDetails.customerSuccessPlatformIntegrationTitle',
  AdminTenantsDetailsDashboardClusterDefault = 'Admin.TenantsDetails.dashboardClusterDefault',
  AdminTenantsDetailsDashboardLimitsConfiguration = 'Admin.TenantsDetails.dashboardLimitsConfiguration',
  AdminTenantsDetailsDashboardMaxServicesCount = 'Admin.TenantsDetails.dashboardMaxServicesCount',
  AdminTenantsDetailsDashboardMaxUsersCount = 'Admin.TenantsDetails.dashboardMaxUsersCount',
  AdminTenantsDetailsDataRetentionSectionTitle = 'Admin.TenantsDetails.dataRetentionSectionTitle',
  AdminTenantsDetailsDataRetentionTime = 'Admin.TenantsDetails.dataRetentionTime',
  AdminTenantsDetailsDataRetentionTimeHint = 'Admin.TenantsDetails.dataRetentionTimeHint',
  AdminTenantsDetailsDataRetentionTimeSuffixHint = 'Admin.TenantsDetails.dataRetentionTimeSuffixHint',
  AdminTenantsDetailsDefaultGraphUserFilter = 'Admin.TenantsDetails.defaultGraphUserFilter',
  AdminTenantsDetailsDefaultGraphUserFilterGraphExplorer = 'Admin.TenantsDetails.defaultGraphUserFilterGraphExplorer',
  AdminTenantsDetailsDefaultGraphUserFilterWarning = 'Admin.TenantsDetails.defaultGraphUserFilterWarning',
  AdminTenantsDetailsDefaultOrganizationUnitForServices = 'Admin.TenantsDetails.defaultOrganizationUnitForServices',
  AdminTenantsDetailsDefaultTeamOwnerRole = 'Admin.TenantsDetails.defaultTeamOwnerRole',
  AdminTenantsDetailsDirectCallWarning = 'Admin.TenantsDetails.directCallWarning',
  AdminTenantsDetailsDirectlyInvitePstnForOutbound = 'Admin.TenantsDetails.directlyInvitePstnForOutbound',
  AdminTenantsDetailsDirectlyInviteUpnForOutbound = 'Admin.TenantsDetails.directlyInviteUpnForOutbound',
  AdminTenantsDetailsDisplayNotAvailableReason = 'Admin.TenantsDetails.displayNotAvailableReason',
  AdminTenantsDetailsDisplayNotAvailableReasonWarning = 'Admin.TenantsDetails.displayNotAvailableReasonWarning',
  AdminTenantsDetailsDisplayNotReadyReason = 'Admin.TenantsDetails.displayNotReadyReason',
  AdminTenantsDetailsDisplayNotReadyReasonWarning = 'Admin.TenantsDetails.displayNotReadyReasonWarning',
  AdminTenantsDetailsEmail = 'Admin.TenantsDetails.email',
  AdminTenantsDetailsEmailTasks = 'Admin.TenantsDetails.emailTasks',
  AdminTenantsDetailsEmergencyCalling = 'Admin.TenantsDetails.emergencyCalling',
  AdminTenantsDetailsEmergencyCallingOverlayAdditionalInfo = 'Admin.TenantsDetails.emergencyCallingOverlayAdditionalInfo',
  AdminTenantsDetailsEmergencyCallingOverlayMessage = 'Admin.TenantsDetails.emergencyCallingOverlayMessage',
  AdminTenantsDetailsEmergencyCallingOverlayTitle = 'Admin.TenantsDetails.emergencyCallingOverlayTitle',
  AdminTenantsDetailsEmergencyCallingTooltip = 'Admin.TenantsDetails.emergencyCallingTooltip',
  AdminTenantsDetailsEmergencyManualPresenceMode = 'Admin.TenantsDetails.emergencyManualPresenceMode',
  AdminTenantsDetailsEmergencyManualPresenceModeTooltip = 'Admin.TenantsDetails.emergencyManualPresenceModeTooltip',
  AdminTenantsDetailsEnableCompanionInNimbusPortal = 'Admin.TenantsDetails.enableCompanionInNimbusPortal',
  AdminTenantsDetailsExternalTasks = 'Admin.TenantsDetails.externalTasks',
  AdminTenantsDetailsForceCleanupPrompt = 'Admin.TenantsDetails.forceCleanupPrompt',
  AdminTenantsDetailsForceCleanupTenant = 'Admin.TenantsDetails.forceCleanupTenant',
  AdminTenantsDetailsForceDelete = 'Admin.TenantsDetails.forceDelete',
  AdminTenantsDetailsGrantPermission = 'Admin.TenantsDetails.grantPermission',
  AdminTenantsDetailsInstantMessaging = 'Admin.TenantsDetails.instantMessaging',
  AdminTenantsDetailsInstantMessagingAcsResourceId = 'Admin.TenantsDetails.instantMessagingAcsResourceId',
  AdminTenantsDetailsInteract = 'Admin.TenantsDetails.interact',
  AdminTenantsDetailsInteractAuthorization = 'Admin.TenantsDetails.interactAuthorization',
  AdminTenantsDetailsInteractAuthorizationNone = 'Admin.TenantsDetails.interactAuthorizationNone',
  AdminTenantsDetailsInteractAuthorizationToken = 'Admin.TenantsDetails.interactAuthorizationToken',
  AdminTenantsDetailsInteractAuthorizationTokenTenant = 'Admin.TenantsDetails.interactAuthorizationTokenTenant',
  AdminTenantsDetailsInteractEnabled = 'Admin.TenantsDetails.interactEnabled',
  AdminTenantsDetailsInteractSessionTimeout = 'Admin.TenantsDetails.interactSessionTimeout',
  AdminTenantsDetailsIsAssistantAcsConnectionStringEnabled = 'Admin.TenantsDetails.isAssistantAcsConnectionStringEnabled',
  AdminTenantsDetailsIsInstantMessagingAcsConnectionStringEnabled = 'Admin.TenantsDetails.isInstantMessagingAcsConnectionStringEnabled',
  AdminTenantsDetailsIsInstantMessagingOwnAccountsEnabled = 'Admin.TenantsDetails.isInstantMessagingOwnAccountsEnabled',
  AdminTenantsDetailsIsInstantMessagingOwnAccountsRequired = 'Admin.TenantsDetails.isInstantMessagingOwnAccountsRequired',
  AdminTenantsDetailsLeaveNimbusOnBlindTransfer = 'Admin.TenantsDetails.leaveNimbusOnBlindTransfer',
  AdminTenantsDetailsLeaveNimbusOnBlindTransferWarning = 'Admin.TenantsDetails.leaveNimbusOnBlindTransferWarning',
  AdminTenantsDetailsLicenseStateActive = 'Admin.TenantsDetails.licenseStateActive',
  AdminTenantsDetailsLicenseStateCanceled = 'Admin.TenantsDetails.licenseStateCanceled',
  AdminTenantsDetailsLicenseStateExpired = 'Admin.TenantsDetails.licenseStateExpired',
  AdminTenantsDetailsLicenseStateLab = 'Admin.TenantsDetails.licenseStateLab',
  AdminTenantsDetailsLicenseStateSuspended = 'Admin.TenantsDetails.licenseStateSuspended',
  AdminTenantsDetailsLicenseStateTrial = 'Admin.TenantsDetails.licenseStateTrial',
  AdminTenantsDetailsLicenseStateWarning = 'Admin.TenantsDetails.licenseStateWarning',
  AdminTenantsDetailsLicensesAssigned = 'Admin.TenantsDetails.licensesAssigned',
  AdminTenantsDetailsMaxEmailTasksPerService = 'Admin.TenantsDetails.maxEmailTasksPerService',
  AdminTenantsDetailsMaxExternalTasksPerService = 'Admin.TenantsDetails.maxExternalTasksPerService',
  AdminTenantsDetailsMaxImTasksPerService = 'Admin.TenantsDetails.maxImTasksPerService',
  AdminTenantsDetailsMaxScheduledOutboundTasks = 'Admin.TenantsDetails.maxScheduledOutboundTasks',
  AdminTenantsDetailsModalities = 'Admin.TenantsDetails.modalities',
  AdminTenantsDetailsMsTeamsProvisioningRestriction = 'Admin.TenantsDetails.msTeamsProvisioningRestriction',
  AdminTenantsDetailsMultiHomedDeployment = 'Admin.TenantsDetails.multiHomedDeployment',
  AdminTenantsDetailsMultiHomedDeploymentWarning = 'Admin.TenantsDetails.multiHomedDeploymentWarning',
  AdminTenantsDetailsMultiHomedDeploymentWarningOtherLocations = 'Admin.TenantsDetails.multiHomedDeploymentWarningOtherLocations',
  AdminTenantsDetailsName = 'Admin.TenantsDetails.name',
  AdminTenantsDetailsNimbusUnify = 'Admin.TenantsDetails.nimbusUnify',
  AdminTenantsDetailsO365Domain = 'Admin.TenantsDetails.o365Domain',
  AdminTenantsDetailsO365DomainOnceSavedCannotBeEdited = 'Admin.TenantsDetails.o365DomainOnceSavedCannotBeEdited',
  AdminTenantsDetailsO365Name = 'Admin.TenantsDetails.o365Name',
  AdminTenantsDetailsOffice365Id = 'Admin.TenantsDetails.office365Id',
  AdminTenantsDetailsOffice365IdInfo = 'Admin.TenantsDetails.office365IdInfo',
  AdminTenantsDetailsOutbound = 'Admin.TenantsDetails.outbound',
  AdminTenantsDetailsPartner = 'Admin.TenantsDetails.partner',
  AdminTenantsDetailsPartnerSecurityGroupId = 'Admin.TenantsDetails.partnerSecurityGroupId',
  AdminTenantsDetailsPendingDeletion = 'Admin.TenantsDetails.pendingDeletion',
  AdminTenantsDetailsPersistUserStatesInReporting = 'Admin.TenantsDetails.persistUserStatesInReporting',
  AdminTenantsDetailsPhoneNumber = 'Admin.TenantsDetails.phoneNumber',
  AdminTenantsDetailsPhoneNumberE164 = 'Admin.TenantsDetails.phoneNumberE164',
  AdminTenantsDetailsPresenceAccount1 = 'Admin.TenantsDetails.presenceAccount1',
  AdminTenantsDetailsPresenceAccount2 = 'Admin.TenantsDetails.presenceAccount2',
  AdminTenantsDetailsPresenceTracking = 'Admin.TenantsDetails.presenceTracking',
  AdminTenantsDetailsProvisioningApi = 'Admin.TenantsDetails.provisioningApi',
  AdminTenantsDetailsProvisioningApiAppPermission = 'Admin.TenantsDetails.provisioningApiAppPermission',
  AdminTenantsDetailsProvisioningApiEnable = 'Admin.TenantsDetails.provisioningApiEnable',
  AdminTenantsDetailsProvisioningScriptWarning = 'Admin.TenantsDetails.provisioningScriptWarning',
  AdminTenantsDetailsReadPresence = 'Admin.TenantsDetails.readPresence',
  AdminTenantsDetailsReadPresenceHint = 'Admin.TenantsDetails.readPresenceHint',
  AdminTenantsDetailsService = 'Admin.TenantsDetails.service',
  AdminTenantsDetailsServiceAdvancedRouting = 'Admin.TenantsDetails.serviceAdvancedRouting',
  AdminTenantsDetailsServiceContactCenterRouting = 'Admin.TenantsDetails.serviceContactCenterRouting',
  AdminTenantsDetailsServiceEmail = 'Admin.TenantsDetails.serviceEmail',
  AdminTenantsDetailsServiceEnterpriseRouting = 'Admin.TenantsDetails.serviceEnterpriseRouting',
  AdminTenantsDetailsServiceExternalTask = 'Admin.TenantsDetails.serviceExternalTask',
  AdminTenantsDetailsServiceInstantMessagingModality = 'Admin.TenantsDetails.serviceInstantMessagingModality',
  AdminTenantsDetailsServiceInteract = 'Admin.TenantsDetails.serviceInteract',
  AdminTenantsDetailsShowUserTimeInState = 'Admin.TenantsDetails.showUserTimeInState',
  AdminTenantsDetailsShowUserTimeInStateWarning = 'Admin.TenantsDetails.showUserTimeInStateWarning',
  AdminTenantsDetailsSip = 'Admin.TenantsDetails.sip',
  AdminTenantsDetailsSms = 'Admin.TenantsDetails.sms',
  AdminTenantsDetailsTabContact = 'Admin.TenantsDetails.tabContact',
  AdminTenantsDetailsTabDataPrivacy = 'Admin.TenantsDetails.tabDataPrivacy',
  AdminTenantsDetailsTabExtensions = 'Admin.TenantsDetails.tabExtensions',
  AdminTenantsDetailsTabGeneral = 'Admin.TenantsDetails.tabGeneral',
  AdminTenantsDetailsTabLicenses = 'Admin.TenantsDetails.tabLicenses',
  AdminTenantsDetailsTabModalities = 'Admin.TenantsDetails.tabModalities',
  AdminTenantsDetailsTabProvisioning = 'Admin.TenantsDetails.tabProvisioning',
  AdminTenantsDetailsTenantId = 'Admin.TenantsDetails.tenantId',
  AdminTenantsDetailsTenantSecurityGroupId = 'Admin.TenantsDetails.tenantSecurityGroupId',
  AdminTenantsDetailsTenantState = 'Admin.TenantsDetails.tenantState',
  AdminTenantsDetailsTestConnection = 'Admin.TenantsDetails.testConnection',
  AdminTenantsDetailsTestUpn = 'Admin.TenantsDetails.testUpn',
  AdminTenantsDetailsTrackPresenceOverGuestAccounts = 'Admin.TenantsDetails.trackPresenceOverGuestAccounts',
  AdminTenantsDetailsTwilio = 'Admin.TenantsDetails.twilio',
  AdminTenantsDetailsTwilioAtLeastOneChannelRequired = 'Admin.TenantsDetails.twilioAtLeastOneChannelRequired',
  AdminTenantsDetailsUseNimbusUnify = 'Admin.TenantsDetails.useNimbusUnify',
  AdminTenantsDetailsUser = 'Admin.TenantsDetails.user',
  AdminTenantsDetailsUserAssistant = 'Admin.TenantsDetails.userAssistant',
  AdminTenantsDetailsUserAttendantConsole = 'Admin.TenantsDetails.userAttendantConsole',
  AdminTenantsDetailsUserCompanion = 'Admin.TenantsDetails.userCompanion',
  AdminTenantsDetailsUserContactCenter = 'Admin.TenantsDetails.userContactCenter',
  AdminTenantsDetailsUserDirectCallHandling = 'Admin.TenantsDetails.userDirectCallHandling',
  AdminTenantsDetailsUserInteract = 'Admin.TenantsDetails.userInteract',
  AdminTenantsDetailsVirtualUserVirtualUser = 'Admin.TenantsDetails.virtualUserVirtualUser',
  AdminTenantsDetailsVoicemailRetentionDays = 'Admin.TenantsDetails.voicemailRetentionDays',
  AdminTenantsDetailsVoicemailRetentionDaysHint = 'Admin.TenantsDetails.voicemailRetentionDaysHint',
  AdminTenantsDetailsVoicemailRetentionDaysSuffixHint = 'Admin.TenantsDetails.voicemailRetentionDaysSuffixHint',
  AdminTenantsDetailsWebChat = 'Admin.TenantsDetails.webChat',
  AdminTenantsDetailsWebChatAuthorizationMode = 'Admin.TenantsDetails.webChatAuthorizationMode',
  AdminTenantsDetailsWebChatWidgetKeyEmpty = 'Admin.TenantsDetails.webChatWidgetKeyEmpty',
  AdminTenantsDetailsWebChatWidgetKeyRegenerate = 'Admin.TenantsDetails.webChatWidgetKeyRegenerate',
  AdminTenantsDetailsWhatsapp = 'Admin.TenantsDetails.whatsapp',
  AdminTenantsDetailsWidgetKey = 'Admin.TenantsDetails.widgetKey',
  AdminTenantsDetailsWidgetKeyRefresh = 'Admin.TenantsDetails.widgetKeyRefresh',
  AdminTenantsDetailsWidgetKeyWarning = 'Admin.TenantsDetails.widgetKeyWarning',
  AdminTenantsDetailsZip = 'Admin.TenantsDetails.zip',
  AdminTenantsListActivate = 'Admin.TenantsList.activate',
  AdminTenantsListActivateTenant = 'Admin.TenantsList.activateTenant',
  AdminTenantsListComment = 'Admin.TenantsList.comment',
  AdminTenantsListCrmId = 'Admin.TenantsList.crmId',
  AdminTenantsListCurrentLocation = 'Admin.TenantsList.currentLocation',
  AdminTenantsListLicenseState = 'Admin.TenantsList.licenseState',
  AdminTenantsListMultiHomed = 'Admin.TenantsList.multiHomed',
  AdminTenantsListNumberOfTeams = 'Admin.TenantsList.numberOfTeams',
  AdminTenantsListO365Domain = 'Admin.TenantsList.o365Domain',
  AdminTenantsListOtherLocations = 'Admin.TenantsList.otherLocations',
  AdminTenantsListPreventNewTenantOnboardingTooltip = 'Admin.TenantsList.preventNewTenantOnboardingTooltip',
  AdminTenantsListSuspend = 'Admin.TenantsList.suspend',
  AdminTenantsListSuspendInboundOutbound = 'Admin.TenantsList.suspendInboundOutbound',
  AdminTenantsListSuspendLogin = 'Admin.TenantsList.suspendLogin',
  AdminTenantsListSuspendTenant = 'Admin.TenantsList.suspendTenant',
  AdminTenantsListSuspendedBy = 'Admin.TenantsList.suspendedBy',
  AdminTenantsListTenantName = 'Admin.TenantsList.tenantName',
  AdminTenantsListTypeYesToConfirm = 'Admin.TenantsList.typeYesToConfirm',
  AdminUserDetailsFilterAttendantConsoleEnabled = 'Admin.UserDetails.filterAttendantConsoleEnabled',
  AdminUserDetailsModalities = 'Admin.UserDetails.modalities',
  AdminUserDetailsO365User = 'Admin.UserDetails.o365User',
  AdminUserDirectCallRaCreateAlreadyExists = 'Admin.User.directCallRa.createAlreadyExists',
  AdminUserDirectCallRaCreateAndUpdateServiceButton = 'Admin.User.directCallRa.createAndUpdateServiceButton',
  AdminUserDirectCallRaCreateAndUpdateServiceHint = 'Admin.User.directCallRa.createAndUpdateServiceHint',
  AdminUserDirectCallRaCreateAndUpdateServiceSavedHint = 'Admin.User.directCallRa.createAndUpdateServiceSavedHint',
  AdminUserDirectCallRaCreateFailed = 'Admin.User.directCallRa.createFailed',
  AdminUserDirectCallRaNameLabel = 'Admin.User.directCallRa.nameLabel',
  AdminUserDirectCallRaNotAvailable = 'Admin.User.directCallRa.notAvailable',
  AdminUserDirectCallRaPhoneNumberLabel = 'Admin.User.directCallRa.phoneNumberLabel',
  AdminUserDirectCallRaPhoneNumberNone = 'Admin.User.directCallRa.phoneNumberNone',
  AdminUserDirectCallRaStatusAvailable = 'Admin.User.directCallRa.statusAvailable',
  AdminUserDirectCallRaStatusError = 'Admin.User.directCallRa.statusError',
  AdminUserDirectCallRaStatusNotFound = 'Admin.User.directCallRa.statusNotFound',
  AdminUserDirectCallRaStatusPending = 'Admin.User.directCallRa.statusPending',
  AdminUserDirectCallRaStatusProvisioned = 'Admin.User.directCallRa.statusProvisioned',
  AdminUserDirectCallRaStatusVerifying = 'Admin.User.directCallRa.statusVerifying',
  AdminUserDirectCallRaSuffixLabel = 'Admin.User.directCallRa.suffixLabel',
  AdminUserDirectCallRaVerifyButton = 'Admin.User.directCallRa.verifyButton',
  AdminUserDirectCallRaVerifyButtonTooltip = 'Admin.User.directCallRa.verifyButtonTooltip',
  AdminUserDirectCallRaStatusFound = 'Admin.User.directCallRa.statusFound',
  AdminUserDirectCallRaStatusFoundTitle = 'Admin.User.directCallRa.statusFoundTitle',
  AdminUserDirectCallRaRemoveButton = 'Admin.User.directCallRa.removeButton',
  AdminUserDirectCallRaRemoveButtonTooltip = 'Admin.User.directCallRa.removeButtonTooltip',
  AdminUserDirectCallRaRemoveFailed = 'Admin.User.directCallRa.removeFailed',
  AdminUserDirectCallRaRemoveConfirmTitle = 'Admin.User.directCallRa.removeConfirmTitle',
  AdminUserDirectCallRaRemoveConfirmDescription = 'Admin.User.directCallRa.removeConfirmDescription',
  AdminUserDirectCallRaForwardingToggleSuccess = 'Admin.User.directCallRa.forwardingToggleSuccess',
  AdminUserDirectCallRaForwardingToggleFailed = 'Admin.User.directCallRa.forwardingToggleFailed',
  AdminUserDirectCallRaTransferButton = 'Admin.User.directCallRa.transferButton',
  AdminUserDirectCallRaTransferButtonTooltip = 'Admin.User.directCallRa.transferButtonTooltip',
  AdminUserDirectCallRaTransferFailed = 'Admin.User.directCallRa.transferFailed',
  AdminUserDirectCallRaTransferNoResourceAccount = 'Admin.User.directCallRa.transferNoResourceAccount',
  AdminUserDirectCallRaTransferSuccess = 'Admin.User.directCallRa.transferSuccess',
  AdminUserDirectCallRaTransferTargetHasService = 'Admin.User.directCallRa.transferTargetHasService',
  AdminUserDirectCallRaSetupSection = 'Admin.User.directCallRa.setupSection',
  AdminUserDirectCallServiceNameLabel = 'Admin.User.directCallService.nameLabel',
  AdminUserDirectCallServiceNameNone = 'Admin.User.directCallService.nameNone',
  AdminUserDirectCallServiceRenameSuccess = 'Admin.User.directCallService.renameSuccess',
  AdminUserDirectCallServiceRenameFailed = 'Admin.User.directCallService.renameFailed',
  AdminUserDirectCallServiceVerifySuccess = 'Admin.User.directCallService.verifySuccess',
  AdminUserDirectCallServiceVerifyFailed = 'Admin.User.directCallService.verifyFailed',
  AdminUserDirectCallServiceVerifyNeedsScript = 'Admin.User.directCallService.verifyNeedsScript',
  AdminUserDirectCallServiceStatusServiceMissing = 'Admin.User.directCallService.statusServiceMissing',
  AdminUserDirectCallServiceStatusServiceSoftDeleted = 'Admin.User.directCallService.statusServiceSoftDeleted',
  AdminUserDirectCallServiceStatusRaUnbound = 'Admin.User.directCallService.statusRaUnbound',
  AdminUserDirectCallServiceStatusRaMissingPstnNumber = 'Admin.User.directCallService.statusRaMissingPstnNumber',
  AdminUserDirectCallServiceStatusRaUnverifiedAfterSave = 'Admin.User.directCallService.statusRaUnverifiedAfterSave',
  AdminUserDirectCallServiceStatusRaUpnMismatch = 'Admin.User.directCallService.statusRaUpnMismatch',
  AdminUserDirectCallServiceStatusRaUpnMismatchNotFound = 'Admin.User.directCallService.statusRaUpnMismatchNotFound',
  AdminUserDirectCallServiceStatusRaBoundElsewhere = 'Admin.User.directCallService.statusRaBoundElsewhere',
  AdminUserDirectCallServiceStatusUpnDomainMismatch = 'Admin.User.directCallService.statusUpnDomainMismatch',
  AdminUserDirectCallServiceStatusRaNotFound = 'Admin.User.directCallService.statusRaNotFound',
  AdminUserDirectCallTransferDialogConfirmButton = 'Admin.User.DirectCallTransfer.confirmButton',
  AdminUserDirectCallTransferDialogDescription = 'Admin.User.DirectCallTransfer.description',
  AdminUserDirectCallTransferDialogNoEligibleUsers = 'Admin.User.DirectCallTransfer.noEligibleUsers',
  AdminUserDirectCallTransferDialogTargetUserLabel = 'Admin.User.DirectCallTransfer.targetUserLabel',
  AdminUserDirectCallTransferDialogTitle = 'Admin.User.DirectCallTransfer.title',
  AdminUserGeneralTabResetAgentSettingsConfirmation = 'Admin.UserGeneralTab.resetAgentSettingsConfirmation',
  AdminUserListAttendantConsole = 'Admin.User.listAttendantConsole',
  AdminUserListDisablePermissions = 'Admin.User.listDisablePermissions',
  AdminUserListRoutingServices = 'Admin.User.listRoutingServices',
  AdminUserServicesTabForFutureUse = 'Admin.UserServicesTab.forFutureUse',
  AdminUsersBulkDirectCallRaCollision = 'Admin.Users.BulkDirectCallRa.collision',
  AdminUsersBulkDirectCallRaAutoAssignRaNames = 'Admin.Users.BulkDirectCallRa.autoAssignRaNames',
  AdminUsersBulkDirectCallRaCreateAndUpdateServiceButton = 'Admin.Users.BulkDirectCallRa.createAndUpdateServiceButton',
  AdminUsersBulkDirectCallRaIntro = 'Admin.Users.BulkDirectCallRa.intro',
  AdminUsersBulkDirectCallRaNeedSetupCount = 'Admin.Users.BulkDirectCallRa.needSetupCount',
  AdminUsersBulkDirectCallRaPersistFailed = 'Admin.Users.BulkDirectCallRa.persistFailed',
  AdminUsersBulkDirectCallRaReadFailed = 'Admin.Users.BulkDirectCallRa.readFailed',
  AdminUsersBulkDirectCallRaScopeForbidden = 'Admin.Users.BulkDirectCallRa.scopeForbidden',
  AdminUsersBulkDirectCallRaSuccess = 'Admin.Users.BulkDirectCallRa.success',
  AdminUsersBulkDirectCallRaSummaryBody = 'Admin.Users.BulkDirectCallRa.summaryBody',
  AdminUsersBulkDirectCallRaSummaryInstruction = 'Admin.Users.BulkDirectCallRa.summaryInstruction',
  AdminUsersBulkDirectCallRaSummaryNoChanges = 'Admin.Users.BulkDirectCallRa.summaryNoChanges',
  AdminUsersBulkDirectCallRaSummaryTitle = 'Admin.Users.BulkDirectCallRa.summaryTitle',
  AdminUsersBulkDirectCallRaTooManyUsers = 'Admin.Users.BulkDirectCallRa.tooManyUsers',
  AdminUsersBulkDirectCallRaTitle = 'Admin.Users.BulkDirectCallRa.title',
  AdminUsersBulkDirectCallRaToolbarButton = 'Admin.Users.BulkDirectCallRa.toolbarButton',
  AdminUsersBulkEditDcrResultLicenseCapExceeded = 'Admin.Users.BulkEdit.dcrResultLicenseCapExceeded',
  AdminUsersBulkEditDirectCallNotApplicable = 'Admin.Users.BulkEdit.directCallNotApplicable',
  AdminUsersBulkEditDirectCallRemoveDisabledTooltip = 'Admin.Users.BulkEdit.directCallRemoveDisabledTooltip',
  AdminUsersBulkEditDirectCallVerifyDisabledTooltip = 'Admin.Users.BulkEdit.directCallVerifyDisabledTooltip',
  AdminRunbookPowershell = 'Admin.Runbook.powershell',
  AdminRunbookPowershellExecute = 'Admin.Runbook.powershellExecute',
  AdminRunbookRunbook = 'Admin.Runbook.runbook',
  AdminRunbookRunbookDeployed = 'Admin.Runbook.runbookDeployed',
  AdminRunbookRunbookNotDeployed = 'Admin.Runbook.runbookNotDeployed',
  AdminServiceEdit = 'Admin.ServiceEdit.title',
  AdminServiceEditBulkInBulkProcessWarning = 'Admin.ServiceEdit.Bulk.inBulkProcessWarning',
  AdminServicesCreateService = 'Admin.Services.createService',
  AdminServicesCreateExtendService = 'Admin.Services.createExtendService',
  AdminServicesCreateUnifyService = 'Admin.Services.createUnifyService',
  AdminServicesProvisioningInProgress = 'Admin.Services.provisioningInProgress',
  AdminServicesNumberOfUsers = 'Admin.Services.numberOfUsers',
  AdminServiceStatePendingDeletion = 'Admin.ServiceState.pendingDeletion',
  AdminServiceStatePstnApplied = 'Admin.ServiceState.pstnApplied',
  AdminServiceStatePstnRunning = 'Admin.ServiceState.pstnRunning',
  AdminServiceStateServiceApplied = 'Admin.ServiceState.serviceApplied',
  AdminServiceStateServiceRunning = 'Admin.ServiceState.serviceRunning',
  AdminServiceStateSuspended = 'Admin.ServiceState.suspended',
  AdminServiceStateUncompleted = 'Admin.ServiceState.uncompleted',
  AdminSettingsNoTeams = 'Admin.Settings.noTeams',
  AdminSettingsNoTenants = 'Admin.Settings.noTenants',
  AdminTenantsListActivateWarning = 'Admin.TenantsList.activateWarning',
  AdminTenantsListSuspendWarning = 'Admin.TenantsList.suspendWarning',
  AdminTenantsNumberOfServices = 'Admin.Tenants.numberOfServices',
  AdminTenantsSearchPlaceholder = 'Admin.Tenants.searchPlaceholder',
  AdminTenantsOnceSavedCannotBeEdited = 'Admin.Tenants.onceSavedCannotBeEdited',
  AdminTenantsDetailsDirectCall = 'Admin.TenantsDetails.DirectCall',
  AdminTenantsDetailsNimbusUnifyProvisioningAlreadyProvisioned = 'Admin.TenantsDetails.nimbusUnifyProvisioningAlreadyProvisioned',
  AdminTenantsDetailsNimbusUnifyProvisioningCorrelationId = 'Admin.TenantsDetails.nimbusUnifyProvisioningCorrelationId',
  AdminTenantsDetailsNimbusUnifyProvisioningErrorAuthorizationFailed = 'Admin.TenantsDetails.nimbusUnifyProvisioningErrorAuthorizationFailed',
  AdminTenantsDetailsNimbusUnifyProvisioningErrorConfigurationInvalid = 'Admin.TenantsDetails.nimbusUnifyProvisioningErrorConfigurationInvalid',
  AdminTenantsDetailsNimbusUnifyProvisioningErrorCorrupted = 'Admin.TenantsDetails.nimbusUnifyProvisioningErrorCorrupted',
  AdminTenantsDetailsNimbusUnifyProvisioningErrorPersistenceFailed = 'Admin.TenantsDetails.nimbusUnifyProvisioningErrorPersistenceFailed',
  AdminTenantsDetailsNimbusUnifyProvisioningErrorQuotaExceeded = 'Admin.TenantsDetails.nimbusUnifyProvisioningErrorQuotaExceeded',
  AdminTenantsDetailsNimbusUnifyProvisioningErrorRequestInvalid = 'Admin.TenantsDetails.nimbusUnifyProvisioningErrorRequestInvalid',
  AdminTenantsDetailsNimbusUnifyProvisioningErrorResourceConflict = 'Admin.TenantsDetails.nimbusUnifyProvisioningErrorResourceConflict',
  AdminTenantsDetailsNimbusUnifyProvisioningErrorResourceNotFound = 'Admin.TenantsDetails.nimbusUnifyProvisioningErrorResourceNotFound',
  AdminTenantsDetailsNimbusUnifyProvisioningErrorServiceError = 'Admin.TenantsDetails.nimbusUnifyProvisioningErrorServiceError',
  AdminTenantsDetailsNimbusUnifyProvisioningErrorThrottled = 'Admin.TenantsDetails.nimbusUnifyProvisioningErrorThrottled',
  AdminTenantsDetailsNimbusUnifyProvisioningErrorTimeout = 'Admin.TenantsDetails.nimbusUnifyProvisioningErrorTimeout',
  AdminTenantsDetailsNimbusUnifyProvisioningErrorUnknown = 'Admin.TenantsDetails.nimbusUnifyProvisioningErrorUnknown',
  AdminTenantsDetailsNimbusUnifyProvisioningFailed = 'Admin.TenantsDetails.nimbusUnifyProvisioningFailed',
  AdminTenantsDetailsNimbusUnifyProvisioningInProgress = 'Admin.TenantsDetails.nimbusUnifyProvisioningInProgress',
  AdminTenantsDetailsNimbusUnifyProvisioningPending = 'Admin.TenantsDetails.nimbusUnifyProvisioningPending',
  AdminTenantsDetailsNimbusUnifyProvisioningStepCreateAcsResource = 'Admin.TenantsDetails.nimbusUnifyProvisioningStepCreateAcsResource',
  AdminTenantsDetailsNimbusUnifyProvisioningStepCreateCognitiveServicesResource = 'Admin.TenantsDetails.nimbusUnifyProvisioningStepCreateCognitiveServicesResource',
  AdminTenantsDetailsNimbusUnifyProvisioningStepCreateEventGridSubscription = 'Admin.TenantsDetails.nimbusUnifyProvisioningStepCreateEventGridSubscription',
  AdminTenantsDetailsNimbusUnifyProvisioningStepCreateLogAnalyticsWorkspace = 'Admin.TenantsDetails.nimbusUnifyProvisioningStepCreateLogAnalyticsWorkspace',
  AdminTenantsDetailsNimbusUnifyProvisioningStepCreateResourceGroup = 'Admin.TenantsDetails.nimbusUnifyProvisioningStepCreateResourceGroup',
  AdminTenantsDetailsNimbusUnifyProvisioningStepCreateSystemTopic = 'Admin.TenantsDetails.nimbusUnifyProvisioningStepCreateSystemTopic',
  AdminTenantsDetailsNimbusUnifyProvisioningStepEnableAcsLogging = 'Admin.TenantsDetails.nimbusUnifyProvisioningStepEnableAcsLogging',
  AdminTenantsDetailsNimbusUnifyProvisioningStepEnableCognitiveServicesLogging = 'Admin.TenantsDetails.nimbusUnifyProvisioningStepEnableCognitiveServicesLogging',
  AdminTenantsDetailsNimbusUnifyProvisioningStepProvisionedBeforeStepTracking = 'Admin.TenantsDetails.nimbusUnifyProvisioningStepProvisionedBeforeStepTracking',
  AdminTenantsDetailsNimbusUnifyProvisioningStepSetRbacPermissions = 'Admin.TenantsDetails.nimbusUnifyProvisioningStepSetRbacPermissions',
  AdminTenantsDetailsNimbusUnifyProvisioningStepSetTags = 'Admin.TenantsDetails.nimbusUnifyProvisioningStepSetTags',
  AdminTenantsDetailsNimbusUnifyProvisioningSucceeded = 'Admin.TenantsDetails.nimbusUnifyProvisioningSucceeded',
  AdminTenantsDetailsNimbusUnifyProvisioningTimedOut = 'Admin.TenantsDetails.nimbusUnifyProvisioningTimedOut',
  AdminTenantsDetailsNimbusUnifyProvisioningTitle = 'Admin.TenantsDetails.nimbusUnifyProvisioningTitle',
  AdminTenantsDetailsNimbusUnifyProvisioningViewStatus = 'Admin.TenantsDetails.nimbusUnifyProvisioningViewStatus',
  AdminToolsResolveCallerInformation = 'Admin.Tools.resolverCallerInformation',
  AdminUserAddAddNewUser = 'Admin.UserAdd.addNewUser',
  AdminUserAddContactAdministrator = 'Admin.UserAdd.Users.contactAdministrator',
  AdminUserAddPermissionError = 'Admin.UserAdd.Users.permissionError',
  AdminUserAddUserAddedInOtherLocation = 'Admin.UserAdd.userAddedInOtherLocation',
  AdminUserAddUserAddError = 'Admin.UserAdd.userAddError',
  AdminUserAddUserAlreadyAdded = 'Admin.UserAdd.userAlreadyAdded',
  AdminUserAssistantTemplates = 'Admin.UserList.Assistant.templates',
  AdminUserEdit = 'Admin.UserEdit.title',
  AdminUserEditBulkApplyToAll = 'Admin.UserEdit.Bulk.ApplyToAll',
  AdminUserEditBulkApplyToAllHint = 'Admin.UserEdit.Bulk.ApplyToAllHint',
  AdminUserEditBulkApplyToAllToolTip = 'Admin.UserEdit.Bulk.ApplyToAllToolTip',
  AdminUserEditBulkEnableNars = 'Admin.UserEdit.Bulk.EnableNars',
  AdminUserEditBulkInBulkProcessWarning = 'Admin.UserEdit.Bulk.InBulkProcessWarning',
  AdminUserEditBulkListNpdWarning = 'Admin.UserEdit.Bulk.ListNpdWarning',
  AdminUserEditBulkNpdWarning = 'Admin.UserEdit.Bulk.NpdWarning',
  AdminUserEditBulkRolesOUWarning = 'Admin.UserEdit.Bulk.RolesOUWarning',
  AdminUserEditBulkSkillAppliedToAll = 'Admin.UserEdit.Bulk.SkillAppliedToAll',
  AdminUserEditBulkSkillApplyDisabledNpd = 'Admin.UserEdit.Bulk.SkillApplyDisabledNpd',
  AdminUserEditBulkSkillApplyToAll = 'Admin.UserEdit.Bulk.SkillApplyToAll',
  AdminUserEditBulkSnippetWarning = 'Admin.UserEdit.Bulk.SnippetWarning',
  AdminUserEditBulkUsersBecameUnavailableAll = 'Admin.UserEdit.Bulk.UsersBecameUnavailableAll',
  AdminUserEditBulkUsersBecameUnavailablePartial = 'Admin.UserEdit.Bulk.UsersBecameUnavailablePartial',
  AdminUserInteractSettingsEnable = 'Admin.UserList.Interact.enable',
  AdminUserInteractSettingsEnableWarning = 'Admin.UserList.Interact.enableWarning',
  AdminUserInteractSettingsImWarning = 'Admin.UserList.Interact.imWarning',
  AdminUserInteractSettingsRestrictWarning = 'Admin.UserList.Interact.restrictWarning',
  AdminUserInteractSettingUserSnippet = 'Admin.UserList.Interact.userSnippet',
  AdminUserLisNotAvailableReasonsInfoMessage = 'Admin.UserList.NotAvailableReasons.infoMessage',
  AdminUserListColumnDepartment = 'Admin.UserList.Column.department',
  AdminUserListColumnDirectCall = 'Admin.UserList.Column.directCall',
  AdminUserListColumnDisplayName = 'Admin.UserList.Column.displayName',
  AdminUserListColumnFirstName = 'Admin.UserList.Column.firstName',
  AdminUserListColumnIsAttendantConsoleEnabled = 'Admin.UserList.Column.isAttendantConsoleEnabled',
  AdminUserListColumnLastName = 'Admin.UserList.Column.lastName',
  AdminUserListColumnNumberOfAssignedServices = 'Admin.UserList.Column.numberOfAssignedServices',
  AdminUserListColumnO365Id = 'Admin.UserList.Column.o365Id',
  AdminUserListColumnUpn = 'Admin.UserList.Column.upn',
  AdminUserListDisabledDeleteDescription = 'Admin.UserList.disabledDeleteDescription',
  AdminUserListDirectCallEnabledNotSetup = 'Admin.UserList.DirectCall.enabledNotSetup',
  AdminUserListDirectCallNoLicense = 'Admin.UserList.DirectCall.noLicense',
  AdminUserListDirectCallNotSetup = 'Admin.UserList.DirectCall.notSetup',
  AdminUserListDirectCallSetupDisabled = 'Admin.UserList.DirectCall.setupDisabled',
  AdminUserListDirectCallSetupEnabled = 'Admin.UserList.DirectCall.setupEnabled',
  AdminUserListDirectCallSetupPending = 'Admin.UserList.DirectCall.setupPending',
  AdminUserListProfilesApplyDisabled = 'Admin.UserList.Profiles.Apply.disabled',
  AdminUserListProfilesApplyNeeds = 'Admin.UserList.Profiles.Apply.needsFirst',
  AdminUserListProfilesApplyToSelected = 'Admin.UserList.Profiles.Apply.toSelected',
  AdminUserListProfilesCannotBeApplied = 'Admin.UserList.Profiles.Apply.cannotBeApplied',
  AdminUserListProfilesCannotBeDeleted = 'Admin.UserList.Profiles.Delete.cannotBeDeleted',
  AdminUserListRolesApplyCannotBeApplied = 'Admin.UserList.Roles.Apply.cannotBeApplied',
  AdminUserListRolesApplyCannotBeDeleted = 'Admin.UserList.Roles.Apply.cannotBeDeleted',
  AdminUserListRolesApplyDisabled = 'Admin.UserList.Roles.Apply.disabled',
  AdminUserListRolesApplyToSelected = 'Admin.UserList.Roles.Apply.toSelected',
  AdminUserListRolesApplyWarningOwnPermissionsChanges = 'Admin.UserList.Roles.Apply.warningOwnPermissionsChanges',
  AdminUserListTabAssistant = 'Admin.UserList.tabAssistant',
  AdminUserListTabDirectCall = 'Admin.UserList.tabDirectCall',
  AdminUserListTabGeneral = 'Admin.UserList.tabGeneral',
  AdminUserListTabInteract = 'Admin.UserList.tabInteract',
  AdminUserListTabNotAvailableReasons = 'Admin.UserList.tabNotAvailableReasons',
  AdminUserListTabNotAvailableReasonsTooltip = 'Admin.UserList.tabNotAvailableReasonsTooltip',
  AdminUserListTabProfiles = 'Admin.UserList.tabProfiles',
  AdminUserListTabRoles = 'Admin.UserList.tabRoles',
  AdminUserListTabServices = 'Admin.UserList.tabServices',
  AdminUserListTabSkills = 'Admin.UserList.tabSkills',
  AdminUserO365User = 'Admin.UserAdd.o365User',
  AdminUserTaskParallelizationByModality = 'Admin.UserTaskParallelization.byModality',
  AdminUserTaskParallelizationHigherThanCombinedLimits = 'Admin.UserTaskParallelization.higherThanCombinedLimits',
  AdminUserTaskParallelizationLowerThanCombinedLimits = 'Admin.UserTaskParallelization.lowerThanCombinedLimits',
  AdminUserTaskParallelizationTotalCapacity = 'Admin.UserTaskParallelization.totalCapacity',
  AdminUsersMSTeamsDirectCall = 'Admin.Users.mSTeamsDirectCall',
  AdminUsersNimbusUnify = 'Admin.Users.nimbusUnify',
  AdminUsersNimbusUnifyLicensesInfo = 'Admin.Users.nimbusUnifyLicensesInfo',
  AdminUsersNimbusUnifyLicensesSuccess = 'Admin.Users.nimbusUnifyLicensesSuccess',
  AriaLabelInputClear = 'AriaLabel.input.clear',
  AriaLabelInputEnterValue = 'AriaLabel.input.enterValue',
  AriaLabelInputSelectOption = 'AriaLabel.input.selectOption',
  AriaLabelTimePickerDays = 'AriaLabel.timePicker.days',
  AriaLabelTimePickerHours = 'AriaLabel.timePicker.hours',
  AriaLabelTimePickerMinutes = 'AriaLabel.timePicker.minutes',
  AriaLabelTimePickerOpen = 'AriaLabel.timePicker.open',
  AriaLabelTimePickerSeconds = 'AriaLabel.timePicker.seconds',
  AssistantContactLuwareSupport = 'Assistant.contactLuwareSupport',
  AssistantContextEmail = 'Context.Email',
  AssistantContextEmailOpenInMySession = 'Context.OpenEmail.InMySession',
  AssistantContextEmpty = 'Context.empty',
  AssistantContextImAddress = 'Context.ImAddress',
  AssistantContextNoDataToDisplay = 'Context.noDataToDisplay',
  AssistantContextOpenSessionDashboard = 'Context.openSessionDashboard',
  AssistantContextPrimaryTelNumber = 'Context.PrimaryTelNumber',
  AssistantContextTelNumber = 'Context.+TelNumber',
  AssistantMySessions = 'Assistant.mySessions',
  AssistantOpenChatConversation = 'Assistant.openChatConversation',
  AssistantOpenLogFolder = 'Assistant.openLogFolder',
  AssistantOutboundBlindTransfer = 'Assistant.Outbound.blindTransfer',
  AssistantOutboundConsultativeTransfer = 'Assistant.Outbound.consultativeTransfer',
  AssistantOutboundSafeTransfer = 'Assistant.Outbound.safeTransfer',
  AssistantOutboundTransfer = 'Assistant.Outbound.transfer',
  AssistantCallFooterBlindTransfer = 'Assistant.CallFooter.blindTransfer',
  AssistantCallFooterConsultativeTransfer = 'Assistant.CallFooter.consultativeTransfer',
  AssistantCallFooterSafeTransfer = 'Assistant.CallFooter.safeTransfer',
  AssistantOutboundCall = 'Assistant.Outbound.call',
  AssistantOutboundCallAs = 'Assistant.Outbound.callAs',
  AssistantParkedFooterLongestElapsedTime = 'Assistant.ParkedFooter.LongestElapsedTime',
  AssistantParkedFooterOpenMySessions = 'Assistant.ParkedFooter.OpenMySessions',
  AssistantParkedFooterTasksCount = 'Assistant.ParkedFooter.TasksCount',
  AssistantSessionFooterActionsConference = 'Assistant.SessionFooter.Actions.conference',
  AssistantSessionFooterActionsHangupAndRetrieve = 'Assistant.SessionFooter.Actions.hangupAndRetrieve',
  AssistantSessionFooterActionsHold = 'Assistant.SessionFooter.Actions.hold',
  AssistantSessionFooterActionsRetrieve = 'Assistant.SessionFooter.Actions.retrieve',
  AssistantSessionFooterActionsHangup = 'Assistant.SessionFooter.Actions.hangup',
  AssistantSessionFooterActionsHangupWithDots = 'Assistant.SessionFooter.Actions.hangupWithDots',
  AssistantSessionFooterActionsTerminate = 'Assistant.SessionFooter.Actions.terminate',
  AssistantSessionFooterActionsTransfer = 'Assistant.SessionFooter.Actions.transfer',
  AssistantSessionFooterActionsSwap = 'Assistant.SessionFooter.Actions.swap',
  AssistantSessionFooterConversationStateOngoing = 'Assistant.SessionFooter.ConversationState.ongoing',
  AssistantSessionFooterConversationStateTransferring = 'Assistant.SessionFooter.ConversationState.transferring',
  AssistantSessionFooterConversationStateTransferFailed = 'Assistant.SessionFooter.ConversationState.transferfailed',
  AssistantSessionFooterConversationStateTransferSuccessful = 'Assistant.SessionFooter.ConversationState.transfersuccessful',
  AssistantSessionFooterConversationStatePutOnHold = 'Assistant.SessionFooter.ConversationState.putOnHold',
  AssistantSettingsAutorun = 'Assistant.Settings.autorun',
  AssistantSettingsBringToForeground = 'Assistant.Settings.bringToForeground',
  AssistantSettingsLanguage = 'Settings.language.title',
  AssistantSettingsNotificationsActive = 'Assistant.Settings.Notifications.active',
  AssistantSettingsNotificationsEmail = 'Assistant.Settings.Notifications.email',
  AssistantSettingsNotificationsExternalTask = 'Assistant.Settings.Notifications.externalTask',
  AssistantSettingsNotificationsInstantMessage = 'Assistant.Settings.Notifications.instantMessage',
  AssistantSettingsPosition = 'Settings.position.title',
  AssistantSettingsPositionBottomRight = 'Settings.position.bottomRight',
  AssistantSettingsPositionTopRight = 'Settings.position.topRight',
  AssistantSettingsTopmost = 'Assistant.Settings.topmost',
  AssistantSettingsZoom = 'Assistant.Settings.zoom',
  AssistantStateNotSelectable = 'AssistantState.notSelectable',
  AssistantStateSelectable = 'AssistantState.selectable',
  AssistantTaskFooterDirectCall = 'Assistant.TaskFooter.directCall',
  AssistantTenantSuspended = 'Assistant.tenantSuspended',
  AssistantWarningLoginFailed = 'Assistant.Warning.loginFailed',
  AssistantWarningLoginFailedPrincipalAcs = 'Assistant.Warning.loginFailedPrincipalAcs',
  AttendantConsoleContactSearchGroupManager = 'AttendantConsole.ContactSearch.Group.manager',
  AttendantConsoleContactSearchGroupPeers = 'AttendantConsole.ContactSearch.Group.peers',
  AttendantConsoleContactSearchGroupPeopleReporting = 'AttendantConsole.ContactSearch.Group.peopleReporting',
  AttendantConsoleContactSearchGroupService = 'AttendantConsole.ContactSearch.Group.service',
  AttendantConsoleContactSearchNoOrgContacts = 'AttendantConsole.ContactSearch.noOrgContacts',
  AttendantConsoleContactSearchOrgStructure = 'AttendantConsole.ContactSearch.orgStructure',
  AttendantConsoleContactSearchShowAll = 'AttendantConsole.ContactSearch.showAll',
  AttendantConsoleContactSearchShowManager = 'AttendantConsole.ContactSearch.showManager',
  AttendantConsoleContactSearchShowPeers = 'AttendantConsole.ContactSearch.showPeers',
  AttendantConsoleContactSearchShowReports = 'AttendantConsole.ContactSearch.showReports',
  AttendantConsolePickupSignalAudioEnabled = 'AttendantConsole.PickupSignal.audioEnabled',
  AttendantConsolePickupSignalAudioStyle = 'AttendantConsole.PickupSignal.audioStyle',
  AttendantConsolePickupSignalSectionTitle = 'AttendantConsole.PickupSignal.sectionTitle',
  AttendantStateAcw = 'AttendantState.acw',
  AttendantStateAcwDesc = 'AttendantState.acwDesc',
  AttendantStateDisabled = 'AttendantState.disabled',
  AttendantStateEnabled = 'AttendantState.enabled',
  AttendantStateInADirectConversation = 'AttendantState.inADirectConversation',
  AttendantStateInAnExternalTask = 'AttendantState.inAnExternalTask',
  AttendantStateInAnOutboundCallbackServiceTask = 'AttendantState.inAnOutboundCallbackServiceTask',
  AttendantStateInAnOutboundServiceTask = 'AttendantState.inAnOutboundServiceTask',
  AttendantStateInAServiceTask = 'AttendantState.inAServiceTask',
  AttendantStateLyncState = 'AttendantState.lyncState',
  AttendantStateLyncStateDesc = 'AttendantState.lyncStateDesc',
  AttendantStateNotSelectable = 'AttendantState.notSelectable',
  AttendantStateOffDutyProfile = 'AttendantState.offDutyProfile',
  AttendantStateOffDutyProfileDesc = 'AttendantState.offDutyProfileDesc',
  AttendantStatePresence = 'AttendantState.presence',
  AttendantStateProfile = 'AttendantState.profile',
  AttendantStateRona = 'AttendantState.rona',
  AttendantStateRonaDesc = 'AttendantState.ronaDesc',
  AttendantStateSelectable = 'AttendantState.selectable',
  AttendantStateTitle = 'AttendantState.title',
  AttendantStateWorking = 'AttendantState.working',
  AuthAdminConsentAccessDenied = 'Auth.AdminConsent.accessDenied',
  AuthAdminConsentApplyingPermissions = 'Auth.AdminConsent.applyingPermissions',
  AuthAdminConsentDefaultErrorDetails = 'Auth.AdminConsent.defaultErrorDetails',
  AuthAdminConsentError = 'Auth.AdminConsent.error',
  AuthAdminConsentSuccess = 'Auth.AdminConsent.success',
  AuthConnected = 'Auth.connected',
  AuthErrorNoPermission = 'Auth.Error.noPermission',
  AuthErrorTenantSuspended = 'Auth.Error.tenantSuspended',
  AuthErrorUnexpectedError = 'Auth.Error.unexpectedError',
  AuthMsSignin = 'Auth.msSignin',
  AuthPowered = 'Auth.powered',
  AuthVersion = 'Auth.version',
  BulkEditAbort = 'BulkEdit.abort',
  BulkEditDisabledByLicense = 'BulkEdit.disabledByLicense',
  BulkEditDisabledNotAvailable = 'BulkEdit.disabledNotAvailable',
  BulkEditEnableMode = 'BulkEdit.enableMode',
  BulkEditExportAllCsv = 'BulkEdit.exportAllCsv',
  BulkEditExportAllJson = 'BulkEdit.exportAllJson',
  BulkEditExportCsv = 'BulkEdit.exportCsv',
  BulkEditExportFailed = 'BulkEdit.exportFailed',
  BulkEditExporting = 'BulkEdit.exporting',
  BulkEditExportJson = 'BulkEdit.exportJson',
  BulkEditExportPartial = 'BulkEdit.exportPartial',
  BulkEditExportSuccess = 'BulkEdit.exportSuccess',
  BulkEditOpenDetails = 'BulkEdit.openDetails',
  BulkEditOperation = 'BulkEdit.operation',
  BulkEditProcessed = 'BulkEdit.processed',
  BulkEditSelected = 'BulkEdit.selected',
  BulkEditTabDisabledUserAssignmentType = 'BulkEdit.tabDisabledUserAssignmentType',
  BulkEditTitle = 'BulkEdit.title',
  BulkEditTitleBulkRemove = 'BulkEdit.titleBulkRemove',
  BulkEditUnsavedChangesButtonTooltip = 'BulkEdit.unsavedChangesButtonTooltip',
  BulkEditTypeDifferent = 'BulkEdit.Type.different',
  BulkEditTypeEqual = 'BulkEdit.Type.equal',
  BulkEditTypeReadonly = 'BulkEdit.Type.readonly',
  AriaLabelCalendarExpand = 'AriaLabel.calendar.expand',
  AriaLabelCalendarGoToToday = 'AriaLabel.calendar.goToToday',
  AriaLabelCalendarNextDay = 'AriaLabel.calendar.nextDay',
  AriaLabelCalendarPreviousDay = 'AriaLabel.calendar.previousDay',
  AriaLabelCompanionPanelDivider = 'AriaLabel.companion.divider',
  AriaLabelContactActionCall = 'AriaLabel.contactAction.call',
  AriaLabelContactActionConnect = 'AriaLabel.contactAction.connect',
  AriaLabelContactActionSendMail = 'AriaLabel.contactAction.sendMail',
  AriaLabelContactActionSendMessage = 'AriaLabel.contactAction.sendMessage',
  AriaLabelContactFavouriteAdd = 'AriaLabel.contactFavourite.add',
  AriaLabelContactFavouriteRemove = 'AriaLabel.contactFavourite.remove',
  AriaLabelHeaderHelp = 'AriaLabel.header.help',
  AriaLabelQueueCollapse = 'AriaLabel.queue.collapse',
  AriaLabelQueueExpand = 'AriaLabel.queue.expand',
  AriaLabelDetailsPanelOptions = 'AriaLabel.details.panelOptions',
  AriaLabelTaskAreaCollapse = 'AriaLabel.taskArea.collapse',
  AriaLabelTaskAreaDivider = 'AriaLabel.taskArea.divider',
  AriaLabelTaskAreaExpand = 'AriaLabel.taskArea.expand',
  AriaLabelTeamToggleActive = 'AriaLabel.team.toggleActive',
  CalendarEnd = 'Calendar.end',
  CalendarFrom = 'Calendar.from',
  CalendarLocation = 'Calendar.location',
  CalendarOpenFullView = 'Calendar.openFullView',
  CalendarStart = 'Calendar.start',
  CalendarSubject = 'Calendar.subject',
  CallAsNotEligible = 'CallAs.notEligible',
  CallAsHaveActiveTaskNow = 'CallAs.haveActiveTaskNow',
  CallAsNameNumber = 'CallAs.nameNumber',
  CallAsNoContactsFound = 'CallAs.noContactFoundInvalid164Number',
  CallAsNoPermissions = 'CallAs.noPermissions',
  CallAsOutboundService = 'CallAs.outboundService',
  CallAsRejectAllCallsEnabled = 'CallAs.rejectAllCallsEnabled',
  CallAsServiceCannotBeFound = 'CallAs.serviceCannotBeFound',
  CallAsServiceWasSuspended = 'CallAs.serviceWasSuspended',
  CallAsTitle = 'CallAs.title',
  CallAsYouHaveAnActiveTaskNow = 'CallAs.uHaveAnActiveTaskNow',
  CallCloseTask = 'Call.closeTask',
  CallFlowTabAccepted = 'CallFlowTab.accepted',
  CallFlowTabCalled = 'CallFlowTab.called',
  CallFlowTabCalling = 'CallFlowTab.calling',
  CallFlowTabCall = 'CallFlowTab.call',
  CallFlowTabOutboundCall = 'CallFlowTab.outboundCall',
  CallFlowTabCallOnBehalf = 'CallFlowTab.callOnBehalf',
  CallFlowTabConsultationCall = 'CallFlowTab.consultationCall',
  CallFlowTabIm = 'CallFlowTab.im',
  CallFlowTabEmail = 'CallFlowTab.email',
  CallFlowTabTransfer = 'CallFlowTab.transfer',
  CallFlowTabTransferredTo = 'CallFlowTab.transferredTo',
  CallFlowTabConsultedTo = 'CallFlowTab.consultedTo',
  CallFlowTabWrote = 'CallFlowTab.wrote',
  CallInCall = 'Call.inCall',
  CallInChat = 'Call.inChat',
  CallInEmail = 'Call.inEmail',
  CallInExternalTask = 'Call.inExternalTask',
  CallOnHold = 'Call.onHold',
  CallParked = 'Call.parked',
  CallPickupInitiated = 'CallPickup.initiated',
  CallPickupNoCapacity = 'CallPickup.noCapacity',
  ChartLastUpdated = 'Chart.lastUpdated',
  GeneralEndDate = 'General.endDate',
  GeneralEndTime = 'General.endTime',
  GeneralFalse = 'General.false',
  GeneralStartDate = 'General.startDate',
  GeneralStartTime = 'General.startTime',
  GeneralTrue = 'General.true',
  MenuOperations = 'Menu.Operations',
  TaskPickupSuccessful = 'TaskPickup.successful',
  TaskPickupUnknownError = 'TaskPickup.unknownError',
  CallPickupNotAvailablSstate = 'CallPickup.notAvailableState',
  CallPickupPickedupBySomeone = 'CallPickup.pickedUpBySomeone',
  CallPickupSkillMismatch = 'CallPickup.skillMismatch',
  CallPickupSuccessful = 'CallPickup.successful',
  CallPickupUnknownError = 'CallPickup.unknownError',
  CallStateAccepted = 'CallState.accepted',
  CallStateBusy = 'CallState.busy',
  CallStateCanceled = 'CallState.canceled',
  CallStateDeclined = 'CallState.declined',
  CallStateFailed = 'CallState.failed',
  CallStateConferenced = 'CallState.conferenced',
  CallStateParked = 'CallState.parked',
  CallStatePutOnHold = 'CallState.putOnHold',
  CallStateRinging = 'CallState.ringing',
  CallStateRona = 'CallState.rona',
  CallStateTerminated = 'CallState.terminated',
  CallStateTransferred = 'CallState.transferred',
  CallTabsChatFlow = 'Call.tabs.chatFlow',
  CallTabsCodes = 'Call.tabs.codes',
  CallTabsContext = 'Call.tabs.context',
  CallTabsFlow = 'Call.tabs.flow',
  ChartLabelAcceptanceSLA = 'Chart.Label.acceptanceSLA',
  ChartLabelAccepted = 'Chart.Label.accepted',
  ChartLabelAcceptedByUser = 'Chart.Label.acceptedByUser',
  ChartLabelAll = 'Chart.Label.all',
  ChartLabelAverage = 'Chart.Label.average',
  ChartLabelCallbackScheduleSuccess = 'Chart.Label.callbackScheduleSuccess',
  ChartLabelCanceled = 'Chart.Label.canceled',
  ChartLabelCanceledByExternalSystem = 'Chart.Label.canceledByExternalSystem',
  ChartLabelConnected = 'Chart.Label.connected',
  ChartLabelConnectedTimeKPI = 'Chart.Label.connectedTimeKPI',
  ChartLabelConsulted = 'Chart.Label.consulted',
  ChartLabelConsultedTransferred = 'Chart.Label.consultedTransferred',
  ChartLabelConversationRecorded = 'Chart.Label.conversationRecorded',
  ChartLabelConversations = 'Chart.Label.Conversations',
  ChartLabelCurrentTasks = 'Chart.Label.currentTasks',
  ChartLabelCustomerHangupBeforeAccept = 'Chart.Label.customerHangupBeforeAccept',
  ChartLabelCustomerHangupInIvr = 'Chart.Label.customerHangupInIvr',
  ChartLabelCustomerHangupInIvrAfterQueue = 'Chart.Label.customerHangupInIvrAfterQueue',
  ChartLabelCustomerHangupInQueue = 'Chart.Label.customerHangupInQueue',
  ChartLabelDeclined = 'Chart.Label.declined',
  ChartLabelDeclinedByWorkflowAfterQueue = 'Chart.Label.declinedByWorkflowAfterQueue',
  ChartLabelDeclinedByWorkflowWhenNoQueue = 'Chart.Label.declinedByWorkflowWhenNoQueue',
  ChartLabelDestinationAccepted = 'Chart.Label.destinationAccepted',
  ChartLabelDestinationDeclined = 'Chart.Label.destinationDeclined',
  ChartLabelDestinationNotReached = 'Chart.Label.destinationNotReached',
  ChartLabelDialingOut = 'Chart.Label.dialingOut',
  ChartLabelEmail = 'Chart.Label.email',
  ChartLabelEMPTY_SERIES = 'Chart.Label.empty',
  ChartLabelExternalTask = 'Chart.Label.externalTask',
  ChartLabelFailed = 'Chart.Label.failed',
  ChartLabelHandledByAcceptSLA = 'Chart.Label.handledByAcceptSLA',
  ChartLabelHandledByHangupSLA = 'Chart.Label.handledByHangupSLA',
  ChartLabelHandledCalls = 'Chart.Label.handled',
  ChartLabelHangupBeforeAccept = 'Chart.Label.hangupBeforeAccept',
  ChartLabelHangupByWorkflow = 'Chart.Label.hangupByWorkflow',
  ChartLabelHangupInIVR = 'Chart.Label.hangupInIVR',
  ChartLabelHangupInIVRAfterQueue = 'Chart.Label.hangupInIVRAfterQueue',
  ChartLabelHangupInQueue = 'Chart.Label.hangupInQueue',
  ChartLabelHangupSLA = 'Chart.Label.hangupSLA',
  ChartLabelInbound = 'Chart.Label.inbound',
  ChartLabelInboundAcceptedByUser = 'Chart.Label.inboundAcceptedByUser',
  ChartLabelInboundReachability = 'Chart.Label.inboundReachability',
  ChartLabelOutboundReachability = 'Chart.Label.outboundReachability',
  ChartLabelInIvr = 'Chart.Label.inIVR',
  ChartLabelInIvrAfterQueue = 'Chart.Label.inIvrAfterQueue',
  ChartLabelInProgress = 'Chart.Label.inProgress',
  ChartLabelInQueue = 'Chart.Label.inQueue',
  ChartLabelInstantMessaging = 'Chart.Label.instantMessaging',
  ChartLabelLostInQueue = 'Chart.Label.lostInQueue',
  ChartLabelMarkedAsHandledByUser = 'Chart.Label.markedAsHandledByUser',
  ChartLabelMarkedAsHandledByWorkflow = 'Chart.Label.markedAsHandledByWorkflow',
  ChartLabelNoData = 'Chart.Label.noData',
  ChartLabelNotAccepted = 'Chart.Label.notAccepted',
  ChartLabelNotHandledByAcceptSLA = 'Chart.Label.notHandledByAcceptSLA',
  ChartLabelNotHandledByHangupSLA = 'Chart.Label.notHandledByHangupSLA',
  ChartLabelNotHandledCalls = 'Chart.Label.notHandled',
  ChartLabelOther = 'Chart.Label.other',
  ChartLabelOutbound = 'Chart.Label.outbound',
  ChartLabelOutcomeHandled = 'Chart.Label.outcomeHandled',
  ChartLabelParked = 'Chart.Label.parked',
  ChartLabelPutOnHold = 'Chart.Label.putOnHold',
  ChartLabelQueueTimeKPI = 'Chart.Label.queueTimeKPI',
  ChartLabelRinging = 'Chart.Label.ringing',
  ChartLabelRona = 'Chart.Label.rona',
  ChartLabelScheduled = 'Chart.Label.scheduled',
  ChartLabelServiceStateDisabled = 'Chart.Label.serviceStateDisabled',
  ChartLabelServiceStatePSTNApplied = 'Chart.Label.serviceStatePSTNApplied',
  ChartLabelServiceStatePSTNRunning = 'Chart.Label.serviceStatePSTNRunning',
  ChartLabelServiceStateServicesApplied = 'Chart.Label.serviceStateServicesApplied',
  ChartLabelServiceStateServicesRunning = 'Chart.Label.serviceStateServicesRunning',
  ChartLabelServiceStateSuspended = 'Chart.Label.serviceStateSuspended',
  ChartLabelServiceStateUncompleted = 'Chart.Label.serviceStateUncompleted',
  ChartLabelStandbyDutyAccepted = 'Chart.Label.standByDutyAccepted',
  ChartLabelStandbyDutyExternalAccepted = 'Chart.Label.standByDutyExternalAccepted',
  ChartLabelTasks = 'Chart.Label.tasks',
  ChartLabelTasksKPI = 'Chart.Label.tasksKPI',
  ChartLabelTransferFailed = 'Chart.Label.transferFailed',
  ChartLabelTransferred = 'Chart.Label.transferred',
  ChartLabelTransferredByUser = 'Chart.Label.transferredByUser',
  ChartLabelTransferredByWorkflow = 'Chart.Label.transferredByWorkflow',
  ChartLabelTransferring = 'Chart.Label.transferring',
  ChartLabelUserAborted = 'Chart.Label.userAborted',
  ChartLabelUserAccepted = 'Chart.Label.userAccepted',
  ChartLabelUserExternalTransferFailed = 'Chart.Label.userExternalTransferFailed',
  ChartLabelUserExternalTransferSuccessful = 'Chart.Label.userExternalTransferSuccessful',
  ChartLabelUserInternalTransferFailed = 'Chart.Label.userInternalTransferFailed',
  ChartLabelUserInternalTransferSuccessful = 'Chart.Label.userInternalTransferSuccessful',
  ChartLabelVoicemail = 'Chart.Label.Voicemail',
  ChartLabelWorkflowDisconnect = 'Chart.Label.workflowDisconnect',
  ChartLabelWorkflowDisconnectAfterQueue = 'Chart.Label.workflowDisconnectAfterQueue',
  ChartLabelWorkflowExternalTransferFailed = 'Chart.Label.externalTransferFailed',
  ChartLabelWorkflowExternalTransferSuccessful = 'Chart.Label.externalTransferSuccessful',
  ChartLabelWorkflowInternalTransferFailed = 'Chart.Label.internalTransferFailed',
  ChartLabelWorkflowInternalTransferSuccessful = 'Chart.Label.internalTransferSuccessful',
  ChatTitleRcs = 'Chat.Title.rcs',
  ChatTitleSms = 'Chat.Title.sms',
  ChatTitleWhatsapp = 'Chat.Title.whatsapp',
  ChatWidgetAttachFilesTooltip = 'Chat.Widget.attachFilesTooltip',
  ChatWidgetAttachmentTooLarge = 'Chat.Widget.attachmentTooLarge',
  ChatWidgetAttachmentTypeNotSupported = 'Chat.Widget.attachmentTypeNotSupported',
  ChatWidgetEmojiCategoryActivity = 'Chat.Widget.emojiCategoryActivity',
  ChatWidgetEmojiCategoryCustom = 'Chat.Widget.emojiCategoryCustom',
  ChatWidgetEmojiCategoryFlags = 'Chat.Widget.emojiCategoryFlags',
  ChatWidgetEmojiCategoryFoods = 'Chat.Widget.emojiCategoryFoods',
  ChatWidgetEmojiCategoryNature = 'Chat.Widget.emojiCategoryNature',
  ChatWidgetEmojiCategoryObjects = 'Chat.Widget.emojiCategoryObjects',
  ChatWidgetEmojiCategoryPeople = 'Chat.Widget.emojiCategoryPeople',
  ChatWidgetEmojiCategoryPlaces = 'Chat.Widget.emojiCategoryPlaces',
  ChatWidgetEmojiCategoryRecent = 'Chat.Widget.emojiCategoryRecent',
  ChatWidgetEmojiCategorySearchResults = 'Chat.Widget.emojiCategorySearchResults',
  ChatWidgetEmojiCategorySymbols = 'Chat.Widget.emojiCategorySymbols',
  ChatWidgetEmojiPickerOpen = 'Chat.Widget.emojiPickerOpen',
  ChatWidgetEmojiPickerTitle = 'Chat.Widget.emojiPickerTitle',
  ChatWidgetFormatBold = 'Chat.Widget.formatBold',
  ChatWidgetFormatBulletedList = 'Chat.Widget.formatBulletedList',
  ChatWidgetFormatCode = 'Chat.Widget.formatCode',
  ChatWidgetFormatItalic = 'Chat.Widget.formatItalic',
  ChatWidgetFormatMonospace = 'Chat.Widget.formatMonospace',
  ChatWidgetFormatNumberedList = 'Chat.Widget.formatNumberedList',
  ChatWidgetFormatQuote = 'Chat.Widget.formatQuote',
  ChatWidgetFormatStrikethrough = 'Chat.Widget.formatStrikethrough',
  ChatWidgetFormattingOptionsToggle = 'Chat.Widget.formattingOptionsToggle',
  ChatWidgetFormPendingHint = 'Chat.Widget.formPendingHint',
  ChatWidgetFormReject = 'Chat.Widget.formReject',
  ChatWidgetFormRejectComment = 'Chat.Widget.formRejectComment',
  ChatWidgetFormSubmit = 'Chat.Widget.formSubmit',
  ChatWidgetInputMessageDisabledPlaceholder = 'Chat.Widget.inputMessageDisabledPlaceholder',
  ChatWidgetInputMessageEndedSessionPlaceholder = 'Chat.Widget.inputMessageEndedSessionPlaceholder',
  ChatWidgetInputMessagePlaceholder = 'Chat.Widget.inputMessagePlaceholder',
  ChatWidgetLoadingMessages = 'Chat.Widget.loadingMessages',
  ChatWidgetMessageAttachment = 'Chat.Widget.messageAttachment',
  ChatWidgetMessageAttachmentBlockedTooltipFileTypeMismatch = 'Chat.Widget.messageAttachmentBlockedTooltipFileTypeMismatch',
  ChatWidgetMessageAttachmentBlockedTooltipFileTypeNotAllowed = 'Chat.Widget.messageAttachmentBlockedTooltipFileTypeNotAllowed',
  ChatWidgetMessageAttachmentBlockedTooltipNoPolicyAssigned = 'Chat.Widget.messageAttachmentBlockedTooltipNoPolicyAssigned',
  ChatWidgetMessageAttachmentBlockedTooltipPolicyUnavailable = 'Chat.Widget.messageAttachmentBlockedTooltipPolicyUnavailable',
  ChatWidgetMessageAttachmentBlockedTooltipTooLarge = 'Chat.Widget.messageAttachmentBlockedTooltipTooLarge',
  ChatWidgetMessageAttachmentBlockedTooltipUnknownFileType = 'Chat.Widget.messageAttachmentBlockedTooltipUnknownFileType',
  ChatWidgetMessageAttachmentDownloadFailed = 'Chat.Widget.messageAttachmentDownloadFailed',
  ChatWidgetMessageAuthorNimbusSystem = 'Chat.Widget.messageAuthorNimbusSystem',
  ChatWidgetMessageAuthorYou = 'Chat.Widget.messageAuthorYou',
  ChatWidgetMessageDeliveryFailureReasonChannelPolicyViolation = 'Chat.Widget.messageDeliveryFailureReasonChannelPolicyViolation',
  ChatWidgetMessageDeliveryFailureReasonGeneric = 'Chat.Widget.messageDeliveryFailureReasonGeneric',
  ChatWidgetMessageDeliveryFailureReasonGenericText = 'Chat.Widget.messageDeliveryFailureReasonGenericText',
  ChatWidgetMessageDeliveryFailureReasonMessageFiltered = 'Chat.Widget.messageDeliveryFailureReasonMessageFiltered',
  ChatWidgetMessageDeliveryFailureReasonMessagingWindowExpired = 'Chat.Widget.messageDeliveryFailureReasonMessagingWindowExpired',
  ChatWidgetMessageDeliveryFailureReasonRateLimited = 'Chat.Widget.messageDeliveryFailureReasonRateLimited',
  ChatWidgetMessageDeliveryFailureReasonRecipientUnreachable = 'Chat.Widget.messageDeliveryFailureReasonRecipientUnreachable',
  ChatWidgetMessageDeliveryFailureReasonUnknown = 'Chat.Widget.messageDeliveryFailureReasonUnknown',
  ChatWidgetMessageDeliveryFailureReasonUnsupportedMediaContent = 'Chat.Widget.messageDeliveryFailureReasonUnsupportedMediaContent',
  ChatWidgetMessageFailedToSent = 'Chat.Widget.messageFailedToSent',
  ChatWidgetMessageFailedTryAgain = 'Chat.Widget.messageFailedTryAgain',
  ChatWidgetMessageFileSharingNotSupported = 'Chat.Widget.messageFileSharingNotSupported',
  ChatWidgetMessageLimitExceededTooltip = 'Chat.Widget.messageLimitExceededTooltip',
  ChatWidgetMessageReadLess = 'Chat.Widget.messageReadLess',
  ChatWidgetMessageReadMore = 'Chat.Widget.messageReadMore',
  ChatWidgetMessageSendFailed = 'Chat.Widget.messageSendFailed',
  ChatWidgetNotAvailable = 'Chat.Widget.notAvailable',
  ChatWidgetRecordingWithAttachmentsTooltip = 'Chat.Widget.recordingWithAttachmentsTooltip',
  ChatWidgetSendMessageTooltip = 'Chat.Widget.sendMessageTooltip',
  ChatWidgetVoiceMessageTooltip = 'Chat.Widget.voiceMessageTooltip',
  CommonSortDisabledHint = 'Common.sort.disabledHint',
  CommonSortNewest = 'Common.sort.newest',
  CommonSortOldest = 'Common.sort.oldest',
  CommonSortOrder = 'Common.sort.order',
  CompanionChatApprovalDescription = 'CompanionChat.approvalDescription',
  CompanionChatApprovalTitle = 'CompanionChat.approvalTitle',
  CompanionChatAuthorAgent = 'CompanionChat.authorAgent',
  CompanionChatAuthorSystem = 'CompanionChat.authorSystem',
  CompanionChatAuthorUser = 'CompanionChat.authorUser',
  CompanionChatRateLimitedError = 'CompanionChat.rateLimitedError',
  CompanionChatUnprocessableError = 'CompanionChat.unproceedableError',
  CompanionChatFailSendMessage = 'CompanionChat.failSendMessage',
  CompanionChatNotFoundError = 'CompanionChat.notFoundError',
  CompanionChatLicenseLimitExceededError = 'CompanionChat.licenseLimitExceededError',
  CompanionChatForbiddenError = 'CompanionChat.forbiddenError',
  CompanionChatUnauthorizedError = 'CompanionChat.unauthorizedError',
  CompanionChatUnavailableError = 'CompanionChat.unavailableError',
  CompanionChatTimeoutError = 'CompanionChat.timeoutError',
  CompanionChatHello = 'CompanionChat.hello',
  CompanionChatSubmittedValues = 'CompanionChat.submittedValues',
  CompanionVirtualUserFormDescription = 'CompanionChat.virtualUserFormDescription',
  CompanionVirtualUserFormTitle = 'CompanionChat.virtualUserFormTitle',
  CompanionVirtualUserReadFormTitle = 'CompanionChat.virtualUserReadFormTitle',
  CompanionVirtualUserUpdateFormTitle = 'CompanionChat.virtualUserUpdateFormTitle',
  CompanionChatMessagePlaceholder = 'CompanionChat.messagePlaceholder',
  CompanionChatTitle = 'CompanionChat.title',
  CompanionChatPageHistoryClearHistory = 'CompanionChatPage.History.clearHistory',
  CompanionChatPageHistoryClearHistoryConfirmBody = 'CompanionChatPage.History.clearHistoryConfirmBody',
  CompanionChatPageHistoryClearHistoryConfirmTitle = 'CompanionChatPage.History.clearHistoryConfirmTitle',
  CompanionChatPageHistoryClearHistoryError = 'CompanionChatPage.History.clearHistoryError',
  CompanionChatPageHistoryClearHistorySuccess = 'CompanionChatPage.History.clearHistorySuccess',
  CompanionChatPageHistoryCollapse = 'CompanionChatPage.History.collapse',
  CompanionChatPageHistoryDeleteConversationConfirmBody = 'CompanionChatPage.History.deleteConversationConfirmBody',
  CompanionChatPageHistoryDeleteConversationConfirmTitle = 'CompanionChatPage.History.deleteConversationConfirmTitle',
  CompanionChatPageHistoryEmpty = 'CompanionChatPage.History.empty',
  CompanionChatPageHistoryError = 'CompanionChatPage.History.error',
  CompanionChatPageHistoryExpand = 'CompanionChatPage.History.expand',
  CompanionChatPageHistoryLoadMore = 'CompanionChatPage.History.loadMore',
  CompanionChatPageHistoryMenuLabel = 'CompanionChatPage.History.menuLabel',
  CompanionChatPageHistoryNewChat = 'CompanionChatPage.History.newChat',
  CompanionChatPageHistoryRenameConversationError = 'CompanionChatPage.History.renameConversationError',
  CompanionChatPageHistoryRenameConversationSuccess = 'CompanionChatPage.History.renameConversationSuccess',
  CompanionChatPageHistoryRetry = 'CompanionChatPage.History.retry',
  CompanionChatPageHistoryTitle = 'CompanionChatPage.History.title',
  CompanionChatPageTitle = 'CompanionChatPage.title',
  CompanionChatWelcomeMessage = 'CompanionChat.welcomeMessage',
  CompanionChatWelcomeQuestion = 'CompanionChat.welcomeQuestion',
  CompanionChatSuggestion1Category = 'CompanionChat.Suggestion.suggestion1Category',
  CompanionChatSuggestion1 = 'CompanionChat.Suggestion.suggestion1',
  CompanionChatSuggestion2Category = 'CompanionChat.Suggestion.suggestion2Category',
  CompanionChatSuggestion2 = 'CompanionChat.Suggestion.suggestion2',
  CompanionChatSuggestion3Category = 'CompanionChat.Suggestion.suggestion3Category',
  CompanionChatSuggestion3 = 'CompanionChat.Suggestion.suggestion3',
  CompanionChatInfoTopSources = 'CompanionChat.Info.topSources',
  CompanionChatAiDisclaimer = 'CompanionChat.aiDisclaimer',
  CompanionChatCollapse = 'CompanionChat.collapse',
  CompanionChatExpand = 'CompanionChat.expand',
  CompanionChatExpandScreen = 'CompanionChat.expandScreen',
  CompanionChatSplitScreen = 'CompanionChat.splitScreen',
  CompanionChatFullScreen = 'CompanionChat.fullScreen',
  ContactActionBlindTransfer = 'ContactAction.blindTransfer',
  ContactActionBlindTransferIsDisabledDueTransferOnUserExit = 'ContactAction.blindTransferIsDisabledDueTransferOnUserExit',
  ContactActionCalendar = 'ContactAction.calendar',
  ContactActionCalendarContactNoLicense = 'ContactAction.calendarContactNoLicense',
  ContactActionCalendarNotFound = 'ContactAction.calendarNotFound',
  ContactActionCalendarUserNoLicense = 'ContactAction.calendarUserNoLicense',
  ContactActionCall = 'ContactAction.call',
  ContactActionConnectTeams = 'ContactAction.connectTeams',
  ContactActionConnectTeamsNoLicense = 'ContactAction.connectTeamsNoLicense',
  ContactActionConsultationCall = 'ContactAction.consultationCall',
  ContactActionConsultationIsDisabledDueSupervision = 'ContactAction.consultationIsDisabledDueSupervision',
  ContactActionConsultationIsDisabledDueTransferOnUserExit = 'ContactAction.consultationIsDisabledDueTransferOnUserExit',
  ContactActionEmail = 'ContactAction.email',
  ContactActionNoTemplate = 'ContactAction.noTemplate',
  ContactActionOpenChatConversation = 'ContactAction.openChatConversation',
  ContactActionSafeTransfer = 'ContactAction.safeTransfer',
  ContactActionSafeTransferIsDisabledDueTransferOnUserExit = 'ContactAction.safeTransferIsDisabledDueTransferOnUserExit',
  ContactActionSelectImAddress = 'ContactAction.selectImAddress',
  ContactActionSelectMail = 'ContactAction.selectMail',
  ContactActionSelectTarget = 'ContactAction.selectTarget',
  ContactActionTransferNoLicense = 'ContactAction.transferNoLicense',
  ContactSearchContactSearch = 'ContactSearch.contactSearch',
  ContactSearchContentPlaceholder = 'ContactSearch.contentPlaceholder',
  ContactSearchExternalContacts = 'ContactSearch.externalContacts',
  ContactSearchFavorites = 'ContactSearch.favorites',
  ContactSearchFilterAccountEnabled = 'ContactSearch.Filter.accountEnabled',
  ContactSearchFilterAssistant = 'ContactSearch.Filter.assistant',
  ContactSearchFilterCity = 'ContactSearch.Filter.city',
  ContactSearchFilterCompany = 'ContactSearch.Filter.company',
  ContactSearchFilterCountry = 'ContactSearch.Filter.country',
  ContactSearchFilterDepartment = 'ContactSearch.Filter.department',
  ContactSearchFilterInitials = 'ContactSearch.Filter.initials',
  ContactSearchFilterJobTitle = 'ContactSearch.Filter.jobTitle',
  ContactSearchFilterLocation = 'ContactSearch.Filter.location',
  ContactSearchFilterManager = 'ContactSearch.Filter.manager',
  ContactSearchFilterNote = 'ContactSearch.Filter.note',
  ContactSearchFilterPostalCode = 'ContactSearch.Filter.postalCode',
  ContactSearchFilterState = 'ContactSearch.Filter.state',
  ContactSearchFilterStreetAddress = 'ContactSearch.Filter.streetAddress',
  ContactSearchGrantUserConsent = 'ContactSearch.grantUserConsent',
  ContactSearchGridContent = 'ContactSearch.gridContent',
  ContactSearchGroups = 'ContactSearch.groups.title',
  ContactSearchGroupsCannotMoveFavourites = 'ContactSearch.groups.cannotMoveFavourites',
  ContactSearchGroupsCannotRemovedFavourites = 'ContactSearch.groups.cannotRemovedFavourites',
  ContactSearchGroupsContactGroups = 'ContactSearch.groups.contactGroups',
  ContactSearchGroupsCreate = 'ContactSearch.groups.create',
  ContactSearchGroupsEdit = 'ContactSearch.groups.edit',
  ContactSearchGroupsGroupsMaxLength = 'ContactSearch.groups.groupsMaxLength',
  ContactSearchGroupsSettings = 'ContactSearch.groups.settings',
  ContactSearchGroupsUsers = 'ContactSearch.groups.users',
  ContactSearchGroupsUsersMaxLength = 'ContactSearch.groups.usersMaxLength',
  ContactSearchInformation = 'ContactSearch.information',
  ContactSearchJobTitle = 'ContactSearch.jobTitle',
  ContactSearchKeyword = 'ContactSearch.keyword',
  ContactSearchName = 'ContactSearch.name',
  ContactSearchNotAvailable = 'ContactSearch.notAvailable',
  ContactSearchSelectFields = 'ContactSearch.selectFields',
  ContactSearchServiceNoContacts = 'ContactSearch.serviceNoContacts',
  ContactSearchSource = 'ContactSearch.source',
  ContactSearchStandard = 'ContactSearch.standard',
  ContactSearchUseNewAttendantConsole = 'ContactSearch.useNewAttendantConsole',
  ContactSearchUseNewAttendantConsoleWarning = 'ContactSearch.useNewAttendantConsoleWarning',
  ContactSearchWarning = 'ContactSearch.warning',
  ConversationCallerHungUp = 'Conversation.callerHungUp',
  ConversationConference = 'Conversation.conference',
  ConversationConnected = 'Conversation.connected',
  ConversationConnectedCall = 'Conversation.connectedCall',
  ConversationConnectingToYou = 'Conversation.connectingToYou',
  ConversationElapsedTime = 'Conversation.elapsedTime',
  ConversationHangup = 'Conversation.hangup',
  ConversationHangupAndRetrieve = 'Conversation.hangupAndRetrieve',
  ConversationHangupCallerAndRetrieve = 'Conversation.hangupCallerAndRetrieve',
  ConversationHangupConsultantAndRetrieve = 'Conversation.hangupConsultantAndRetrieve',
  ConversationHold = 'Conversation.hold',
  ConversationPark = 'Conversation.park',
  ConversationUnpark = 'Conversation.unpark',
  ConversationInQueue = 'Conversation.inQueue',
  ConversationMerge = 'Conversation.merge',
  ConversationNotReached = 'Conversation.notReached',
  ConversationParked = 'Conversation.parked',
  ConversationPutOnHold = 'Conversation.putOnHold',
  ConversationQueueList1stLevel = 'ConversationQueueList.1stLevel',
  ConversationQueueListCannotPickUp = 'ConversationQueueList.cannotPickUp',
  ConversationQueueListConnectedTo = 'ConversationQueueList.connectedTo',
  ConversationQueueListCustomer = 'ConversationQueueList.customer',
  ConversationQueueListDistributionLevel = 'ConversationQueueList.distributionLevel',
  ConversationQueueListModalities = 'ConversationQueueList.modalities',
  ConversationQueueListNoTasks = 'ConversationQueueList.noTasks',
  ConversationQueueListPickup = 'ConversationQueueList.pickup',
  ConversationQueueListPriority = 'ConversationQueueList.priority',
  ConversationQueueListQueueTime = 'ConversationQueueList.queueTime',
  ConversationQueueListSource = 'ConversationQueueList.source',
  ConversationQueueListState = 'ConversationQueueList.state',
  ConversationQueueListTeam = 'ConversationQueueList.team',
  ConversationQueueListTimeInState = 'ConversationQueueList.timeInState',
  ConversationQueueListWaiting = 'ConversationQueueList.waiting',
  ConversationResume = 'Conversation.resume',
  ConversationRetrieve = 'Conversation.retrieve',
  ConversationRinging = 'Conversation.ringing',
  ConversationStateActive = 'ConversationState.active',
  ConversationStateDialingOut = 'ConversationState.dialingOut',
  ConversationStateDialOut = 'ConversationState.dialOut',
  ConversationStateIncoming = 'ConversationState.incoming',
  ConversationStateNoConversation = 'ConversationState.noConversation',
  ConversationStateNoData = 'ConversationState.noData',
  ConversationStateParked = 'ConversationState.parked',
  ConversationStatePutOnHold = 'ConversationState.putOnHold',
  ConversationStateTransferActive = 'ConversationState.holdActive',
  ConversationStateTransferOnHold = 'ConversationState.onHoldTransfer',
  ConversationStateUnparkingDisabledWithOngoingTask = 'ConversationState.unparkingDisabledWithOngoingTask',
  ConversationStateUnparkingUseNewAttendantConsoleWarning = 'ConversationState.unparkingUseNewAttendantConsoleWarning',
  ConversationSupervisionHoldDisabled = 'Conversation.supervisionHoldDisabled',
  ConversationStatesDialingOut = 'Conversation.States.dialingOut',
  ConversationStatesEstablishing = 'Conversation.States.establishing',
  ConversationStatesInIvr = 'Conversation.States.inIvr',
  ConversationStatesInIvrAfterQueue = 'Conversation.States.inIvrAfterQueue',
  ConversationStatesInQueue = 'Conversation.States.inQueue',
  ConversationStatesOngoing = 'Conversation.States.ongoing',
  ConversationStatesParked = 'Conversation.States.parked',
  ConversationStatesPutOnHold = 'Conversation.States.putOnHold',
  ConversationStatesRinging = 'Conversation.States.ringing',
  ConversationStatesTerminated = 'Conversation.States.terminated',
  ConversationStatesTransferring = 'Conversation.States.transferring',
  ConversationSwap = 'Conversation.swap',
  ConversationTerminate = 'Conversation.terminate',
  ConversationTransfer = 'Conversation.transfer',
  ConversationTransferred = 'Conversation.transferred',
  ConversationTransferring = 'Conversation.transferring',
  DashboardLongestWaitingTask = 'Dashboard.longestWaitingTask',
  DashboardNeedAdditionalThings = 'Dashboard.needAdditionalThings',
  DashboardNoInformation = 'Dashboard.noInformation',
  DutyAcw = 'Duty.acw',
  DutyContactCenterAssistant = 'Duty.contactCenterAssistant',
  DutyExtendedAcw = 'Duty.extendedAcw',
  DutyOff = 'Duty.off',
  EmailTemplateOutboundCallBody = 'EmailTemplate.OutboundCall.body',
  EmailTemplateOutboundCallSubject = 'EmailTemplate.OutboundCall.subject',
  FavoriteAdd = 'Favorite.add',
  FavoriteLimit = 'Favorite.limit',
  FavoriteRemove = 'Favorite.remove',
  FeaturePermissionsAdvancedSearch = 'FeaturePermissions.advancedSearch',
  FeaturePermissionsAdvancedSearchDesc = 'FeaturePermissions.advancedSearchDesc',
  FeaturePermissionsBasicSearch = 'FeaturePermissions.basicSearch',
  FeaturePermissionsBasicSearchDesc = 'FeaturePermissions.basicSearchDesc',
  FeaturePermissionsCalendarView = 'FeaturePermissions.calendarView',
  FeaturePermissionsCalendarViewDesc = 'FeaturePermissions.calendarViewDesc',
  FeaturePermissionsExchangeContactSearch = 'FeaturePermissions.exchangeContactSearch',
  FeaturePermissionsExchangeContactSearchDesc = 'FeaturePermissions.exchangeContactSearchDesc',
  FeaturePermissionsPresence = 'FeaturePermissions.presence',
  FeaturePermissionsPresenceDesc = 'FeaturePermissions.presenceDesc',
  FilterAll = 'Filter.all',
  FilterAny = 'Filter.any',
  FilterClearSelection = 'Filter.clearSelection',
  FilterFalse = 'Filter.false',
  FilterSelectAll = 'Filter.selectAll',
  FilterTrue = 'Filter.true',
  FilterTypeSearch = 'Filter.typeSearch',
  GeneraDataPagerFirstPage = 'General.Pager.firstPage',
  GeneraDataPagerItems = 'General.Pager.items',
  GeneraDataPagerItemsPerPage = 'General.Pager.itemsPerPage',
  GeneraDataPagerLastPage = 'General.Pager.lastPage',
  GeneraDataPagerNextPage = 'General.Pager.nextPage',
  GeneraDataPagerOf = 'General.Pager.of',
  GeneraDataPagerPreviousPage = 'General.Pager.previousPage',
  GeneralAPIKey = 'General.apiKey',
  GeneralAPIKeySecret = 'General.apiKeySecret',
  GeneralAPIKeySid = 'General.apiKeySid',
  GeneralAcContactSearchSourceTypeActiveDirectory = 'General.AcContactSearchSourceType.activeDirectory',
  GeneralAcContactSearchSourceTypeExchange = 'General.AcContactSearchSourceType.exchange',
  GeneralAcContactSearchSourceTypeNimbusAddressBooks = 'General.AcContactSearchSourceType.nimbusAddressBooks',
  GeneralAcContactSearchSourceTypeNimbusServices = 'General.AcContactSearchSourceType.nimbusServices',
  GeneralAccept = 'General.accept',
  GeneralAcceptanceRate = 'General.acceptanceRate',
  GeneralActions = 'General.actions',
  GeneralActivationTime = 'General.activationTime',
  GeneralActive = 'General.active',
  GeneralActiveProfile = 'General.activeProfile',
  GeneralAdd = 'General.add',
  GeneralAddEntity = 'General.addEntity',
  GeneralAddress = 'General.address',
  GeneralAfterQueueIVRTime = 'General.afterQueueIVRTime',
  GeneralAll = 'General.all',
  GeneralAllDay = 'General.allDay',
  GeneralAlmostDone = 'General.almostDone',
  GeneralAnonymizedOnRequest = 'General.anonymizedOnRequest',
  GeneralAnonymous = 'General.anonymous',
  GeneralApply = 'General.apply',
  GeneralApplyAll = 'General.applyAll',
  GeneralApplyingPermissions = 'General.applyingPermissions',
  GeneralApprove = 'General.approve',
  GeneralApproved = 'General.approved',
  GeneralAssistant = 'General.assistant',
  GeneralAttendantConsoleContactPermissionsDirectories = 'General.attendantConsole.contactPermissions.directories',
  GeneralAttendantConsoleContactPermissionsRequestPermissions = 'General.attendantConsole.contactPermissions.requestPermissions',
  GeneralAttendantConsoleContactSearchNonFilterable = 'General.attendantConsole.contactSearch.nonFilterable',
  GeneralAttendantConsoleContactSearchTypeAvailablePartially = 'General.attendantConsole.contactSearchType.availablePartially',
  GeneralAttendantConsoleContactSearchTypeNotAvailableByFilters = 'General.attendantConsole.contactSearchType.notAvailableByFilters',
  GeneralAttendantConsoleContactSearchTypeNotAvailableByUserPermissions = 'General.attendantConsole.contactSearchType.notAvailableByUserPermissions',
  GeneralAttendantConsoleContactWidgetEmptyAllBody = 'General.attendantConsole.contactWidget.empty.all.body',
  GeneralAttendantConsoleContactWidgetEmptyAllTitle = 'General.attendantConsole.contactWidget.empty.all.title',
  GeneralAttendantConsoleContactWidgetEmptyContactGroupBody = 'General.attendantConsole.contactWidget.empty.contactGroup.body',
  GeneralAttendantConsoleContactWidgetEmptyContactGroupTitle = 'General.attendantConsole.contactWidget.empty.contactGroup.title',
  GeneralAttendantConsoleContactWidgetEmptyNotConfiguredBody = 'General.attendantConsole.contactWidget.empty.notConfigured.body',
  GeneralAttendantConsoleContactWidgetEmptyNotConfiguredTitle = 'General.attendantConsole.contactWidget.empty.notConfigured.title',
  GeneralAttendantConsoleContactWidgetEmptySearchResultBody = 'General.attendantConsole.contactWidget.empty.searchResult.body',
  GeneralAttendantConsoleContactWidgetEmptySearchResultTitle = 'General.attendantConsole.contactWidget.empty.searchResult.title',
  GeneralAttendantConsoleContactWidgetEmptyTooManyContactsByNotesBody = 'General.attendantConsole.contactWidget.empty.tooManyContactsByNotes.body',
  GeneralAttendantConsoleContactWidgetEmptyTooManyContactsByNotesTitle = 'General.attendantConsole.contactWidget.empty.tooManyContactsByNotes.title',
  GeneralAttendantConsoleContactWidgetGridColumnContactDetails = 'General.attendantConsole.contactWidget.gridColumnContactDetails',
  GeneralAttendantConsoleContactWidgetGridColumnName = 'General.attendantConsole.contactWidget.gridColumnName',
  GeneralAttendantConsoleContactWidgetViewTypeCard = 'General.attendantConsole.contactWidget.viewTypeCard',
  GeneralAttendantConsoleContactWidgetViewTypeGrid = 'General.attendantConsole.contactWidget.viewTypeGrid',
  GeneralAttendantConsoleDetailsCalendarError = 'General.attendantConsole.details.calendarError',
  GeneralAttendantConsoleDetailsCalendarExpandView = 'General.attendantConsole.details.calendarExpandView',
  GeneralAttendantConsoleDetailsConsultationCallDetails = 'General.attendantConsole.details.consultationCallDetails',
  GeneralAttendantConsoleDetailsContactDetails = 'General.attendantConsole.details.contactDetails',
  GeneralAttendantConsoleDetailsContactInformation = 'General.attendantConsole.details.contactInformation',
  GeneralAttendantConsoleDetailsContactInformationCustom = 'General.attendantConsole.details.contactInformationCustom',
  GeneralAttendantConsoleDetailsDefault = 'General.attendantConsole.details.default',
  GeneralAttendantConsoleDetailsEmailTo = 'General.attendantConsole.details.emailTo',
  GeneralAttendantConsoleDetailsInstantMessage = 'General.attendantConsole.details.instantMessage',
  GeneralAttendantConsoleDetailsNoEmailAddresses = 'General.attendantConsole.details.noEmailAddresses',
  GeneralAttendantConsoleDetailsNoUpnAddresses = 'General.attendantConsole.details.noUpnAddresses',
  GeneralAttendantConsoleDetailsOrganizationStructureEmpty = 'General.attendantConsole.details.organizationStructureEmpty',
  GeneralAttendantConsoleDetailsSelectCard = 'General.attendantConsole.details.selectCard',
  GeneralAttendantConsoleDetailsServiceDetails = 'General.attendantConsole.details.serviceDetails',
  GeneralAttendantConsoleDetailsServiceInformation = 'General.attendantConsole.details.serviceInformation',
  GeneralAttendantConsoleDetailsSessionDetails = 'General.attendantConsole.details.sessionDetails',
  GeneralAttendantConsoleDetailsStateAutoExpand = 'General.attendantConsole.details.stateAutoExpand',
  GeneralAttendantConsoleDetailsStateFixed = 'General.attendantConsole.details.stateFixed',
  GeneralAttendantConsoleDetailsTeamUsersEmpty = 'General.attendantConsole.details.teamUsersEmpty',
  GeneralAttendantConsoleDetailsTemplates = 'General.attendantConsole.details.templates',
  GeneralAttendantConsoleErrorsCallCompleted = 'General.attendantConsole.errors.callCompleted',
  GeneralAttendantConsoleErrorsCallNotFound = 'General.attendantConsole.errors.callNotFound',
  GeneralAttendantConsoleErrorsConsultationCallDoesNotBelongToServiceSession = 'General.attendantConsole.errors.consultationCallDoesNotBelongToServiceSession',
  GeneralAttendantConsoleErrorsConsultationCallDoesNotBelongToUser = 'General.attendantConsole.errors.consultationCallDoesNotBelongToUser',
  GeneralAttendantConsoleErrorsConsultationCallHasInvalidState = 'General.attendantConsole.errors.consultationCallHasInvalidState',
  GeneralAttendantConsoleErrorsConsultationCallToServiceDisabled = 'General.attendantConsole.errors.consultationCallToServiceDisabled',
  GeneralAttendantConsoleErrorsNotCurrentConnectedUser = 'General.attendantConsole.errors.notCurrentConnectedUser',
  GeneralAttendantConsoleErrorsInvalidUserSessionState = 'General.attendantConsole.errors.invalidUserSessionState',
  GeneralAttendantConsoleErrorsServiceDoesNotAcceptAudio = 'General.attendantConsole.errors.serviceDoesNotAcceptAudio',
  GeneralAttendantConsoleErrorsServiceNotFound = 'General.attendantConsole.errors.serviceNotFound',
  GeneralAttendantConsoleErrorsTechnicalError = 'General.attendantConsole.errors.technicalError',
  GeneralAttendantConsoleErrorsTransferAlreadyInProgress = 'General.attendantConsole.errors.transferAlreadyInProgress',
  GeneralAttendantConsoleErrorsTransferTargetBusy = 'General.attendantConsole.errors.transferTargetBusy',
  GeneralAttendantConsoleErrorsTransferTargetDnd = 'General.attendantConsole.errors.transferTargetDnd',
  GeneralAttendantConsoleNewVersion = 'General.attendantConsoleNewVersion',
  GeneralAttendantConsoleNewVersionDescription = 'General.attendantConsoleNewVersionDescription',
  GeneralAttendantConsoleNewVersionStart = 'General.attendantConsoleNewVersionStart',
  GeneralAttendantConsoleNotAMember = 'General.attendantConsoleNotAMember',
  GeneralAttendantConsoleNotLicensed = 'General.attendantConsoleNotLicensed',
  GeneralAudio = 'General.audio',
  GeneralAudioVideo = 'General.audioVideo',
  GeneralAvailable = 'General.available',
  GeneralBack = 'General.back',
  GeneralBackBtn = 'General.backBtn',
  GeneralBackgroundColor = 'General.backgroundColor',
  GeneralBot = 'General.bot',
  GeneralBotRequestTemplate = 'General.botRequestTemplate',
  GeneralBotResponseTemplate = 'General.botResponseTemplate',
  GeneralBusinessPhone = 'General.businessPhone',
  GeneralBySomeone = 'General.bySomeone',
  GeneralCalendar = 'General.calendar',
  GeneralCallOnBehalf = 'General.callOnBehalf',
  GeneralCallOnBehalfError = 'General.callOnBehalfError',
  GeneralCallOnBehalfTooltip = 'General.callOnBehalfTooltip',
  GeneralCallerInformation = 'General.callerInformation',
  GeneralCallingNumber = 'General.callingNumber',
  GeneralCancel = 'General.cancel',
  GeneralCannotDeleted = 'General.cannotDeleted',
  GeneralCannotDeletedUsedIn = 'General.cannotDeletedUsedIn',
  GeneralCannotRemoved = 'General.cannotRemoved',
  GeneralCategory = 'General.category',
  GeneralChange = 'General.change',
  GeneralChartKpis = 'General.chartKpis',
  GeneralCity = 'General.city',
  GeneralClickHere = 'General.clickHere',
  GeneralClose = 'General.close',
  GeneralCodesAndTags = 'General.codesAndTags',
  GeneralCodesAndTagsManagedInNimbusOne = 'General.codesAndTagsManagedInNimbusOne',
  GeneralCollapseView = 'General.collapseView',
  GeneralColorAshGrey = 'General.Color.ashGrey',
  GeneralColorBittersweetRed = 'General.Color.bittersweetRed',
  GeneralColorBittersweetRedDark = 'General.Color.bittersweetRedDark',
  GeneralColorBittersweetRedLight = 'General.Color.bittersweetRedLight',
  GeneralColorDimGrey = 'General.Color.dimGrey',
  GeneralColorFawnOrange = 'General.Color.fawnOrange',
  GeneralColorFawnOrangeDark = 'General.Color.fawnOrangeDark',
  GeneralColorFawnOrangeLight = 'General.Color.fawnOrangeLight',
  GeneralColorGunmetalDark = 'General.Color.gunmetalDark',
  GeneralColorHonetFlower = 'General.Color.honetFlower',
  GeneralColorJungleGreen = 'General.Color.jungleGreen',
  GeneralColorJungleGreenDark = 'General.Color.jungleGreenDark',
  GeneralColorJungleGreenLight = 'General.Color.jungleGreenLight',
  GeneralColorMellowYellow = 'General.Color.mellowYellow',
  GeneralColorMing = 'General.Color.ming',
  GeneralColorMingDark = 'General.Color.mingDark',
  GeneralColorMingLight = 'General.Color.mingLight',
  GeneralColorMountainMeadow = 'General.Color.mountainMeadow',
  GeneralColorMountainMeadowDark = 'General.Color.mountainMeadowDark',
  GeneralColorMountainMeadowLight = 'General.Color.mountainMeadowLight',
  GeneralColorOldBrick = 'General.Color.oldBrick',
  GeneralColorOldBrickDark = 'General.Color.oldBrickDark',
  GeneralColorOldBrickLight = 'General.Color.oldBrickLight',
  GeneralColorPaleCopper = 'General.Color.paleCopper',
  GeneralColorPaleCopperDark = 'General.Color.paleCopperDark',
  GeneralColorPaleCopperLight = 'General.Color.paleCopperLight',
  GeneralColorRazzmicBerry = 'General.Color.razzmicBerry',
  GeneralColorSoftBlue = 'General.Color.softBlue',
  GeneralColorVividBlue = 'General.Color.vividBlue',
  GeneralColorWhite = 'General.Color.white',
  GeneralCompanion = 'General.companion',
  GeneralCompanionTranscription = 'General.companionTranscription',
  GeneralCompanionTranslation = 'General.companionTranslation',
  GeneralCompanionSentimentAnalysis = 'General.companionSentimentAnalysis',
  GeneralCompanionSummary = 'General.companionSummary',
  GeneralCompanionVirtualAssistant = 'General.companionVirtualAssistant',
  GeneralCompanionVirtualUserSummary = 'General.companionVirtualUserSummary',
  GeneralCompany = 'General.company',
  GeneralConfirm = 'General.confirm',
  GeneralConnected = 'General.connected',
  GeneralDisconnected = 'General.disconnected',
  GeneralConnectedTime = 'General.connectedTime',
  GeneralConnectedTimeToday = 'General.connectedTimeToday',
  GeneralConsultationCall = 'General.consultationCall',
  GeneralConsultationCallFor = 'General.consultationCallFor',
  GeneralContactPinTypeManager = 'General.ContactPinType.manager',
  GeneralContactPinTypePeers = 'General.ContactPinType.peers',
  GeneralContactPinTypeReports = 'General.ContactPinType.reports',
  GeneralContactPinTypeService = 'General.ContactPinType.service',
  GeneralContactSearch = 'General.contactSearch',
  GeneralContactSourceTypeActiveDirectory = 'General.ContactSourceType.activeDirectory',
  GeneralContactSourceTypeCustom = 'General.ContactSourceType.custom',
  GeneralContactSourceTypeExchangeContact = 'General.ContactSourceType.exchangeContact',
  GeneralContactSourceTypeExternal = 'General.ContactSourceType.external',
  GeneralContactSourceTypeNimbusTeam = 'General.ContactSourceType.nimbusTeam',
  GeneralContactSourceTypeTmTeam = 'General.ContactSourceType.tmTeam',
  ContextContext = 'General.context',
  ContextParameterContext = 'General.parameterContext',
  GeneralConfigurationItemCannotBeRemoved = 'General.configurationItemCannotBeRemoved',
  GeneralConversationContext = 'General.conversationContext',
  GeneralConversationDirectionInbound = 'General.ConversationDirection.inbound',
  GeneralConversationDirectionInboundCall = 'General.ConversationDirection.inboundCall',
  GeneralConversationDirectionNone = 'General.ConversationDirection.none',
  GeneralConversationDirectionOutbound = 'General.ConversationDirection.outbound',
  GeneralConversationDirectionOutboundCall = 'General.ConversationDirection.outboundCall',
  GeneralConversationInboundConversations = 'General.ConversationDirection.inboundConversations',
  GeneralConversationOutboundConversations = 'General.ConversationDirection.outboundConversations',
  GeneralConversationOutboundConversationsWorkflows = 'General.ConversationDirection.outboundConversationsWorkflows',
  GeneralCopied = 'General.copied',
  GeneralCopy = 'General.copy',
  GeneralCopyAll = 'General.copyAll',
  GeneralCopyClipboard = 'General.copyClipboard',
  GeneralCors = 'General.cors',
  GeneralCountry = 'General.country',
  GeneralCreate = 'General.create',
  GeneralCreateNew = 'General.createNew',
  GeneralCurrent = 'General.current',
  GeneralCurrentDay = 'General.currentDay',
  GeneralCurrentDayShort = 'General.currentDayShort',
  GeneralCustomParameter = 'General.customParameter',
  GeneralCustomParameterMustUnique = 'General.customParameterMustUnique',
  GeneralCustomParameterRequired = 'General.customParameterRequired',
  GeneralCustomRole = 'General.customRole',
  GeneralCustomRoles = 'General.customRoles',
  GeneralDaily = 'General.daily',
  GeneralDashboard = 'General.dashboard',
  GeneralDashboardConversationOutboundTypeCallback = 'General.DashboardConversationOutboundType.callback',
  GeneralDashboardConversationOutboundTypeOutboundCallWithWorkflow = 'General.DashboardConversationOutboundType.outboundCallWithWorkflow',
  GeneralDashboardConversationOutboundTypeOutboundService = 'General.DashboardConversationOutboundType.outboundService',
  GeneralDashboardNonPersonal = 'General.dashboardNonPersonal',
  GeneralDate = 'General.date',
  GeneralDateAndTime = 'General.dateAndTime',
  GeneralDateFormat = 'General.dateFormat',
  GeneralDayOfWeekFriday = 'General.DayOfWeek.friday',
  GeneralDayOfWeekFridayShort = 'General.DayOfWeek.fridayShort',
  GeneralDayOfWeekMonday = 'General.DayOfWeek.monday',
  GeneralDayOfWeekMondayShort = 'General.DayOfWeek.mondayShort',
  GeneralDayOfWeekSaturday = 'General.DayOfWeek.saturday',
  GeneralDayOfWeekSaturdayShort = 'General.DayOfWeek.saturdayShort',
  GeneralDayOfWeekSunday = 'General.DayOfWeek.sunday',
  GeneralDayOfWeekSundayShort = 'General.DayOfWeek.sundayShort',
  GeneralDayOfWeekThursday = 'General.DayOfWeek.thursday',
  GeneralDayOfWeekThursdayShort = 'General.DayOfWeek.thursdayShort',
  GeneralDayOfWeekTuesday = 'General.DayOfWeek.tuesday',
  GeneralDayOfWeekTuesdayShort = 'General.DayOfWeek.tuesdayShort',
  GeneralDayOfWeekWednesday = 'General.DayOfWeek.wednesday',
  GeneralDayOfWeekWednesdayShort = 'General.DayOfWeek.wednesdayShort',
  GeneralDays = 'General.days',
  GeneralDaysAgo = 'General.daysAgo',
  GeneralDecline = 'General.decline',
  GeneralDefault = 'General.default',
  GeneralDelete = 'General.delete',
  GeneralReject = 'General.reject',
  GeneralRejected = 'General.rejected',
  GeneralDeleteConfirmEntityQuestion = 'General.deleteConfirmEntityQuestion',
  GeneralDeleteEntityDependencies = 'General.deleteEntityDependencies',
  GeneralDeleteEntityDescription = 'General.deleteEntityDescription',
  GeneralDeleteEntityQuestion = 'General.deleteEntityQuestion',
  GeneralDepartment = 'General.department',
  GeneralDescription = 'General.description',
  GeneralDiscard = 'General.discard',
  GeneralDisplayName = 'General.displayName',
  GeneralDistributionPolicy = 'General.distributionPolicy',
  GeneralDistributionPriorityHigh = 'General.DistributionPriority.high',
  GeneralDistributionPriorityHighest = 'General.DistributionPriority.highest',
  GeneralDistributionPriorityLow = 'General.DistributionPriority.low',
  GeneralDistributionPriorityLowest = 'General.DistributionPriority.lowest',
  GeneralDistributionPriorityNormal = 'General.DistributionPriority.normal',
  GeneralDistributionPriorityNothingElse = 'General.DistributionPriority.nothingElse',
  GeneralDistributionPriorityStrict = 'General.DistributionPriority.strict',
  GeneralDistributionPriorityVeryHigh = 'General.DistributionPriority.veryHigh',
  GeneralDistributionPriorityVeryLow = 'General.DistributionPriority.veryLow',
  GeneralDomain = 'General.domain',
  GeneralDownload = 'General.download',
  GeneralDtmf = 'General.dtmf',
  GeneralDuration = 'General.duration',
  GeneralDutyPresenceAvailable = 'General.DutyPresence.available',
  GeneralDutyPresenceNotAvailable = 'General.DutyPresence.notAvailable',
  GeneralDutyPresenceOffDuty = 'General.DutyPresence.offDuty',
  GeneralEdit = 'General.edit',
  GeneralEditEntity = 'General.editEntity',
  GeneralEmail = 'General.email',
  GeneralEmpty = 'General.empty',
  GeneralEnabled = 'General.enabled',
  GeneralEndpoint = 'General.endpoint',
  GeneralEnterFullScreen = 'General.enterFullScreen',
  GeneralEntry = 'General.entry',
  GeneralEnvironment = 'General.environment',
  GeneralError = 'General.error',
  GeneralExitFullScreen = 'General.exitFullScreen',
  GeneralExpandView = 'General.expandView',
  GeneralExtend = 'General.extend',
  GeneralExternalTask = 'General.externalTask',
  GeneralFailed = 'General.failed',
  GeneralFeature = 'General.feature',
  GeneralFieldsRequired = 'General.fieldsRequired',
  GeneralFilter = 'General.filter',
  GeneralFirstAcceptedUser = 'General.firstAcceptedUser',
  GeneralFirstCodesAndTags = 'General.firstCodesAndTags',
  GeneralFirstConnectedUser = 'General.firstConnectedUser',
  GeneralFirstName = 'General.firstName',
  GeneralFont = 'General.font',
  GeneralFontColor = 'General.fontColor',
  GeneralFontSize = 'General.fontSize',
  GeneralFontSizeDecrease = 'General.fontSizeDecrease',
  GeneralFontSizeIncrease = 'General.fontSizeIncrease',
  GeneralForFutureUse = 'General.forFutureUse',
  GeneralFrom = 'General.from',
  GeneralForMoreInformation = 'General.forMoreInformation',
  GeneralGridNoRecords = 'General.Grid.noRecords',
  GeneralGridTypeToSearch = 'General.Grid.typeToSearch',
  GeneralHeight = 'General.height',
  GeneralHhmmss = 'General.hhmmss',
  GeneralHidden = 'General.hidden',
  GeneralHomePhone = 'General.homePhone',
  GeneralHours = 'General.hours',
  GeneralHoursAgo = 'General.hoursAgo',
  GeneralIVRTime = 'General.ivrTime',
  GeneralImAddress = 'General.imAddress',
  GeneralImportanceHigh = 'General.importanceHigh',
  GeneralImportanceLow = 'General.importanceLow',
  GeneralInQueue = 'General.inQueue',
  GeneralInactive = 'General.inactive',
  GeneralInboundReachabilityToday = 'General.inboundReachabilityToday',
  GeneralInformation = 'General.information',
  GeneralInitialModalityAudio = 'General.InitialModality.audio',
  GeneralInitialModalityEmail = 'General.InitialModality.email',
  GeneralInitialModalityExternalTask = 'General.InitialModality.externalTask',
  GeneralInitialModalityFullAudio = 'General.InitialModalityFull.audio',
  GeneralInitialModalityFullEmail = 'General.InitialModalityFull.email',
  GeneralInitialModalityFullExternalTask = 'General.InitialModalityFull.externalTask',
  GeneralInitialModalityFullInstantMessaging = 'General.InitialModalityFull.instantMessaging',
  GeneralInitialModalityFullNone = 'General.InitialModalityFull.none',
  GeneralInitialModalityInstantMessaging = 'General.InitialModality.instantMessaging',
  GeneralInitialModalityNone = 'General.InitialModality.none',
  GeneralInitialModalityTitle = 'General.InitialModality.title',
  GeneralInitials = 'General.initials',
  GeneralInput = 'General.input',
  GeneralInstantMessaging = 'General.instantMessaging',
  GeneralInteractionsPeriod = 'General.interactionsPeriod',
  GeneralIntervalStatusClosed = 'General.IntervalStatus.closed',
  GeneralIntervalStatusHoliday = 'General.IntervalStatus.holiday',
  GeneralIntervalStatusNone = 'General.IntervalStatus.none',
  GeneralIntervalStatusOpen = 'General.IntervalStatus.open',
  GeneralIntervalStatusSpecial = 'General.IntervalStatus.special',
  GeneralIntervalStatusSpecial2 = 'General.IntervalStatus.special2',
  GeneralIntervalStatusSpecial3 = 'General.IntervalStatus.special3',
  GeneralIntervalStatusSpecial4 = 'General.IntervalStatus.special4',
  GeneralInvalidDtmf = 'General.invalidDtmf',
  GeneralIsDuty = 'General.isDuty',
  GeneralIsSystem = 'General.isSystem',
  GeneralItemBelongsToDifferentOrganizationUnit = 'General.itemBelongsToDifferentOrganizationUnit',
  GeneralJobtitle = 'General.jobTitle',
  GeneralKpi = 'General.kpi',
  GeneralLanguage = 'General.language',
  GeneralLastName = 'General.lastName',
  GeneralLastXDays = 'General.lastXDays',
  GeneralLastXDaysShort = 'General.lastXDaysShort',
  GeneralLastXHours = 'General.lastXHours',
  GeneralLastXHoursShort = 'General.lastXHoursShort',
  GeneralLastXWeeksShort = 'General.lastXWeeksShort',
  GeneralLevel = 'General.level',
  GeneralLiveCaption = 'General.liveCaption',
  GeneralLoading = 'General.Loading',
  GeneralLocation = 'General.location',
  GeneralLog = 'General.log',
  GeneralLoggedIn = 'General.loggedIn',
  GeneralLogout = 'General.logout',
  GeneralMailAddress = 'General.mailAddress',
  GeneralMailbox = 'General.mailbox',
  GeneralMailboxUpn = 'General.mailboxUpn',
  GeneralMediaPlayerMute = 'General.MediaPlayer.mute',
  GeneralMediaPlayerResourceGenerateTtsGeneralError = 'General.MediaPlayer.generateTtsGeneralError',
  GeneralMediaPlayerResourceGenerateTtsTimeoutError = 'General.MediaPlayer.generateTtsTimeoutError',
  GeneralMediaPlayerResourceLoading = 'General.MediaPlayer.resourceLoading',
  GeneralMediaPlayerResourceLoadingFailed = 'General.MediaPlayer.resourceLoadingFailed',
  GeneralMediaPlayerUnmute = 'General.MediaPlayer.unmute',
  GeneralMediaPlayerVolume = 'General.MediaPlayer.volume',
  GeneralMessagingEntry = 'General.messagingEntry',
  GeneralMinutesAgo = 'General.minutesAgo',
  GeneralMmss = 'General.mmss',
  GeneralMobilePhone = 'General.mobilePhone',
  GeneralModalityTitle = 'General.modality.title',
  GeneralMonthly = 'General.monthly',
  GeneralMonthsAgo = 'General.monthsAgo',
  GeneralMonthsApril = 'General.Months.april',
  GeneralMonthsAugust = 'General.Months.august',
  GeneralMonthsDecember = 'General.Months.december',
  GeneralMonthsFebruary = 'General.Months.february',
  GeneralMonthsJanuary = 'General.Months.january',
  GeneralMonthsJuly = 'General.Months.july',
  GeneralMonthsJune = 'General.Months.june',
  GeneralMonthsMarch = 'General.Months.march',
  GeneralMonthsMay = 'General.Months.may',
  GeneralMonthsNovember = 'General.Months.november',
  GeneralMonthsOctober = 'General.Months.october',
  GeneralMonthsSeptember = 'General.Months.september',
  GeneralMoveDown = 'General.moveDown',
  GeneralMoveToLeft = 'General.moveToLeft',
  GeneralMoveToRight = 'General.moveToRight',
  GeneralMoveUp = 'General.moveUp',
  GeneralMultiLanguage = 'General.multiLanguage',
  GeneralMyDay = 'General.myDay',
  GeneralMyPartners = 'General.myPartners',
  GeneralMyQueue = 'General.myQueue',
  GeneralMyReporting = 'General.myReporting',
  GeneralMyServices = 'General.myServices',
  GeneralMyState = 'General.myState',
  GeneralMyTenants = 'General.myTenants',
  GeneralNa = 'General.na',
  GeneralName = 'General.name',
  GeneralNewEntity = 'General.newEntity',
  GeneralNextBtn = 'General.nextBtn',
  GeneralNoAccess = 'General.noAccess',
  GeneralNoCallsLastXBusinessDays = 'General.noCallsPeriodLastXBusinessDays',
  GeneralNoCallsLastXDays = 'General.noCallsPeriodLastXDays',
  GeneralNoCallsLastXHours = 'General.noCallsPeriodLastXHours',
  GeneralNoCallsToday = 'General.noCallsPeriodToday',
  GeneralNoDashboards = 'General.noDashboards',
  GeneralNoDataAvailable = 'General.noDataAvailable',
  GeneralNoDataFound = 'General.noDataFound',
  GeneralNoItemsSelected = 'General.noItemsSelected',
  GeneralNoPermission = 'General.noPermission',
  GeneralNoPermissions = 'General.noPermissions',
  GeneralNoTeamsProvisioned = 'General.noTeamsProvisioned',
  GeneralNoUserInService = 'General.noUserInService',
  GeneralNonActiveServiceHelpdesk = 'General.nonActiveServiceHepdesk',
  GeneralNonActiveServiceTechnicalContact = 'General.nonActiveServiceTechnicalContact',
  GeneralNonActiveServicesDetailsHelpdesk = 'General.nonActiveServicesDetailsHelpdesk',
  GeneralNone = 'General.none',
  GeneralNotAssignedToNimbusService = 'General.notAssigedToNimbusService',
  GeneralNotAvailable = 'General.notAvailable',
  GeneralNotAvailableReason = 'General.notAvailableReason',
  GeneralNotAvailableReasons = 'General.notAvailableReasons',
  GeneralNotAvailableShort = 'General.notAvailableShort',
  GeneralNotMember = 'General.notMember',
  GeneralNotQueued = 'General.notQueued',
  GeneralNotconnected = 'General.notconnected',
  GeneralNote = 'General.note',
  GeneralNpdItemWarning = 'General.npdItemWarning',
  GeneralOccurrenceFirst = 'General.Occurrence.first',
  GeneralOccurrenceFourth = 'General.Occurrence.fourth',
  GeneralOccurrenceLast = 'General.Occurrence.last',
  GeneralOccurrenceSecond = 'General.Occurrence.second',
  GeneralOccurrenceThird = 'General.Occurrence.third',
  GeneralOff = 'General.off',
  GeneralOk = 'General.ok',
  GeneralOn = 'General.on',
  GeneralOpenInBrowser = 'General.openInBrowser',
  GeneralOrder = 'General.order',
  GeneralOrganization = 'General.organization',
  GeneralOrganizationUnit = 'General.organizationUnit',
  GeneralOrganizationUnitAcronnym = 'General.organizationUnitAcronym',
  GeneralOrganizationUnits = 'General.organizationUnits',
  GeneralOutboundTask = 'General.outboundTask',
  GeneralPartner = 'General.partner',
  GeneralPath = 'General.path',
  GeneralPathInvalid = 'General.pathInvalid',
  GeneralPathRequired = 'General.pathRequired',
  GeneralPeriod = 'General.period',
  GeneralPermissionError = 'General.permissionError',
  GeneralPermissionsNotRefreshed = 'General.permissionsNotRefreshed',
  GeneralPhoneNumber = 'General.phoneNumber',
  GeneralPickupCall = 'General.pickupCall',
  GeneralPlaylist = 'General.playlist',
  GeneralPleaseLogin = 'General.pleaseLogin',
  GeneralPortalContext = 'General.portalContext',
  GeneralPostalCode = 'General.postalCode',
  GeneralPresenceActivityAvailable = 'General.PresenceActivity.available',
  GeneralPresenceActivityAway = 'General.PresenceActivity.away',
  GeneralPresenceActivityBeRightBack = 'General.PresenceActivity.beRightBack',
  GeneralPresenceActivityBusy = 'General.PresenceActivity.busy',
  GeneralPresenceActivityDoNotDisturb = 'General.PresenceActivity.doNotDisturb',
  GeneralPresenceActivityInACall = 'General.PresenceActivity.inACall',
  GeneralPresenceActivityInAConferenceCall = 'General.PresenceActivity.inAConferenceCall',
  GeneralPresenceActivityInAMeeting = 'General.PresenceActivity.inAMeeting',
  GeneralPresenceActivityInactive = 'General.PresenceActivity.inactive',
  GeneralPresenceActivityOffWork = 'General.PresenceActivity.offWork',
  GeneralPresenceActivityOffline = 'General.PresenceActivity.offline',
  GeneralPresenceActivityOutOfOffice = 'General.PresenceActivity.outOfOffice',
  GeneralPresenceActivityPresenceUnknown = 'General.PresenceActivity.presenceUnknown',
  GeneralPresenceActivityPresenting = 'General.PresenceActivity.presenting',
  GeneralPresenceActivityUrgentInterruptionsOnly = 'General.PresenceActivity.urgentInterruptionsOnly',
  GeneralPresenceStatusAvailable = 'General.PresenceStatus.available',
  GeneralPresenceStatusAvailableIdle = 'General.PresenceStatus.availableIdle',
  GeneralPresenceStatusAway = 'General.PresenceStatus.away',
  GeneralPresenceStatusBeRightBack = 'General.PresenceStatus.beRightBack',
  GeneralPresenceStatusBusy = 'General.PresenceStatus.busy',
  GeneralPresenceStatusBusyIdle = 'General.PresenceStatus.busyIdle',
  GeneralPresenceStatusDoNotDisturb = 'General.PresenceStatus.doNotDisturb',
  GeneralPresenceStatusOffline = 'General.PresenceStatus.offline',
  GeneralPresenceStatusPresenceUnknown = 'General.PresenceStatus.presenceUnknown',
  GeneralPreview = 'General.preview',
  GeneralPrimaryCode = 'General.primaryCode',
  GeneralProfile = 'General.profile',
  GeneralProperties = 'General.properties',
  GeneralProviderConnector = 'General.providerConnector',
  GeneralPstnNumber = 'General.pstnNumber',
  GeneralQueueTime = 'General.queueTime',
  GeneralQueueTimeToday = 'General.queueTimeToday',
  GeneralQuiet = 'General.quiet',
  GeneralReachabilityReady = 'General.Reachability.ready',
  GeneralReachabilityNotReady = 'General.Reachability.notReady',
  GeneralRead = 'General.read',
  GeneralReadDocumentation = 'General.readDocumentation',
  GeneralReadMore = 'General.readMore',
  GeneralRegenerateAudio = 'General.regenerateAudio',
  GeneralRegex = 'General.regex',
  GeneralRegion = 'General.region',
  GeneralRemove = 'General.remove',
  GeneralRemoveEntity = 'General.removeEntity',
  GeneralRemoveEntityDescription = 'General.removeEntityDescription',
  GeneralRemoveEntityQuestion = 'General.removeEntityQuestion',
  GeneralRename = 'General.rename',
  GeneralReportIncident = 'General.reportIncident',
  GeneralResetColumnWidths = 'General.resetColumnWidths',
  GeneralResource = 'General.resource',
  GeneralResourceCannotBeUsed = 'General.resourceCannotBeUsed',
  GeneralResources = 'General.resources',
  GeneralResponsibilityLevel = 'General.responsibilityLevel',
  GeneralResponsibilityProfile = 'General.responsibilityProfile',
  GeneralResponsibilityProfileType = 'General.responsibilityProfileType',
  GeneralResponsibilityProfileTypeDuty = 'General.ResponsibilityProfileType.duty',
  GeneralResponsibilityProfileTypeOffDuty = 'General.ResponsibilityProfileType.offDuty',
  GeneralResult = 'General.result',
  GeneralRetry = 'General.retry',
  GeneralRingingTime = 'General.ringingTime',
  GeneralRole = 'General.role',
  GeneralRoleLimitDescription = 'General.roleLimitDescription',
  GeneralRona = 'General.rona',
  GeneralSave = 'General.save',
  GeneralSearch = 'General.search',
  GeneralSearchForEmailOrPhone = 'General.searchForEmailOrPhone',
  GeneralSecondaryCode = 'General.secondaryCode',
  GeneralSecondsAgo = 'General.secondsAgo',
  GeneralSelect = 'General.select',
  GeneralSelected = 'General.selected',
  GeneralSelectedEntry = 'General.selectedEntry',
  GeneralSelectedServiceDoesNotHaveModalityEnabled = 'General.selectedServiceDoesNotHaveModalityEnabled',
  GeneralSeries = 'General.series',
  GeneralService = 'General.service',
  GeneralServiceAgents = 'General.serviceAgents',
  GeneralServiceDeleted = 'General.serviceDeleted',
  GeneralServiceEntities = 'General.serviceEntities',
  GeneralServiceGroupDirectCall = 'General.serviceGroup.directCall',
  GeneralServiceGroupStandard = 'General.serviceGroup.standard',
  GeneralServiceGroupTitle = 'General.serviceGroup.title',
  GeneralServiceOwners = 'General.serviceOwners',
  GeneralServiceUpn = 'General.serviceUpn',
  GeneralServices = 'General.services',
  GeneralSessionDashboard = 'General.sessionDashboard',
  GeneralSessionDetails = 'General.sessionDetails',
  GeneralSessionOutcome = 'General.sessionOutcome',
  GeneralSessionWidgets = 'General.sessionWidgets',
  GeneralShare = 'General.share',
  GeneralSipAddress = 'General.sipAddress',
  GeneralSkill = 'General.skill',
  GeneralSkillBased = 'General.skillBased',
  GeneralSkillLevel = 'General.skillLevel',
  GeneralSkillsAddRemove = 'General.skillsAddRemove',
  GeneralSkillsChangeLevel = 'General.skillsChangeLevel',
  GeneralSuggestedByAi = 'General.suggestedByAi',
  GeneralSpeechRecognizer = 'General.speechRecognizer',
  GeneralState = 'General.state',
  GeneralStop = 'General.stop',
  GeneralStreet = 'General.street',
  GeneralSubmit = 'General.submit',
  GeneralSuccessful = 'General.successful',
  GeneralSuccessfulPartially = 'General.successfulPartially',
  GeneralSupervisionModeBargeIn = 'General.SupervisionMode.bargeIn',
  GeneralSupervisionModeListen = 'General.SupervisionMode.listen',
  GeneralSupervisionModeWhisper = 'General.SupervisionMode.whisper',
  GeneralSummarization = 'General.summarization',
  GeneralSummarizationTypeChapterTitle = 'General.SummarizationType.chapterTitle',
  GeneralSummarizationTypeRecap = 'General.SummarizationType.recap',
  GeneralSummarizationTypeIssue = 'General.SummarizationType.issue',
  GeneralSummarizationTypeResolution = 'General.SummarizationType.resolution',
  GeneralSummarizationTypeNarrative = 'General.SummarizationType.narrative',
  GeneralTag = 'General.tag',
  GeneralTags = 'General.tags',
  GeneralTasks = 'General.tasks',
  GeneralTasksHeatmap = 'General.tasksHeatmap',
  GeneralTasksToday = 'General.tasksToday',
  GeneralTeamId = 'General.teamId',
  GeneralTenant = 'General.tenant',
  GeneralTerminate = 'General.terminate',
  GeneralTextAlignCenter = 'General.textAlignCenter',
  GeneralTextAlignJustify = 'General.textAlignJustify',
  GeneralTextAlignLeft = 'General.textAlignLeft',
  GeneralTextAlignRight = 'General.textAlignRight',
  GeneralTextBold = 'General.textBold',
  GeneralTextClearFormatting = 'General.textClearFormatting',
  GeneralTextIndentDecrease = 'General.textIndentDecrease',
  GeneralTextIndentIncrease = 'General.textIndentIncrease',
  GeneralTextItalic = 'General.textItalic',
  GeneralTextListBullets = 'General.textListBullets',
  GeneralTextListNumbering = 'General.textListNumbering',
  GeneralTextStrikethrough = 'General.textStrikethrough',
  GeneralTextSubscript = 'General.textSubscript',
  GeneralTextSuperscript = 'General.textSuperscript',
  GeneralTextUnderline = 'General.textUnderline',
  GeneralTheme = 'General.theme',
  GeneralThresholds = 'General.thresholds',
  GeneralTitle = 'General.title',
  GeneralTo = 'General.to',
  GeneralToday = 'General.today',
  GeneralTodayWithTime = 'General.todayWithTime',
  GeneralOneHourAgo = 'General.oneHourAgo',
  GeneralTotalUsers = 'General.totalUsers',
  GeneralTranscript = 'General.transcript',
  GeneralTranscription = 'General.transcription',
  GeneralCodeSuggestions = 'General.codeSuggestions',
  GeneralTagSuggestions = 'General.tagSuggestions',
  GeneralTranscriptionLiveCaption = 'General.transcriptionLiveCaption',
  GeneralTrend = 'General.trend',
  GeneralTryAgain = 'General.tryAgain',
  GeneralTutorials = 'General.tutorials',
  GeneralType = 'General.type',
  GeneralTypeANamePlaceholder = 'General.typeAName',
  GeneralTypeAValuePlaceholder = 'General.typeAValue',
  GeneralTypeInToSearch = 'General.typeInToSearch',
  GeneralTypeURLEx = 'General.typeURLEx',
  GeneralTypeYourText = 'General.typeYourText',
  GeneralUntilHours = 'General.untilHours',
  GeneralUpdate = 'General.update',
  GeneralUpdates = 'General.updates',
  GeneralUpn = 'General.upn',
  GeneralUpnShort = 'General.upnShort',
  GeneralUrlCantBeOpenedInNativeTeams = 'General.urlCantBeOpenedInNativeTeams',
  GeneralUsedInService = 'General.usedInService',
  GeneralUsedInVirtualUser = 'General.usedInVirtualUser',
  GeneralUsedInWorkflow = 'General.usedInWorkflow',
  GeneralUser = 'General.User',
  GeneralUserEntities = 'General.userEntities',
  GeneralUserAssignmentTypeContactCenterLicenseRequired = 'General.UserAssignmentType.contactCenterLicenseRequired',
  GeneralUserAssignmentTypeDirectCall = 'General.UserAssignmentType.directCall',
  GeneralUserAssignmentTypeDistributionPolicyNeedsToBeConfigured = 'General.UserAssignmentType.distributionPolicyNeedsToBeConfigured',
  GeneralUserAssignmentTypeMicrosoftTeamsBased = 'General.UserAssignmentType.microsoftTeamsBased',
  GeneralUserAssignmentTypeNone = 'General.UserAssignmentType.none',
  GeneralUserAssignmentTypeSkillBased = 'General.UserAssignmentType.skillBased',
  GeneralUserAssignmentTypeTitle = 'General.UserAssignmentType.title',
  GeneralUserInteractionOutcomeAccepted = 'General.UserInteractionOutcome.accepted',
  GeneralUserInteractionOutcomeCancelled = 'General.UserInteractionOutcome.cancelled',
  GeneralUserInteractionOutcomeConnected = 'General.UserInteractionOutcome.connected',
  GeneralUserInteractionOutcomeConsultedTransferred = 'General.UserInteractionOutcome.consultedTransferred',
  GeneralUserInteractionOutcomeDeclined = 'General.UserInteractionOutcome.declined',
  GeneralUserInteractionOutcomeDestinationAccepted = 'General.UserInteractionOutcome.destinationAccepted',
  GeneralUserInteractionOutcomeDestinationDeclined = 'General.UserInteractionOutcome.destinationDeclined',
  GeneralUserInteractionOutcomeDialingOut = 'General.UserInteractionOutcome.dialingOut',
  GeneralUserInteractionOutcomeInAfterCallWork = 'General.UserInteractionOutcome.inAfterCallWork',
  GeneralUserInteractionOutcomeInExtendedAfterCallWork = 'General.UserInteractionOutcome.inExtendedAfterCallWork',
  GeneralUserInteractionOutcomeIncoming = 'General.UserInteractionOutcome.incoming',
  GeneralUserInteractionOutcomeMarkedAsHandled = 'General.UserInteractionOutcome.markedAsHandled',
  GeneralUserInteractionOutcomeNotAccepted = 'General.UserInteractionOutcome.notAccepted',
  GeneralUserInteractionOutcomeNotReached = 'General.UserInteractionOutcome.notReached',
  GeneralUserInteractionOutcomeParked = 'General.UserInteractionOutcome.parked',
  GeneralUserInteractionOutcomePutOnHold = 'General.UserInteractionOutcome.putOnHold',
  GeneralUserInteractionOutcomeRona = 'General.UserInteractionOutcome.rona',
  GeneralUserInteractionOutcomeTransferFailed = 'General.UserInteractionOutcome.transferFailed',
  GeneralUserInteractionOutcomeTransferred = 'General.UserInteractionOutcome.transferred',
  GeneralUserInteractionOutcomeTransferring = 'General.UserInteractionOutcome.transferring',
  GeneralUserInteractionOutcomeUnknown = 'General.UserInteractionOutcome.unknown',
  GeneralUserInteractionOutcomeUserAborted = 'General.UserInteractionOutcome.userAborted',
  GeneralUserInteractionOutcomeUserMarkedAsHandled = 'General.UserInteractionOutcome.userMarkedAsHandled',
  GeneralUserInteractionOutcomeWorkflowMarkedAsHandled = 'General.UserInteractionOutcome.workflowMarkedAsHandled',
  GeneralUsers = 'General.Users',
  GeneralValidatorCannotContaineSpecialChars = 'General.Validator.cannotContaineSpecialChars',
  GeneralValidatorDuplicateDomain = 'General.Validator.duplicateDomain',
  GeneralValidatorExpectedDtmfInputValidator = 'General.Validator.expectedDtmfInputValidator',
  GeneralValidatorInvalidContextParameterPattern = 'General.Validator.invalidContextParameterPattern',
  GeneralValidatorInvalidIntentNamePattern = 'General.Validator.invalidIntentNamePattern',
  GeneralValidatorInvalidParameter = 'General.Validator.invalidParameter',
  GeneralValidatorInvalidDomain = 'General.Validator.invalidDomain',
  GeneralValidatorInvalidEmailAddress = 'General.Validator.invalidEmailAddress',
  GeneralValidatorInvalidFileDuration = 'General.Validator.invalidFileDuration',
  GeneralValidatorInvalidFileSize = 'General.Validator.invalidFileSize',
  GeneralValidatorInvalidFileType = 'General.Validator.invalidFileType',
  GeneralValidatorInvalidGUID = 'General.Validator.invalidGUID',
  GeneralValidatorInvalidJsonFormat = 'General.Validator.invalidJsonFormat',
  GeneralValidatorInvalidPhoneNumber = 'General.Validator.invalidPhoneNumber',
  GeneralValidatorInvalidSIPAddress = 'General.Validator.invalidSIPAddress',
  GeneralValidatorInvalidUrl = 'General.Validator.invalidUrl',
  GeneralValidatorMax = 'General.Validator.max',
  GeneralValidatorMaxLength = 'General.Validator.maxLength',
  GeneralValidatorMaximumLength = 'General.Validator.maximumLength',
  GeneralValidatorMin = 'General.Validator.min',
  GeneralValidatorPstnIsNotUnique = 'General.Validator.pstnIsNotUnique',
  GeneralValidatorRegexpIsNotValid = 'General.Validator.regexpIsNotValid',
  GeneralValidatorRegexpIsValid = 'General.Validator.regexpIsValid',
  GeneralValidatorRequired = 'General.Validator.required',
  GeneralValidatorRequiredDndInputItem = 'General.Validator.requiredDndInputItem',
  GeneralValidatorServiceUpnNotFound = 'General.Validator.serviceUpnNotFound',
  GeneralValidatorUnique = 'General.Validator.unique',
  GeneralValidatorUpnIsNotUnique = 'General.Validator.upnIsNotUnique',
  GeneralValidatorUpnIsNotValid = 'General.Validator.upnIsNotValid',
  GeneralValidatorValueCanNotBeEmpty = 'General.Validator.valueCanNotBeEmpty',
  GeneralValidatorValueIsNotUnique = 'General.Validator.valueIsNotUnique',
  GeneralValidatorValueTtsMaxLength = 'General.Validator.ttsMaxLength',
  GeneralVersion = 'General.version',
  GeneralVirtualUser = 'General.virtualUser',
  GeneralVirtualUsers = 'General.virtualUsers',
  GeneralVisible = 'General.visible',
  GeneralVoiceInput = 'General.voiceInput',
  GeneralVoiceInputInvalid = 'General.voiceInputInvalid',
  GeneralVoicemail = 'General.voicemail',
  GeneralWarning = 'General.warning',
  GeneralWeekly = 'General.weekly',
  GeneralWeeks = 'General.weeks',
  GeneralWeeksAgo = 'General.weeksAgo',
  GeneralWidgetChartLegendBottom = 'General.WidgetChartLegend.bottom',
  GeneralWidgetChartLegendHidden = 'General.WidgetChartLegend.hidden',
  GeneralWidgetChartLegendLeft = 'General.WidgetChartLegend.left',
  GeneralWidgetChartLegendRight = 'General.WidgetChartLegend.right',
  GeneralWidgetChartLegendTop = 'General.WidgetChartLegend.top',
  GeneralWidgetChartOrientationHorizontal = 'General.WidgetChartOrientation.horizontal',
  GeneralWidgetChartOrientationVertical = 'General.WidgetChartOrientation.vertical',
  GeneralWidgetClockTypeAnalog = 'General.WidgetClockType.analog',
  GeneralWidgetClockTypeBoth = 'General.WidgetClockType.both',
  GeneralWidgetClockTypeDigital = 'General.WidgetClockType.digital',
  GeneralWidgetGroupCommon = 'General.WidgetGroup.common',
  GeneralWidgetGroupService = 'General.WidgetGroup.service',
  GeneralWidgetGroupUser = 'General.WidgetGroup.user',
  GeneralWidgetKpiAsOfNow = 'General.WidgetKpi.asOfNow',
  GeneralWidgetKpiAverageIvrTimeS = 'General.WidgetKpi.averageIvrTimeS',
  GeneralWidgetKpiAverageQueueTimeS = 'General.WidgetKpi.averageQueueTimeS',
  GeneralWidgetKpiAverageTotalConnectedTimeS = 'General.WidgetKpi.averageTotalConnectedTimeS',
  GeneralWidgetKpiAverageVoicemailHandleTimeS = 'General.WidgetKpi.averageVoicemailHandleTimeS',
  GeneralWidgetKpiInboundPercentReachability = 'General.WidgetKpi.inboundPercentReachability',
  GeneralWidgetKpiLongestWaitingTask = 'General.WidgetKpi.longestWaitingTask',
  GeneralWidgetKpiOutboundPercentReachability = 'General.WidgetKpi.outboundPercentReachability',
  GeneralWidgetKpiPercentAcceptanceSLA = 'General.WidgetKpi.percentAcceptanceSLA',
  GeneralWidgetKpiPercentHandledRate = 'General.WidgetKpi.percentHandledRate',
  GeneralWidgetKpiPercentHangupSLA = 'General.WidgetKpi.percentHangupSLA',
  GeneralWidgetKpiPercentReachability = 'General.WidgetKpi.percentReachability',
  GeneralWidgetKpiPercentOutboundReachability = 'General.WidgetKpi.percentOutboundReachability',
  GeneralWidgetKpiTotalMembersActive = 'General.WidgetKpi.totalMembersActive',
  GeneralWidgetKpiTotalMembersAvailable = 'General.WidgetKpi.totalMembersAvailable',
  GeneralWidgetKpiTotalMembersNotAvailable = 'General.WidgetKpi.totalMembersNotAvailable',
  GeneralWidgetKpiTotalSessions = 'General.WidgetKpi.totalSessions',
  GeneralWidgetKpiTotalSessionsCurrentlyConnected = 'General.WidgetKpi.totalSessionsCurrentlyConnected',
  GeneralWidgetKpiTotalSessionsCurrentlyInQueue = 'General.WidgetKpi.totalSessionsCurrentlyInQueue',
  GeneralWidgetKpiTotalSessionsHandledBySystem = 'General.WidgetKpi.totalSessionsHandledBySystem',
  GeneralWidgetKpiTotalSessionsHandledByUser = 'General.WidgetKpi.totalSessionsHandledByUser',
  GeneralWidgetKpiTotalSessionsHandledByUserSla = 'General.WidgetKpi.totalSessionsHandledByUserSla',
  GeneralWidgetKpiTotalSessionsHangupBeforeAccept = 'General.WidgetKpi.totalSessionsHangupBeforeAccept',
  GeneralWidgetKpiTotalSessionsHangupByCustomer = 'General.WidgetKpi.totalSessionsHangupByCustomer',
  GeneralWidgetKpiTotalSessionsHangupByWorkflow = 'General.WidgetKpi.totalSessionsHangupByWorkflow',
  GeneralWidgetKpiTotalSessionsHangupInIvr = 'General.WidgetKpi.totalSessionsHangupInIvr',
  GeneralWidgetKpiTotalSessionsHangupInIvrAfterQueue = 'General.WidgetKpi.totalSessionsHangupInIvrAfterQueue',
  GeneralWidgetKpiTotalSessionsHangupInQueue = 'General.WidgetKpi.totalSessionsHangupInQueue',
  GeneralWidgetKpiTotalSessionsHangupInQueueSla = 'General.WidgetKpi.totalSessionsHangupInQueueSla',
  GeneralWidgetKpiTotalSessionsNotHandled = 'General.WidgetKpi.totalSessionsNotHandled',
  GeneralWidgetKpiTotalSessionsQueued = 'General.WidgetKpi.totalSessionsQueued',
  GeneralWidgetKpiTotalSessionsUserTransferred = 'General.WidgetKpi.totalSessionsUserTransferred',
  GeneralWidgetKpiTotalSessionsWorfklowTransferred = 'General.WidgetKpi.totalSessionsWorfklowTransferred',
  GeneralWidgetKpiTotalSessionsWorkflowConversationRecorded = 'General.WidgetKpi.totalSessionsWorkflowConversationRecorded',
  GeneralWidgetKpiTotalVoicemailsNew = 'General.WidgetKpi.totalVoicemailsNew',
  GeneralWidgetKpiTypeMembers = 'General.WidgetKpiType.members',
  GeneralWidgetKpiTypePercent = 'General.WidgetKpiType.percent',
  GeneralWidgetKpiTypeTasks = 'General.WidgetKpiType.tasks',
  GeneralWidgetKpiTypeTime = 'General.WidgetKpiType.time',
  GeneralWidgetKpiUserPercentTasksAccepted = 'General.WidgetKpiUser.percentTasksAccepted',
  GeneralWidgetKpiUserPercentTasksDeclined = 'General.WidgetKpiUser.percentTasksDeclined',
  GeneralWidgetKpiUserPercentTasksRona = 'General.WidgetKpiUser.percentTasksRona',
  GeneralWidgetKpiUserTotalTasksAccepted = 'General.WidgetKpiUser.totalTasksAccepted',
  GeneralWidgetKpiUserTotalTasksDeclined = 'General.WidgetKpiUser.totalTasksDeclined',
  GeneralWidgetKpiUserTotalTasksRona = 'General.WidgetKpiUser.totalTasksRona',
  GeneralWidgetKpiUserTotalTimeConnected = 'General.WidgetKpiUser.totalTimeConnected',
  GeneralWidgetKpiUserTotalTimeRinging = 'General.WidgetKpiUser.totalTimeRinging',
  GeneralWidgetOperatorGreater = 'General.WidgetOperator.greater',
  GeneralWidgetOperatorGreaterOrEqual = 'General.WidgetOperator.greaterOrEqual',
  GeneralWidgetOperatorIsEqualTo = 'General.WidgetOperator.isEqualTo',
  GeneralWidgetOperatorIsNotEqualTo = 'General.WidgetOperator.isNotEqualTo',
  GeneralWidgetOperatorLess = 'General.WidgetOperator.less',
  GeneralWidgetOperatorLessOrEqual = 'General.WidgetOperator.lessOrEqual',
  GeneralWidgetUpwardTrendTypeInconclusive = 'General.WidgetUpwardTrendType.inconclusive',
  GeneralWidgetUpwardTrendTypeNegative = 'General.WidgetUpwardTrendType.negative',
  GeneralWidgetUpwardTrendTypePositive = 'General.WidgetUpwardTrendType.positive',
  GeneralWidgetUserStateTypeDutyState = 'General.WidgetUserStateType.dutyState',
  GeneralWidgetUserStateTypePresenceState = 'General.WidgetUserStateType.presenceState',
  GeneralWidgetUserStateTypeResponsibilityProfile = 'General.WidgetUserStateType.responsibilityProfile',
  GeneralWidgetUserStateTypeResponsibilityProfileType = 'General.WidgetUserStateType.responsibilityProfileType',
  GeneralWidgets = 'General.widgets',
  GeneralWidth = 'General.width',
  GeneralWorkflow = 'General.workflow',
  GeneralWorkflowType = 'General.workflowType',
  GeneralXPlaylists = 'General.xPlaylists',
  GeneralXServices = 'General.xServices',
  GeneralXVirtualUsers = 'General.xVirtualUsers',
  GeneralXWorkflows = 'General.xWorkflows',
  GeneralYearly = 'General.yearly',
  GeneralYearsAgo = 'General.yearsAgo',
  GeneralYesterday = 'General.yesterday',
  GeneralYesterdayWithTime = 'General.yesterdayWithTime',
  GeneralZoomIn = 'General.zoomIn',
  GeneralZoomOut = 'General.zoomOut',
  GeoLocationChooseGeoLocation = 'GeoLocation.chooseGeoLocation',
  GeoLocationCurrentLocation = 'GeoLocation.currentLocation',
  GeoLocationNoLocationAvailable = 'GeoLocation.noLocationAvailable',
  GeoLocationSelectYourEnvironment = 'GeoLocation.selectYourEnvironment',
  HistoricalSessionDetailsTitle = 'HistoricalSessions.details.title',
  HistoricalSessionDetailsVoicemailConfidence = 'HistoricalSessions.details.voicemail.confidence',
  HistoricalSessionDetailsVoicemailDuration = 'HistoricalSessions.details.voicemail.duration',
  HistoricalSessionDetailsVoicemailLanguage = 'HistoricalSessions.details.voicemail.language',
  HistoricalSessionDetailsVoicemailTitle = 'HistoricalSessions.details.voicemail.title',
  HistoricalSessionFilterACWTime = 'HistoricalSessions.filter.acwTime',
  HistoricalSessionFilterDirection = 'HistoricalSessions.filter.direction',
  HistoricalSessionFilterModality = 'HistoricalSessions.filter.modality',
  HistoricalSessionFilterTaskResult = 'HistoricalSessions.filter.taskResult',
  HistoricalSessionGridACWTime = 'HistoricalSessions.grid.acwTime',
  HistoricalSessionGridConnectedTime = 'HistoricalSessions.grid.connectedTime',
  HistoricalSessionGridCustomer = 'HistoricalSessions.grid.customer',
  HistoricalSessionGridDateTime = 'HistoricalSessions.grid.dateTime',
  HistoricalSessionGridDuration = 'HistoricalSessions.grid.duration',
  HistoricalSessionGridFirstAccepted = 'HistoricalSessions.grid.firstAccepted',
  HistoricalSessionGridOpeningHours = 'HistoricalSessions.grid.openingHours',
  HistoricalSessionGridOrganizationUnit = 'HistoricalSessions.grid.organizationUnit',
  HistoricalSessionGridPrimaryCode = 'HistoricalSessions.grid.primaryCode',
  HistoricalSessionGridQueued = 'HistoricalSessions.grid.queued',
  HistoricalSessionGridRefresh = 'HistoricalSessions.grid.refresh',
  HistoricalSessionGridResult = 'HistoricalSessions.grid.result',
  HistoricalSessionGridRingingTime = 'HistoricalSessions.grid.ringingTime',
  HistoricalSessionGridSecondaryCode = 'HistoricalSessions.grid.secondaryCode',
  HistoricalSessionGridSource = 'HistoricalSessions.grid.source',
  HistoricalSessionGridUser = 'HistoricalSessions.grid.user',
  HistoricalSessionGridUserSessions = 'HistoricalSessions.grid.userSessions',
  HistoricalSessionGridVoicemail = 'HistoricalSessions.grid.voicemail',
  HistoricalSessionsFilterInitialModalityAv = 'HistoricalSessions.filter.initialModality.AV',
  HistoricalSessionsFilterInitialModalityEm = 'HistoricalSessions.filter.initialModality.EM',
  HistoricalSessionsFilterInitialModalityEt = 'HistoricalSessions.filter.initialModality.ET',
  HistoricalSessionsFilterInitialModalityIm = 'HistoricalSessions.filter.initialModality.IM',
  HistoricalSessionsWidgetHistoricalSessions = 'HistoricalSessions.widgets.historicalSessions',
  HistoricalSessionsWidgetSessions = 'HistoricalSessions.widgets.sessions',
  HistoricalSessionsWidgetSessionsDirection = 'HistoricalSessions.widgets.sessionsDirection',
  HistoricalSessionsWidgetSessionsResult = 'HistoricalSessions.widgets.sessionsResult',
  HistoricalSessionsWidgetSessionsType = 'HistoricalSessions.widgets.sessionsType',
  HistoricalSessionsWidgetUserHistoricalSessions = 'HistoricalSessions.widgets.userHistoricalSessions',
  ImTemplateOutboundCall = 'ImTemplate.OutboundCall.message',
  LanguageSelectorAfrikaans = 'LanguageSelector.afrikaans',
  LanguageSelectorArabic = 'LanguageSelector.arabic',
  LanguageSelectorArmenian = 'LanguageSelector.armenian',
  LanguageSelectorAzerbaijani = 'LanguageSelector.azerbaijani',
  LanguageSelectorBelarusian = 'LanguageSelector.belarusian',
  LanguageSelectorBosnian = 'LanguageSelector.bosnian',
  LanguageSelectorBulgarian = 'LanguageSelector.bulgarian',
  LanguageSelectorCatalan = 'LanguageSelector.catalan',
  LanguageSelectorChinese = 'LanguageSelector.chinese',
  LanguageSelectorCroatian = 'LanguageSelector.croatian',
  LanguageSelectorCzech = 'LanguageSelector.czech',
  LanguageSelectorDanish = 'LanguageSelector.danish',
  LanguageSelectorDutch = 'LanguageSelector.dutch',
  LanguageSelectorEnglish = 'LanguageSelector.english',
  LanguageSelectorEnglishUK = 'LanguageSelector.englishUK',
  LanguageSelectorEstonian = 'LanguageSelector.estonian',
  LanguageSelectorFinnish = 'LanguageSelector.finnish',
  LanguageSelectorFrench = 'LanguageSelector.french',
  LanguageSelectorGerman = 'LanguageSelector.german',
  LanguageSelectorGreek = 'LanguageSelector.greek',
  LanguageSelectorHebrew = 'LanguageSelector.hebrew',
  LanguageSelectorHindi = 'LanguageSelector.hindi',
  LanguageSelectorHungarian = 'LanguageSelector.hungarian',
  LanguageSelectorIcelandic = 'LanguageSelector.icelandic',
  LanguageSelectorIndonesian = 'LanguageSelector.indonesian',
  LanguageSelectorItalian = 'LanguageSelector.italian',
  LanguageSelectorJapanese = 'LanguageSelector.japanese',
  LanguageSelectorKazakh = 'LanguageSelector.kazakh',
  LanguageSelectorKorean = 'LanguageSelector.korean',
  LanguageSelectorLanguage = 'LanguageSelector.language',
  LanguageSelectorLatvian = 'LanguageSelector.latvian',
  LanguageSelectorLithuanian = 'LanguageSelector.lithuanian',
  LanguageSelectorMacedonian = 'LanguageSelector.macedonian',
  LanguageSelectorNepali = 'LanguageSelector.nepali',
  LanguageSelectorNorwegian = 'LanguageSelector.norwegian',
  LanguageSelectorPersian = 'LanguageSelector.persian',
  LanguageSelectorPolish = 'LanguageSelector.polish',
  LanguageSelectorPortuguese = 'LanguageSelector.portuguese',
  LanguageSelectorRomanian = 'LanguageSelector.romanian',
  LanguageSelectorRussian = 'LanguageSelector.russian',
  LanguageSelectorSerbian = 'LanguageSelector.serbian',
  LanguageSelectorSlovak = 'LanguageSelector.slovak',
  LanguageSelectorSlovenian = 'LanguageSelector.slovenian',
  LanguageSelectorSpanish = 'LanguageSelector.spanish',
  LanguageSelectorSwedish = 'LanguageSelector.swedish',
  LanguageSelectorThai = 'LanguageSelector.thai',
  LanguageSelectorTurkish = 'LanguageSelector.turkish',
  LanguageSelectorUkrainian = 'LanguageSelector.ukrainian',
  LanguageSelectorVietnamese = 'LanguageSelector.vietnamese',
  LanguageSelectorWelsh = 'LanguageSelector.welsh',
  LicenseListO365LicenseExchangeDescription = 'LicenseList.o365LicenseExchangeDescription',
  LicenseListO365LicenseExchangeName = 'LicenseList.o365LicenseExchangeName',
  LicenseListO365LicenseName = 'LicenseList.o365LicenseName',
  LinksLuwareAssistantInstallation = 'Links.luwareAssistantInstallation',
  LinksLuwareCloud = 'Links.luwareCloud',
  LinksLuwareCompanionServiceSettings = 'Links.luwareCompanionServiceSettings',
  LinkaLuwareDataPrivacyServiceSettings = 'Links.luwareDataPrivacyServiceSettings',
  LinksLuwareDataPrivacyTenantSettings = 'Links.luwareDataPrivacyTenantSettings',
  LinksLuwareDistributionPolicies = 'Links.luwareDistributionPolicies',
  LinksLuwareExtensionServiceSettingsCC = 'Links.luwareExtensionServiceSettingsCC',
  LinksLuwareFlowActions = 'Links.luwareFlowActions',
  LinksLuwareGeneral = 'Links.luwareGeneral',
  LinksLuwareModalitiesServiceSettings = 'Links.luwareModalitiesServiceSettings',
  LinksLuwareOperations = 'Links.luwareOperations',
  LinksLuwarePlaylists = 'Links.luwarePlaylists',
  LinksLuwarePowerAutomateConnector = 'Links.luwarePowerAutomateConnector',
  LinksLuwarePowerBiTemplate = 'Links.luwarePowerBiTemplate',
  LinksLuwareProvisioningVIaPowershell = 'Links.luwareProvisioningVIaPowershell',
  LinksLuwareReleaseNotes = 'Links.luwareReleaseNotes',
  LinksLuwareUploadManifest = 'Links.luwareUploadManifest',
  LinksLuwareUserNotifications = 'Links.luwareUserNotifications',
  LinksLuwareWorkflowActivities = 'Links.luwareWorkflowActivities',
  LongestWaitingTitle = 'LongestWaiting.title',
  ManageAssistantServiceTemplate = 'Manage.Assistant.ServiceTemplates.Template',
  ManageAssistantServiceTemplateDetails = 'Manage.Assistant.ServiceTemplates.templateDetails',
  ManageAssistantTemplate = 'Manage.Assistant.Templates.Template',
  ManageAssistantTemplateActions = 'Manage.Assistant.Templates.actions',
  ManageAssistantTemplateCallType = 'Manage.Assistant.Templates.callType',
  ManageAssistantTemplateCallTypeNimbus = 'Manage.Assistant.Templates.callTypeNimbus',
  ManageAssistantTemplateCallTypePeerToPeer = 'Manage.Assistant.Templates.callTypePeerToPeer',
  ManageAssistantTemplateCannotBeRemoved = 'Manage.Assistant.Templates.cannotBeRemoved',
  ManageAssistantTemplateDescription = 'Manage.Assistant.Templates.description',
  ManageAssistantTemplateDetails = 'Manage.Assistant.Templates.templateDetails',
  ManageAssistantTemplatePostfixAndMore = 'Manage.Assistant.Templates.postfixAndMore',
  ManageAssistantTemplateOrigin = 'Manage.Assistant.Templates.origin',
  ManageAssistantTemplateOriginEmail = 'Manage.Assistant.Templates.originEmail',
  ManageAssistantTemplateOriginExternal = 'Manage.Assistant.Templates.originExternal',
  ManageAssistantTemplateOriginExternalTask = 'Manage.Assistant.Templates.originExternalTask',
  ManageAssistantTemplateOriginInstantMessaging = 'Manage.Assistant.Templates.originInstantMessaging',
  ManageAssistantTemplateOriginInternal = 'Manage.Assistant.Templates.originInternal',
  ManageAssistantTemplateOriginOutbound = 'Manage.Assistant.Templates.originOutbound',
  ManageAssistantTemplateOriginPstn = 'Manage.Assistant.Templates.originPstn',
  ManageAssistantTemplatesTitle = 'Manage.Assistant.Templates.title',
  ManageAssistantTemplateTriggerEvent = 'Manage.Assistant.Templates.triggerEvent',
  ManageAssistantTemplateTriggers = 'Manage.Assistant.Templates.triggers',
  ManageAssistantTemplateTriggerTypeAccepted = 'Manage.Assistant.Templates.triggerAccepted',
  ManageAssistantTemplateTriggerTypeRinging = 'Manage.Assistant.Templates.triggerRinging',
  ManageAssistantTemplateTriggerTypeTerminated = 'Manage.Assistant.Templates.triggerTerminated',
  ManageAssistantTemplateTypeADescription = 'Manage.Assistant.Templates.typeADescription',
  ManageAssistantTemplateUsedInService = 'Manage.Assistant.ServiceTemplates.usedInService',
  ManageAssistantTemplateUsedInUser = 'Manage.Assistant.Templates.usedInUser',
  ManageAssistantTitle = 'Manage.Assistant.title',
  ManageAssistantTriggerAddTrigger = 'Manage.Assistant.Templates.Trigger.addTrigger',
  ManageAssistantTriggerAuthorizationPassword = 'Manage.Assistant.Templates.Trigger.Authorization.password',
  ManageAssistantTriggerAuthorizationPasswordPlaceholder = 'Manage.Assistant.Templates.Trigger.Authorization.passwordPlaceholder',
  ManageAssistantTriggerAuthorizationScopes = 'Manage.Assistant.Templates.Trigger.Authorization.scopes',
  ManageAssistantTriggerAuthorizationTitle = 'Manage.Assistant.Templates.Trigger.Authorization.title',
  ManageAssistantTriggerAuthorizationTypeAccessToken = 'Manage.Assistant.Templates.Trigger.Authorization.Type.accessToken',
  ManageAssistantTriggerAuthorizationTypeBasic = 'Manage.Assistant.Templates.Trigger.Authorization.Type.basic',
  ManageAssistantTriggerAuthorizationTypeNone = 'Manage.Assistant.Templates.Trigger.Authorization.Type.none',
  ManageAssistantTriggerAuthorizationTypeScopes = 'Manage.Assistant.Templates.Trigger.Authorization.Type.scopes',
  ManageAssistantTriggerAuthorizationTypeTitle = 'Manage.Assistant.Templates.Trigger.Authorization.Type.title',
  ManageAssistantTriggerAuthorizationUserName = 'Manage.Assistant.Templates.Trigger.Authorization.userName',
  ManageAssistantTriggerAuthorizationUserNamePlaceholder = 'Manage.Assistant.Templates.Trigger.Authorization.userNamePlaceholder',
  ManageAssistantTriggerGlobalBody = 'Manage.Assistant.Templates.Trigger.Global.body',
  ManageAssistantTriggerGlobalBodyPlaceholder = 'Manage.Assistant.Templates.Trigger.Global.bodyPlaceholder',
  ManageAssistantTriggerGlobalCustomParameters = 'Manage.Assistant.Templates.Trigger.Global.customParameters',
  ManageAssistantTriggerGlobalForm = 'Manage.Assistant.Templates.Trigger.Global.form',
  ManageAssistantTriggerGlobalFormInvalid = 'Manage.Assistant.Templates.Trigger.Global.formInvalid',
  ManageAssistantTriggerGlobalHTTP = 'Manage.Assistant.Templates.Trigger.Global.HTTP',
  ManageAssistantTriggerGlobalOpenIn = 'Manage.Assistant.Templates.Trigger.Global.openIn',
  ManageAssistantTriggerGlobalOrderInvalid = 'Manage.Assistant.Templates.Trigger.Global.invalidOrder',
  ManageAssistantTriggerGlobalParameterError = 'Manage.Assistant.Templates.Trigger.Global.parameterError',
  ManageAssistantTriggerGlobalParameters = 'Manage.Assistant.Templates.Trigger.Global.parameters',
  ManageAssistantTriggerGlobalParametersPlaceholder = 'Manage.Assistant.Templates.Trigger.Global.parametersPlaceholder',
  ManageAssistantTriggerGlobalPath = 'Manage.Assistant.Templates.Trigger.Global.path',
  ManageAssistantTriggerGlobalPathPlaceholder = 'Manage.Assistant.Templates.Trigger.Global.pathPlaceholder',
  ManageAssistantTriggerGlobalSystemParameters = 'Manage.Assistant.Templates.Trigger.Global.systemParameters',
  ManageAssistantTriggerGlobalTitle = 'Manage.Assistant.Templates.Trigger.Global.title',
  ManageAssistantTriggerGlobalTriggerId = 'Manage.Assistant.Templates.Trigger.Global.triggerId',
  ManageAssistantTriggerGlobalUrl = 'Manage.Assistant.Templates.Trigger.Global.url',
  ManageAssistantTriggerGlobalUrlParameters = 'Manage.Assistant.Templates.Trigger.Global.urlParameters',
  ManageAssistantTriggerGlobalUrlPlaceholder = 'Manage.Assistant.Templates.Trigger.Global.urlPlaceholder',
  ManageAssistantTriggerHeadersInvalid = 'Manage.Assistant.Templates.Trigger.Headers.invalid',
  ManageAssistantTriggerHeadersKey = 'Manage.Assistant.Templates.Trigger.Headers.key',
  ManageAssistantTriggerHeadersPlaceholder = 'Manage.Assistant.Templates.Trigger.Headers.placeholder',
  ManageAssistantTriggerHeadersTitle = 'Manage.Assistant.Templates.Trigger.Headers.title',
  ManageAssistantTriggerHeadersValue = 'Manage.Assistant.Templates.Trigger.Headers.value',
  ManageAssistantTriggerInvalid = 'Manage.Assistant.Templates.Trigger.invalid',
  ManageAssistantTriggerResponseTitle = 'Manage.Assistant.Templates.Trigger.Response.title',
  ManageAssistantTriggerResponseWait = 'Manage.Assistant.Templates.Trigger.Response.wait',
  ManageAssistantTriggerResponseWaitTimeout = 'Manage.Assistant.Templates.Trigger.Response.waitTimeout',
  ManageAssistantTriggerType = 'Manage.Assistant.Templates.Trigger.type',
  ManageAssistantTriggerTypeApplication = 'Manage.Assistant.Templates.Trigger.application',
  ManageAssistantTriggerTypeWebRequest = 'Manage.Assistant.Templates.Trigger.webRequest',
  ManageAttendantConsoleAddressBookContacts = 'Manage.AttendantConsole.AddressBooks.contacts',
  ManageAttendantConsoleAddressBookDelete = 'Manage.AttendantConsole.AddressBooks.delete',
  ManageAttendantConsoleAddressBookEdit = 'Manage.AttendantConsole.AddressBooks.edit',
  ManageAttendantConsoleAddressBookImage = 'Manage.AttendantConsole.AddressBooks.image',
  ManageAttendantConsoleAddressBookModifiedDate = 'Manage.AttendantConsole.AddressBooks.modifiedDate',
  ManageAttendantConsoleAddressBookName = 'Manage.AttendantConsole.AddressBooks.name',
  ManageAttendantConsoleAddressBookOrganizationUnit = 'Manage.AttendantConsole.AddressBooks.organizationUnit',
  ManageAttendantConsoleAddressBookSingleTitle = 'Manage.AttendantConsole.AddressBooks.singleTitle',
  ManageAttendantConsoleAddressBookTitle = 'Manage.AttendantConsole.AddressBooks.title',
  ManageAttendantConsoleAddressCompany = 'Manage.AttendantConsole.AddressBooks.company',
  ManageAttendantConsoleAddressDepartment = 'Manage.AttendantConsole.AddressBooks.department',
  ManageAttendantConsoleAddressExternalId = 'Manage.AttendantConsole.AddressBooks.externalId',
  ManageAttendantConsoleAddressFirstName = 'Manage.AttendantConsole.AddressBooks.firstName',
  ManageAttendantConsoleAddressLastName = 'Manage.AttendantConsole.AddressBooks.lastName',
  ManageAttendantConsoleTitle = 'Manage.AttendantConsole.title',
  ManageBotDeleteCannotBeDeleted = 'Manage.Bot.Delete.cannotBeDeleted',
  ManageBotRequestTemplateBody = 'Manage.BotRequestTemplate.body',
  ManageBotRequestTemplateDeleteCannotBeDeleted = 'Manage.BotRequestTemplate.Delete.cannotBeDeleted',
  ManageBotRequestTemplateTitle = 'Manage.BotRequestTemplate.title',
  ManageBotResponseTemplateAnswerFormatted = 'Manage.BotResponseTemplate.answerFormatted',
  ManageBotResponseTemplateAnswerRaw = 'Manage.BotResponseTemplate.answerRaw',
  ManageBotResponseTemplateCustomFieldMapping = 'Manage.BotResponseTemplate.customFieldMapping',
  ManageBotResponseTemplateDeleteCannotBeDeleted = 'Manage.BotResponseTemplate.Delete.cannotBeDeleted',
  ManageBotResponseTemplateExit = 'Manage.BotResponseTemplate.exit',
  ManageBotResponseTemplateIntent = 'Manage.BotResponseTemplate.intent',
  ManageBotResponseTemplateSentiment = 'Manage.BotResponseTemplate.sentiment',
  ManageBotResponseTemplateSystemFieldMapping = 'Manage.BotResponseTemplate.systemFieldMapping',
  ManageBotResponseTemplateTitle = 'Manage.BotResponseTemplate.title',
  ManageBotTitle = 'Manage.Bot.title',
  ManageCodesDescription = 'Manage.Codes.description',
  ManageCodesCompanionContext = 'Manage.Codes.companionContext',
  ManageCodesInsertCustomParameter = 'Manage.Codes.insertCustomParameter',
  ManageCodesInsertSystemParameter = 'Manage.Codes.insertSystemParameter',
  ManageCodesVirtualUserContext = 'Manage.Codes.virtualUserContext',
  ManageCodesTypeAVirtualUserContext = 'Manage.Codes.typeAVirtualUserContext',
  ManageCodesInfoVirtualUserContext = 'Manage.Codes.infoVirtualUserContext',
  ManageCodesName = 'Manage.Codes.name',
  ManageCodesSelectOrganizationUnitToGetParams = 'Manage.Codes.selectOrganizationUnitToGetParams',
  ManageCodesTitle = 'Manage.Codes.title',
  ManageCodesTypeADescription = 'Manage.Codes.typeADescription',
  ManageCodesTypeACompanionContext = 'Manage.Codes.typeACompanionContext',
  ManageCodesInfoCompanionContext = 'Manage.Codes.infoCompanionContext',
  ManageCodesURL = 'Manage.Codes.url',
  ManageConversationContextParameterChangeOnlyOnCreate = 'Manage.ConversationContextParameter.changeOnlyOnCreate',
  ManageConversationContextParameterDefaultValue = 'Manage.ConversationContextParameter.defaultValue',
  ManageConversationContextParameterName = 'Manage.ConversationContextParameter.name',
  ManageConversationContextParameterParameterId = 'Manage.ConversationContextParameter.parameterId',
  ManageConversationContextParameterTitle = 'Manage.ConversationContextParameter.title',
  ManageDashboardDashboardNonPersonalCreator = 'Manage.Dashboard.DashboardNonPersonal.creator',
  ManageDashboardDashboardNonPersonalDateModified = 'Manage.Dashboard.DashboardNonPersonal.dateModified',
  ManageDashboardDashboardNonPersonalEditProperties = 'Manage.Dashboard.DashboardNonPersonal.editProperties',
  ManageDashboardDashboardNonPersonalPublish = 'Manage.Dashboard.DashboardNonPersonal.publish',
  ManageDashboardDashboardNonPersonalPublished = 'Manage.Dashboard.DashboardNonPersonal.published',
  ManageDashboardDashboardNonPersonalTitle = 'Manage.Dashboard.DashboardNonPersonal.title',
  ManageDashboardDetailsColor = 'Manage.DashboardDetails.color',
  ManageDashboardDetailsCopy = 'Manage.DashboardDetails.copy',
  ManageDashboardDetailsEdit = 'Manage.DashboardDetails.edit',
  ManageDashboardDetailsPicture = 'Manage.DashboardDetails.picture',
  ManageDashboardDetailsTitleCreate = 'Manage.DashboardDetails.titleCreate',
  ManageDashboardsDuplicate = 'Manage.Dashboards.duplicate',
  ManageDashboardsTitle = 'Manage.Dashboards.title',
  ManageDashboardTitle = 'Manage.Dashboard.title',
  ManageDashboardWidgetChartKpiDetailsColor = 'Manage.DashboardWidgetChartKpiDetails.color',
  ManageDashboardWidgetChartKpiDetailsKpi = 'Manage.DashboardWidgetChartKpiDetails.kpi',
  ManageDashboardWidgetChartKpiDetailsTitleCreate = 'Manage.DashboardWidgetChartKpiDetails.titleCreate',
  ManageDashboardWidgetChartKpiDetailsTitleEdit = 'Manage.DashboardWidgetChartKpiDetails.titleEdit',
  ManageDashboardWidgetDetailsAcw = 'Manage.DashboardWidgetDetails.acw',
  ManageDashboardWidgetDetailsAcwExtended = 'Manage.DashboardWidgetDetails.acwExtended',
  ManageDashboardWidgetDetailsBackgroundColor = 'Manage.DashboardWidgetDetails.backgroundColor',
  ManageDashboardWidgetDetailsChartLegend = 'Manage.DashboardWidgetDetails.chartLegend',
  ManageDashboardWidgetDetailsChartMaxItemsSize = 'Manage.DashboardWidgetDetails.chartMaxItemsSize',
  ManageDashboardWidgetDetailsChartOrientation = 'Manage.DashboardWidgetDetails.chartOrientation',
  ManageDashboardWidgetDetailsChartTaskType = 'Manage.DashboardWidgetDetails.taskType',
  ManageDashboardWidgetDetailsChartValueLabels = 'Manage.DashboardWidgetDetails.chartValueLabels',
  ManageDashboardWidgetDetailsClockType = 'Manage.DashboardWidgetDetails.clockType',
  ManageDashboardWidgetDetailsColumns = 'Manage.DashboardWidgetDetails.columns',
  ManageDashboardWidgetDetailsContent = 'Manage.DashboardWidgetDetails.content',
  ManageDashboardWidgetDetailsDateFormat = 'Manage.DashboardWidgetDetails.dateFormat',
  ManageDashboardWidgetDetailsDirection = 'Manage.DashboardWidgetDetails.direction',
  ManageDashboardWidgetDetailsDirections = 'Manage.DashboardWidgetDetails.directions',
  ManageDashboardWidgetDetailsDueDate = 'Manage.DashboardWidgetDetails.dueDate',
  ManageDashboardWidgetDetailsDutyStates = 'Manage.DashboardWidgetDetails.dutyStates',
  ManageDashboardWidgetDetailsLookBackChartShowValueAxis = 'Manage.DashboardWidgetDetails.lookBackChartShowValueAxis',
  ManageDashboardWidgetDetailsModalities = 'Manage.DashboardWidgetDetails.modalities',
  ManageDashboardWidgetDetailsOperator = 'Manage.DashboardWidgetDetails.operator',
  ManageDashboardWidgetDetailsPageSize = 'Manage.DashboardWidgetDetails.pageSize',
  ManageDashboardWidgetDetailsPresenceActivities = 'Manage.DashboardWidgetDetails.presenceActivities',
  ManageDashboardWidgetDetailsPresenceStates = 'Manage.DashboardWidgetDetails.presenceStates',
  ManageDashboardWidgetDetailsPrimaryChartKpis = 'Manage.DashboardWidgetDetails.primaryChartKpis',
  ManageDashboardWidgetDetailsProfileLevel = 'Manage.DashboardWidgetDetails.profileLevel',
  ManageDashboardWidgetDetailsReadiness = 'Manage.DashboardWidgetDetails.readiness',
  ManageDashboardWidgetDetailsResponsibilityProfiles = 'Manage.DashboardWidgetDetails.responsibilityProfiles',
  ManageDashboardWidgetDetailsResponsibilityProfileTypes = 'Manage.DashboardWidgetDetails.responsibilityProfileTypes',
  ManageDashboardWidgetDetailsRetriesLeft = 'Manage.DashboardWidgetDetails.retriesLeft',
  ManageDashboardWidgetDetailsRona = 'Manage.DashboardWidgetDetails.rona',
  ManageDashboardWidgetDetailsScale = 'Manage.DashboardWidgetDetails.scale',
  ManageDashboardWidgetDetailsSecondaryChartKpis = 'Manage.DashboardWidgetDetails.secondaryChartKpis',
  ManageDashboardWidgetDetailsServicesLimitErrorMessage = 'Manage.DashboardWidgetDetails.servicesLimitErrorMessage',
  ManageDashboardWidgetDetailsServicesLimitInfoMessage = 'Manage.DashboardWidgetDetails.servicesLimitInfoMessage',
  ManageDashboardWidgetDetailsShowBusyHoursOnly = 'Manage.DashboardWidgetDetails.showBusyHoursOnly',
  ManageDashboardWidgetDetailsShowDate = 'Manage.DashboardWidgetDetails.showDate',
  ManageDashboardWidgetDetailsShowFilter = 'Manage.DashboardWidgetDetails.showFilter',
  ManageDashboardWidgetDetailsShowLookBackChart = 'Manage.DashboardWidgetDetails.showLookBackChart',
  ManageDashboardWidgetDetailsShowTime = 'Manage.DashboardWidgetDetails.showTime',
  ManageDashboardWidgetDetailsShowTimezone = 'Manage.DashboardWidgetDetails.showTimezone',
  ManageDashboardWidgetDetailsShowTitle = 'Manage.DashboardWidgetDetails.showTitle',
  ManageDashboardWidgetDetailsShowTrendIndicator = 'Manage.DashboardWidgetDetails.showTrendIndicator',
  ManageDashboardWidgetDetailsStates = 'Manage.DashboardWidgetDetails.states',
  ManageDashboardWidgetDetailsTimeFormat = 'Manage.DashboardWidgetDetails.timeFormat',
  ManageDashboardWidgetDetailsTimeInResponsibilityProfile = 'Manage.DashboardWidgetDetails.timeInResponsibilityProfile',
  ManageDashboardWidgetDetailsTimeInState = 'Manage.DashboardWidgetDetails.timeInState',
  ManageDashboardWidgetDetailsTimezone = 'Manage.DashboardWidgetDetails.timezone',
  ManageDashboardWidgetDetailsTitle = 'Manage.DashboardWidgetDetails.title',
  ManageDashboardWidgetDetailsType = 'Manage.DashboardWidgetDetails.type',
  ManageDashboardWidgetDetailsTypes = 'Manage.DashboardWidgetDetails.types',
  ManageDashboardWidgetDetailsUpwardTrendType = 'Manage.DashboardWidgetDetails.upwardTrendType',
  ManageDashboardWidgetDetailsUrl = 'Manage.DashboardWidgetDetails.url',
  ManageDashboardWidgetDetailsUrlInvalid = 'Manage.DashboardWidgetDetails.urlInvalid',
  ManageDashboardWidgetDetailsUserLicenseTypes = 'Manage.DashboardWidgetDetails.userLicenseTypes',
  ManageDashboardWidgetDetailsUsersLimitErrorMessage = 'Manage.DashboardWidgetDetails.usersLimitErrorMessage',
  ManageDashboardWidgetDetailsUsersLimitInfoMessage = 'Manage.DashboardWidgetDetails.usersLimitInfoMessage',
  ManageDashboardWidgetDetailsWidgetDataSource = 'Manage.DashboardWidgetDetails.widgetDataSource',
  ManageDashboardWidgetDetailsWidgetFilters = 'Manage.DashboardWidgetDetails.widgetFilters',
  ManageDashboardWidgetsAddWidget = 'Manage.DashboardWidgets.addWidget',
  ManageDashboardWidgetsAppenderTitle = 'Manage.DashboardWidgets.Appender.title',
  ManageDashboardWidgetsCopyUrl = 'Manage.DashboardWidgets.copyUrl',
  ManageDashboardWidgetsEditMode = 'Manage.DashboardWidgets.editMode',
  ManageDashboardWidgetsLinkDirectLink = 'Manage.DashboardWidgets.Link.directLink',
  ManageDashboardWidgetsLinkShowHeader = 'Manage.DashboardWidgets.Link.showHeader',
  ManageDashboardWidgetsLinkShowMenu = 'Manage.DashboardWidgets.Link.showMenu',
  ManageDashboardWidgetsProperties = 'Manage.DashboardWidgets.properties',
  ManageDashboardWidgetsWidgetNotAvailable = 'Manage.DashboardWidgets.widgetNotAvailable',
  ManageDashboardWidgetsWidgetNotAvailableTenantDataPrivacy = 'Manage.DashboardWidgets.widgetNotAvailableTenantDataPrivacy',
  ManageDashboardWidgetsWidgetServicesLimitExceeded = 'Manage.DashboardWidgets.widgetServicesLimitExceeded',
  ManageDashboardWidgetsWidgetServicesLimitExceededDescription = 'Manage.DashboardWidgets.widgetServicesLimitExceededDescription',
  ManageDashboardWidgetsWidgetUsersLimitExceeded = 'Manage.DashboardWidgets.widgetUsersLimitExceeded',
  ManageDashboardWidgetsWidgetUsersLimitExceededDescription = 'Manage.DashboardWidgets.widgetUsersLimitExceededDescription',
  ManageDashboardWidgetThresholdDetailsAudio = 'Manage.DashboardWidgetThresholdDetails.audio',
  ManageDashboardWidgetThresholdDetailsColor = 'Manage.DashboardWidgetThresholdDetails.color',
  ManageDashboardWidgetThresholdDetailsColumn = 'Manage.DashboardWidgetThresholdDetails.column',
  ManageDashboardWidgetThresholdDetailsColumnValue = 'Manage.DashboardWidgetThresholdDetails.columnValue',
  ManageDashboardWidgetThresholdDetailsIsValueSource = 'Manage.DashboardWidgetThresholdDetails.isValueSource',
  ManageDashboardWidgetThresholdDetailsOperator = 'Manage.DashboardWidgetThresholdDetails.operator',
  ManageDashboardWidgetThresholdDetailsTitleCreate = 'Manage.DashboardWidgetThresholdDetails.titleCreate',
  ManageDashboardWidgetThresholdDetailsTitleEdit = 'Manage.DashboardWidgetThresholdDetails.titleEdit',
  ManageDashboardWidgetThresholdDetailsValue = 'Manage.DashboardWidgetThresholdDetails.value',
  ManageDistributionDistributionPolicyCannotBeDeleted = 'Manage.Distribution.DistributionPolicy.Delete.cannotBeDeleted',
  ManageDistributionDistributionPolicyEditDistributionLevelsProfileSkipLevels = 'Manage.Distribution.DistributionPolicy.Edit.DistributionLevels.profileSkipLevels',
  ManageDistributionDistributionPolicyEditDistributionLevelsProfileSkipLevelsMessageInfo = 'Manage.Distribution.DistributionPolicy.Edit.DistributionLevels.profileSkipLevelsMessageInfo',
  ManageDistributionDistributionPolicyEditDistributionLevelsProfileSkipTypeNoUsersOnDuty = 'Manage.Distribution.DistributionPolicy.Edit.DistributionLevels.ProfileSkipType.noUsersOnDuty',
  ManageDistributionDistributionPolicyEditDistributionLevelsProfileSkipTypeNoUsersSelectable = 'Manage.Distribution.DistributionPolicy.Edit.DistributionLevels.ProfileSkipType.noUsersSelectable',
  ManageDistributionDistributionPolicyEditDistributionLevelsProfileSkipWhen = 'Manage.Distribution.DistributionPolicy.Edit.DistributionLevels.profileSkipWhen',
  ManageDistributionDistributionPolicyEditDistributionLevelsTitle = 'Manage.Distribution.DistributionPolicy.Edit.DistributionLevels.title',
  ManageDistributionDistributionPolicyEditGeneralInitialPreferencePhase = 'Manage.Distribution.DistributionPolicy.Edit.General.initialPreferencePhase',
  ManageDistributionDistributionPolicyEditGeneralInitialSkippedPreferredUserStates = 'Manage.Distribution.DistributionPolicy.Edit.General.initialSkippedPreferredUserStates',
  ManageDistributionDistributionPolicyEditGeneralLastUserRoutingEnabled = 'Manage.Distribution.DistributionPolicy.Edit.General.lastUserRoutingEnabled',
  ManageDistributionDistributionPolicyEditGeneralLastUserRoutingPhase = 'Manage.Distribution.DistributionPolicy.Edit.General.lastUserRoutingPhase',
  ManageDistributionDistributionPolicyEditGeneralLearnMore = 'Manage.Distribution.DistributionPolicy.Edit.General.learnMore',
  ManageDistributionDistributionPolicyEditGeneralPowerAutomateDependency = 'Manage.Distribution.DistributionPolicy.Edit.General.powerAutomateDependency',
  ManageDistributionDistributionPolicyEditGeneralPreferredAndLastUserRouting = 'Manage.Distribution.DistributionPolicy.Edit.General.preferredAndLastUserRouting',
  ManageDistributionDistributionPolicyEditGeneralPreferredUserRouting = 'Manage.Distribution.DistributionPolicy.Edit.General.preferredUserRouting',
  ManageDistributionDistributionPolicyEditGeneralRequiresConfiguration = 'Manage.Distribution.DistributionPolicy.Edit.General.requiresConfiguration',
  ManageDistributionDistributionPolicyEditGeneralSkipPreferredUserStatesNone = 'Manage.Distribution.DistributionPolicy.Edit.General.SkipPreferredUserStates.none',
  ManageDistributionDistributionPolicyEditGeneralSkipPreferredUserStatesOffDutyAndNotAvailable = 'Manage.Distribution.DistributionPolicy.Edit.General.SkipPreferredUserStates.offDutyAndNotAvailable',
  ManageDistributionDistributionPolicyEditGeneralSkipPreferredUserStatesOffDutyAndOffline = 'Manage.Distribution.DistributionPolicy.Edit.General.SkipPreferredUserStates.offDutyAndOffline',
  ManageDistributionDistributionPolicyEditGeneralTitle = 'Manage.Distribution.DistributionPolicy.Edit.General.title',
  ManageDistributionDistributionPolicyGridPreferredUser = 'Manage.Distribution.DistributionPolicy.Grid.preferredUser',
  ManageDistributionDistributionPolicyOrderBestQualified = 'Manage.Distribution.DistributionPolicy.Order.bestQualified',
  ManageDistributionDistributionPolicyOrderLongestIdle = 'Manage.Distribution.DistributionPolicy.Order.longestIdle',
  ManageDistributionDistributionPolicyTitle = 'Manage.Distribution.DistributionPolicy.title',
  ManageDistributionDistributionPolicyXServices = 'Manage.Distribution.DistributionPolicy.Delete.xServices',
  ManageDistributionResponsibilityProfilesCannotBeDeletedBySystemProfile = 'Manage.Distribution.ResponsibilityProfiles.Delete.cannotBeDeletedBySystemProfile',
  ManageDistributionResponsibilityProfilesCannotBeDeletedByUsersAssigned = 'Manage.Distribution.ResponsibilityProfiles.Delete.cannotBeDeletedByUsersAssigned',
  ManageDistributionResponsibilityProfilesName = 'Manage.Distribution.ResponsibilityProfiles.name',
  ManageDistributionResponsibilityProfilesTitle = 'Manage.Distribution.ResponsibilityProfiles.title',
  ManageDistributionSkillCategoriesCategoryCannotBeChanged = 'Manage.Distribution.SkillCategories.categoryCannotBeChanged',
  ManageDistributionSkillCategoriesCategoryLevelCannotBeDeleted = 'Manage.Distribution.SkillCategories.categoryLevelCannotBeDeleted',
  ManageDistributionSkillCategoriesCategoryResponsibilityCannotBeDeleted = 'Manage.Distribution.SkillCategories.categoryResponsibilityCannotBeDeleted',
  ManageDistributionSkillCategoriesDeleteCannotBeDeleted = 'Manage.Distribution.SkillCategories.Delete.cannotBeDeleted',
  ManageDistributionSkillCategoriesLevelsInfoMessage = 'Manage.Distribution.SkillCategories.levelsInfoMessage',
  ManageDistributionSkillCategoriesResponsibilitiesInfoMessage = 'Manage.Distribution.SkillCategories.responsibilitiesInfoMessage',
  ManageDistributionSkillCategoriesTitle = 'Manage.Distribution.SkillCategories.title',
  ManageDistributionSkillsDeleteCannotBeDeleted = 'Manage.Distribution.Skills.Delete.cannotBeDeleted',
  ManageDistributionSkillsSelectOrganizatunit = 'Manage.Distribution.Skills.selectOrganizationUnit',
  ManageDistributionSkillsTitle = 'Manage.Distribution.Skills.title',
  ManageDistributionTitle = 'Manage.Distribution.title',
  ManageEntityAddressBook = 'Manage.Entity.addressBook',
  ManageEntityCallerAnonymizationRegex = 'Manage.Entity.callerAnonymizationRegex',
  ManageEntityDirectSystemMessage = 'Manage.Entity.directSystemMessage',
  ManageEntityDirectSystemMessages = 'Manage.Entity.directSystemMessages',
  ManageEntityDirectTemplate = 'Manage.Entity.directTemplate',
  ManageEntityDistributionPolicy = 'Manage.Entity.distributionPolicy',
  ManageEntityDomainTemplate = 'Manage.Entity.domainTemplate',
  ManageEntityMailbox = 'Manage.Entity.mailbox',
  ManageEntityNonPersonalDashboard = 'Manage.Entity.nonPersonalDashboard',
  ManageEntityNotAvailableReason = 'Manage.Entity.notAvailableReason',
  ManageEntityOpeningHours = 'Manage.Entity.openingHours',
  ManageEntityOrganizationUnit = 'Manage.Entity.organizationUnit',
  ManageEntityParameter = 'Manage.Entity.parameter',
  ManageEntityPlaylist = 'Manage.Entity.playlist',
  ManageEntityResource = 'Manage.Entity.resource',
  ManageEntityResponsibilityProfile = 'Manage.Entity.responsibilityProfile',
  ManageEntityServiceSystemMessage = 'Manage.Entity.serviceSystemMessage',
  ManageEntityServiceSystemMessages = 'Manage.Entity.serviceSystemMessages',
  ManageEntityServiceTemplate = 'Manage.Entity.serviceTemplate',
  ManageEntitySkill = 'Manage.Entity.skill',
  ManageEntitySkillCategory = 'Manage.Entity.skillCategory',
  ManageEntitySystemTemplate = 'Manage.Entity.systemTemplate',
  ManageEntityWorkflow = 'Manage.Entity.workflow',
  ManageEntityWorkflowTemplate = 'Manage.Entity.workflowTemplate',
  ManageWebRequestActivityTitle = 'Manage.WebRequestActivity.title',
  ManageWebRequest = 'Manage.WebRequestActivity.webRequest',
  ManageWebRequestGeneralTabTitle = 'Manage.WebRequestActivity.generalTabTitle',
  ManageWebRequestRequestTabTitle = 'Manage.WebRequestActivity.requestTabTitle',
  ManageWebRequestResponseTabTitle = 'Manage.WebRequestActivity.responseTabTitle',
  ManageWebRequestTestTabTitle = 'Manage.WebRequestActivity.testTabTitle',
  ManageWebRequestActivityCannotBeRemoved = 'Manage.WebRequestActivity.cannotBeRemoved',
  ManageWebRequestActivityWebRequestMethod = 'Manage.WebRequestActivity.webRequestMethod',
  ManageWebRequestActivityAuthentication = 'Manage.WebRequestActivity.authentication',
  ManageWebRequestAuthentication = 'Manage.WebRequestAuthentication.title',
  ManageWebRequestAuthenticationDetails = 'Manage.WebRequestAuthentication.details',
  ManageWebRequestAuthenticationType = 'Manage.WebRequestAuthentication.type',
  ManageWebRequestAuthenticationUsedInWebRequests = 'Manage.WebRequestAuthentication.usedInWebRequests',
  ManageWebRequestAuthenticationApiKeyName = 'Manage.WebRequestAuthentication.apiKeyName',
  ManageWebRequestAuthenticationApiKeyNameComment = 'Manage.WebRequestAuthentication.apiKeyNameComment',
  ManageWebRequestAuthenticationHowSent = 'Manage.WebRequestAuthentication.howSent',
  ManageWebRequestAuthenticationKeyValue = 'Manage.WebRequestAuthentication.keyValue',
  ManageWebRequestAuthenticationAccessTokenUrl = 'Manage.WebRequestAuthentication.accessTokenUrl',
  ManageWebRequestAuthenticationClientId = 'Manage.WebRequestAuthentication.clientId',
  ManageWebRequestAuthenticationClientSecret = 'Manage.WebRequestAuthentication.clientSecret',
  ManageWebRequestAuthenticationScope = 'Manage.WebRequestAuthentication.scope',
  ManageWebRequestAuthenticationTypeApiKey = 'Manage.WebRequestAuthentication.Type.apiKey',
  ManageWebRequestAuthenticationTypeOAuth2ClientCredentials = 'Manage.WebRequestAuthentication.Type.oAuth2ClientCredentials',
  ManageWebRequestAuthenticationTypeBasicAuth = 'Manage.WebRequestAuthentication.Type.basicAuth',
  ManageWebRequestAuthenticationDeliveryMethodHeader = 'Manage.WebRequestAuthentication.DeliveryMethod.header',
  ManageWebRequestAuthenticationDeliveryMethodQueryString = 'Manage.WebRequestAuthentication.DeliveryMethod.queryString',
  ManageWebRequestActivityUrl = 'Manage.WebRequestActivity.url',
  ManageWebRequestActivityHeaders = 'Manage.WebRequestActivity.headers',
  ManageWebRequestActivityBodyTitle = 'Manage.WebRequestActivity.bodyTitle',
  ManageWebRequestActivityBodyDescription = 'Manage.WebRequestActivity.bodyDescription',
  ManageWebRequestActivitySelectOrganizationUnitToGetParams = 'Manage.WebRequestActivity.selectOrganizationUnitToGetParams',
  ManageWebRequestActivityInvalidUrl = 'Manage.WebRequestActivity.invalidUrl',
  ManageWebRequestActivityWaitForResponse = 'Manage.WebRequestActivity.waitForResponse',
  ManageWebRequestActivityWaitTimeout = 'Manage.WebRequestActivity.waitTimeout',
  ManageWebRequestActivityWaitTimeoutMs = 'Manage.WebRequestActivity.waitTimeoutMs',
  ManageWebRequestActivityMapping = 'Manage.WebRequestActivity.mapping',
  ManageWebRequestActivityResponseMappings = 'Manage.WebRequestActivity.responseMappings',
  ManageWebRequestActivityValue = 'Manage.WebRequestActivity.value',
  ManageWebRequestActivityKey = 'Manage.WebRequestActivity.key',
  ManageWebRequestActivityEditHeader = 'Manage.WebRequestActivity.editHeader',
  ManageWebRequestActivityCreateHeader = 'Manage.WebRequestActivity.createHeader',
  ManageWebRequestActivityEditResponseMapping = 'Manage.WebRequestActivity.editResponseMapping',
  ManageWebRequestActivityCreateResponseMapping = 'Manage.WebRequestActivity.createResponseMapping',
  ManageWebRequestActivityParameter = 'Manage.WebRequestActivity.parameter',
  ManageWebRequestActivityParameters = 'Manage.WebRequestActivity.parameters',
  ManageWebRequestActivityResponsePart = 'Manage.WebRequestActivity.responsePart',
  ManageWebRequestActivityPath = 'Manage.WebRequestActivity.path',
  ManageWebRequestActivityQueryType = 'Manage.WebRequestActivity.queryType',
  ManageWebRequestActivityMatchPattern = 'Manage.WebRequestActivity.matchPattern',
  ManageWebRequestActivityReplacementPattern = 'Manage.WebRequestActivity.replacementPattern',
  ManageWebRequestActivityTestInputPlaceholder = 'Manage.WebRequestActivity.addValue',
  ManageWebRequestActivityRequestUrl = 'Manage.WebRequestActivity.requestUrl',
  ManageWebRequestActivityAddDisabledHeaderBtnTooltip = 'Manage.WebRequestActivity.addDisabledHeaderBtnTooltip',
  ManageWebRequestActivityAddDisabledResponseMappingsBtnTooltip = 'Manage.WebRequestActivity.addDisabledResponseMappingsBtnTooltip',
  ManageWebRequestActivityHeaderKeyValidationMessage = 'Manage.WebRequestActivity.headerKeyValidationMessage',
  ManageWebRequestActivityTestRequestFailedMessage = 'Manage.WebRequestActivity.testRequestFailedMessage',
  ManageInstantMessagingCustomParameters = 'Manage.InstantMessaging.customParameters',
  ManageInstantMessagingDirectParameters = 'Manage.InstantMessaging.directParameters',
  ManageInstantMessagingDirectSystemMessages = 'Manage.InstantMessaging.directSystemMessages',
  ManageInstantMessagingDirectSystemMessagesDelete = 'Manage.InstantMessaging.directSystemMessageDelete',
  ManageInstantMessagingDisplayNameInteract = 'Manage.InstantMessaging.displayNameInteract',
  ManageInstantMessagingFormAcceptMessage = 'Manage.InstantMessaging.form.acceptMessage',
  ManageInstantMessagingFormCurrentServiceName = 'Manage.InstantMessaging.form.currentServiceName',
  ManageInstantMessagingFormCurrentUserDisplayName = 'Manage.InstantMessaging.form.currentUserDisplayName',
  ManageInstantMessagingFormCustomDisplayName = 'Manage.InstantMessaging.form.customDisplayName',
  ManageInstantMessagingFormCustomServiceDisplayName = 'Manage.InstantMessaging.form.customServiceDisplayName',
  ManageInstantMessagingFormCustomUserDisplayName = 'Manage.InstantMessaging.form.customUserDisplayName',
  ManageInstantMessagingFormDefaultValueAcceptMessage = 'Manage.InstantMessaging.form.defaultValue.acceptMessage',
  ManageInstantMessagingFormDefaultValueInactivityMessageForCustomer = 'Manage.InstantMessaging.form.defaultValue.inactivityMessageForCustomer',
  ManageInstantMessagingFormDefaultValueInactivityMessageForUser = 'Manage.InstantMessaging.form.defaultValue.inactivityMessageForUser',
  ManageInstantMessagingFormDefaultValueSessionDeclinedByUserMessage = 'Manage.InstantMessaging.form.defaultValue.sessionDeclinedByUserMessage',
  ManageInstantMessagingFormDefaultValueSessionEndedByCustomerMessage = 'Manage.InstantMessaging.form.defaultValue.sessionEndedByCustomerMessage',
  ManageInstantMessagingFormDefaultValueSessionEndedBySystemMessage = 'Manage.InstantMessaging.form.defaultValue.sessionEndedBySystemMessage',
  ManageInstantMessagingFormDefaultValueSessionEndedByTaskLimitReachedMessage = 'Manage.InstantMessaging.form.defaultValue.sessionEndedByTaskLimitReachedMessage',
  ManageInstantMessagingFormDefaultValueSessionEndedByUserMessage = 'Manage.InstantMessaging.form.defaultValue.sessionEndedByUserMessage',
  ManageInstantMessagingFormDefaultValueTerminateMessage = 'Manage.InstantMessaging.form.defaultValue.terminateMessage',
  ManageInstantMessagingFormHiddenUserDisplayName = 'Manage.InstantMessaging.form.hiddenUserDisplayName',
  ManageInstantMessagingFormInactivityMessageForCustomer = 'Manage.InstantMessaging.form.inactivityMessageForCustomer',
  ManageInstantMessagingFormInactivityMessageForUser = 'Manage.InstantMessaging.form.inactivityMessageForUser',
  ManageInstantMessagingFormInitialServiceName = 'Manage.InstantMessaging.form.initialServiceName',
  ManageInstantMessagingFormSessionConnected = 'Manage.InstantMessaging.form.sessionConnected',
  ManageInstantMessagingFormSessionDeclinedByUserMessage = 'Manage.InstantMessaging.form.sessionDeclinedByUserMessage',
  ManageInstantMessagingFormSessionEndedByCustomerMessage = 'Manage.InstantMessaging.form.sessionEndedByCustomerMessage',
  ManageInstantMessagingFormSessionEndedBySystemMessage = 'Manage.InstantMessaging.form.sessionEndedBySystemMessage',
  ManageInstantMessagingFormSessionEndedByTaskLimitReachedMessage = 'Manage.InstantMessaging.form.sessionEndedByTaskLimitReachedMessage',
  ManageInstantMessagingFormSessionEndedByUserMessage = 'Manage.InstantMessaging.form.sessionEndedByUserMessage',
  ManageInstantMessagingFormTerminateMessage = 'Manage.InstantMessaging.form.terminateMessage',
  ManageInstantMessagingMessageCannotBeRemoved = 'Manage.InstantMessaging.cannotBeRemoved',
  ManageInstantMessagingMessageDescription = 'Manage.InstantMessaging.description',
  ManageInstantMessagingMessageTabCustomer = 'Manage.InstantMessaging.tab.customer',
  ManageInstantMessagingMessageTabGeneral = 'Manage.InstantMessaging.tab.general',
  ManageInstantMessagingMessageTabUser = 'Manage.InstantMessaging.tab.user',
  ManageInstantMessagingMessageTabUserDirectOnly = 'Manage.InstantMessaging.tab.userDirectOnly',
  ManageInstantMessagingMessageUsedInMessagingEntry = 'Manage.InstantMessaging.usedInMessagingEntry',
  ManageInstantMessagingMessageUsedInService = 'Manage.InstantMessaging.usedInService',
  ManageInstantMessagingMessageUsedInUsers = 'Manage.InstantMessaging.usedInUser',
  ManageInstantMessagingMessagingEntries = 'Manage.InstantMessaging.messagingEntries',
  ManageInstantMessagingProviderConnectors = 'Manage.InstantMessaging.providerConnectors',
  ManageInstantMessagingServiceSystemMessages = 'Manage.InstantMessaging.serviceSystemMessages',
  ManageInstantMessagingServiceSystemMessagesDelete = 'Manage.InstantMessaging.serviceSystemMessageDelete',
  ManageInstantMessagingSystemMessagesDeleteItem = 'Manage.InstantMessaging.systemMessageDeleteItem',
  ManageInstantMessagingSystemParameters = 'Manage.InstantMessaging.systemParameters',
  ManageInstantMessagingTitle = 'Manage.InstantMessaging.title',
  ManageInstantMessagingValidationMaxLength = 'Manage.InstantMessaging.validation.maxLength',
  ManageInteractDomainTemplate = 'Manage.Interact.DomainTemplates.DomainTemplate',
  ManageInteractDomainTemplatesCannotBeRemoved = 'Manage.Interact.DomainTemplates.cannotBeRemoved',
  ManageInteractDomainTemplatesInputPlaceholder = 'Manage.Interact.DomainTemplates.inputPlaceholder',
  ManageInteractDomainTemplatesPort = 'Manage.Interact.DomainTemplates.port',
  ManageInteractDomainTemplatesProtocol = 'Manage.Interact.DomainTemplates.protocol',
  ManageInteractDomainTemplatesTitle = 'Manage.Interact.DomainTemplates.title',
  ManageInteractDomainTemplatesUsedInUser = 'Manage.Interact.DomainTemplates.usedInUser',
  ManageInteractTitle = 'Manage.Interact.title',
  ManageMenuTenant = 'Manage.Menu.tenant',
  ManageMessagingEntriesCannotBeRemoved = 'Manage.MessagingEntries.cannotBeRemoved',
  ManageMessagingEntriesChatServiceSid = 'Manage.MessagingEntries.chatServiceSid',
  ManageMessagingEntriesSelectOrgUnitForConnector = 'Manage.MessagingEntries.selectOrgUnitForConnector',
  ManageMessagingEntriesValidatorsChatServiceSidPattern = 'Manage.MessagingEntries.Validators.chatServiceSidPattern',
  ManageMessagingEntriesValidatorsChatServiceSidUnique = 'Manage.MessagingEntries.Validators.chatServiceSidUnique',
  ManageMessagingEntriesValidateSuccess = 'Manage.MessagingEntries.Validate.success',
  ManageMessagingEntriesValidateFailed = 'Manage.MessagingEntries.Validate.failed',
  ManageMessagingEntriesValidateTooltip = 'Manage.MessagingEntries.Validate.tooltip',
  ManageOpeningHourPeriodIsRecurrent = 'Manage.OpeningHours.periodIsRecurrent',
  ManageOpeningHoursDay = 'Manage.OpeningHours.day',
  ManageOpeningHoursDays = 'Manage.OpeningHours.days',
  ManageOpeningHoursDefaultStatus = 'Manage.OpeningHours.defaultStatus',
  ManageOpeningHoursDeleteCannotBeDeleted = 'Manage.OpeningHours.Delete.cannotBeDeleted',
  ManageOpeningHoursDeleteCurrentPeriod = 'Manage.OpeningHours.deleteCurrentPeriod',
  ManageOpeningHoursDeleteEditedRecurrentPeriod = 'Manage.OpeningHours.deleteEditedRecurrentPeriod',
  ManageOpeningHoursDeleteQuestion = 'Manage.OpeningHours.Delete.quesiton',
  ManageOpeningHoursDeleteRecurrentPeriod = 'Manage.OpeningHours.deleteRecurrentPeriod',
  ManageOpeningHoursDeleteTitle = 'Manage.OpeningHours.Delete.title',
  ManageOpeningHourSeriesEdit = 'Manage.OpeningHours.seriesEdit',
  ManageOpeningHoursHour = 'Manage.OpeningHours.hour',
  ManageOpeningHourShowFullDay = 'Manage.OpeningHours.showFullDay',
  ManageOpeningHourShowWorkDay = 'Manage.OpeningHours.showWorkDay',
  ManageOpeningHoursIntervalAllDay = 'Manage.OpeningHours.Interval.allDay',
  ManageOpeningHoursIntervalAtLeast = 'Manage.OpeningHours.Interval.atLeast',
  ManageOpeningHoursIntervalCreateNewPeriod = 'Manage.OpeningHours.Interval.createNewPeriod',
  ManageOpeningHoursIntervalDate = 'Manage.OpeningHours.Interval.date',
  ManageOpeningHoursIntervalDay = 'Manage.OpeningHours.Interval.day',
  ManageOpeningHoursIntervalEditPeriod = 'Manage.OpeningHours.Interval.editPeriod',
  ManageOpeningHoursIntervalEnd = 'Manage.OpeningHours.Interval.end',
  ManageOpeningHoursIntervalEndAfter = 'Manage.OpeningHours.Interval.endAfter',
  ManageOpeningHoursIntervalEndby = 'Manage.OpeningHours.Interval.endBy',
  ManageOpeningHoursIntervalMonth = 'Manage.OpeningHours.Interval.month',
  ManageOpeningHoursIntervalNoEndDate = 'Manage.OpeningHours.Interval.noEndDate',
  ManageOpeningHoursIntervalOf = 'Manage.OpeningHours.Interval.of',
  ManageOpeningHoursIntervalOfEveryMonth = 'Manage.OpeningHours.Interval.ofEveryMonth',
  ManageOpeningHoursIntervalOn = 'Manage.OpeningHours.Interval.on',
  ManageOpeningHoursIntervalOnThe = 'Manage.OpeningHours.Interval.onThe',
  ManageOpeningHoursIntervalRecurEvery = 'Manage.OpeningHours.Interval.recurEvery',
  ManageOpeningHoursIntervalRecurrence = 'Manage.OpeningHours.Interval.recurrence',
  ManageOpeningHoursIntervalRepeatOn = 'Manage.OpeningHours.Interval.repeatOn',
  ManageOpeningHoursIntervalStart = 'Manage.OpeningHours.Interval.start',
  ManageOpeningHoursIntervalThe = 'Manage.OpeningHours.Interval.the',
  ManageOpeningHoursIntervalTimezone = 'Manage.OpeningHours.Interval.timezone',
  ManageOpeningHoursIntervalTitle = 'Manage.OpeningHours.Interval.title',
  ManageOpeningHoursIntervalTitlePlaceholder = 'Manage.OpeningHours.Interval.titlePlaceholder',
  ManageOpeningHoursIntervalType = 'Manage.OpeningHours.Interval.type',
  ManageOpeningHoursIntervalWeekday = 'Manage.OpeningHours.Interval.weekday',
  ManageOpeningHoursMinute = 'Manage.OpeningHours.minute',
  ManageOpeningHoursMonth = 'Manage.OpeningHours.month',
  ManageOpeningHoursMonths = 'Manage.OpeningHours.months',
  ManageOpeningHoursRecurrentPeriod = 'Manage.OpeningHours.recurrentPeriod',
  ManageOpeningHoursRestoreOriginalPeriod = 'Manage.OpeningHours.restoreOriginalPeriod',
  ManageOpeningHoursRestoreOriginalSeriesEvent = 'Manage.OpeningHours.restoreOriginalSeriesEvent',
  ManageOpeningHoursSecond = 'Manage.OpeningHours.second',
  ManageOpeningHoursUsedAsPrimary = 'Manage.OpeningHours.usedAsPrimary',
  ManageOpeningHoursUsedAsSecondary = 'Manage.OpeningHours.usedAsSecondary',
  ManageOpeningHoursValidationDateEndBeforeStart = 'Manage.OpeningHours.Validation.dateEndBeforeStart',
  ManageOpeningHoursValidationRangeEndBeforeStart = 'Manage.OpeningHours.Validation.rangeEndBeforeStart',
  ManageOpeningHoursWeek = 'Manage.OpeningHours.week',
  ManageOpeningHoursWeeks = 'Manage.OpeningHours.weeks',
  ManageOpeningHoursYears = 'Manage.OpeningHours.years',
  ManageOrganizationUnitsDescription = 'Manage.OrganizationUnits.description',
  ManageOrganizationUnitsName = 'Manage.OrganizationUnits.name',
  ManageOrganizationUnitsParent = 'Manage.OrganizationUnits.parent',
  ManageOrganizationUnitsService = 'Manage.OrganizationUnits.service',
  ManageOrganizationUnitsSingle = 'Manage.OrganizationUnits.single',
  ManageOrganizationUnitsTitle = 'Manage.OrganizationUnits.title',
  ManageOrganizationUnitsUsers = 'Manage.OrganizationUnits.users',
  ManagePoliciesAssignmentsTitle = 'Manage.Policies.Assignments.title',
  ManagePoliciesDefinitionsTitle = 'Manage.Policies.Definitions.title',
  ManagePoliciesEffectiveSettingsTitle = 'Manage.Policies.EffectiveSettings.title',
  ManagePoliciesTitle = 'Manage.Policies.title',
  ManageProviderConnectorsApiKeySidValidation = 'Manage.ProviderConnectors.apiKeySidValidation',
  ManageProviderConnectorsCannotBeRemoved = 'Manage.ProviderConnectors.cannotBeRemoved',
  ManageProviderConnectorsValidateSuccess = 'Manage.ProviderConnectors.Validate.success',
  ManageProviderConnectorsValidateFailed = 'Manage.ProviderConnectors.Validate.failed',
  ManageProvisioningAgentsLastSeen = 'Manage.Provisioning.Agents.lastSeen',
  ManageProvisioningAgentsLastSync = 'Manage.Provisioning.Agents.lastSync',
  ManageProvisioningAgentsRefresh = 'Manage.Provisioning.Agents.refresh',
  ManageProvisioningAgentsRegisterAgent = 'Manage.Provisioning.Agents.registerAgent',
  ManageProvisioningAgentsRevoke = 'Manage.Provisioning.Agents.revoke',
  ManageProvisioningAgentsRevokeConfirmBody = 'Manage.Provisioning.Agents.Revoke.confirmBody',
  ManageProvisioningAgentsRevokeConfirmTitle = 'Manage.Provisioning.Agents.Revoke.confirmTitle',
  ManageProvisioningAgentsRevokeError = 'Manage.Provisioning.Agents.Revoke.error',
  ManageProvisioningAgentsRevokeSuccess = 'Manage.Provisioning.Agents.Revoke.success',
  ManageProvisioningAgentsStatus = 'Manage.Provisioning.Agents.status',
  ManageProvisioningAgentsStatusDegraded = 'Manage.Provisioning.Agents.Status.degraded',
  ManageProvisioningAgentsStatusDisconnected = 'Manage.Provisioning.Agents.Status.disconnected',
  ManageProvisioningAgentsStatusError = 'Manage.Provisioning.Agents.Status.error',
  ManageProvisioningAgentsStatusHealthy = 'Manage.Provisioning.Agents.Status.healthy',
  ManageProvisioningAgentsStatusSyncing = 'Manage.Provisioning.Agents.Status.syncing',
  ManageProvisioningAgentsStatusUnknown = 'Manage.Provisioning.Agents.Status.unknown',
  ManageProvisioningAgentsTitle = 'Manage.Provisioning.Agents.title',
  ManageProvisioningAgentsTokenCopied = 'Manage.Provisioning.Agents.Token.copied',
  ManageProvisioningAgentsTokenDescription = 'Manage.Provisioning.Agents.Token.description',
  ManageProvisioningAgentsTokenError = 'Manage.Provisioning.Agents.Token.error',
  ManageProvisioningAgentsTokenExpiresAt = 'Manage.Provisioning.Agents.Token.expiresAt',
  ManageProvisioningAgentsTokenLabel = 'Manage.Provisioning.Agents.Token.label',
  ManageProvisioningAgentsTokenRegisteredNote = 'Manage.Provisioning.Agents.Token.registeredNote',
  ManageProvisioningAgentsTokenTitle = 'Manage.Provisioning.Agents.Token.title',
  ManageProvisioningAgentsVersion = 'Manage.Provisioning.Agents.version',
  ManageProvisioningTitle = 'Manage.Provisioning.title',
  ManageSectionCreatePeriod = 'Manage.Section.createPeriod',
  ManageServicesAllowedFileTypesCannotBeRemoved = 'Manage.Services.allowedFileTypes.cannotBeRemoved',
  ManageServicesAllowedFileTypesCategoryAudio = 'Manage.Services.allowedFileTypes.category.audio',
  ManageServicesAllowedFileTypesCategoryDocumentsAndText = 'Manage.Services.allowedFileTypes.category.documentsAndText',
  ManageServicesAllowedFileTypesCategoryImages = 'Manage.Services.allowedFileTypes.category.images',
  ManageServicesAllowedFileTypesCategoryMiscellaneous = 'Manage.Services.allowedFileTypes.category.miscellaneous',
  ManageServicesAllowedFileTypesCategoryVideos = 'Manage.Services.allowedFileTypes.category.videos',
  ManageServicesAllowedFileTypesCustomerToNimbusTab = 'Manage.Services.allowedFileTypes.customerToNimbusTab',
  ManageServicesAllowedFileTypesEmail = 'Manage.Services.allowedFileTypes.email',
  ManageServicesAllowedFileTypesFuture = 'Manage.Services.allowedFileTypes.future',
  ManageServicesAllowedFileTypesGeneralTab = 'Manage.Services.allowedFileTypes.generalTab',
  ManageServicesAllowedFileTypesMaxSizeError = 'Manage.Services.allowedFileTypes.maxSizeError',
  ManageServicesAllowedFileTypesMaxSizeMb = 'Manage.Services.allowedFileTypes.maxSizeMb',
  ManageServicesAllowedFileTypesMimeTypes = 'Manage.Services.allowedFileTypes.mimeTypes',
  ManageServicesAllowedFileTypesNimbusToCustomerTab = 'Manage.Services.allowedFileTypes.nimbusToCustomerTab',
  ManageServicesAllowedFileTypesRcs = 'Manage.Services.allowedFileTypes.rcs',
  ManageServicesAllowedFileTypesTitle = 'Manage.Services.allowedFileTypes.title',
  ManageServicesAllowedFileTypesWebChat = 'Manage.Services.allowedFileTypes.webChat',
  ManageServicesAllowedFileTypesWhatsApp = 'Manage.Services.allowedFileTypes.whatsApp',
  ManageServicesCallerAnonymizationRegexTitle = 'Manage.Services.callerAnonymizationRegex.title',
  ManageServicesConversationContext = 'Manage.Services.conversationContext',
  ManageServicesConversationContextParameter = 'Manage.Services.conversationContextParameter',
  ManageServicesConversationContextParameterError = 'Manage.Services.conversationContextParamerterError',
  ManageServicesMailboxesCannotBeDeletedByServiceAssigned = 'Manage.Services.Mailboxes.Delete.cannotBeDeletedByServiceAssigned',
  ManageServicesMailboxesTitle = 'Manage.Services.Mailboxes.title',
  ManageServicesOpeningHours = 'Manage.Services.openingHours',
  ManageServicesTitle = 'Manage.Services.title',
  ManageSpeechRecognizerMessageDescription = 'Manage.SpeechRecognizer.description',
  ManageSpeechRecognizerMessageUsedInService = 'Manage.SpeechRecognizer.usedInService',
  ManageSpeechRecognizerStandardAzureAIServices = 'Manage.SpeechRecognizer.standardAzureAIServices',
  ManageSpeechRecognizerStandardAzureAIServicesInfo = 'Manage.SpeechRecognizer.standardAzureAIServicesInfo',
  ManageSpeechRecognizerDefaultAzureAIService = 'Manage.SpeechRecognizer.defaultAIService',
  ManageSpeechRecognizerDefaultAzureAIServiceInfo = 'Manage.SpeechRecognizer.defaultAIServiceInfo',
  ManageSpeechRecognizerTitle = 'Manage.SpeechRecognizer.title',
  ManageTitle = 'Manage.title',
  ManageUserCustomRolesDeleteCannotBeDeleted = 'Manage.User.CustomRoles.Delete.cannotBeDeleted',
  ManageUserCustomRolesEditAdministrationTitle = 'Manage.User.CustomRoles.Edit.Administration.title',
  ManageUserCustomRolesEditFeaturesTitle = 'Manage.User.CustomRoles.Edit.Features.title',
  ManageUserCustomRolesEditGeneralTitle = 'Manage.User.CustomRoles.Edit.General.title',
  ManageUserNotAvailableReasonsDeleteCannotBeDeleted = 'Manage.User.NotAvailableReasons.Delete.cannotBeDeleted',
  ManageUserTitle = 'Manage.User.title',
  ManageUiProfileAssignedUsersCount = 'Manage.UiProfile.assignedUsersCount',
  ManageUiProfileAvailablePages = 'Manage.UiProfile.availablePages',
  ManageUiProfileCreateTitle = 'Manage.UiProfile.createTitle',
  ManageUiProfileCustomImageChangeTooltip = 'Manage.UiProfile.customImageChangeTooltip',
  ManageUiProfileCustomImageResetTooltip = 'Manage.UiProfile.customImageResetTooltip',
  ManageUiProfileCustomTooltipPlaceholder = 'Manage.UiProfile.customTooltipPlaceholder',
  ManageUiProfileDefaultPageLabel = 'Manage.UiProfile.defaultPageLabel',
  ManageUiProfileDeleteConfirmBody = 'Manage.UiProfile.deleteConfirmBody',
  ManageUiProfileDeleteConfirmTitle = 'Manage.UiProfile.deleteConfirmTitle',
  ManageUiProfileDescriptionLabel = 'Manage.UiProfile.descriptionLabel',
  ManageUiProfileEditTitle = 'Manage.UiProfile.editTitle',
  ManageUiProfileNameLabel = 'Manage.UiProfile.nameLabel',
  ManageUiProfileNoPages = 'Manage.UiProfile.noPages',
  ManageUiProfileReorderDragHandle = 'Manage.UiProfile.reorderDragHandle',
  ManageUiProfileSelectedPages = 'Manage.UiProfile.selectedPages',
  ManageUiProfileSurfaceLabel = 'Manage.UiProfile.surfaceLabel',
  ManageUiProfileTitle = 'Manage.UiProfile.title',
  ManageUiProfileVisiblePagesLabel = 'Manage.UiProfile.visiblePagesLabel',
  ManageVirtualAssistantTitle = 'Manage.VirtualAssistant.title',
  ManageVirtualUserBotConfiguration = 'Manage.VirtualUser.botConfiguration',
  ManageVirtualUserInitialMessage = 'Manage.VirtualUser.initialMessage',
  ManageVirtualUserOutcomesInstructions = 'Manage.VirtualUser.outcomesInstructions',
  ManageVirtualUserWebRequestsDescription = 'Manage.VirtualUser.webRequestsDescription',
  ManageVirtualUserModalities = 'Manage.VirtualUser.modalities',
  ManageVirtualUserTools = 'Manage.VirtualUser.tools',
  ManageVirtualUserExtensionTools = 'Manage.VirtualUser.extensionTools',
  ManageVirtualUserExtensions = 'Manage.VirtualUser.extensions',
  ManageVirtualUserInstructions = 'Manage.VirtualUser.instructions',
  ManageVirtualUserMessages = 'Manage.VirtualUser.messages',
  ManageVirtualUserPersona = 'Manage.VirtualUser.persona',
  ManageVirtualUserExitIntents = 'Manage.VirtualUser.exitIntents',
  ManageVirtualUserExitIntentCreate = 'Manage.VirtualUser.exitIntentCreate',
  ManageVirtualUserExitIntentEdit = 'Manage.VirtualUser.exitIntentEdit',
  ManageVirtualUserExitIntentName = 'Manage.VirtualUser.exitIntentName',
  ManageVirtualUserExitIntentContext = 'Manage.VirtualUser.exitIntentContext',
  ManageVirtualUserExitIntentDescription = 'Manage.VirtualUser.exitIntentDescription',
  ManageVirtualUserExitIntentIsExit = 'Manage.VirtualUser.exitIntentIsExit',
  ManageVirtualUserExitIntentMissingParameterDescriptionsWarning = 'Manage.VirtualUser.exitIntentMissingParameterDescriptionsWarning',
  ManageVirtualUserExitIntentParameterMissingDescriptionWarning = 'Manage.VirtualUser.exitIntentParameterMissingDescriptionWarning',
  ManageVirtualUserExitIntentParameters = 'Manage.VirtualUser.exitIntentParameters',
  ManageVirtualUserExitIntentNameUnique = 'Manage.VirtualUser.intentNameUnique',
  ManageVirtualUserAtLeastOneExitIntent = 'Manage.VirtualUser.atLeastOneExitIntent',
  ManageVirtualUserSystemInstruction = 'Manage.VirtualUser.systemInstruction',
  ManageVirtualUserTitle = 'Manage.VirtualUser.title',
  ManageVirtualUserRecognizer = 'Manage.VirtualUser.recognizer',
  ManageVirtualUserUserVoice = 'Manage.VirtualUser.userVoice',
  ManageVirtualUserMcpServer = 'Manage.VirtualUser.mcpServer',
  ManageVirtualUserMcpServerDetails = 'Manage.VirtualUser.mcpServerDetails',
  ManageVirtualUserMcpServerEdit = 'Manage.VirtualUser.mcpServerEdit',
  ManageVirtualUserMcpServerCreate = 'Manage.VirtualUser.mcpServerCreate',
  ManageVirtualUserMcpServerUrl = 'Manage.VirtualUser.mcpServerUrl',
  ManageVirtualUserMcpServers = 'Manage.VirtualUser.mcpServers',
  ManageVirtualUserMcpServerNameUnique = 'Manage.VirtualUser.mcpServerNameUnique',
  ManageVirtualUserMcpServerNoAuthentication = 'Manage.VirtualUser.mcpServerNoAuthentication',
  ManageVirtualUserWebRequestEdit = 'Manage.VirtualUser.webRequestEdit',
  ManageVirtualUserWebRequestCreate = 'Manage.VirtualUser.webRequestCreate',
  ManageVirtualUserWebRequestContext = 'Manage.VirtualUser.webRequestContext',
  ManageVirtualUserUserUserVoiceAlloy = 'Manage.VirtualUser.UserVoices.alloy',
  ManageVirtualUserUserUserVoiceAsh = 'Manage.VirtualUser.UserVoices.ash',
  ManageVirtualUserUserUserVoiceBallad = 'Manage.VirtualUser.UserVoices.ballad',
  ManageVirtualUserUserUserVoiceCedar = 'Manage.VirtualUser.UserVoices.cedar',
  ManageVirtualUserUserUserVoiceCoral = 'Manage.VirtualUser.UserVoices.coral',
  ManageVirtualUserUserUserVoiceEcho = 'Manage.VirtualUser.UserVoices.echo',
  ManageVirtualUserUserUserVoiceMarin = 'Manage.VirtualUser.UserVoices.marin',
  ManageVirtualUserUserUserVoiceSage = 'Manage.VirtualUser.UserVoices.sage',
  ManageVirtualUserUserUserVoiceShimmer = 'Manage.VirtualUser.UserVoices.shimmer',
  ManageVirtualUserUserUserVoiceVerse = 'Manage.VirtualUser.UserVoices.verse',
  ManageVirtualUserProfile = 'Manage.VirtualUser.profile',
  ManageVirtualUserProfileIntentAnalyzer = 'Manage.VirtualUser.Profile.intentAnalyzer',
  ManageVirtualUserProfileAiWorkflow = 'Manage.VirtualUser.Profile.aiWorkflow',
  ManageVirtualUserProfileOpenProfile = 'Manage.VirtualUser.Profile.openProfile',
  ManageVirtualUserAiBehavior = 'Manage.VirtualUser.aiBehavior',
  ManageVirtualUserClosingMessage = 'Manage.VirtualUser.closingMessage',
  ManageVirtualUserConversationMessages = 'Manage.VirtualUser.conversationMessages',
  ManageVirtualUserGeneralInformation = 'Manage.VirtualUser.generalInformation',
  ManageVirtualUserIdleTimeout = 'Manage.VirtualUser.idleTimeout',
  ManageVirtualUserRole = 'Manage.VirtualUser.role',
  ManageVirtualUserRolePlaceholder = 'Manage.VirtualUser.rolePlaceholder',
  ManageVirtualUserSessionTimeout = 'Manage.VirtualUser.sessionTimeout',
  ManageVirtualUserTimeouts = 'Manage.VirtualUser.timeouts',
  ManageVirtualUserTone = 'Manage.VirtualUser.tone',
  ManageVirtualUserTonePlaceholder = 'Manage.VirtualUser.tonePlaceholder',
  ManageVirtualUserVerbosity = 'Manage.VirtualUser.verbosity',
  ManageVirtualUserVerbosityBalanced = 'Manage.VirtualUser.Verbosity.balanced',
  ManageVirtualUserVerbosityConcise = 'Manage.VirtualUser.Verbosity.concise',
  ManageVirtualUserVerbosityDetailed = 'Manage.VirtualUser.Verbosity.detailed',
  ManageVirtualUserVerbosityPlaceholder = 'Manage.VirtualUser.verbosityPlaceholder',
  ManageVirtualUserSystemPromptPlaceholder = 'Manage.VirtualUser.systemPromptPlaceholder',
  ManageVirtualUserVoiceAndLanguage = 'Manage.VirtualUser.voiceAndLanguage',
  ManageVirtualUserGeneralTab = 'Manage.VirtualUser.generalTab',
  ManageVirtualUserAiBehaviorTab = 'Manage.VirtualUser.aiBehaviorTab',
  ManageVirtualUserConversationTab = 'Manage.VirtualUser.conversationTab',
  ManageVirtualUserExtensionsTab = 'Manage.VirtualUser.extensionsTab',
  ManageVirtualUserOutcomesTab = 'Manage.VirtualUser.outcomesTab',
  ManageVirtualUserInitialMessagePlaceholder = 'Manage.VirtualUser.initialMessagePlaceholder',
  ManageVirtualUserClosingMessagePlaceholder = 'Manage.VirtualUser.closingMessagePlaceholder',
  ManageVirtualUserFlowDescriptionPlaceholder = 'Manage.VirtualUser.flowDescriptionPlaceholder',
  ManageBotConfigurationAuthenticationType = 'Manage.BotConfiguration.authenticationType',
  ManageBotConfigurationAuthenticationTypeAPIKey = 'Manage.BotConfiguration.AuthenticationType.apiKey',
  ManageBotConfigurationBotTypeNimbusAiService = 'Manage.BotConfiguration.BotType.nimbusAiService',
  ManageBotConfigurationBotTypeBYOAiService = 'Manage.BotConfiguration.BotType.customAiServices',
  ManageBotConfigurationAgentType = 'Manage.BotConfiguration.agentType',
  ManageBotConfigurationAgentTypeAzureOpenAi = 'Manage.BotConfiguration.AgentType.azureOpenAi',
  ManageBotConfigurationAgentTypeAzureVoiceLiveApi = 'Manage.BotConfiguration.AgentType.azureVoiceLiveApi',
  ManageBotConfigurationAgentTypeCoPilotDirectLine3 = 'Manage.BotConfiguration.AgentType.coPilotDirectLine3',
  ManageBotConfigurationSettings = 'Manage.BotConfiguration.settings',
  ManageBotConfigurationClientId = 'Manage.BotConfiguration.clientId',
  ManageBotConfigurationClientSecret = 'Manage.BotConfiguration.clientSecret',
  ManageBotConfigurationResourceUrl = 'Manage.BotConfiguration.resourceUrl',
  ManageWorkflowActivateWarning = 'Manage.Workflow.activateWarning',
  ManageWorkflowAddActivity = 'Manage.Workflow.addActivity',
  ManageWorkflowAService = 'Manage.Workflow.aService',
  ManageWorkflowAudioVideoWorkflowTitle = 'Manage.Workflow.audioVideoWorkflow',
  ManageWorkflowBasedOn = 'Manage.Workflow.Playlist.basedOn',
  ManageWorkflowCannotBeRemoved = 'Manage.Workflow.cannotBeRemoved',
  ManageWorkflowCopyWorkflow = 'Manage.Workflow.copyWorkflow',
  ManageWorkflowEmailWorkflowTitle = 'Manage.Workflow.emailWorkflow',
  ManageWorkflowExportAllButton = 'Manage.Workflow.ImportExport.exportAllButton',
  ManageWorkflowExportAllPartialFailureBody = 'Manage.Workflow.ImportExport.exportAll.partialFailure.body',
  ManageWorkflowExportAllPartialFailureTitle = 'Manage.Workflow.ImportExport.exportAll.partialFailure.title',
  ManageWorkflowExportAllTotalFailureBody = 'Manage.Workflow.ImportExport.exportAll.totalFailure.body',
  ManageWorkflowExportAllTotalFailureTitle = 'Manage.Workflow.ImportExport.exportAll.totalFailure.title',
  ManageWorkflowExportButton = 'Manage.Workflow.ImportExport.exportButton',
  ManageWorkflowExportTemplateDecisionBody = 'Manage.Workflow.ImportExport.exportDecision.body',
  ManageWorkflowExportTemplateDecisionTitle = 'Manage.Workflow.ImportExport.exportDecision.title',
  ManageWorkflowExportTemplateDecisionWorkflowAndTemplate = 'Manage.Workflow.ImportExport.exportDecision.workflowAndTemplate',
  ManageWorkflowExportTemplateDecisionWorkflowOnly = 'Manage.Workflow.ImportExport.exportDecision.workflowOnly',
  ManageWorkflowExternalTaskWorkflowTitle = 'Manage.Workflow.externalTaskWorkflow',
  ManageWorkflowImportButton = 'Manage.Workflow.ImportExport.importButton',
  ManageWorkflowImportConfirmOverwriteConfirmButton = 'Manage.Workflow.ImportExport.confirm.overwrite.confirmButton',
  ManageWorkflowImportConfirmOverwriteContentBody = 'Manage.Workflow.ImportExport.confirm.overwrite.contentBody',
  ManageWorkflowImportConfirmOverwriteTitle = 'Manage.Workflow.ImportExport.confirm.overwrite.title',
  ManageWorkflowImportConflictBody = 'Manage.Workflow.ImportExport.confirm.conflict.body',
  ManageWorkflowImportConflictKeepBoth = 'Manage.Workflow.ImportExport.confirm.conflict.keepBoth',
  ManageWorkflowImportConflictTitle = 'Manage.Workflow.ImportExport.confirm.conflict.title',
  ManageWorkflowImportErrorIncompatibleVersion = 'Manage.Workflow.ImportExport.error.incompatibleVersion',
  ManageWorkflowImportErrorIncompatibleVersionTitle = 'Manage.Workflow.ImportExport.error.incompatibleVersionTitle',
  ManageWorkflowImportErrorKindMismatch = 'Manage.Workflow.ImportExport.error.kindMismatch',
  ManageWorkflowImportErrorKindMismatchTitle = 'Manage.Workflow.ImportExport.error.kindMismatchTitle',
  ManageWorkflowImportErrorMalformedFile = 'Manage.Workflow.ImportExport.error.malformedFile',
  ManageWorkflowImportErrorMalformedFileTitle = 'Manage.Workflow.ImportExport.error.malformedFileTitle',
  ManageWorkflowImportErrorMissingReferences = 'Manage.Workflow.ImportExport.error.missingReferences',
  ManageWorkflowImportErrorUnknownBlockType = 'Manage.Workflow.ImportExport.error.unknownBlockType',
  ManageWorkflowImportErrorUnknownBlockTypeTitle = 'Manage.Workflow.ImportExport.error.unknownBlockTypeTitle',
  ManageWorkflowInstancesServiceType = 'Manage.Workflow.Instances.serviceType',
  ManageWorkflowInstancesTemplate = 'Manage.Workflow.Instances.template',
  ManageWorkflowInstancesTemplateType = 'Manage.Workflow.Instances.templateType',
  ManageWorkflowInstancesTitle = 'Manage.Workflow.Instances.title',
  ManageWorkflowInstantMessagingWorkflowTitle = 'Manage.Workflow.instantMessagingWorkflow',
  ManageWorkflowNameWithCopy = 'Manage.Workflow.nameWithCopy',
  ManageWorkflowNewWorkflow = 'Manage.Workflow.newWorkflow',
  ManageWorkflowNewWorkflowTemplate = 'Manage.Workflow.newWorkflowTemplate',
  ManageWorkflowPlaylistAudiofile = 'Manage.Workflow.Playlist.audiofile',
  ManageWorkflowPlaylistFavoriteIndicator = 'Manage.Workflow.Playlist.favoriteIndicator',
  ManageWorkflowPlaylistFileNotValid = 'Manage.Workflow.Playlist.fileNotValid',
  ManageWorkflowPlaylistMarkAsFavoriteForOu = 'Manage.Workflow.Playlist.markAsFavoriteForOu',
  ManageWorkflowPlaylistName = 'Manage.Workflow.Playlist.name',
  ManageWorkflowPlaylistPleaseSelectOrganizationUnit = 'Manage.Workflow.Playlist.pleaseSelectOrganizationUnit',
  ManageWorkflowPlaylistPreview = 'Manage.Workflow.Playlist.preview',
  ManageWorkflowPlaylistRemoveFavoriteForOu = 'Manage.Workflow.Playlist.removeFavoriteForOu',
  ManageWorkflowPlaylistReplaceFavoriteBody = 'Manage.Workflow.Playlist.replaceFavoriteBody',
  ManageWorkflowPlaylistReplaceFavoriteTitle = 'Manage.Workflow.Playlist.replaceFavoriteTitle',
  ManageWorkflowPlaylistTitle = 'Manage.Workflow.Playlist.title',
  ManageWorkflowPlaylistUsedInPlaylist = 'Manage.Workflow.Playlist.usedInPlaylist',
  ManageWorkflowPlaylistUsedInService = 'Manage.Workflow.Playlist.usedInService',
  ManageWorkflowPlaylistUsedInWorkflow = 'Manage.Workflow.Playlist.usedInWorkflow',
  ManageWorkflowPlaylistWmaPreviewNotSupported = 'Manage.Workflow.Playlist.WmaPreviewNotSupported',
  ManageWorkflowResources = 'Manage.Workflow.resources',
  ManageWorkflowTemplates = 'Manage.Workflow.templates',
  ManageWorkflowTemplatesCopy = 'Manage.WorkflowTemplate.copy',
  ManageWorkflowTemplatesDeleteConfirmationText = 'Manage.WorkflowTemplate.Delete.confirmationText',
  ManageWorkflowTemplatesDeleteDescription = 'Manage.WorkflowTemplate.Delete.description',
  ManageWorkflowTemplatesSaveErrorDescription = 'Manage.WorkflowTemplate.SaveError.description',
  ManageWorkflowTemplatesSaveLockDescription = 'Manage.WorkflowTemplate.SaveLock.description',
  ManageWorkflowTemplatesTitle = 'Manage.WorkflowTemplate.title',
  ManageWorkflowTemplatesUsedInWorkflows = 'Manage.WorkflowTemplate.usedInWorkflows',
  ManageWorkflowType = 'Manage.Workflow.Type.type',
  ManageWorkflowTypeAV = 'Manage.Workflow.Type.AV',
  ManageWorkflowTypeAVExtend = 'Manage.Workflow.Type.AVExtend',
  ManageWorkflowTypeAVUnify = 'Manage.Workflow.Type.AVUnify',
  ManageWorkflowTypeAVDesc = 'Manage.Workflow.Type.AVDesc',
  ManageWorkflowTypeDirectCall = 'Manage.Workflow.Type.directCall',
  ManageWorkflowTypeEmail = 'Manage.Workflow.Type.email',
  ManageWorkflowTypeEmailDesc = 'Manage.Workflow.Type.emailDesc',
  ManageWorkflowTypeET = 'Manage.Workflow.Type.ET',
  ManageWorkflowTypeETDesc = 'Manage.Workflow.Type.ETDesc',
  ManageWorkflowTypeIM = 'Manage.Workflow.Type.IM',
  ManageWorkflowTypeIMDesc = 'Manage.Workflow.Type.IMDesc',
  ManageWorkflowTypeProperties = 'Manage.Workflow.Type.properties',
  ManageWorkflowWorkflow = 'Manage.Workflow.workflow',
  ManageWorkflowServiceTypeDirectCall = 'Manage.Workflow.ServiceType.directCall',
  ManageWorkflowServiceTypeExtend = 'Manage.Workflow.ServiceType.extend',
  ManageWorkflowServiceTypeUnify = 'Manage.Workflow.ServiceType.unify',
  ManageWorkflowWorkflowsList = 'Manage.Workflow.workflowsList',
  MenuAuthentication = 'Menu.Authentication',
  MenuChangeHistory = 'Menu.ChangeHistory',
  MenuFeatureFlagVisibility = 'Menu.FeatureFlagVisibility',
  MenuCustomer = 'Menu.Customer',
  MenuCustomerInsights = 'Menu.customerInsights',
  MenuCustomerOverview = 'Menu.customerOverview',
  MenuDashboards = 'Menu.dashboards',
  MenuExternalTools = 'Menu.ExternalTools',
  MenuInfo = 'Menu.info',
  MenuLiveView = 'Menu.LiveView',
  MenuManage = 'Menu.Manage',
  MenuMore = 'Menu.more',
  MenuOpenInNimbus = 'Menu.openInNimbus',
  MenuOverview = 'Menu.Overview',
  MenuPartners = 'Menu.Partners',
  MenuPersonal = 'Menu.personal',
  MenuPersonalAttendantconsole = 'Menu.personalAttendantconsole',
  MenuPersonalMySessions = 'Menu.personalMySessions',
  MenuPersonalOverview = 'Menu.personalOverview',
  MenuPersonalServicesOverview = 'Menu.personalServicesOverview',
  MenuProvisioning = 'Menu.provisioning',
  MenuQuit = 'Menu.quit',
  MenuReporting = 'Menu.reporting',
  MenuService = 'Menu.Service',
  MenuSessionsList = 'Menu.SessionsList',
  MenuSettings = 'Menu.settings',
  MenuStatistics = 'Menu.Statistics',
  MenuTaskFlowVisualizer = 'Menu.TaskFlowVisualizer',
  MenuTaskManagement = 'Menu.TaskManagement',
  MenuTeams = 'Menu.Teams',
  MenuTenant = 'Menu.Tenant',
  MenuTenants = 'Menu.Tenants',
  MenuTools = 'Menu.Tools',
  MenuUsers = 'Menu.Users',
  MenuVoicemails = 'Menu.Voicemails',
  MenuWorkflow = 'Menu.workflow',
  MultihomingAccessPortalMessage = 'Multihoming.AccessPortalMessage',
  MySessionsChatParkedBannerText = 'MySessions.Chat.parkedBannerText',
  MySessionsCompanionWidgetNoFeaturesAvailable = 'MySessions.CompanionWidget.noFeaturesAvailable',
  MySessionsCompanionWidgetRateLimitedError = 'MySessions.CompanionWidget.rateLimitedError',
  MySessionsCompanionWidgetConsentDenied = 'MySessions.CompanionWidget.consentDenied',
  MySessionsCompanionWidgetSummaryNotAvailable = 'MySessions.CompanionWidget.summaryNotAvailable',
  MySessionsCompanionWidgetVirtualUserSummaryGenerating = 'MySessions.CompanionWidget.virtualUserSummaryGenerating',
  MySessionsConsultationSessionCannotTerminateActiveCCTS = 'MySessions.ConsultationSession.cannotTerminateActiveCCTS',
  MySessionsContextMenuCopyEmail = 'MySessions.ContextMenu.copyEmail',
  MySessionsContextMenuCopyEmailSuccess = 'MySessions.ContextMenu.copyEmailSuccess',
  MySessionsContextMenuCopyError = 'MySessions.ContextMenu.copyError',
  MySessionsContextMenuCopyPhone = 'MySessions.ContextMenu.copyPhone',
  MySessionsContextMenuCopyPhoneSuccess = 'MySessions.ContextMenu.copyPhoneSuccess',
  MySessionsContextMenuOpenInsights = 'MySessions.ContextMenu.openInsights',
  MySessionsContextMenuOpenInsightsNewTab = 'MySessions.ContextMenu.openInsightsNewTab',
  MySessionsContextMenuStartCallback = 'MySessions.ContextMenu.startCallback',
  MySessionsContextMenuStartCallbackBlockedAnonymous = 'MySessions.ContextMenu.startCallbackBlockedAnonymous',
  MySessionsContextMenuStartCallbackBlockedNoOutbound = 'MySessions.ContextMenu.startCallbackBlockedNoOutbound',
  MySessionsContextMenuStartCallbackBlockedNoPhone = 'MySessions.ContextMenu.startCallbackBlockedNoPhone',
  MySessionsContextMenuStartCallbackError = 'MySessions.ContextMenu.startCallbackError',
  MySessionsContextMenuStartCallbackSuccess = 'MySessions.ContextMenu.startCallbackSuccess',
  MySessionsContextMenuShowCustomerPopup = 'MySessions.ContextMenu.showCustomerPopup',
  MySessionsContextMenuTriggerLabel = 'MySessions.ContextMenu.triggerLabel',
  MySessionsContextMenuUseEmail = 'MySessions.ContextMenu.useEmail',
  MySessionsContextMenuUsePhone = 'MySessions.ContextMenu.usePhone',
  MySessionsCustomerContextPopupError = 'MySessions.CustomerContextPopup.error',
  MySessionsCustomerContextPopupMatched = 'MySessions.CustomerContextPopup.matched',
  MySessionsCustomerContextPopupNoMatch = 'MySessions.CustomerContextPopup.noMatch',
  MySessionsCustomerContextPopupRecentInteractions = 'MySessions.CustomerContextPopup.recentInteractions',
  MySessionsCustomerContextPopupTitle = 'MySessions.CustomerContextPopup.title',
  MySessionsEmailWidgetAttachFiles = 'MySessions.EmailWidget.attachFiles',
  MySessionsEmailWidgetAttachFilesBeingProcessed = 'MySessions.EmailWidget.attachFilesBeingProcessed',
  MySessionsEmailWidgetAttachmentsCustomerAttachments = 'MySessions.EmailWidget.Attachments.customerAttachments',
  MySessionsEmailWidgetAttachmentsDownload = 'MySessions.EmailWidget.Attachments.download',
  MySessionsEmailWidgetAttachmentsDownloadAll = 'MySessions.EmailWidget.Attachments.downloadAll',
  MySessionsEmailWidgetAttachmentsDownloadAllInfo = 'MySessions.EmailWidget.Attachments.downloadAllInfo',
  MySessionsEmailWidgetAttachmentsDownloadAllWarning = 'MySessions.EmailWidget.Attachments.downloadAllWarning',
  MySessionsEmailWidgetAttachmentsDownloadWarning = 'MySessions.EmailWidget.Attachments.downloadWarning',
  MySessionsEmailWidgetAttachmentsRemove = 'MySessions.EmailWidget.Attachments.remove',
  MySessionsEmailWidgetAttachmentsTitle = 'MySessions.EmailWidget.Attachments.title',
  MySessionsEmailWidgetAttachmentsValidationSizeLimitExceeded = 'MySessions.EmailWidget.Attachments.validationSizeLimitExceeded',
  MySessionsEmailWidgetAttachmentsValidationTitle = 'MySessions.EmailWidget.Attachments.validationTitle',
  MySessionsEmailWidgetAttachmentsValidationUnsupportedExtension = 'MySessions.EmailWidget.Attachments.validationUnsupportedExtension',
  MySessionsEmailWidgetCancel = 'MySessions.EmailWidget.cancel',
  MySessionsEmailWidgetCc = 'MySessions.EmailWidget.cc',
  MySessionsEmailWidgetFrom = 'MySessions.EmailWidget.from',
  MySessionsEmailWidgetImportant = 'MySessions.EmailWidget.important',
  MySessionsEmailWidgetLow = 'MySessions.EmailWidget.low',
  MySessionsEmailWidgetMarkAsHandled = 'MySessions.EmailWidget.markAsHandled',
  MySessionsEmailWidgetReply = 'MySessions.EmailWidget.reply',
  MySessionsEmailWidgetReplyAll = 'MySessions.EmailWidget.replyAll',
  MySessionsEmailWidgetSaveDraft = 'MySessions.EmailWidget.saveDraft',
  MySessionsEmailWidgetEmailDraft = 'MySessions.EmailWidget.emailDraft',
  MySessionsEmailWidgetSend = 'MySessions.EmailWidget.send',
  MySessionsEmailWidgetSubject = 'MySessions.EmailWidget.subject',
  MySessionsEmailWidgetTitle = 'MySessions.EmailWidget.title',
  MySessionsEmailWidgetTo = 'MySessions.EmailWidget.to',
  MySessionsInteractionAttributesWidgetTitle = 'MySessions.InteractionAttributesWidget.title',
  MySessionsInteractionConnectedTime = 'MySessions.Interactions.connectedTime',
  MySessionsInteractionDialOutTime = 'MySessions.Interactions.dialOutTime',
  MySessionsInteractionHandled = 'MySessions.Interactions.handled',
  MySessionsInteractionHandledBy = 'MySessions.Interactions.handledBy',
  MySessionsInteractionInAfterCallWork = 'MySessions.Interactions.inAfterCallWork',
  MySessionsInteractionInExtendedAfterCallWork = 'MySessions.Interactions.inExtendedAfterCallWork',
  MySessionsInteractionNoAttributes = 'MySessions.Interactions.noAttributes',
  MySessionsInteractionNoInteractions = 'MySessions.Interactions.noInteractions',
  MySessionsInteractionNoSearchResult = 'MySessions.Interactions.noSearchResult',
  MySessionsInteractionParkTime = 'MySessions.Interactions.parkTime',
  MySessionsInteractionPutOnHoldTime = 'MySessions.Interactions.putOnHoldTime',
  MySessionsInteractionQueueTime = 'MySessions.Interactions.queueTime',
  MySessionsInteractionResult = 'MySessions.Interactions.result',
  MySessionsInteractionRingTime = 'MySessions.Interactions.ringTime',
  MySessionsInteractionTransferringTime = 'MySessions.Interactions.transferringTime',
  MySessionsPageNoOtherWidgetsConfigured = 'MySessions.Page.noOtherWidgetsConfigured',
  MySessionsSessionConversationContextWidgetTitle = 'MySessions.ConversationContextWidget.title',
  MySessionsSessionConversationContextWidgetWarningMessage = 'MySessions.ConversationContextWidget.warningMessage',
  MySessionsSessionDetailsWidgetCopySuccess = 'MySessions.SessionsDetailsWidget.copySuccess',
  MySessionsSessionDetailsWidgetTitle = 'MySessions.SessionsDetailsWidget.title',
  MySessionsSystemParamsCallChainId = 'MySessions.SystemParams.callChainId',
  MySessionsSystemParamsCallerAndTelNumber = 'MySessions.SystemParams.callerAndTelNumber',
  MySessionsSystemParamsCallerId = 'MySessions.SystemParams.callerId',
  MySessionsSystemParamsCallerIntent = 'MySessions.SystemParams.callerIntent',
  MySessionsSystemParamsCallerSentiment = 'MySessions.SystemParams.callerSentiment',
  MySessionsSystemParamsCallerTelNumber = 'MySessions.SystemParams.callerTelNumber',
  MySessionsSystemParamsCallerUPN = 'MySessions.SystemParams.callerUPN',
  MySessionsSystemParamsCallId = 'MySessions.SystemParams.callId',
  MySessionsSystemParamsCustomerAndPrimaryTelNumber = 'MySessions.SystemParams.customerAndPrimaryTelNumber',
  MySessionsSystemParamsCustomerCity = 'MySessions.SystemParams.customerCity',
  MySessionsSystemParamsCustomerCompany = 'MySessions.SystemParams.customerCompany',
  MySessionsSystemParamsCustomerCountry = 'MySessions.SystemParams.customerCountry',
  MySessionsSystemParamsCustomerDepartment = 'MySessions.SystemParams.customerDepartment',
  MySessionsSystemParamsCustomerDisplayName = 'MySessions.SystemParams.customerDisplayName',
  MySessionsSystemParamsCustomerEmail = 'MySessions.SystemParams.customerEmail',
  MySessionsSystemParamsCustomerFirstName = 'MySessions.SystemParams.customerFirstName',
  MySessionsSystemParamsCustomerIdentifier = 'MySessions.SystemParams.customerIdentifier',
  MySessionsSystemParamsCustomerImAddress = 'MySessions.SystemParams.customerImAddress',
  MySessionsSystemParamsCustomerJobTitle = 'MySessions.SystemParams.customerJobTitle',
  MySessionsSystemParamsCustomerLastName = 'MySessions.SystemParams.customerLastName',
  MySessionsSystemParamsCustomerPostCode = 'MySessions.SystemParams.customerPostCode',
  MySessionsSystemParamsCustomerPrimaryTelNumber = 'MySessions.SystemParams.customerPrimaryTelNumber',
  MySessionsSystemParamsCustomerState = 'MySessions.SystemParams.customerState',
  MySessionsSystemParamsCustomerStreetAddress = 'MySessions.SystemParams.customerStreetAddress',
  MySessionsSystemParamsCustomerUpn = 'MySessions.SystemParams.customerUpn',
  MySessionsSystemParamsDestinationAndTelNumber = 'MySessions.SystemParams.destinationAndTelNumber',
  MySessionsSystemParamsDestinationId = 'MySessions.SystemParams.destinationId',
  MySessionsSystemParamsDestinationIntent = 'MySessions.SystemParams.destinationIntent',
  MySessionsSystemParamsDestinationSentiment = 'MySessions.SystemParams.destinationSentiment',
  MySessionsSystemParamsDestinationTelNumber = 'MySessions.SystemParams.destinationTelNumber',
  MySessionsSystemParamsDestinationUpn = 'MySessions.SystemParams.destinationUpn',
  MySessionsSystemParamsEmailServiceMailboxUpn = 'MySessions.SystemParams.emailServiceMailboxUpn',
  MySessionsSystemParamsEmailSubject = 'MySessions.SystemParams.emailSubject',
  MySessionsSystemParamsInitialMessage = 'MySessions.SystemParams.initialMessage',
  MySessionsSystemParamsMicrosoftCallerId = 'MySessions.SystemParams.microsoftCallerId',
  MySessionsSystemParamsMicrosoftDestinationId = 'MySessions.SystemParams.microsoftDestinationId',
  MySessionsSystemParamsOriginalCalledDisplay = 'MySessions.SystemParams.originalCalledDisplay',
  MySessionsSystemParamsOriginalCalledNumber = 'MySessions.SystemParams.originalCalledNumber',
  MySessionsSystemParamsOriginalCalledTargetType = 'MySessions.SystemParams.originalCalledTargetType',
  MySessionsSystemParamsReferenceId = 'MySessions.SystemParams.referenceId',
  MySessionsSystemParamsServiceAndTelNumber = 'MySessions.SystemParams.serviceAndTelNumber',
  MySessionsSystemParamsServiceDisplayName = 'MySessions.SystemParams.serviceDisplayName',
  MySessionsSystemParamsServiceTelNumber = 'MySessions.SystemParams.serviceTelNumber',
  MySessionsSystemParamsServiceUpn = 'MySessions.SystemParams.serviceUpn',
  MySessionsSystemParamsTeamDescription = 'MySessions.SystemParams.teamDescription',
  MySessionsSystemParamsTeamId = 'MySessions.SystemParams.teamId',
  MySessionsSystemParamsTeamName = 'MySessions.SystemParams.teamName',
  MySessionsTranscriptionProcessing = 'Transcriptions.processing',
  MySessionsUserInteractionsParkedListByModality = 'MySessions.UserInteractionsParkedList.byModality',
  MySessionsUserInteractionsParkedListGroupCalls = 'MySessions.UserInteractionsParkedList.groupCalls',
  MySessionsUserInteractionsParkedListGroupEmail = 'MySessions.UserInteractionsParkedList.groupEmail',
  MySessionsUserInteractionsParkedListGroupExternalTasks = 'MySessions.UserInteractionsParkedList.groupExternalTasks',
  MySessionsUserInteractionsParkedListGroupIm = 'MySessions.UserInteractionsParkedList.groupIm',
  MySessionsUserInteractionsParkedListNewest = 'MySessions.UserInteractionsParkedList.newest',
  MySessionsUserInteractionsParkedListOldest = 'MySessions.UserInteractionsParkedList.oldest',
  MySessionsUserInteractionsParkedListSortDisabledHint = 'MySessions.UserInteractionsParkedList.sortDisabledHint',
  MySessionsUserInteractionsWidgetHistoricalTab = 'MySessions.UserInteractionsWidget.historicalTab',
  MySessionsUserInteractionsWidgetParkedTab = 'MySessions.UserInteractionsWidget.parkedTab',
  MySessionsUserInteractionsWidgetSessions = 'MySessions.UserInteractionsWidget.sessions',
  MySessionsUserInteractionsWidgetTitle = 'MySessions.UserInteractionsWidget.title',
  MySessionsVoicemailWidgetConfidence = 'MySessions.VoicemailWidget.confidence',
  MySessionsVoicemailWidgetDownloadAudio = 'MySessions.VoicemailWidget.downloadAudio',
  MySessionsVoicemailWidgetDownloadTranscript = 'MySessions.VoicemailWidget.downloadTranscript',
  MySessionsVoicemailWidgetDuration = 'MySessions.VoicemailWidget.duration',
  MySessionsVoicemailWidgetLanguage = 'MySessions.VoicemailWidget.language',
  MySessionsVoicemailWidgetListenedBy = 'MySessions.VoicemailWidget.listenedBy',
  MySessionsVoicemailWidgetProcessedBy = 'MySessions.VoicemailWidget.processedBy',
  MySessionsVoicemailWidgetStreamAudio = 'MySessions.VoicemailWidget.streamAudio',
  MySessionsVoicemailWidgetTitle = 'MySessions.VoicemailWidget.title',
  MySessionsVoicemailWidgetTranscription = 'MySessions.VoicemailWidget.transcription',
  MySessionsVoicemailWidgetTranscriptionFailed = 'MySessions.VoicemailWidget.transcriptionFailed',
  MySessionsVoicemailWidgetTranscriptionPending = 'MySessions.VoicemailWidget.transcriptionPending',
  NotAvailableReasonFillOut = 'NotAvailableReason.fillOut',
  NotAvailableReasonOpenRequests = 'NotAvailableReason.openRequests',
  NotAvailableReasonSelectOtherReason = 'NotAvailableReason.selectOtherReason',
  OriginalCallTargetLabel = 'OriginalCallTarget.label',
  OriginalCallTargetTargetTypeAnonymous = 'OriginalCallTarget.targetType.Anonymous',
  OriginalCallTargetTargetTypeFederated = 'OriginalCallTarget.targetType.Federated',
  OriginalCallTargetTargetTypeResourceAccount = 'OriginalCallTarget.targetType.ResourceAccount',
  OriginalCallTargetTargetTypeService = 'OriginalCallTarget.targetType.Service',
  OriginalCallTargetTargetTypeUnknown = 'OriginalCallTarget.targetType.Unknown',
  OriginalCallTargetTargetTypeUser = 'OriginalCallTarget.targetType.User',
  OriginalCallTargetUnresolvedTooltip = 'OriginalCallTarget.unresolvedTooltip',
  PhoneNumberNormalizationPopupDescriptionMessage = 'PhoneNumberNormalization.Popup.descriptionMessage',
  PhoneNumberNormalizationPopupErrorMessage = 'PhoneNumberNormalization.Popup.errorMessage',
  PhoneNumberNormalizationPopupFormat = 'PhoneNumberNormalization.Popup.format',
  PhoneNumberNormalizationPopupFormatMessage = 'PhoneNumberNormalization.Popup.formatMessage',
  PhoneNumberNormalizationPopupInfoMessage = 'PhoneNumberNormalization.Popup.infoMessage',
  PhoneNumberNormalizationPopupTarget = 'PhoneNumberNormalization.Popup.target',
  PhoneNumberNormalizationPopupTitle = 'PhoneNumberNormalization.Popup.title',
  PhoneNumberNormalizationPopupTransfer = 'PhoneNumberNormalization.Popup.transfer',
  PhoneNumberNormalizationPopupWarningMessage = 'PhoneNumberNormalization.Popup.warningMessage',
  PortalPageAttendantConsole = 'PortalPage.AttendantConsole',
  PortalPageCompanion = 'PortalPage.Companion',
  PortalPageConfiguration = 'PortalPage.Configuration',
  PortalPageCustomerInsights = 'PortalPage.CustomerInsights',
  PortalPageDashboards = 'PortalPage.Dashboards',
  PortalPageHome = 'PortalPage.Home',
  PortalPageLiveView = 'PortalPage.LiveView',
  PortalPageMySession = 'PortalPage.MySession',
  PortalPageServicesOverview = 'PortalPage.ServicesOverview',
  PortalPageSessionList = 'PortalPage.SessionList',
  PortalPageSettings = 'PortalPage.Settings',
  PortalPageStatistics = 'PortalPage.Statistics',
  PortalPageTaskFlowVisualizer = 'PortalPage.TaskFlowVisualizer',
  PortalPageUserPreferences = 'PortalPage.UserPreferences',
  PortalPageVoicemails = 'PortalPage.Voicemails',
  PresenceAppearOffline = 'Presence.appearOffline',
  PresenceAvailable = 'Presence.available',
  PresenceAvailableIdle = 'Presence.availableIdle',
  PresenceAway = 'Presence.away',
  PresenceBic = 'Presence.bic',
  PresenceBrb = 'Presence.brb',
  PresenceBusy = 'Presence.busy',
  PresenceBusyIdle = 'Presence.busyIdle',
  PresenceDirectAvailable = 'Presence.directAvailable',
  PresenceDnd = 'Presence.dnd',
  PresenceInAMeeting = 'Presence.inAMeeting',
  PresenceInTimeAvailable = 'Presence.inTimeAvailable',
  PresenceLoading = 'Presence.loading',
  PresenceNoOneAvailable = 'Presence.noOneAvailable',
  PresenceOffline = 'Presence.offline',
  PresenceOffWork = 'Presence.offWork',
  PresenceOof = 'Presence.oof',
  PresenceSetPresence = 'Presence.setPresence',
  PresenceUnknown = 'Presence.unknown',
  PresenceUrgentInteruptionsOnly = 'Presence.urgentInteruptionsOnly',
  ProvisioningAddConfiguringForTeams = 'Provisioning.Add.configuringForTeams',
  ProvisioningAddInstallationAggrement = 'Provisioning.Add.installationAggrement',
  ProvisioningAddLicenseTerms = 'Provisioning.Add.licenseTerms',
  ProvisioningAddThankYou = 'Provisioning.Add.thankYou',
  ProvisioningMissingPermissionContactAdmin = 'Provisioning.missingPermission.contactAdmin',
  ProvisioningMissingPermissionReregisterDescription = 'Provisioning.missingPermission.provisioning',
  ProvisioningMissingPermissionRestoringDescription = 'Provisioning.missingPermission.restoring',
  ProvisioningMissingPermissionTitle = 'Provisioning.missingPermission.title',
  ProvisioningNoLicensesDescription = 'Provisioning.noLicenses.description',
  ProvisioningNoLicensesTitle = 'Provisioning.noLicenses.title',
  ProvisioningnotAvailableLocation = 'Provisioning.notAvailableLocation',
  ProvisioningOpenLocation = 'Provisioning.openLocation',
  ProvisioningProvisioningBot = 'Provisioning.provisioningBot',
  ProvisioningReactivate = 'Provisioning.reactivate',
  ProvisioningRemoveDescription = 'Provisioning.Remove.description',
  ProvisioningRemoveQuestion = 'Provisioning.Remove.question',
  ProvisioningRemoveTabOnlyDescription = 'Provisioning.RemoveTabOnly.description',
  ProvisioningRemoveTabOnlyQuestion = 'Provisioning.RemoveTabOnly.question',
  ProvisioningRemoveTabOnlyTitle = 'Provisioning.RemoveTabOnly.title',
  ProvisioningRemoveTitle = 'Provisioning.Remove.title',
  ProvisioningReregisterDescription = 'Provisioning.Reregister.description',
  ProvisioningReregisterTitle = 'Provisioning.Reregister.title',
  ProvisioningRestoreYourService = 'Provisioning.restoreYourService',
  ProvisioningUnavailableClusterDescription = 'Provisioning.unavailableCluster.description',
  ProvisioningUnavailableClusterTitle = 'Provisioning.unavailableCluster.title',
  QueueActive = 'Queue.active',
  QueueActiveSessions = 'Queue.activeSessions',
  QueueParkedSessions = 'Queue.parkedSessions',
  QueueHold = 'Queue.hold',
  QueueIncoming = 'Queue.incoming',
  QueueThereAreNoSessions = 'Queue.thereAreNoSessions',
  QueueMute = 'Queue.mute',
  QueueUnMute = 'Queue.unmute',
  QueueThereIsNoActiveSession = 'Queue.thereIsNoActiveSession',
  QueueThereIsNoParkedSession = 'Queue.thereIsNoParkedSession',
  QueueModalityAudio = 'Queue.modality.audio',
  QueueModalityEmail = 'Queue.modality.email',
  QueueModalityExternalTask = 'Queue.modality.ext',
  QueueModalityInstantMessaging = 'Queue.modality.im',
  QueueTitle = 'Queue.title',
  ReportProblemQuestion = 'ReportProblem.question',
  RunbookLinkPowershell = 'Runbook.linkPowershell',
  RunbookManualTriggerError = 'Runbook.manualTriggerError',
  RunbookNotApplicableChanges = 'Runbook.notApplicableChanges',
  RunbookNotApplicableChangesOnSave = 'Runbook.notApplicableChangesOnSave',
  RunbookNotFound = 'Runbook.notFound',
  RunbookNotFoundOnSave = 'Runbook.notFoundOnSave',
  RunbookTestCallButton = 'Runbook.testCallButton',
  RunbookTestCallDescription = 'Runbook.testCallDescription',
  RunbookTestCallLabel = 'Runbook.testCallLabel',
  RunbookTriggering = 'Runbook.triggering',
  SearchFilterCompatibilityAdNimbus = 'SearchFilterCompatibility.adNimbus',
  SearchFilterCompatibilityExchangeNimbus = 'SearchFilterCompatibility.exchangeNimbus',
  SearchInputAdOnlyNimbus = 'SearchInput.adOnlyNimbus',
  SearchInputExchangeOnlyNimbus = 'SearchInput.exchangeOnlyNimbus',
  SearchInputPlaceholder = 'SearchInput.placeholder',
  SearchParserDuplicatesError = 'SearchParser.duplicatesError',
  SearchParserExpressionError = 'SearchParser.expressionError',
  SearchParserIncompatibleFiltersError = 'SearchParser.incompatibleFiltersError',
  SearchParserNoTextAfterError = 'SearchParser.noTextAfterError',
  SearchParserSpacingErrorGeneral = 'SearchParser.spacingErrorGeneral',
  SearchParserValueError = 'SearchParser.valueError',
  ServiceLineTitle = 'ServiceLine.title',
  ServiceStatistics = 'ServiceStatistics.title',
  SettingsApplyAndSave = 'Settings.applyAndSave',
  SettingsAutorun = 'Settings.autorun',
  SettingsConversationContextTransferKeepContext = 'Settings.ConversationContext.transferKeepContext',
  SettingsConversationContextTransferToService = 'Settings.ConversationContext.transferToService',
  SettingsConversationContextTransferToUser = 'Settings.ConversationContext.transferToUser',
  SettingsDistributionConversationsDistributed = 'Settings.Distribution.conversationsDistributed',
  SettingsDistributionConversationsNotDistributed = 'Settings.Distribution.conversationsNotDistributed',
  SettingsDistributionUserAccountWarning = 'Settings.Distribution.userAccountWarning',
  SettingsFormAddButton = 'SettingsForm.addButton',
  SettingsFormAfterCallWork = 'SettingsForm.afterCallWork',
  SettingsFormAfterCallWorkAllowCallOnBehalf = 'SettingsForm.afterCallWorkAllowCallOnBehalf',
  SettingsFormAfterCallWorkAllowToExtend = 'SettingsForm.afterCallWorkAllowToExtend',
  SettingsFormAfterCallWorkAllowToStop = 'SettingsForm.afterCallWorkAllowToStop',
  SettingsFormAfterCallWorkEnabled = 'SettingsForm.afterCallWorkEnabled',
  SettingsFormAfterCallWorkExtendedTime = 'SettingsForm.afterCallWorkExtendedTime',
  SettingsFormAfterCallWorkStartForFailedCallOnBehalf = 'SettingsForm.afterCallWorkStartForFailedCallOnBehalf',
  SettingsFormAfterCallWorkStartForFailedCallOnBehalfInfo = 'SettingsForm.afterCallWorkStartForFailedCallOnBehalfInfo',
  SettingsFormAfterCallWorkTime = 'SettingsForm.afterCallWorkTime',
  SettingsFormAllowDownload = 'SettingsForm.allowDownload',
  SettingsFormAllowedFileTypes = 'SettingsForm.allowedFileTypes',
  SettingsFormAllowUserDirectCallPreferencesEdit = 'SettingsForm.allowUserDirectCallPreferencesEdit',
  SettingsFormAnonymizationSection = 'SettingsForm.anonymizationSection',
  SettingsFormAnonymizeCallerInfo = 'SettingsForm.anonymizeCallerInfo',
  SettingsFormAnonymizeCallerInfoSpecific = 'SettingsForm.anonymizeCallerInfoSpecific',
  SettingsFormAnonymizeCallerInfoWarning = 'SettingsForm.anonymizeCallerInfoWarning',
  SettingsFormApplicationId = 'SettingsForm.applicationId',
  SettingsFormAssistantConversationContext = 'SettingsForm.assistantConversationContext',
  SettingsFormAssistantFormTitle = 'SettingsForm.assistantFormTitle',
  SettingsFormAssistantTemplates = 'SettingsForm.assistantTemplates',
  SettingsFormAttendantConsole = 'SettingsForm.attendantConsole',
  SettingsFormBusyAvailabilitiesSettings = 'SettingsForm.busyAvailabilitiesSettings',
  SettingsFormCanTeamMemberChangeActiveState = 'SettingsForm.users.canTeamMemberChangeActiveState',
  SettingsFormCodes = 'SettingsForm.codes',
  SettingsFormCallerAnonymizationRules = 'SettingsForm.callerAnonymizationRules',
  SettingsFormConversationContext = 'SettingsForm.conversationContext',
  SettingsFormConversationContextParameter = 'SettingsForm.conversationContextParameter',
  SettingsFormConversationContextParameterColumnDefaultValue = 'SettingsForm.conversationContextParameterColumnDefaultValue',
  SettingsFormConversationContextParameterColumnId = 'SettingsForm.conversationContextParameterColumnId',
  SettingsFormConversationContextParameterColumnName = 'SettingsForm.conversationContextParameterColumnName',
  SettingsFormConversationContextParameterColumnOrganizationUnit = 'SettingsForm.conversationContextParameterColumnOrganizationUnit',
  SettingsFormConversationsDistribution = 'SettingsForm.conversationsDistribution',
  SettingsFormDefaultTeamOwnerRole = 'SettingsForm.defaultTeamOwnerRole',
  SettingsFormDeleteUrl = 'SettingsForm.deleteUrl',
  SettingsFormDirectCallPreferencesEditSection = 'SettingsForm.directCallPreferencesEditSection',
  SettingsFormDirectCallWorkflowOnlyNote = 'SettingsForm.directCallWorkflowOnlyNote',
  SettingsFormDisabledReasonAfterCallWorkIsEnabled = 'SettingsForm.disabledReason.afterCallWorkIsEnabled',
  SettingsFormDisabledReasonAVWorkflowIsUsed = 'SettingsForm.disabledReason.aVWorkflowIsUsed',
  SettingsFormDisabledReasonBulkChannel = 'SettingsForm.disabledReason.bulkChannel',
  SettingsFormDisabledReasonBulkMailbox = 'SettingsForm.disabledReason.bulkMailbox',
  SettingsFormDisabledReasonBulkMailboxFolder = 'SettingsForm.disabledReason.bulkMailboxFolder',
  SettingsFormDisabledReasonBulkMessagingEntry = 'SettingsForm.disabledReason.bulkMessagingEntry',
  SettingsFormDisabledReasonBulkOpeningHoursStatus = 'SettingsForm.disabledReason.bulkOpeningHoursStatus',
  SettingsFormDisabledReasonBulkPSTN = 'SettingsForm.disabledReason.bulkPSTN',
  SettingsFormDisabledReasonChangingLicenseNotPossible = 'SettingsForm.disabledReason.changingLicenseNotPossible',
  SettingsFormDisabledReasonChangingMessageConfigurationNotPossible = 'SettingsForm.disabledReason.changingMessageConfigurationNotPossible',
  SettingsFormDisabledReasonConversationContextIsEnabled = 'SettingsForm.disabledReason.conversationContextIsEnabled',
  SettingsFormDisabledReasonDirectCallResourceAccountAssigned = 'SettingsForm.disabledReason.directCallResourceAccountAssigned',
  SettingsFormDisabledReasonEmailWorkflowEnabled = 'SettingsForm.disabledReason.emailWorkflowEnabled',
  SettingsFormDisabledReasonEnterpriseOrContactCenterRequired = 'SettingsForm.disabledReason.enterpriseOrContactCenterRequired',
  SettingsFormDisabledReasonExternalTasksWorkflowEnabled = 'SettingsForm.disabledReason.externalTasksWorkflowEnabled',
  SettingsFormDisabledReasonFolderAssignedToOtherService = 'SettingsForm.disabledReason.folderAssignedToOtherService',
  SettingsFormDisabledReasonForFutureUse = 'SettingsForm.disabledReason.forFutureUse',
  SettingsFormDisabledReasonIMModalityNoChannels = 'SettingsForm.disabledReason.iMModalityNoChannels',
  SettingsFormDisabledReasonIMWorkflowEnabled = 'SettingsForm.disabledReason.iMWorkflowEnabled',
  SettingsFormDisabledReasonOutboundCallWithWorkflowEnabled = 'SettingsForm.disabledReason.outboundCallWithWorkflowEnabled',
  SettingsFormDisabledReasonInteractForServiceIsUsed = 'SettingsForm.disabledReason.interactForServiceIsUsed',
  SettingsFormDisabledReasonInteractOnTenantIsDisabled = 'SettingsForm.disabledReason.interactOnTenantIsDisabled',
  SettingsFormDisabledReasonVirtualUserOnTenantIsDisabled = 'SettingsForm.disabledReason.virtualUserOnTenantIsDisabled',
  SettingsFormDisabledReasonCompanionOnTenantIsDisabled = 'SettingsForm.disabledReason.companionOnTenantIsDisabled',
  SettingsFormDisabledReasonLicenseBreach = 'SettingsForm.disabledReason.licenseBreach',
  SettingsFormDisabledReasonNimbusUnifyServiceLicenseDisabledReason = 'SettingsForm.disabledReason.nimbusUnifyServiceLicenseDisabledReason',
  SettingsFormDisabledReasonSkillBasedUserAssignmentTypeIsUsed = 'SettingsForm.disabledReason.skillBasedUserAssignmentTypeIsUsed',
  SettingsFormDisabledReasonStoreConversationContextDataIsEnabled = 'SettingsForm.disabledReason.storeConversationContextDataIsEnabled',
  SettingsFormDisabledReasonSystemAndCustomParametersInWidgetIsUsed = 'SettingsForm.disabledReason.systemAndCustomParametersInWidgetIsUsed',
  SettingsFormDisabledReasonUsingAddonNotPossible = 'SettingsForm.disabledReason.usingAddonNotPossible',
  SettingsFormDisabledReasonUsingLicenseNotPossible = 'SettingsForm.disabledReason.usingLicenseNotPossible',
  SettingsFormE164Number = 'SettingsForm.e164Number',
  SettingsFormEmail = 'Settings.email',
  SettingsFormEmergencyDestinationCannotValidate = 'SettingsForm.emergencyDestinationCannotValidate',
  SettingsFormEmergencyDestionationNotValid = 'SettingsForm.emergencyDestionationNotValid',
  SettingsFormEmergencyRedirectDestination = 'SettingsForm.emergencyRedirectDestination',
  SettingsFormEmergencyRedirectEnabled = 'SettingsForm.emergencyRedirectEnabled',
  SettingsFormEmergencyRouting = 'SettingsForm.emergencyRouting',
  SettingsFormExtensionsLiveCaptioning = 'SettingsForm.extensionsTab.liveCaptioning',
  SettingsFormExtensionsMap = 'SettingsForm.extensionsTab.map',
  SettingsFormExtensionsSessionDetails = 'SettingsForm.extensionsTab.sessionDetails',
  SettingsFormExtensionsTabAssistant = 'SettingsForm.extensionsTab.assistant',
  SettingsFormExtensionsTabAttendantConsole = 'SettingsForm.extensionsTab.attendantConsole',
  SettingsFormExtensionsTabCustomParameters = 'SettingsForm.extensionsTab.customParameters',
  SettingsFormExtensionsTabEmbeddedContext = 'SettingsForm.extensionsTab.embeddedContext',
  SettingsFormExtensionsTabMySessionParameters = 'SettingsForm.extensionsTab.mySessionParameters',
  SettingsFormExtensionsTabMySessions = 'SettingsForm.extensionsTab.mySessions',
  SettingsFormExtensionsTabNimbusOneClient = 'SettingsForm.extensionsTab.nimbusOneClient',
  SettingsFormExtensionsTabNimbusOneConversationContext = 'SettingsForm.extensionsTab.nimbusOneConversationContext',
  SettingsFormExtensionsTabNimbusOneSessionParameters = 'SettingsForm.extensionsTab.nimbusOneSessionParameters',
  SettingsFormExtensionsTabSessionParameters = 'SettingsForm.extensionsTab.sessionParameters',
  SettingsFormExtensionsTabStoreConversationContextData = 'SettingsForm.extensionsTab.storeConversationContextData',
  SettingsFormExtensionsTabStoreConversationContextDataReadMore = 'SettingsForm.extensionsTab.storeConversationContextDataReadMore',
  SettingsFormExtensionsTabStoreConversationContextDataWarning = 'SettingsForm.extensionsTab.storeConversationContextDataWarning',
  SettingsFormExtensionsTabSystemParameters = 'SettingsForm.extensionsTab.systemParameters',
  SettingsFormExtensionsTabTranscriptInformation = 'SettingsForm.extensionsTab.transcriptInformation',
  SettingsFormExtensionsTabUnifyCallFlow = 'SettingsForm.extensionsTab.unify.callFlow',
  SettingsFormExtensionsTabUnifyContextInformation = 'SettingsForm.extensionsTab.unify.contextInformation',
  SettingsFormExtensionsTabUnifyConversationContextTabs = 'SettingsForm.extensionsTab.unify.conversationContextTabs',
  SettingsFormExtensionsTabUnifyConversationContextTabsHint = 'SettingsForm.extensionsTab.unify.conversationContextTabsHint',
  SettingsFormExtensionsTabUnifyStoreConversationContextDataWarning = 'SettingsForm.extensionsTab.unify.storeConversationContextDataWarning',
  SettingsFormExtensionsTabUnifyWidgetHint = 'SettingsForm.extensionsTab.unify.widgetHint',
  SettingsFormInteractAudioVideo = 'SettingsForm.interact.audioVideoEnabled',
  SettingsFormInteractContactOnBusy = 'SettingsForm.interact.contactOnBusy',
  SettingsFormInteractDirectImSystemMessages = 'SettingsForm.interact.directImSystemMessages',
  SettingsFormInteractDirectSystemMessage = 'SettingsForm.interact.directSystemMessage',
  SettingsFormInteractDomainTemplate = 'SettingsForm.interact.domainTemplate',
  SettingsFormInteractEnable = 'SettingsForm.interact.enable',
  SettingsFormInteractIM = 'SettingsForm.interact.imEnabled',
  SettingsFormInteractIMDisabledWarning = 'SettingsForm.interact.imDisabledWarning',
  SettingsFormInteractIntegration = 'SettingsForm.interact.integration',
  SettingsFormInteractModalities = 'SettingsForm.interact.modalities',
  SettingsFormInteractNotRegistered = 'SettingsForm.interact.notRegistered',
  SettingsFormInteractRegistrationLink = 'SettingsForm.interact.registrationLink',
  SettingsFormInteractRestrictAccess = 'SettingsForm.interact.restrictAccess',
  SettingsFormInteractRestriction = 'SettingsForm.interact.restriction',
  SettingsFormInteractServiceImSystemMessages = 'SettingsForm.interact.serviceImSystemMessages',
  SettingsFormInteractServiceSnippet = 'SettingsForm.interact.serviceSnippet',
  SettingsFormInteractTenantDisabledWarning = 'SettingsForm.interact.tenantDisabledWarning',
  SettingsFormMediaHandlingSection = 'SettingsForm.mediaHandlingSection',
  SettingsFormMultiHomingCheckUsers = 'Settings.MultiHomingCheckUsers',
  SettingsFormMultiHomingDescription = 'Settings.MultiHomingDescription',
  SettingsFormMySessionsSection = 'SettingsForm.mySessionsSection',
  SettingsFormNotEnoughPermissionsToViewPage = 'Settings.notEnoughPermissionsToViewPage',
  SettingsFormOpeningHoursActive = 'SettingsForm.openingHoursActive',
  SettingsFormOpeningHoursPrimary = 'SettingsForm.openingHoursPrimary',
  SettingsFormOpeningHoursSecondary = 'SettingsForm.openingHoursSecondary',
  SettingsFormOpeningHoursStatusNextChange = 'SettingsForm.openingHoursStatusNextChange',
  SettingsFormOutbound = 'SettingsForm.outbound',
  SettingsFormOutboundIsEnabled = 'SettingsForm.outboundIsEnabled',
  SettingsFormPermissionsApplyDisabled = 'SettingsForm.permissions.applyDisabled',
  SettingsFormPermissionsApplyToSelected = 'SettingsForm.permissions.applyToSelected',
  SettingsFormPermissionsNpd = 'SettingsForm.permissions.npd',
  SettingsFormPermissionsUserDisabled = 'SettingsForm.permissions.userDisabled',
  SettingsFormPersistentRona = 'SettingsForm.persistentRona',
  SettingsFormPersistentRonaEnabled = 'SettingsForm.persistentRonaEnabled',
  SettingsFormPersistentRonaResetTime = 'SettingsForm.persistentRonaResetTime',
  SettingsFormPhoneNumber = 'Settings.phoneNumber',
  SettingsFormPlease = 'SettingsForm.please',
  SettingsFormPleaseContactYourITHelpdesk = 'Settings.pleaseContactYourITHelpdesk',
  SettingsFormPleaseContactYourTechnicalContact = 'Settings.pleaseContactYourTechnicalContact',
  SettingsFormPortalConversationContext = 'SettingsForm.portalConversationContext',
  SettingsFormProvisioned = 'SettingsForm.provisioned',
  SettingsFormPSTN = 'SettingsForm.pstn',
  SettingsFormRunPowershellScript = 'SettingsForm.runPowershellScript',
  SettingsFormSelectedPrimaryCodeWillBeDeleted = 'SettingsForm.selectedPrimaryCodeWillBeDeleted',
  SettingsFormSelectedSecondaryCodeWillBeDeleted = 'SettingsForm.selectedSecondaryCodeWillBeDeleted',
  SettingsFormService = 'SettingsForm.service',
  SettingsFormServiceDisplayName = 'SettingsForm.serviceDisplayName',
  SettingsFormServiceNimbusExtendTitle = 'SettingsForm.serviceNimbusExtend.title',
  SettingsFormServiceNimbusExtendDesc = 'SettingsForm.serviceNimbusExtend.description',
  SettingsFormServiceNimbusUnifyTitle = 'SettingsForm.serviceNimbusUnify.title',
  SettingsFormServiceNimbusUnifyDesc = 'SettingsForm.serviceNimbusUnify.description',
  SettingsFormServiceUPN = 'SettingsForm.serviceUPN',
  SettingsFormShortConversationThreshold = 'SettingsForm.shortConversationThreshold',
  SettingsFormShowAcceptedByOtherUserName = 'SettingsForm.showAcceptedByOtherUserName',
  SettingsFormShowHistoricalSessions = 'SettingsForm.showHistoricalSessions',
  SettingsFormSuccess = 'Settings.formSuccess',
  SettingsFormSuccessPartially = 'Settings.formSuccessPartially',
  SettingsFormTaskPriority = 'SettingsForm.taskPriority',
  SettingsFormTeamCannotBeAccessed = 'Settings.teamCannotBeAccessed',
  SettingsFormTransferOnUserExit = 'SettingsForm.transferOnUserExit',
  SettingsFormTransferOnUserExitMessageInfo = 'SettingsForm.transferOnUserExitMessageInfo',
  SettingsFormTransferOnUserExitUsePstnTransfer = 'SettingsForm.transferOnUserExitUsePstnTransfer',
  SettingsFormTransferOnUserExitUsePstnTransferMessageInfo = 'SettingsForm.transferOnUserExitUsePstnTransferMessageInfo',
  SettingsFormTransferOnUserExitUsePstnTransferMessageWarning = 'SettingsForm.transferOnUserExitUsePstnTransferMessageWarning',
  SettingsFormTransferOnUserExitUsePstnTransferPstnRemovedMessageWarning = 'SettingsForm.transferOnUserExitUsePstnTransferPstnRemovedMessageWarning',
  SettingsFormTriggerFailed = 'Settings.formTriggerFailed',
  SettingsFormTriggerSuccess = 'Settings.formTriggerSuccess',
  SettingsFormUpdateAndTriggerSuccess = 'Settings.formUpdateAndTriggerSuccess',
  SettingsFormUpdateFailed = 'Settings.formUpdateFailed',
  SettingsFormUpdating = 'Settings.formUpdating',
  SettingsFormURLWillBeDeleted = 'SettingsForm.urlWillBeDeleted',
  SettingsFormUser = 'SettingsForm.user',
  SettingsFormUsersActive = 'SettingsForm.users.active',
  SettingsFormUsersMember = 'SettingsForm.users.member',
  SettingsFormUsersName = 'SettingsForm.users.name',
  SettingsFormUsersOwner = 'SettingsForm.users.owner',
  SettingsFormUsersOwnerLimited = 'SettingsForm.users.ownerLimited',
  SettingsFormUsersRole = 'SettingsForm.users.role',
  SettingsFormUsersUpn = 'SettingsForm.users.upn',
  SettingsFormUsersUsers = 'SettingsForm.users.users',
  SettingsFormValueToBeApplied = 'SettingsForm.valueToBeApplied',
  SettingsFormVoiceMessageChannel = 'SettingsForm.voiceMessageChannel',
  SettingsFormVoicemailTranscription = 'SettingsForm.voicemailTranscription',
  SettingsFormVoicemailSection = 'SettingsForm.voicemailSection',
  SettingsFormVoicemailSpeechRecognizer = 'SettingsForm.voicemailSpeechRecognizer',
  SettingsFormWaitingMusic = 'SettingsForm.waitingMusic',
  SettingsFormWaitingMusicHelpText = 'SettingsForm.waitingMusicHelpText',
  SettingsFormWaitingMusicNoPlaylistsAvailable = 'SettingsForm.waitingMusicNoPlaylistsAvailable',
  SettingsFormWaitingMusicNoneOption = 'SettingsForm.waitingMusicNoneOption',
  SettingsFormWaitingMusicPlaylist = 'SettingsForm.waitingMusicPlaylist',
  SettingsFormWaitingMusicResolvedLuwareDefault = 'SettingsForm.waitingMusicResolved.luwareDefault',
  SettingsFormWaitingMusicResolvedOUFavorite = 'SettingsForm.waitingMusicResolved.ouFavorite',
  SettingsFormWaitingMusicResolvedServiceOverride = 'SettingsForm.waitingMusicResolved.serviceOverride',
  SettingsFormWaitingMusicUnavailablePlaylist = 'SettingsForm.waitingMusicUnavailablePlaylist',
  SettingsFormWaitingMusicUnavailablePlaylistTooltip = 'SettingsForm.waitingMusicUnavailablePlaylistTooltip',
  SettingsFormWidgetActiveAVWorkflowLabel = 'Settings.Workflow.serviceWorkflow.activeAVWorkflowLabel',
  SettingsFormWidgetActiveAVWorkflowTitle = 'Settings.Workflow.serviceWorkflow.activeAVWorkflowTitle',
  SettingsFormWidgetActiveAVWorkflowTitleShort = 'Settings.Workflow.serviceWorkflow.activeAVWorkflowTitleShort',
  SettingsFormWidgetActiveByDefault = 'SettingsForm.activeByDefault',
  SettingsFormWidgetActiveEmailLabel = 'Settings.Workflow.serviceWorkflow.activeEmailWorkflowLabel',
  SettingsFormWidgetActiveEmailMailboxErrorMessage = 'Settings.Workflow.serviceWorkflow.activeEmailWorkflowMailboxErrorMessage',
  SettingsFormWidgetActiveEmailMailboxIsAlreadyAssignedMessage = 'Settings.Workflow.serviceWorkflow.activeEmailWorkflowMailboxIsAlreadyAssignedMessage',
  SettingsFormWidgetActiveEmailMailboxLabel = 'Settings.Workflow.serviceWorkflow.activeEmailWorkflowMailboxLabel',
  SettingsFormWidgetActiveEmailMailboxFolderGeneralErrorMessage = 'Settings.Workflow.serviceWorkflow.activeEmailWorkflowMailboxFolderGeneralErrorMessage',
  SettingsFormWidgetActiveEmailMailboxFolderLabel = 'Settings.Workflow.serviceWorkflow.activeEmailWorkflowMailboxFolderLabel',
  SettingsFormWidgetActiveEmailMailboxFolderNoMailboxMessage = 'Settings.Workflow.serviceWorkflow.activeEmailWorkflowMailboxFolderNoMailboxMessage',
  SettingsFormWidgetActiveEmailMailboxNoPermissionsMessage = 'Settings.Workflow.serviceWorkflow.activeEmailWorkflowMailboxNoPermissionsMessage',
  SettingsFormWidgetActiveEmailMailboxNotFoundMessage = 'Settings.Workflow.serviceWorkflow.activeEmailWorkflowMailboxNotFoundMessage',
  SettingsFormWidgetActiveEmailMailboxSubscribedMessage = 'Settings.Workflow.serviceWorkflow.activeEmailWorkflowMailboxSubscribedMessage',
  SettingsFormWidgetActiveEmailMailboxSubscriptionNotFoundMessage = 'Settings.Workflow.serviceWorkflow.activeEmailWorkflowMailboxSubscriptionNotFoundMessage',
  SettingsFormWidgetActiveEmailTitle = 'Settings.Workflow.serviceWorkflow.activeEmailWorkflowTitle',
  SettingsFormWidgetActiveETLabel = 'Settings.Workflow.serviceWorkflow.activeETWorkflowLabel',
  SettingsFormWidgetActiveETTitle = 'Settings.Workflow.serviceWorkflow.activeETWorkflowTitle',
  SettingsFormWidgetActiveIMInteractLabel = 'Settings.Workflow.serviceWorkflow.activeIMInteractLabel',
  SettingsFormWidgetActiveIMInteractWorkflowLabel = 'Settings.Workflow.serviceWorkflow.activeIMInteractWorkflowLabel',
  SettingsFormWidgetActiveIMInteractWorkflowResult = 'Settings.Workflow.serviceWorkflow.activeIMInteractWorkflowResult',
  SettingsFormWidgetActiveIMSmsLabel = 'Settings.Workflow.serviceWorkflow.activeIMSmsLabel',
  SettingsFormWidgetActiveIMSmsWorkflowLabel = 'Settings.Workflow.serviceWorkflow.activeIMSmsWorkflowLabel',
  SettingsFormWidgetActiveIMSmsWorkflowResult = 'Settings.Workflow.serviceWorkflow.activeIMSmsWorkflowResult',
  SettingsFormWidgetActiveIMWhatsappLabel = 'Settings.Workflow.serviceWorkflow.activeIMWhatsappLabel',
  SettingsFormWidgetActiveIMWhatsappWorkflowLabel = 'Settings.Workflow.serviceWorkflow.activeIMWhatsappWorkflowLabel',
  SettingsFormWidgetActiveIMWhatsappWorkflowResult = 'Settings.Workflow.serviceWorkflow.activeIMWhatsappWorkflowResult',
  SettingsFormWidgetActiveIMWorkflowLabel = 'Settings.Workflow.serviceWorkflow.activeIMWorkflowLabel',
  SettingsFormWidgetActiveIMWorkflowTitle = 'Settings.Workflow.serviceWorkflow.activeIMWorkflowTitle',
  SettingsFormWidgetActiveIMWorkflowTitleShort = 'Settings.Workflow.serviceWorkflow.activeIMWorkflowTitleShort',
  SettingsFormWidgetActiveOutboundAVWorkflowLabel = 'Settings.Workflow.serviceWorkflow.activeOutboundAVWorkflowLabel',
  SettingsFormWidgetActiveSmsMessagingEntryLabel = 'Settings.Workflow.serviceWorkflow.activeSmsMessagingEntryLabel',
  SettingsFormWidgetActiveSmsMessagingEntryResult = 'Settings.Workflow.serviceWorkflow.activeSmsMessagingEntryResult',
  SettingsFormWidgetActiveSmsSystemMessageLabel = 'Settings.Workflow.serviceWorkflow.activeSmsSystemMessageLabel',
  SettingsFormWidgetActiveSmsSystemMessageResult = 'Settings.Workflow.serviceWorkflow.activeSmsSystemMessageResult',
  SettingsFormWidgetActiveSmsWorkflowLabel = 'Settings.Workflow.serviceWorkflow.activeSmsWorkflowLabel',
  SettingsFormWidgetActiveWhatsappMessagingEntryLabel = 'Settings.Workflow.serviceWorkflow.activeWhatsappMessagingEntryLabel',
  SettingsFormWidgetActiveWhatsappMessagingEntryResult = 'Settings.Workflow.serviceWorkflow.activeWhatsappMessagingEntryResult',
  SettingsFormWidgetActiveWhatsappSystemMessageLabel = 'Settings.Workflow.serviceWorkflow.activeWhatsappSystemMessageLabel',
  SettingsFormWidgetActiveWhatsappSystemMessageResult = 'Settings.Workflow.serviceWorkflow.activeWhatsappSystemMessageResult',
  SettingsFormWidgetActiveWhatsappWorkflowLabel = 'Settings.Workflow.serviceWorkflow.activeWhatsappWorkflowLabel',
  SettingsFormWidgetActiveWorkflow = 'SettingsForm.activeWorkflow',
  SettingsFormWidgetAudioLanguage = 'SettingsForm.audioLanguage',
  SettingsFormWidgetAvailableIs = 'SettingsForm.availableIs',
  SettingsFormWidgetAvailablePresenceStates = 'SettingsForm.availablePresenceStates',
  SettingsFormWidgetAwayIs = 'SettingsForm.awayIs',
  SettingsFormWidgetBusyIs = 'SettingsForm.busyIs',
  SettingsFormWidgetDoNotDisturbIs = 'SettingsForm.doNotDisturbIs',
  SettingsFormWidgetHideUserStatistic = 'SettingsForm.hideUserStatistic',
  SettingsFormWidgetInACallAvailable = 'SettingsForm.inACallAvailable',
  SettingsFormWidgetInAMeetingAvailable = 'SettingsForm.inAMeetingAvailable',
  SettingsFormWidgetOfflineIs = 'SettingsForm.offlineIs',
  SettingsFormWidgetParallelTasksBlockingModeTitle = 'Settings.Workflow.serviceWorkflow.parallelTasksBlockingModeTitle',
  SettingsFormWidgetParallelTasksBlockingModeBlocking = 'Settings.Workflow.serviceWorkflow.parallelTasksBlockingModeBlocking',
  SettingsFormWidgetParallelTasksBlockingModeBlockingExceptAV = 'Settings.Workflow.serviceWorkflow.parallelTasksBlockingModeBlockingExceptAV',
  SettingsFormWidgetParallelTasksBlockingModeNonBlocking = 'Settings.Workflow.serviceWorkflow.parallelTasksBlockingModeNonBlocking',
  SettingsFormWidgetParallelTasksBlockingModeShortTitle = 'Settings.Workflow.serviceWorkflow.parallelTasksBlockingModeShortTitle',
  SettingsFormWidgetReporting = 'SettingsForm.reporting',
  SettingsFormWidgetSLAAcceptanceTime = 'SettingsForm.acceptanceTime',
  SettingsFormWidgetSLAHangupTime = 'SettingsForm.hangupTime',
  SettingsFormWidgetSpeechRecognizer = 'SettingsForm.speechRecognizer',
  SettingsFormWidgetSummarizedItems = 'SettingsForm.summarizedItems',
  SettingsFormEnabledForMySessions = 'SettingsForm.enabledForMySessions',
  SettingsFormDataStorageEnabled = 'SettingsForm.dataStorageEnabled',
  SettingsFormDataStorageEnabledWarning = 'SettingsForm.dataStorageEnabledWarning',
  SettingsFormCompanionCodeSuggestionsAutoAssign = 'SettingsForm.companionCodeSuggestionsAutoAssign',
  SettingsFormCompanionAutoAssignDelay = 'SettingsForm.companionAutoAssignDelay',
  SettingsFormCompanionSuggestionsAutoAssignTitle = 'SettingsForm.companionSuggestionsAutoAssignTitle',
  SettingsFormCompanionSpeechRecognizerWarning = 'SettingsForm.companionSpeechRecognizerWarning',
  SettingsFormCompanionOutboundTranscriptionNote = 'SettingsForm.companionOutboundTranscriptionNote',
  SettingsFormCompanionTagSuggestionsAutoAssign = 'SettingsForm.companionTagSuggestionsAutoAssign',
  SettingsFormCompanionTagSuggestionsLanguage = 'SettingsForm.companionTagSuggestionsLanguage',
  SettingsFormCompanionTagSuggestionsLanguageHint = 'SettingsForm.companionTagSuggestionsLanguageHint',
  SettingsFormCompanionUnifyLanguages = 'SettingsForm.companionUnifyLanguages',
  SettingsFormCompanionUnifyLanguagesMaxTooltip = 'SettingsForm.companionUnifyLanguagesMaxTooltip',
  SettingsFormCompanionUnifyLanguagesBaseDuplicateTooltip = 'SettingsForm.companionUnifyLanguagesBaseDuplicateTooltip',
  SettingsFormCompanionUnifySentimentAnalysis = 'SettingsForm.companionUnifySentimentAnalysis',
  SettingsFormTenantDataPrivacyWarning = 'SettingsForm.tenantDataPrivacyWarning',
  SettingsFormTenantDataPrivacyWarningCompanion = 'SettingsForm.tenantDataPrivacyWarningCompanion',
  SettingsFormTenantDataPrivacyWarningVirtualUser = 'SettingsForm.tenantDataPrivacyWarningVirtualUser',
  SettingsFormWidgetVirtualLiveCaptioning = 'SettingsForm.virtualLiveCaptioning',
  SettingsFormWidgetVirtualAudioTranscription = 'SettingsForm.virtualAudioTranscription',
  SettingsFormWidgetVirtualCloseCaptioning = 'SettingsForm.virtualCloseCaptioning',
  SettingsFormWidgetVirtualRealTimeTranscription = 'SettingsForm.virtualRealTimeTranscription',
  SettingsFormWidgetVirtualTaskAssistant = 'SettingsForm.virtualTaskAssistant',
  SettingsFormWidgetVirtualUserAssistant = 'SettingsForm.virtualUserAssistant',
  SettingsFormWidgetVirtualAssistants = 'SettingsForm.virtualAssistants',
  SettingsFormWidgetVirtualVoiceTranscription = 'SettingsForm.virtualVoiceTranscription',
  SettingsFormWidgetWorkflow = 'SettingsForm.workflow',
  SettingsOpenLoginWindowOnStartup = 'Settings.openLoginWindowOnStartup',
  SettingsPreCallInfo = 'Settings.preCallInfo',
  SettingsPreCallInfoCallFlow = 'Settings.preCallInfoCallFlow',
  SettingsPreCallInfoInfo = 'Settings.preCallInfoInfo',
  SettingsSaveAndApply = 'Settings.saveAndApply',
  SettingsSaveAndTrigger = 'Settings.saveAndTrigger',
  SettingsShowPreCallInfo = 'Settings.showPreCallInfo',
  SettingsTabsAgents = 'Settings.Tabs.agents',
  SettingsTabsContext = 'Settings.Tabs.context',
  SettingsTabsDataPrivacy = 'Settings.Tabs.dataPrivacy',
  SettingsTabsDistribution = 'Settings.Tabs.distribution',
  SettingsTabsExtensions = 'Settings.Tabs.extensions',
  SettingsTabsGeneral = 'Settings.Tabs.general',
  SettingsTabsInteract = 'Settings.Tabs.interact',
  SettingsTabsModalities = 'Settings.Tabs.modalities',
  SettingsTabsPermission = 'Settings.Tabs.permission',
  SettingsTabsUsers = 'Settings.Tabs.users',
  SettingsTabsCompanion = 'Settings.Tabs.companion',
  SettingsUnsavedChanges = 'Settings.unsavedChanges',
  SettingsUnsavedChangesQuestion = 'Settings.unsavedChangesQuestion',
  SettingsUnsavedChangesQuestionWithoutSave = 'Settings.unsavedChangesQuestionWithoutSave',
  SettingsWorkflowServiceImSystemMessageLabel = 'Settings.Workflow.serviceImSystemMessage',
  TaskFlowVisualizerAgentShareOfHandled = 'TaskFlowVisualizer.agent.shareOfHandled',
  TaskFlowVisualizerAgentTooltip = 'TaskFlowVisualizer.agent.tooltip',
  TaskFlowVisualizerAgentUnassigned = 'TaskFlowVisualizer.agent.unassigned',
  TaskFlowVisualizerAgentUnknown = 'TaskFlowVisualizer.agent.unknown',
  TaskFlowVisualizerAgentVoicemail = 'TaskFlowVisualizer.agent.voicemail',
  TaskFlowVisualizerAgentWaitAndShare = 'TaskFlowVisualizer.agent.waitAndShare',
  TaskFlowVisualizerAgentsLabel = 'TaskFlowVisualizer.agentsLabel',
  TaskFlowVisualizerAverageQueueForHandled = 'TaskFlowVisualizer.averageQueueForHandled',
  TaskFlowVisualizerBucketsAdd = 'TaskFlowVisualizer.buckets.add',
  TaskFlowVisualizerBucketsAlwaysVisibleHint = 'TaskFlowVisualizer.buckets.alwaysVisibleHint',
  TaskFlowVisualizerBucketsChipTooltip = 'TaskFlowVisualizer.buckets.chipTooltip',
  TaskFlowVisualizerBucketsColorLabel = 'TaskFlowVisualizer.buckets.colorLabel',
  TaskFlowVisualizerBucketsEditOutcomes = 'TaskFlowVisualizer.buckets.editOutcomes',
  TaskFlowVisualizerBucketsFailureFixedHint = 'TaskFlowVisualizer.buckets.failureFixedHint',
  TaskFlowVisualizerBucketsFailureHint = 'TaskFlowVisualizer.buckets.failureHint',
  TaskFlowVisualizerBucketsFailureLabel = 'TaskFlowVisualizer.buckets.failureLabel',
  TaskFlowVisualizerBucketsGroupsLabel = 'TaskFlowVisualizer.buckets.groupsLabel',
  TaskFlowVisualizerBucketsHidden = 'TaskFlowVisualizer.buckets.hidden',
  TaskFlowVisualizerBucketsHint = 'TaskFlowVisualizer.buckets.hint',
  TaskFlowVisualizerBucketsMoveDown = 'TaskFlowVisualizer.buckets.moveDown',
  TaskFlowVisualizerBucketsMoveUp = 'TaskFlowVisualizer.buckets.moveUp',
  TaskFlowVisualizerBucketsNameLabel = 'TaskFlowVisualizer.buckets.nameLabel',
  TaskFlowVisualizerBucketsNoOutcomes = 'TaskFlowVisualizer.buckets.noOutcomes',
  TaskFlowVisualizerBucketsOpen = 'TaskFlowVisualizer.buckets.open',
  TaskFlowVisualizerBucketsOutcomeCount = 'TaskFlowVisualizer.buckets.outcomeCount',
  TaskFlowVisualizerBucketsOutcomeOwner = 'TaskFlowVisualizer.buckets.outcomeOwner',
  TaskFlowVisualizerBucketsOutcomes = 'TaskFlowVisualizer.buckets.outcomes',
  TaskFlowVisualizerBucketsOutcomesOf = 'TaskFlowVisualizer.buckets.outcomesOf',
  TaskFlowVisualizerBucketsRemove = 'TaskFlowVisualizer.buckets.remove',
  TaskFlowVisualizerBucketsRemoveFixed = 'TaskFlowVisualizer.buckets.removeFixed',
  TaskFlowVisualizerBucketsRemoveMinimum = 'TaskFlowVisualizer.buckets.removeMinimum',
  TaskFlowVisualizerBucketsReset = 'TaskFlowVisualizer.buckets.reset',
  TaskFlowVisualizerBucketsSelectedCount = 'TaskFlowVisualizer.buckets.selectedCount',
  TaskFlowVisualizerBucketsTitle = 'TaskFlowVisualizer.buckets.title',
  TaskFlowVisualizerBucketsUnassigned = 'TaskFlowVisualizer.buckets.unassigned',
  TaskFlowVisualizerBucketsUnnamed = 'TaskFlowVisualizer.buckets.unnamed',
  TaskFlowVisualizerBucketsVisibleHint = 'TaskFlowVisualizer.buckets.visibleHint',
  TaskFlowVisualizerBucketsVisibleLabel = 'TaskFlowVisualizer.buckets.visibleLabel',
  TaskFlowVisualizerCounterDropOff = 'TaskFlowVisualizer.counter.dropOff',
  TaskFlowVisualizerDestinationKindExternal = 'TaskFlowVisualizer.destinationKind.external',
  TaskFlowVisualizerDestinationKindOther = 'TaskFlowVisualizer.destinationKind.other',
  TaskFlowVisualizerDestinationKindService = 'TaskFlowVisualizer.destinationKind.service',
  TaskFlowVisualizerDestinationKindUnknown = 'TaskFlowVisualizer.destinationKind.unknown',
  TaskFlowVisualizerDestinationKindUser = 'TaskFlowVisualizer.destinationKind.user',
  TaskFlowVisualizerDrilldownAcceptedTasks = 'TaskFlowVisualizer.drilldown.acceptedTasks',
  TaskFlowVisualizerDrilldownDestinations = 'TaskFlowVisualizer.drilldown.destinations',
  TaskFlowVisualizerDrilldownEmptyDescription = 'TaskFlowVisualizer.drilldown.emptyDescription',
  TaskFlowVisualizerDrilldownEmptyTitle = 'TaskFlowVisualizer.drilldown.emptyTitle',
  TaskFlowVisualizerDrilldownHandledTasks = 'TaskFlowVisualizer.drilldown.handledTasks',
  TaskFlowVisualizerDrilldownInboundTasks = 'TaskFlowVisualizer.drilldown.inboundTasks',
  TaskFlowVisualizerDrilldownOutboundTasks = 'TaskFlowVisualizer.drilldown.outboundTasks',
  TaskFlowVisualizerDrilldownOutcomeMix = 'TaskFlowVisualizer.drilldown.outcomeMix',
  TaskFlowVisualizerDrilldownRank = 'TaskFlowVisualizer.drilldown.rank',
  TaskFlowVisualizerDrilldownShareOfAccepted = 'TaskFlowVisualizer.drilldown.shareOfAccepted',
  TaskFlowVisualizerDrilldownShareOfHandled = 'TaskFlowVisualizer.drilldown.shareOfHandled',
  TaskFlowVisualizerDrilldownTitle = 'TaskFlowVisualizer.drilldown.title',
  TaskFlowVisualizerDrilldownTopHandler = 'TaskFlowVisualizer.drilldown.topHandler',
  TaskFlowVisualizerDropoffTitle = 'TaskFlowVisualizer.dropoff.title',
  TaskFlowVisualizerHistogramBarTooltip = 'TaskFlowVisualizer.histogram.barTooltip',
  TaskFlowVisualizerHistogramEmpty = 'TaskFlowVisualizer.histogram.empty',
  TaskFlowVisualizerHistogramNow = 'TaskFlowVisualizer.histogram.now',
  TaskFlowVisualizerHistogramRange30D = 'TaskFlowVisualizer.histogram.range.30d',
  TaskFlowVisualizerHistogramRange48H = 'TaskFlowVisualizer.histogram.range.48h',
  TaskFlowVisualizerHistogramRange7D = 'TaskFlowVisualizer.histogram.range.7d',
  TaskFlowVisualizerHistogramRangeLabel = 'TaskFlowVisualizer.histogram.rangeLabel',
  TaskFlowVisualizerHistogramRangeToday = 'TaskFlowVisualizer.histogram.range.today',
  TaskFlowVisualizerHistogramSpan30D = 'TaskFlowVisualizer.histogram.span.30d',
  TaskFlowVisualizerHistogramSpan48H = 'TaskFlowVisualizer.histogram.span.48h',
  TaskFlowVisualizerHistogramSpan7D = 'TaskFlowVisualizer.histogram.span.7d',
  TaskFlowVisualizerHistogramSpanToday = 'TaskFlowVisualizer.histogram.span.today',
  TaskFlowVisualizerHistogramTitle = 'TaskFlowVisualizer.histogram.title',
  TaskFlowVisualizerKpiAcceptanceSla = 'TaskFlowVisualizer.kpi.acceptanceSla',
  TaskFlowVisualizerKpiAcceptedTasks = 'TaskFlowVisualizer.kpi.acceptedTasks',
  TaskFlowVisualizerKpiAveragePerTask = 'TaskFlowVisualizer.kpi.averagePerTask',
  TaskFlowVisualizerKpiDropOffTasks = 'TaskFlowVisualizer.kpi.dropOffTasks',
  TaskFlowVisualizerKpiDropOffTasksHint = 'TaskFlowVisualizer.kpi.dropOffTasksHint',
  TaskFlowVisualizerKpiHandledTasks = 'TaskFlowVisualizer.kpi.handledTasks',
  TaskFlowVisualizerKpiHandledTasksHint = 'TaskFlowVisualizer.kpi.handledTasksHint',
  TaskFlowVisualizerKpiQueueTime = 'TaskFlowVisualizer.kpi.queueTime',
  TaskFlowVisualizerKpiQueueTimeHint = 'TaskFlowVisualizer.kpi.queueTimeHint',
  TaskFlowVisualizerKpiShareOfHandled = 'TaskFlowVisualizer.kpi.shareOfHandled',
  TaskFlowVisualizerKpiShareOfIncoming = 'TaskFlowVisualizer.kpi.shareOfIncoming',
  TaskFlowVisualizerKpiSla = 'TaskFlowVisualizer.kpi.sla',
  TaskFlowVisualizerKpiSlaHint = 'TaskFlowVisualizer.kpi.slaHint',
  TaskFlowVisualizerKpiStillInQueue = 'TaskFlowVisualizer.kpi.stillInQueue',
  TaskFlowVisualizerKpiTotalTasks = 'TaskFlowVisualizer.kpi.totalTasks',
  TaskFlowVisualizerKpiTotalTasksHint = 'TaskFlowVisualizer.kpi.totalTasksHint',
  TaskFlowVisualizerKpiUnderSla = 'TaskFlowVisualizer.kpi.underSla',
  TaskFlowVisualizerLaneAccepted = 'TaskFlowVisualizer.lane.accepted',
  TaskFlowVisualizerLaneFailed = 'TaskFlowVisualizer.lane.failed',
  TaskFlowVisualizerLaneFailedHint = 'TaskFlowVisualizer.lane.failedHint',
  TaskFlowVisualizerLaneHandled = 'TaskFlowVisualizer.lane.handled',
  TaskFlowVisualizerLaneHandledHint = 'TaskFlowVisualizer.lane.handledHint',
  TaskFlowVisualizerLaneHandledTotal = 'TaskFlowVisualizer.lane.handledTotal',
  TaskFlowVisualizerLaneHangUp = 'TaskFlowVisualizer.lane.hangUp',
  TaskFlowVisualizerLaneHangUpHint = 'TaskFlowVisualizer.lane.hangUpHint',
  TaskFlowVisualizerLaneInQueue = 'TaskFlowVisualizer.lane.inQueue',
  TaskFlowVisualizerLaneInQueueHint = 'TaskFlowVisualizer.lane.inQueueHint',
  TaskFlowVisualizerLaneIncoming = 'TaskFlowVisualizer.lane.incoming',
  TaskFlowVisualizerLaneIncomingHint = 'TaskFlowVisualizer.lane.incomingHint',
  TaskFlowVisualizerLaneLostAborted = 'TaskFlowVisualizer.lane.lostAborted',
  TaskFlowVisualizerLaneLostAbortedHint = 'TaskFlowVisualizer.lane.lostAbortedHint',
  TaskFlowVisualizerLaneOther = 'TaskFlowVisualizer.lane.other',
  TaskFlowVisualizerLaneOtherHint = 'TaskFlowVisualizer.lane.otherHint',
  TaskFlowVisualizerLaneOutgoing = 'TaskFlowVisualizer.lane.outgoing',
  TaskFlowVisualizerLaneOutgoingHint = 'TaskFlowVisualizer.lane.outgoingHint',
  TaskFlowVisualizerLive = 'TaskFlowVisualizer.live',
  TaskFlowVisualizerLiveHint = 'TaskFlowVisualizer.liveHint',
  TaskFlowVisualizerLivePaused = 'TaskFlowVisualizer.livePaused',
  TaskFlowVisualizerLiveUpdatedJustNow = 'TaskFlowVisualizer.liveUpdatedJustNow',
  TaskFlowVisualizerLiveUpdatedMinutes = 'TaskFlowVisualizer.liveUpdatedMinutes',
  TaskFlowVisualizerLoadDisabled = 'TaskFlowVisualizer.loadDisabled',
  TaskFlowVisualizerLoadFailed = 'TaskFlowVisualizer.loadFailed',
  TaskFlowVisualizerLoadForbidden = 'TaskFlowVisualizer.loadForbidden',
  TaskFlowVisualizerModeLive = 'TaskFlowVisualizer.mode.live',
  TaskFlowVisualizerModeLiveHint = 'TaskFlowVisualizer.mode.liveHint',
  TaskFlowVisualizerModeReplay = 'TaskFlowVisualizer.mode.replay',
  TaskFlowVisualizerModeReplayButton = 'TaskFlowVisualizer.mode.replayButton',
  TaskFlowVisualizerModeReplayHint = 'TaskFlowVisualizer.mode.replayHint',
  TaskFlowVisualizerOrientationSwitchToLeftToRight = 'TaskFlowVisualizer.orientation.switchToLeftToRight',
  TaskFlowVisualizerOrientationSwitchToTopDown = 'TaskFlowVisualizer.orientation.switchToTopDown',
  TaskFlowVisualizerOverviewDayTasksTooltip = 'TaskFlowVisualizer.overview.dayTasksTooltip',
  TaskFlowVisualizerOverviewDayTooltip = 'TaskFlowVisualizer.overview.dayTooltip',
  TaskFlowVisualizerOverviewEmpty = 'TaskFlowVisualizer.overview.empty',
  TaskFlowVisualizerOverviewFailed = 'TaskFlowVisualizer.overview.failed',
  TaskFlowVisualizerOverviewRangeDays = 'TaskFlowVisualizer.overview.rangeDays',
  TaskFlowVisualizerOverviewRangeLabel = 'TaskFlowVisualizer.overview.rangeLabel',
  TaskFlowVisualizerOverviewSelectedDayTasksTooltip = 'TaskFlowVisualizer.overview.selectedDayTasksTooltip',
  TaskFlowVisualizerOverviewSelectedDayTooltip = 'TaskFlowVisualizer.overview.selectedDayTooltip',
  TaskFlowVisualizerOverviewTitle = 'TaskFlowVisualizer.overview.title',
  TaskFlowVisualizerOverviewTotal = 'TaskFlowVisualizer.overview.total',
  TaskFlowVisualizerRangeLabel = 'TaskFlowVisualizer.rangeLabel',
  TaskFlowVisualizerReconnecting = 'TaskFlowVisualizer.reconnecting',
  TaskFlowVisualizerRefresh = 'TaskFlowVisualizer.refresh',
  TaskFlowVisualizerReplayEmpty = 'TaskFlowVisualizer.replay.empty',
  TaskFlowVisualizerReplayLoading = 'TaskFlowVisualizer.replay.loading',
  TaskFlowVisualizerReplayLoopOff = 'TaskFlowVisualizer.replay.loopOff',
  TaskFlowVisualizerReplayLoopOn = 'TaskFlowVisualizer.replay.loopOn',
  TaskFlowVisualizerReplayPause = 'TaskFlowVisualizer.replay.pause',
  TaskFlowVisualizerReplayPlay = 'TaskFlowVisualizer.replay.play',
  TaskFlowVisualizerReplayPlaybackHint = 'TaskFlowVisualizer.replay.playbackHint',
  TaskFlowVisualizerReplayPlaybackLabel = 'TaskFlowVisualizer.replay.playbackLabel',
  TaskFlowVisualizerReplayPlaybackMinutes = 'TaskFlowVisualizer.replay.playbackMinutes',
  TaskFlowVisualizerReplayPlaybackSeconds = 'TaskFlowVisualizer.replay.playbackSeconds',
  TaskFlowVisualizerReplayPosition = 'TaskFlowVisualizer.replay.position',
  TaskFlowVisualizerReplaySlotTooltip = 'TaskFlowVisualizer.replay.slotTooltip',
  TaskFlowVisualizerReplayTasks = 'TaskFlowVisualizer.replay.tasks',
  TaskFlowVisualizerReplayTruncated = 'TaskFlowVisualizer.replay.truncated',
  TaskFlowVisualizerReplayWholeDay = 'TaskFlowVisualizer.replay.wholeDay',
  TaskFlowVisualizerReplayWholeDayHint = 'TaskFlowVisualizer.replay.wholeDayHint',
  TaskFlowVisualizerReplayWindowHint = 'TaskFlowVisualizer.replay.windowHint',
  TaskFlowVisualizerReplayWindowLabel = 'TaskFlowVisualizer.replay.windowLabel',
  TaskFlowVisualizerReportingFallbackNotice = 'TaskFlowVisualizer.reportingFallbackNotice',
  TaskFlowVisualizerShowAgents = 'TaskFlowVisualizer.showAgents',
  TaskFlowVisualizerShowAllAgents = 'TaskFlowVisualizer.showAllAgents',
  TaskFlowVisualizerStatesHidden = 'TaskFlowVisualizer.statesHidden',
  TaskFlowVisualizerStatesLabel = 'TaskFlowVisualizer.statesLabel',
  TaskFlowVisualizerTallyTooltip = 'TaskFlowVisualizer.tallyTooltip',
  TaskFlowVisualizerTopAgentsHint = 'TaskFlowVisualizer.topAgentsHint',
  TaskFlowVisualizerWindowHint = 'TaskFlowVisualizer.window.hint',
  TaskFlowVisualizerWindowHours = 'TaskFlowVisualizer.window.hours',
  TaskFlowVisualizerWindowToday = 'TaskFlowVisualizer.window.today',
  TaskFlowVisualizerWindowMinutes = 'TaskFlowVisualizer.window.minutes',
  TaskListCallCannotBeRemoved = 'TaskList.callCannotBeRemoved',
  TaskListCannotDownloadTraces = 'TaskList.cannotDownloadTraces',
  TaskListCustomer = 'TaskList.customer',
  TaskListDownloadAnonymizedTrace = 'TaskList.downloadAnonymizedTrace',
  TaskListDownloadRawTrace = 'TaskList.downloadRawTrace',
  TaskListDownloadTraces = 'TaskList.downloadTraces',
  TaskListIssues = 'TaskList.issues',
  TaskListNoTasks = 'TaskList.noTasks',
  TaskListRefresh = 'TaskList.refresh',
  TaskListRemoveTask = 'TaskList.removeTask',
  TaskListSource = 'TaskList.source',
  TaskListStartTime = 'TaskList.startTime',
  TaskListState = 'TaskList.state',
  TaskListTimeInState = 'TaskList.timeInState',
  TaskListTitle = 'TaskList.title',
  TaskListUsers = 'TaskList.users',
  TaskTranscriptionLicenseMissing = 'TaskTranscription.licenseMissing',
  TaskTranscriptionConsentDenied = 'TaskTranscription.consentDenied',
  TaskTranscriptionTranscriptionNotAvailable = 'TaskTranscription.transcriptionNotAvailable',
  TeamApiError = 'TeamApi.error',
  TeamsInQueue = 'Teams.inQueue',
  TeamsName = 'Teams.name',
  ThemeSettingBrowser = 'ThemeSetting.browser',
  ThemeSettingDark = 'ThemeSetting.dark',
  ThemeSettingLight = 'ThemeSetting.light',
  UnifiedSessionsAcwTime = 'UnifiedSessions.acwTime',
  UnifiedSessionsConnectedTime = 'UnifiedSessions.connectedTime',
  UnifiedSessionsDateAndTime = 'UnifiedSessions.dateAndTime',
  UnifiedSessionsDuration = 'UnifiedSessions.duration',
  UnifiedSessionsInitialService = 'UnifiedSessions.initialService',
  UnifiedSessionsInteractions = 'UnifiedSessions.interactions',
  UnifiedSessionsIvr = 'UnifiedSessions.ivr',
  UnifiedSessionsMaskedData = 'UnifiedSessions.maskedData',
  UnifiedSessionsMaskedUserName = 'UnifiedSessions.maskedUserName',
  UnifiedSessionsMaskedServiceName = 'UnifiedSessions.maskedServiceName',
  UnifiedSessionsOutcomeExternalSystemCancelled = 'UnifiedSessions.Outcome.externalSystemCancelled',
  UnifiedSessionsOutcomeExternalSystemCancelledAfterQueue = 'UnifiedSessions.Outcome.externalSystemCancelledAfterQueue',
  UnifiedSessionsOutcomeExternalSystemCancelledBeforeAccept = 'UnifiedSessions.Outcome.externalSystemCancelledBeforeAccept',
  UnifiedSessionsOutcomeExternalSystemCancelledInQueue = 'UnifiedSessions.Outcome.externalSystemCancelledInQueue',
  UnifiedSessionsInitialCallerQueueTime = 'UnifiedSessions.initialCallerQueueTime',
  UnifiedSessionsQueueTime = 'UnifiedSessions.queueTime',
  UnifiedSessionsResult = 'UnifiedSessions.result',
  UnifiedSessionsRingTime = 'UnifiedSessions.ringTime',
  UnifiedSessionsSearchPlaceholderMessage = 'UnifiedSessions.searchPlaceholderMessage',
  UnifiedSessionsServiceSessions = 'UnifiedSessions.serviceSessions',
  UnifiedSessionsStep = 'UnifiedSessions.step',
  UnifiedSessionsUserSessions = 'UnifiedSessions.userSessions',
  UnifiedSessionsVoicemailTranscript = 'UnifiedSessions.voicemailTranscript',
  UserNotReadyReasonNone = 'User.NotReadyReason.None',
  UserNotReadyReasonPresenceUnknown = 'User.NotReadyReason.PresenceUnknown',
  UserNotReadyReasonPresenceOffline = 'User.NotReadyReason.PresenceOffline',
  UserNotReadyReasonPresenceAppearOffline = 'User.NotReadyReason.PresenceAppearOffline',
  UserNotReadyReasonPresenceAway = 'User.NotReadyReason.PresenceAway',
  UserNotReadyReasonPresenceBeRightBack = 'User.NotReadyReason.PresenceBeRightBack',
  UserNotReadyReasonPresenceBusy = 'User.NotReadyReason.PresenceBusy',
  UserNotReadyReasonPresenceBusyInACall = 'User.NotReadyReason.PresenceBusyInACall',
  UserNotReadyReasonPresenceBusyInAMeeting = 'User.NotReadyReason.PresenceBusyInAMeeting',
  UserNotReadyReasonPresenceDoNotDisturb = 'User.NotReadyReason.PresenceDoNotDisturb',
  UserNotReadyReasonTaskStateOnATask = 'User.NotReadyReason.TaskStateOnATask',
  UserNotReadyReasonTaskStateOnATaskBlocking = 'User.NotReadyReason.TaskStateOnATaskBlocking',
  UserNotReadyReasonTaskStateInRona = 'User.NotReadyReason.TaskStateInRona',
  UserNotReadyReasonTaskStateInACW = 'User.NotReadyReason.TaskStateInACW',
  UserNotReadyReasonTaskStateInExtendedACW = 'User.NotReadyReason.TaskStateInExtendedACW',
  UserNotReadyReasonTaskStateTaskLimitReached = 'User.NotReadyReason.TaskStateTaskLimitReached',
  UserNotReadyReasonDutyStateEmpty = 'User.NotReadyReason.DutyStateEmpty',
  UserNotReadyReasonDutyStateInactive = 'User.NotReadyReason.DutyStateInactive',
  UserNotReadyReasonDutyStateOffDuty = 'User.NotReadyReason.DutyStateOffDuty',
  UserNotReadyReasonDutyStateOffDutyAndInactive = 'User.NotReadyReason.DutyStateOffDutyAndInactive',
  UserNotReadyReasonOnServiceLevelAway = 'User.NotReadyReasonOnServiceLevel.Away',
  UserNotReadyReasonOnServiceLevelBusy = 'User.NotReadyReasonOnServiceLevel.Busy',
  UserNotReadyReasonOnServiceLevelGeneralNotReady = 'User.NotReadyReasonOnServiceLevel.GeneralNotReady',
  UserNotReadyReasonOnServiceLevelInACall = 'User.NotReadyReasonOnServiceLevel.InACall',
  UserNotReadyReasonOnServiceLevelInAMeeting = 'User.NotReadyReasonOnServiceLevel.InAMeeting',
  UserNotReadyReasonOnServiceLevelNone = 'User.NotReadyReasonOnServiceLevel.None',
  UserPreferencesACPipelineClientSideLogging = 'UserPreferences.logging.acPipelineClientSideLogging',
  UserPreferencesBotImSignaling = 'UserPreferences.bot.imSignaling',
  UserPreferencesBotImSignalingDescription = 'UserPreferences.bot.imSignalingDescription',
  UserPreferencesBotImSignalingNotRegistered = 'UserPreferences.bot.notRegistered',
  UserPreferencesBotImSignalingRegister = 'UserPreferences.bot.register',
  UserPreferencesBotImSignalingRegistered = 'UserPreferences.bot.registered',
  UserPreferencesBotImSignalingRegisterTitle = 'UserPreferences.bot.registerTitle',
  UserPreferencesBotRegistration = 'UserPreferences.bot.registration',
  UserPreferencesCapturedLogs = 'UserPreferences.logging.capturedLogs',
  UserPreferencesClientSideLogging = 'UserPreferences.logging.clientSideLogging',
  UserPreferencesEnvironmentLabel = 'UserPreferences.environment.label',
  UserPreferencesMSALClientSideLogging = 'UserPreferences.logging.msalRClientSideLogging',
  UserPreferencesNimbusManifestDescription = 'UserPreferences.nimbusManifest.description',
  UserPreferencesNimbusManifestHowTo = 'UserPreferences.nimbusManifest.howTo',
  UserPreferencesNimbusManifestImDescription = 'UserPreferences.nimbusManifestIm.description',
  UserPreferencesNimbusManifestImHowTo = 'UserPreferences.nimbusManifestIm.howTo',
  UserPreferencesNimbusAssistantDescription = 'UserPreferences.nimbusAssistant.description',
  UserPreferencesNimbusAssistantHowTo = 'UserPreferences.nimbusAssistant.howTo',
  UserPreferencesNimbusAssistantLabel = 'UserPreferences.nimbusAssistant.label',
  UserPreferencesNimbusAssistantTooltip = 'UserPreferences.nimbusAssistant.tooltip',
  UserPreferencesNimbusManifestLabel = 'UserPreferences.nimbusManifest.label',
  UserPreferencesNimbusManifestImLabel = 'UserPreferences.nimbusManifestIm.label',
  UserPreferencesNotificationsAudioNoItems = 'UserPreferences.notifications.audioNoItems',
  UserPreferencesNotificationsAudioTitle = 'UserPreferences.notifications.audioTitle',
  UserPreferencesNotificationsDesktopNotificationNoItems = 'UserPreferences.notifications.desktopNotificationNoItems',
  UserPreferencesNotificationsDesktopNotificationTitle = 'UserPreferences.notifications.desktopNotificationTitle',
  UserPreferencesNotificationsMandatoryConfiguration = 'UserPreferences.notifications.mandatoryConfiguration',
  UserPreferencesNotificationsPickupSignalLoadFailed = 'UserPreferences.notifications.pickupSignalLoadFailed',
  UserPreferencesNotificationsPickupSignalSaveFailed = 'UserPreferences.notifications.pickupSignalSaveFailed',
  UserPreferencesNotificationsMessagesEmailBody = 'UserPreferences.notifications.messages.email.body',
  UserPreferencesNotificationsMessagesEmailTitle = 'UserPreferences.notifications.messages.email.title',
  UserPreferencesNotificationsMessagesExternalTaskBody = 'UserPreferences.notifications.messages.externalTask.body',
  UserPreferencesNotificationsMessagesExternalTaskTitle = 'UserPreferences.notifications.messages.externalTask.title',
  UserPreferencesNotificationsMessagesInstantMessageBody = 'UserPreferences.notifications.messages.instantMessage.body',
  UserPreferencesNotificationsMessagesInstantMessageTitle = 'UserPreferences.notifications.messages.instantMessage.title',
  UserPreferencesO365LicensesLabel = 'UserPreferences.o365Licenses.label',
  UserPreferencesPermissionsAdminLabel = 'UserPreferences.permissions.admin.label',
  UserPreferencesPermissionsAllFeatures = 'UserPreferences.permissions.allFeatures',
  UserPreferencesPermissionsManageConsent = 'UserPreferences.permissions.manageConsent',
  UserPreferencesPermissionsUserLabel = 'UserPreferences.permissions.user.label',
  UserPreferencesPowerAutomateDescription = 'UserPreferences.powerAutomate.description',
  UserPreferencesPowerAutomateHowTo = 'UserPreferences.powerAutomate.howTo',
  UserPreferencesPowerAutomateLabel = 'UserPreferences.powerAutomate.label',
  UserPreferencesPowerBiTemplateDescription = 'UserPreferences.powerBiTemplate.description',
  UserPreferencesPowerBiTemplateHowTo = 'UserPreferences.powerBiTemplate.howTo',
  UserPreferencesPowerBiTemplateLabel = 'UserPreferences.powerBiTemplate.label',
  UserPreferencesPowerBiTemplateTooltip = 'UserPreferences.powerBiTemplate.tooltip',
  UserPreferencesPowershellDescriptionWithLink = 'UserPreferences.powershell.descriptionWithLink',
  UserPreferencesPowershellHowTo = 'UserPreferences.powershell.howTo',
  UserPreferencesPowershellLabel = 'UserPreferences.powershell.label',
  UserPreferencesReleaseNotesDescription = 'UserPreferences.releaseNotes.description',
  UserPreferencesReleaseNotesHowTo = 'UserPreferences.releaseNotes.howTo',
  UserPreferencesReleaseNotesLabel = 'UserPreferences.releaseNotes.label',
  UserPreferencesReleaseNotesTooltip = 'UserPreferences.releaseNotes.tooltip',
  UserPreferencesResourcesSetupSection = 'UserPreferences.resources.setupSection',
  UserPreferencesResourcesToolsSection = 'UserPreferences.resources.toolsSection',
  UserPreferencesResourcesUsageSection = 'UserPreferences.resources.usageSection',
  UserPreferencesSignalRClientSideLogging = 'UserPreferences.logging.signalRClientSideLogging',
  UserPreferencesSignalRDiagnosticClient = 'UserPreferences.logging.signalRdiagnosticClient',
  UserPreferencesDirectCallAccountSection = 'UserPreferences.directCall.accountSection',
  UserPreferencesDirectCallAddRule = 'UserPreferences.directCall.rules.addRule',
  UserPreferencesDirectCallAllDayLabel = 'UserPreferences.directCall.allDayLabel',
  UserPreferencesDirectCallDayFriShort = 'UserPreferences.directCall.days.friShort',
  UserPreferencesDirectCallDayMonShort = 'UserPreferences.directCall.days.monShort',
  UserPreferencesDirectCallDaysLabel = 'UserPreferences.directCall.days.label',
  UserPreferencesDirectCallDaySatShort = 'UserPreferences.directCall.days.satShort',
  UserPreferencesDirectCallDaySunShort = 'UserPreferences.directCall.days.sunShort',
  UserPreferencesDirectCallDayThuShort = 'UserPreferences.directCall.days.thuShort',
  UserPreferencesDirectCallDayTueShort = 'UserPreferences.directCall.days.tueShort',
  UserPreferencesDirectCallDayWedShort = 'UserPreferences.directCall.days.wedShort',
  UserPreferencesDirectCallDragHandleTitle = 'UserPreferences.directCall.dragHandleTitle',
  UserPreferencesDirectCallEditRule = 'UserPreferences.directCall.rules.edit',
  UserPreferencesDirectCallFeatureDisabled = 'UserPreferences.directCall.featureDisabled',
  UserPreferencesDirectCallForwardingEnabled = 'UserPreferences.directCall.forwardingEnabled',
  UserPreferencesDirectCallForwardingEnabledHint = 'UserPreferences.directCall.forwardingEnabledHint',
  UserPreferencesDirectCallForwardingEnabledHintShort = 'UserPreferences.directCall.forwardingEnabledHintShort',
  UserPreferencesDirectCallForwardingSection = 'UserPreferences.directCall.forwardingSection',
  UserPreferencesDirectCallFromLabel = 'UserPreferences.directCall.fromLabel',
  UserPreferencesDirectCallKindAlways = 'UserPreferences.directCall.rules.kind.always',
  UserPreferencesDirectCallKindAlwaysPhone = 'UserPreferences.directCall.rules.kind.alwaysPhone',
  UserPreferencesDirectCallKindAlwaysService = 'UserPreferences.directCall.rules.kind.alwaysService',
  UserPreferencesDirectCallKindAlwaysVoicemail = 'UserPreferences.directCall.rules.kind.alwaysVoicemail',
  UserPreferencesDirectCallKindAlwaysWorkflow = 'UserPreferences.directCall.rules.kind.alwaysWorkflow',
  UserPreferencesDirectCallKindPresence = 'UserPreferences.directCall.rules.kind.presence',
  UserPreferencesDirectCallKindTimeWindow = 'UserPreferences.directCall.rules.kind.timeWindow',
  UserPreferencesDirectCallManagedByAdmin = 'UserPreferences.directCall.managedByAdmin',
  UserPreferencesDirectCallPhoneLabel = 'UserPreferences.directCall.phoneLabel',
  UserPreferencesDirectCallPresenceAvailable = 'UserPreferences.directCall.presence.available',
  UserPreferencesDirectCallPresenceAway = 'UserPreferences.directCall.presence.away',
  UserPreferencesDirectCallPresenceBusy = 'UserPreferences.directCall.presence.busy',
  UserPreferencesDirectCallPresenceDoNotDisturb = 'UserPreferences.directCall.presence.doNotDisturb',
  UserPreferencesDirectCallPresenceInACall = 'UserPreferences.directCall.presence.inACall',
  UserPreferencesDirectCallPresenceLabel = 'UserPreferences.directCall.presenceLabel',
  UserPreferencesDirectCallPresenceNotAvailable = 'UserPreferences.directCall.presence.notAvailable',
  UserPreferencesDirectCallPriority = 'UserPreferences.directCall.rules.priority',
  UserPreferencesDirectCallRemoveRule = 'UserPreferences.directCall.rules.remove',
  UserPreferencesDirectCallResourceAccountEmpty = 'UserPreferences.directCall.resourceAccountEmpty',
  UserPreferencesDirectCallResourceAccountErrorTooltip = 'UserPreferences.directCall.resourceAccountErrorTooltip',
  UserPreferencesDirectCallResourceAccountLabel = 'UserPreferences.directCall.resourceAccountLabel',
  UserPreferencesDirectCallResourceAccountLoadFailed = 'UserPreferences.directCall.resourceAccountLoadFailed',
  UserPreferencesDirectCallResourceAccountNoneOption = 'UserPreferences.directCall.resourceAccountNoneOption',
  UserPreferencesDirectCallResourceAccountNoPhone = 'UserPreferences.directCall.resourceAccountNoPhone',
  UserPreferencesDirectCallResourceAccountPendingTooltip = 'UserPreferences.directCall.resourceAccountPendingTooltip',
  UserPreferencesDirectCallResourceAccountPhoneLabel = 'UserPreferences.directCall.resourceAccountPhoneLabel',
  UserPreferencesDirectCallResourceAccountPhoneNone = 'UserPreferences.directCall.resourceAccountPhoneNone',
  UserPreferencesDirectCallRuleDialogAddTitle = 'UserPreferences.directCall.rules.dialog.addTitle',
  UserPreferencesDirectCallRuleDialogEditTitle = 'UserPreferences.directCall.rules.dialog.editTitle',
  UserPreferencesDirectCallRuleKindLabel = 'UserPreferences.directCall.ruleKindLabel',
  UserPreferencesDirectCallRuleSummaryForwardTo = 'UserPreferences.directCall.rules.summary.forwardTo',
  UserPreferencesDirectCallRuleSummaryTimeWindow = 'UserPreferences.directCall.rules.summary.timeWindow',
  UserPreferencesDirectCallRulesEmpty = 'UserPreferences.directCall.rules.empty',
  UserPreferencesDirectCallRulesWidgetLabel = 'UserPreferences.directCall.rules.widgetLabel',
  UserPreferencesDirectCallSaveFailed = 'UserPreferences.directCall.saveFailed',
  UserPreferencesDirectCallServiceTeamIdLabel = 'UserPreferences.directCall.serviceTeamIdLabel',
  UserPreferencesDirectCallServiceTeamIdPlaceholder = 'UserPreferences.directCall.serviceTeamIdPlaceholder',
  UserPreferencesDirectCallTargetLabel = 'UserPreferences.directCall.targetLabel',
  UserPreferencesDirectCallTargetPhone = 'UserPreferences.directCall.rules.target.phone',
  UserPreferencesDirectCallTargetService = 'UserPreferences.directCall.rules.target.service',
  UserPreferencesDirectCallTargetSpecificUser = 'UserPreferences.directCall.rules.target.specificUser',
  UserPreferencesDirectCallTargetVoicemail = 'UserPreferences.directCall.rules.target.voicemail',
  UserPreferencesDirectCallTargetWorkflow = 'UserPreferences.directCall.rules.target.workflow',
  UserPreferencesDirectCallTimezoneLabel = 'UserPreferences.directCall.timezoneLabel',
  UserPreferencesDirectCallTimezonePlaceholder = 'UserPreferences.directCall.timezonePlaceholder',
  UserPreferencesDirectCallToLabel = 'UserPreferences.directCall.toLabel',
  UserPreferencesDirectCallUserIdLabel = 'UserPreferences.directCall.userIdLabel',
  UserPreferencesDirectCallWorkflowIdLabel = 'UserPreferences.directCall.workflowIdLabel',
  UserPreferencesTabAppearance = 'UserPreferences.tab.appearance',
  UserPreferencesTabDirectCallLabel = 'UserPreferences.tab.directCallLabel',
  UserPreferencesTabDirectCalling = 'UserPreferences.tab.directCalling',
  UserPreferencesTabGeneral = 'UserPreferences.tab.general',
  UserPreferencesTabLogging = 'UserPreferences.tab.logging',
  UserPreferencesTabNotifications = 'UserPreferences.tab.notifications',
  UserPreferencesTabPermissions = 'UserPreferences.tab.permissions',
  UserPreferencesTabProvisioning = 'UserPreferences.tab.provisioning',
  UserPreferencesTabResources = 'UserPreferences.tab.resources',
  UserPreferencesTitle = 'UserPreferences.title',
  UserPreferencesUserLabel = 'UserPreferences.user.label',
  UsersStatisticsTitle = 'UsersStatistics.title',
  UserUiAccessAssignedProfileInfo = 'User.UiAccess.assignedProfileInfo',
  UserUiAccessCreateLink = 'User.UiAccess.createLink',
  UserUiAccessMissingPermissionInfo = 'User.UiAccess.missingPermissionInfo',
  UserUiAccessNoProfilesInfo = 'User.UiAccess.noProfilesInfo',
  UserUiAccessProfileLabel = 'User.UiAccess.profileLabel',
  VoiceMessageDownloadGeneralError = 'VoiceMessage.Download.generalError',
  VoiceMessageDownloadInprogress = 'VoiceMessage.Download.inprogress',
  VoiceMessageDownloadNoPermission = 'VoiceMessage.Download.noPermission',
  VoiceMessageDownloadSuccess = 'VoiceMessage.Download.success',
  VoiceMessageDownloadSwitchUser = 'VoiceMessage.Download.switchUser',
  VoiceMessageDownloadTryAgain = 'VoiceMessage.Download.tryAgain',
  WarningAndTryAgain = 'Warning.andTryAgain',
  WarningConnectionIssues = 'Warning.connectionIssues',
  WarningContactYourAdministrator = 'Warning.contactYourAdministrator',
  WarningContactYourAdministratorWithLink = 'Warning.contactYourAdministratorWithLink',
  WarningIncompatibleVersion = 'Warning.incompatibleVersion',
  WarningIncorrectFormat = 'Warning.incorrectFormat',
  WarningNoGraphPermissions = 'Warning.noGraphPermissions',
  WarningNoMsTeamsToken = 'Warning.noMsTeamsToken',
  WarningNoOutboundServices = 'Warning.noOutboundServices',
  WarningNotLicensed = 'Warning.notLicensed',
  WarningPleaseLogIn = 'Warning.pleaseLogin',
  WidgetExternalDateTimeDescription = 'Widget.ExternalDateTime.description',
  WidgetExternalDateTimeTitle = 'Widget.ExternalDateTime.title',
  WidgetExternalIFrameDescription = 'Widget.ExternalIFrame.description',
  WidgetExternalIFrameTitle = 'Widget.ExternalIFrame.title',
  WidgetExternalMarkdownContent = 'Widget.ExternalMarkdown.content',
  WidgetExternalMarkdownDescription = 'Widget.ExternalMarkdown.description',
  WidgetExternalMarkdownTitle = 'Widget.ExternalMarkdown.title',
  WidgetServiceHeatmapChartDescription = 'Widget.ServiceHeatmapChart.description',
  WidgetServiceHeatmapChartLegendColorDescription = 'Widget.ServiceHeatmapChart.legend.colorDescription',
  WidgetServiceHeatmapChartLegendDescription = 'Widget.ServiceHeatmapChart.legend.description',
  WidgetServiceKpiChartDescription = 'Widget.ServiceKpiChart.description',
  WidgetServiceKpiChartLookBack = 'Widget.ServiceKpiChart.lookBack',
  WidgetServiceKpiChartTitle = 'Widget.ServiceKpiChart.title',
  WidgetServiceKpiChartTrend = 'Widget.ServiceKpiChart.trend',
  WidgetServiceKpiComparisonChartDescription = 'Widget.ServiceKpiComparisonChart.description',
  WidgetServiceKpiComparisonChartTitle = 'Widget.ServiceKpiComparisonChart.title',
  WidgetServiceKpiDescription = 'Widget.ServiceKpi.description',
  WidgetServiceKpiGraphChartDescription = 'Widget.ServiceKpiGraphChart.description',
  WidgetServiceKpiGraphChartTitle = 'Widget.ServiceKpiGraphChart.title',
  WidgetServiceKpiTabularDescription = 'Widget.ServiceKpiTabular.description',
  WidgetServiceKpiTabularTitle = 'Widget.ServiceKpiTabular.title',
  WidgetServiceKpiTitle = 'Widget.ServiceKpi.title',
  WidgetServiceQueueTabularColumnSlaAcceptanceTime = 'Widget.ServiceQueueTabular.column.slaAcceptanceTime',
  WidgetServiceQueueTabularColumnSlaHangupTime = 'Widget.ServiceQueueTabular.column.slaHangupTime',
  WidgetServiceQueueTabularDescription = 'Widget.ServiceQueueTabular.description',
  WidgetServiceQueueTabularTitle = 'Widget.ServiceQueueTabular.title',
  WidgetServiceSupervisionTabularDescription = 'Widget.ServiceSupervisionTabular.description',
  WidgetServiceSupervisionTabularSetSupervisionError = 'Widget.ServiceSupervisionTabular.setSupervision.error',
  WidgetServiceSupervisionTabularSetSupervisionErrorTeamsOnHold = 'Widget.ServiceSupervisionTabular.setSupervision.errorTeamsOnHold',
  WidgetServiceSupervisionTabularSetSupervisionSuccess = 'Widget.ServiceSupervisionTabular.setSupervision.success',
  WidgetServiceSupervisionTabularTitle = 'Widget.ServiceSupervisionTabular.title',
  WidgetServiceTasksExternalTabularDeleteExternalTaskError = 'Widget.ServiceTasksExternalTabular.deleteExternalTask.error',
  WidgetServiceTasksExternalTabularDeleteExternalTaskSuccess = 'Widget.ServiceTasksExternalTabular.deleteExternalTask.success',
  WidgetServiceTasksExternalTabularDescription = 'Widget.ServiceTasksExternalTabular.description',
  WidgetServiceTasksExternalTabularTitle = 'Widget.ServiceTasksExternalTabular.title',
  WidgetServiceTasksLiveInboundTabularDescription = 'Widget.ServiceTasksLiveInboundTabular.description',
  WidgetServiceTasksLiveInboundTabularTitle = 'Widget.ServiceTasksLiveInboundTabular.title',
  WidgetServiceTasksOutboundTabularDeleteOutboundTaskError = 'Widget.ServiceTasksOutboundTabular.deleteOutboundTask.error',
  WidgetServiceTasksOutboundTabularDeleteOutboundTaskSuccess = 'Widget.ServiceTasksOutboundTabular.deleteOutboundTask.success',
  WidgetServiceTasksOutboundTabularDescription = 'Widget.ServiceTasksOutboundTabular.description',
  WidgetServiceTasksOutboundTabularTitle = 'Widget.ServiceTasksOutboundTabular.title',
  WidgetSServiceHeatmapChartTitle = 'Widget.ServiceHeatmapChart.title',
  WidgetUserPerformanceTabularColumnOrganizationUnit = 'Widget.UserPerformanceTabular.column.organizationUnit',
  WidgetUserPerformanceTabularColumnPerformanceChart = 'Widget.UserPerformanceTabular.column.performanceChart',
  WidgetUserPerformanceTabularColumnUserAvatar = 'Widget.UserPerformanceTabular.column.userAvatar',
  WidgetUserPerformanceTabularColumnUserName = 'Widget.UserPerformanceTabular.column.userName',
  WidgetUserPerformanceTabularDescription = 'Widget.UserPerformanceTabular.description',
  WidgetUserPerformanceTabularPerformanceChartWarning = 'Widget.UserPerformanceTabular.performanceChartColumnWarning',
  WidgetUserPerformanceTabularPerformanceChartWarningShort = 'Widget.UserPerformanceTabular.performanceChartColumnWarningShort',
  WidgetUserPerformanceTabularTitle = 'Widget.UserPerformanceTabular.title',
  WidgetUserStateChartDescription = 'Widget.UserStateChart.description',
  WidgetUserStateChartTitle = 'Widget.UserStateChart.title',
  WidgetUserStateTabularDescription = 'Widget.UserStateTabular.description',
  WidgetUserStateTabularTitle = 'Widget.UserStateTabular.title',
  WidgetUserSupervisorTabularActivateResponsibilityProfileEdit = 'Widget.UserSupervisorTabular.activateResponsibilityProfile.edit',
  WidgetUserSupervisorTabularActivateResponsibilityProfileError = 'Widget.UserSupervisorTabular.activateResponsibilityProfile.error',
  WidgetUserSupervisorTabularActivateResponsibilityProfileSuccess = 'Widget.UserSupervisorTabular.activateResponsibilityProfile.success',
  WidgetUserSupervisorTabularDescription = 'Widget.UserSupervisorTabular.description',
  WidgetUserSupervisorTabularStopAcwError = 'Widget.UserSupervisorTabular.stopAcw.error',
  WidgetUserSupervisorTabularStopAcwSuccess = 'Widget.UserSupervisorTabular.stopAcw.success',
  WidgetUserSupervisorTabularStopRonaError = 'Widget.UserSupervisorTabular.stopRona.error',
  WidgetUserSupervisorTabularStopRonaSuccess = 'Widget.UserSupervisorTabular.stopRona.success',
  WidgetUserSupervisorTabularTitle = 'Widget.UserSupervisorTabular.title',
  WidgetUserTileColumnUsers = 'Widget.UserTile.column.users',
  WidgetUserTileDescription = 'Widget.UserTile.description',
  WidgetUserTileTitle = 'Widget.UserTile.title',
  VoicemailsBulkDeleteConfirmBody = 'Voicemails.bulkDelete.confirmBody',
  VoicemailsChartRange30D = 'Voicemails.chart.range.30d',
  VoicemailsChartRange48H = 'Voicemails.chart.range.48h',
  VoicemailsChartRange7D = 'Voicemails.chart.range.7d',
  VoicemailsChartRangeToday = 'Voicemails.chart.range.today',
  VoicemailsDetailCallBack = 'Voicemails.detail.callBack',
  VoicemailsDetailConfidenceFair = 'Voicemails.detail.confidenceFair',
  VoicemailsDetailConfidenceGood = 'Voicemails.detail.confidenceGood',
  VoicemailsDetailConfidenceGoodThreshold = 'Voicemails.detail.confidenceGoodThreshold',
  VoicemailsDetailConfidenceGoodThresholdShort = 'Voicemails.detail.confidenceGoodThresholdShort',
  VoicemailsDetailConfidenceLow = 'Voicemails.detail.confidenceLow',
  VoicemailsDetailConfidenceProcessing = 'Voicemails.detail.confidenceProcessing',
  VoicemailsDetailDownloadTranscript = 'Voicemails.detail.downloadTranscript',
  VoicemailsDetailMarkAsCurrentlyHandled = 'Voicemails.detail.markAsCurrentlyHandled',
  VoicemailsDetailMarkAsHandled = 'Voicemails.detail.markAsHandled',
  VoicemailsDetailMarkAsInProgress = 'Voicemails.detail.markAsInProgress',
  VoicemailsDetailMarkAsListened = 'Voicemails.detail.markAsListened',
  VoicemailsDetailMarkAsNew = 'Voicemails.detail.markAsNew',
  VoicemailsDetailMarkAsSolved = 'Voicemails.detail.markAsSolved',
  VoicemailsDetailTranscriptionConfidence = 'Voicemails.detail.transcriptionConfidence',
  VoicemailsGridAudio = 'Voicemails.grid.audio',
  VoicemailsGridCaller = 'Voicemails.grid.caller',
  VoicemailsGridCurrentlyProcessing = 'Voicemails.grid.currentlyProcessing',
  VoicemailsGridDateTime = 'Voicemails.grid.dateTime',
  VoicemailsGridDuration = 'Voicemails.grid.duration',
  VoicemailsGridFilterAll = 'Voicemails.grid.filterAll',
  VoicemailsGridFilterProcessingState = 'Voicemails.grid.filterProcessingState',
  VoicemailsGridHandled = 'Voicemails.grid.handled',
  VoicemailsGridHandledAt = 'Voicemails.grid.handledAt',
  VoicemailsGridHandledBy = 'Voicemails.grid.handledBy',
  VoicemailsGridInProgress = 'Voicemails.grid.inProgress',
  VoicemailsGridListened = 'Voicemails.grid.listened',
  VoicemailsGridNew = 'Voicemails.grid.new',
  VoicemailsGridNotHandled = 'Voicemails.grid.notHandled',
  VoicemailsGridProcessed = 'Voicemails.grid.processed',
  VoicemailsGridProcessedAt = 'Voicemails.grid.processedAt',
  VoicemailsGridProcessedAtColumn = 'Voicemails.grid.processedAtColumn',
  VoicemailsGridProcessedBy = 'Voicemails.grid.processedBy',
  VoicemailsGridProcessedByColumn = 'Voicemails.grid.processedByColumn',
  VoicemailsGridProcessingDuration = 'Voicemails.grid.processingDuration',
  VoicemailsGridProcessingDurationColumn = 'Voicemails.grid.processingDurationColumn',
  VoicemailsGridSolved = 'Voicemails.grid.solved',
  VoicemailsGridSolvedBy = 'Voicemails.grid.solvedBy',
  VoicemailsGridState = 'Voicemails.grid.state',
  VoicemailsGridTranscription = 'Voicemails.grid.transcription',
  VoicemailsSelectedCount = 'Voicemails.selectedCount',
  VoicemailsStatsHandleTimeTitle = 'Voicemails.stats.handleTimeTitle',
  VoicemailsStatsHandledTitle = 'Voicemails.stats.handledTitle',
  VoicemailsStatsPending = 'Voicemails.stats.pending',
  VoicemailsStatsStatesTitle = 'Voicemails.stats.statesTitle',
  VoicemailsStatsTitle = 'Voicemails.stats.title',
  VoicemailsStatsTotalTitle = 'Voicemails.stats.totalTitle',
  WorkflowsAdd = 'Workflows.add',
  WorkflowsAddInput = 'Workflows.addInput',
  WorkflowsAutoArrange = 'Workflows.autoArrange',
  WorkflowsChannelPermissionRequirement = 'Workflows.channelPermissionRequirement',
  WorkflowsDestinationTypeDirectEntry = 'Workflows.Properties.Options.directEntry',
  WorkflowsDistributionsBroadcast = 'Workflows.Properties.Options.broadcast',
  WorkflowsDistributionsDirect = 'Workflows.Properties.Options.direct',
  WorkflowsDistributionsDirectConference = 'Workflows.Properties.Options.directConference',
  WorkflowsDistributionsPickupConference = 'Workflows.Properties.Options.pickupConference',
  WorkflowsDistributionsPickup = 'Workflows.Properties.Options.pickup',
  WorkflowsDistributionsPickupWithAdjustableRONA = 'Workflows.Properties.Options.pickupWithAdjustableRONA',
  WorkflowsPropertiesOptionsPSTN = 'Workflows.Properties.Options.pSTN',
  WorkflowsPropertiesOptionsTeamsUserBeta = 'Workflows.Properties.Options.teamsUser(Beta)',
  WorkflowsPropertiesOptionsUnifyUser = 'Workflows.Properties.Options.unifyUser',
  WorkflowsExitsIdleTimeout = 'Workflows.Exits.idletimeout',
  WorkflowsExitsTimeoutReached = 'Workflows.Exits.timeoutReached',
  WorkflowsExitsUpdated = 'Workflows.Exits.updated',
  WorkflowsHeaderActionTransformToAdvancedIvr = 'Workflows.Header.Action.transformToAdvancedIvr',
  WorkflowsMoreInformation = 'Workflows.moreInformation',
  WorkflowsParameter = 'Workflows.parameter',
  WorkflowsPleaseContactYourAdministratorWithLink = 'Workflows.pleaseContactYourAdministratorWithLink',
  WorkflowsPropertiesAudioWasNotLoaded = 'Workflows.Properties.audioWasNotLoaded',
  WorkflowsPropertiesAttemptTimeout = 'Workflows.Properties.attemptTimeout',
  WorkflowsPropertiesCheckX = 'Workflows.Properties.checkX',
  WorkflowsPropertiesConfirmationDtmf = 'Workflows.Properties.confirmationDtmf',
  WorkflowsPropertiesConnectionAttempts = 'Workflows.Properties.connectionAttempts',
  WorkflowsPropertiesCustomCallContextParameter = 'Workflows.Properties.customCallContextParameter',
  WorkflowsPropertiesCurrentService = 'Workflows.Properties.currentService',
  WorkflowsPropertiesDelayTime = 'Workflows.Properties.delayTime',
  WorkflowsPropertiesDestination = 'Workflows.Properties.destination',
  WorkflowsPropertiesDistributionPriority = 'Workflows.Properties.distributionPriority',
  WorkflowsPropertiesDistributionType = 'Workflows.Properties.distributionType',
  WorkflowsPropertiesDTMFInput = 'Workflows.Properties.dTMFInput',
  WorkflowsProperties1StParameter = 'Workflows.Properties.1StParameter',
  WorkflowsProperties2NdParameter = 'Workflows.Properties.2NdParameter',
  WorkflowsPropertiesDuration = 'Workflows.Properties.duration',
  WorkflowsPropertiesExit1 = 'Workflows.Properties.exit1',
  WorkflowsPropertiesExitX = 'Workflows.Properties.exitX',
  WorkflowsPropertiesIdleTimeout = 'Workflows.Properties.idleTimeout',
  WorkflowsPropertiesInitialSilenceTimeout = 'Workflows.Properties.initialSilenceTimeout',
  WorkflowsPropertiesInputTimeout = 'Workflows.Properties.inputTimeout',
  WorkflowsPropertiesInputX = 'Workflows.Properties.inputX',
  WorkflowsPropertiesIntents = 'Workflows.Properties.intents',
  WorkflowsPropertiesKeepQueuePosition = 'Workflows.Properties.keepQueuePosition',
  WorkflowsPropertiesLanguagesWereNotLoaded = 'Workflows.Properties.languagesWereNotLoaded',
  WorkflowsPropertiesLanguageWasNotLoaded = 'Workflows.Properties.languageWasNotLoaded',
  WorkflowsPropertiesMainPromptText = 'Workflows.Properties.mainPromptText',
  WorkflowsPropertiesMaximumRecordingTime = 'Workflows.Properties.maximumRecordingTime',
  WorkflowsPropertiesMaxAttempts = 'Workflows.Properties.maxAttempts',
  WorkflowsPropertiesMaxInputTime = 'Workflows.Properties.maxInputTime',
  WorkflowsPropertiesMaxQueueTime = 'Workflows.Properties.maxQueueTime',
  WorkflowsPropertiesMaxWaitingTime = 'Workflows.Properties.maxWaitingTime',
  WorkflowsPropertiesMaxWaitTime = 'Workflows.Properties.maxWaitTime',
  WorkflowsPropertiesOtherLanguages = 'Workflows.Properties.otherLanguages',
  WorkflowsPropertiesParameterVirtualUserContextWarning = 'Workflows.Properties.parameterVirtualUserContextWarning',
  WorkflowsPropertiesPhone = 'Workflows.Properties.phone',
  WorkflowsPropertiesUserType = 'Workflows.Properties.userType',
  WorkflowsPropertiesPlayAnnouncement = 'Workflows.Properties.playAnnouncement',
  WorkflowsPropertiesPromptLanguage = 'Workflows.Properties.promptLanguage',
  WorkflowsPropertiesPromptOnNoResponse = 'Workflows.Properties.promptOnNoResponse',
  WorkflowsPropertiesPromptOnNoMatch = 'Workflows.Properties.promptOnNoMatch',
  WorkflowsPropertiesPromptText = 'Workflows.Properties.promptText',
  WorkflowsPropertiesQueueTimeLimit = 'Workflows.Properties.queueTimeLimit',
  WorkflowsPropertiesReferenceID = 'Workflows.Properties.referenceID',
  WorkflowsPropertiesRonaTimeout = 'Workflows.Properties.ronaTimeout',
  WorkflowsPropertiesTarget = 'Workflows.Properties.target',
  WorkflowsPropertiesTextareaInfoMessage = 'Workflows.Properties.textareaInfoMessage',
  WorkflowsPropertiesTwilioMessageLimitWarning = 'Workflows.Properties.twilioMessageLimitWarning',
  WorkflowsPropertiesVirtualUser = 'Workflows.Properties.virtualUser',
  WorkflowsPropertiesVirtualUserLicenseWarning = 'Workflows.Properties.virtualUserLicenseWarning',
  WorkflowsSelectedParameterName = 'Workflows.selectedParameterName',
}
